/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	if (!window.vcollectRunOnlyOnce) {
	  if (!window.document || !window.document.body) {
	    console.error("请将 vcollect 置于 body 下作为第一个 script");
	  } else {
	    window.vcollectRunOnlyOnce = true;
	    var Core = __webpack_require__(1);
	    var owl = __webpack_require__(19);
	    var spider = __webpack_require__(26);
	    var pathTracker = __webpack_require__(182);
	    var log = __webpack_require__(186);
	    var ua = __webpack_require__(5);
	    var util = __webpack_require__(2);

	    __webpack_require__(187);

	    var multiDomain = __webpack_require__(180);

	    var tryjs = __webpack_require__(18);

	    // var proxyTap = require("./lib/proxy-collector");

	    // 注册各种埋点脚本
	    var registQueue = [
	      tryjs(
	        function registSpider() {
	          var core = new Core();
	          spider.init(core);

	          // 如果 script 标签没有禁用 spider 自动 pv 上报，则执行自动上报 pv
	          var disabled = util._listDisabledAuto();
	          if (disabled.indexOf("spider") < 0) {
	            spider.trackPageview();
	          }

	          core.onSpmChange(function () {
	            if (disabled.indexOf("spider") < 0) {
	              spider.trackPageview();
	            }
	          });
	        },
	        function (err) {
	          spider.reset();
	        }
	      ),

	      tryjs(function registPerf() {
	        var disabled = util._listDisabledAuto();
	        // if (disabled.indexOf("perf") < 0) {
	        //   owl.init(new Core(), { auto: true });
	        // } else {
	        //   owl.init(new Core(), { auto: false });
	        // }
	        // 强制关闭性能监控埋点上报
	        owl.init(new Core(), { auto: false })
	      }),

	      tryjs(function registLog() {
	        var disabled = util._listDisabledAuto();
	        log.init(new Core(), {
	          // auto: disabled.indexOf("error") === -1
	          // 强制关闭错误主动上报
	          auto: false
	        });
	      }),

	      tryjs(function registPathTracker() {
	        var disabled = util._listDisabledAuto()
	        // 11.2.30版本默认强制下线pathTracker功能
	        // if(disabled.indexOf('pathTracker') < 0){

	        //   pathTracker.init(new Core());

	        //   window.pathTracker = pathTracker;
	        // }
	      })
	    ];

	    for (var i = 0, len = registQueue.length; i < len; i++) {
	      registQueue[i]();
	    }

	    window.vcollect = {
	      ua: ua,
	      reportError: log.report,
	      setError: log.setError
	    };

	    window.cat = log;
	    window.spider = spider;
	    window.owl = owl;
	    // window.pathTracker = pathTracker;
	    // 若当前开启了多域名配置并且发起了promise请求，则暴露在window对象下
	    multiDomain.ruleMapPromise && (window.ruleMapPromise = multiDomain.ruleMapPromise)


	    // proxyTap(window.vcollect, 'vcollect')
	    // proxyTap(window.spider, 'spider', 'disableAutoReport')
	    // proxyTap(window.spider, 'spider', 'getSearchParams')
	    // proxyTap(window.spider, 'spider', 'getCookie')
	    // proxyTap(window.spider, 'spider', 'reset')
	    // proxyTap(window.spider, 'spider', 'init')
	    // proxyTap(window.cat, 'cat')
	    // proxyTap(window.owl, 'owl')
	  }
	}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	var util = __webpack_require__(2);
	var canvasFp = __webpack_require__(7);
	var ua = __webpack_require__(5);
	var uaTool = __webpack_require__(8);
	var SdkLoader = __webpack_require__(3);
	var tapper = __webpack_require__(10);
	var console = util._console;
	var constants = __webpack_require__(15);

	var pageMetaData = {};
	var COOKIE_KEY_PREFIX = "__spider__"; // cookie 字段，历史原因，性能和埋点均使用该字段;
	var POST_DELAY = 100;
	var REF_URL = "";
	var REPORT_URL = (function() {
	  var hostname = location.hostname;
	  var env = "";
	  if (hostname.match(/\.(dev|daily|test|pre)\./)) {
	    env = "daily.";
	  } 
	  // else if (hostname.match(/\.pre\./)) {
	  //   env = "pre.";
	  // }
	  // var envMatch = hostname.match(/\.(dev|daily|pre|test)\./);
	  // var env = envMatch ? "pre." : "";

	  return "https://logtake." + env + "weidian.com/h5collector/webcollect/3.0";
	})();

	// 启动 body-observe
	var bodyObserver = __webpack_require__(16)();

	var visitId = "";
	var total = 0;
	var index = 0;
	var Core = function Core() {
	  this._logQueue = [];
	  this._callbackQueue = [];
	  this.delayPostTimer = null;

	  total++;

	  this.init();

	  var self = this;
	  this.onSpmChange(function() {
	    // 如果是第一次触发变化，则重置 visitId
	    if (index === 0) {
	      visitId = "";
	    }
	    index++;
	    self.init();

	    // 如果是最后一次触发变化，则重置 index。便于下次变化重新计数
	    if (index === total) {
	      index = 0;
	    }
	  });
	};

	function doCallbackQueue(queue, success) {
	  var i, cb;
	  for (i = 0; i < queue.length; i++) {
	    cb = queue[i];
	    if (cb) {
	      cb(success);
	    }
	  }
	  queue.length = 0;
	}

	function generateRandomVisitorId() {
	  return util._generateToken(canvasFp() + (navigator.userAgent || ""));
	}

	function storeVisitorId(visitorId) {
	  var cookieStoreDomain = util._getCookieStoreDomain();

	  util._setCookie(COOKIE_KEY_PREFIX + "visitorid", visitorId, {
	    domain: cookieStoreDomain,
	    path: "/",
	    "max-age": 60 * 60 * 24 * 365 * 2
	  });
	}

	// 缓存ID，确保只执行一次
	var VISITOR_ID;
	function getVisitorIdFromApp(callback) {
	  if (VISITOR_ID) {
	    callback({
	      visitorId: VISITOR_ID,
	      // 不是第一次
	      noFirst: true
	    });
	    return;
	  }

	  function fallback() {
	    VISITOR_ID = generateRandomVisitorId();
	    callback({
	      visitorId: VISITOR_ID,
	      // 不是第一次
	      noFirst: true
	    });
	  }

	  if (ua.isApp) {
	    SdkLoader().ready(function() {
	      if (window.KDJSBridge2) {
	        window.KDJSBridge2.call("WDJSBridge", "getCuid", {}, function(res) {
	          if (res && res.param && res.param.cuid) {
	            VISITOR_ID = res.param.cuid;
	            callback({
	              visitorId: VISITOR_ID
	            });
	          } 
	          // else if (
	          //   uaTool.isWDSeller() &&
	          //   uaTool.isAndroid() &&
	          //   util.versionCompare(uaTool.getWDAppVersion(), "9.0.42") >= 0
	          // ) {
	          //   // 店长版Android用getDeviceInfo获取cuid 9.0.42版本开始
	          //   window.KDJSBridge2.call(
	          //     "service",
	          //     "UNISDKPayService",
	          //     {
	          //       params: {
	          //         action: "getDeviceInfo"
	          //       }
	          //     },
	          //     function(res) {
	          //       if (
	          //         res &&
	          //         res.param &&
	          //         res.param.result &&
	          //         res.param.result.data &&
	          //         res.param.result.data.cuid
	          //       ) {
	          //         VISITOR_ID = res.param.result.data.cuid;
	          //         callback({
	          //           visitorId: VISITOR_ID
	          //         });
	          //       } else {
	          //         fallback();
	          //       }
	          //     }
	          //   );
	          // } 
	          else {
	            // jsbridge获取cuid若失败，则错误埋点上报
	            window.pecker && window.pecker.bat.error({
	              message: "getCuid fail",
	              result: res
	            })
	            fallback();
	          }
	        });
	      } else {
	        window.pecker && window.pecker.bat.error({
	          message: "load KDJSBridge2 fail"
	        })
	        fallback();
	      }
	    });
	  } else {
	    fallback();
	  }
	}

	// 初始化：元数据、cookie、session 等
	Core.prototype.init = function(spma, spmb) {
	  if (arguments.length === 0) {
	    var meta = util._getMetaFromDom();
	    spma = meta.spma;
	    spmb = meta.spmb;
	  }

	  if (!spma || !spmb) {
	    return;
	  }

	  if (!util._isValidSpmValue(spma)) {
	    throw new Error(
	      "spm只允许英文、数字、中划线、下划线组成, " + spma + "不合法"
	    );
	  }

	  if (!util._isValidSpmValue(spmb)) {
	    throw new Error(
	      "spm只允许英文、数字、中划线、下划线组成, " + spmb + "不合法"
	    );
	  }

	  var visitorId = util._getCookie(COOKIE_KEY_PREFIX + "visitorid");
	  var sessionId = util._getCookie(COOKIE_KEY_PREFIX + "sessionid");
	  if (!visitorId) {
	    visitorId = generateRandomVisitorId();
	  }
	  if (!sessionId) {
	    sessionId = util._generateToken(visitorId);
	  }

	  // update the expires always
	  var cookieStoreDomain = util._getCookieStoreDomain();

	  // 存储visitorId
	  storeVisitorId(visitorId);

	  util._setCookie(COOKIE_KEY_PREFIX + "sessionid", sessionId, {
	    domain: cookieStoreDomain,
	    path: "/",
	    "max-age": 60 * 30
	  });

	  visitId = visitId || util._generateToken(visitorId);
	  // 兼容一人多店需求，buyer_id兼容新增duid字段处理
	  var buyerId = util._getCookie("duid") || util._getCookie("uid") || util._getCookie("WD_b_id") || null;
	  var sellerId = util._getCookie("sid") || util._getCookie("WD_s_id") || null;
	  pageMetaData = {
	    document_url: document.URL,
	    document_ref: REF_URL || document.referrer || null,
	    visitor_id: visitorId,
	    session_id: sessionId,
	    visit_id: visitId,
	    buyer_id: buyerId,
	    seller_id: sellerId,
	    spma: spma,
	    spmb: spmb,
	    biz_version: "vcollect94"
	  };
	};

	// 工具方法：数据上报
	Core.prototype.report = function(type, subtype, data, callback) {
	  if (typeof data !== "object" || data === null) {
	    return;
	  }
	  // 因为在当前页上报的是上一次的日志数量，若在上报打点数据之前还有其他日志上报，则会导致打点偏大
	  // 故这段时间的数量先记录，在上报打点数据之后再累加
	  // TODO  打点
	  if(constants.ENABLE_TAPPER) {
	    tapper.tap()
	  }
	  // 在请求之前更新掉visitorId
	  function updateVisitorId(args) {
	    var visitorId = args.visitorId;
	    pageMetaData.visitor_id = visitorId;
	    storeVisitorId(visitorId);
	  }

	  var self = this;
	  function handle() {
	    var meta = pageMetaData;
	    var reportData = util._extendObj({}, data, {
	      type: type,
	      subtype: subtype,
	      uuid: util._generateToken(meta.visitorid + meta.visitid),
	      report_time: +new Date()
	    });
	    self._logQueue.push(reportData);
	    if (callback) {
	      self._callbackQueue.push(callback);
	    }

	    if (self._logQueue.length >= 200) {
	      self._postData(type);
	    } else {
	      if (self.delayPostTimer === null) {
	        self.delayPostTimer = setTimeout(function() {
	          self._postData(type);
	        }, POST_DELAY);
	      }
	    }
	  }

	  if (ua.isApp && pageMetaData.visitor_id.length < 32) {
	    // 解决visitorId通过jsbridge获取
	    try {
	      getVisitorIdFromApp(function(args) {
	        !args.noFirst && updateVisitorId(args);
	        handle();
	      });
	    } catch (error) {
	      // jsbridge获取cuid若失败，则错误埋点上报
	      window.pecker && window.pecker.bat.error({
	        message: error.message,
	        errorMame: error.name
	      })

	      handle();
	    }
	  } else {
	    handle();
	  }
	};

	Core.prototype._postData = function(type) {
	  var callbackQueue = this._callbackQueue.slice(0);
	  if (callbackQueue.length) {
	    setTimeout(function() {
	      doCallbackQueue(callbackQueue, false);
	    }, 800);
	  }
	  util._post({
	    url:
	      REPORT_URL +
	      "?" +
	      util._queryStringStringify({
	        type: type,
	        spm: [pageMetaData.spma, pageMetaData.spmb].join(".")
	      }),
	    data: {
	      log: util._JSONStringifySafty({
	        meta: pageMetaData,
	        data: this._logQueue
	      })
	    },
	    success: function(res) {
	      if (res && res.status && res.status.code !== 0) {
	        doCallbackQueue(callbackQueue, false);
	        console.warn("[vcollect] 上报失败，请检查数据格式是否正确");
	      } else {
	        doCallbackQueue(callbackQueue, true);
	      }
	    },
	    error: function() {
	      doCallbackQueue(callbackQueue, false);
	    }
	  });

	  this._logQueue.length = 0;
	  this._callbackQueue.length = 0;
	  clearTimeout(this.delayPostTimer);
	  this.delayPostTimer = null;
	};

	// 工具方法：获取元数据
	Core.prototype.getMeta = function() {
	  return pageMetaData;
	};

	// 工具方法：获取上报的 URL
	Core.prototype.getReportUrl = function() {
	  return REPORT_URL;
	};

	// 工具方法：更新 referer
	Core.prototype.updateDocReferrer = function() {
	  REF_URL = location.href;
	};

	Core.prototype.onSpmChange = function(fn) {
	  bodyObserver(function(preSpmb, curSpmb) {
	    var spma = pageMetaData.spma;
	    fn({ spma: spma, spmb: preSpmb }, { spma: spma, spmb: curSpmb });
	  });
	};

	module.exports = Core;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var SdkLoader = __webpack_require__(3);

	var sha1 = __webpack_require__(6);
	var console = (function () {
	  var ret = {};
	  var noop = function () { };

	  [
	    "log",
	    "info",
	    "warn",
	    "error",
	    "assert",
	    "group",
	    "groupCollapsed",
	    "groupEnd"
	  ].forEach(function (propertyName) {
	    try {
	      ret[propertyName] = window.console[propertyName].bind(window.console);
	    } catch (e) {
	      ret[propertyName] = noop;
	    }
	  });

	  return ret;
	})();

	/**
	 * decode string with try catch
	 *
	 * @param {String} str
	 * @returns {String}
	 */
	var decodeURIComponent = function (str) {
	  var ret = "";

	  try {
	    ret = window.decodeURIComponent(str);
	  } catch (e) {
	    // URIERROR
	    console.warn(str + " 无法被 decodeURIComponent，将尝试 unescape");
	  }

	  if (ret === "") {
	    try {
	      ret = window.unescape(str);
	    } catch (e) {
	      console.warn(str + " 无法被 unescape，不进行解码");
	      ret = str;
	    }
	  }

	  return ret;
	};

	/**
	 * _getCookie(key)
	 * @param  {string}  key cookie-key-name
	 * @return {string?}        对应cookie的值，如果该值不存在，返回 null
	 */
	function _getCookie(key) {
	  var splitToken = "; ";

	  var ret = {};
	  if (document.cookie !== "") {
	    document.cookie.split(splitToken).forEach(function (entry) {
	      var arr = entry.split("=");
	      ret[decodeURIComponent(arr[0])] = decodeURIComponent(arr[1] || "");
	    });
	  }

	  return arguments.length === 0 ? ret : ret[key] || null;
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/document/cookie
	function _setCookie(key, value, options) {
	  options = options || {};

	  var arr = [];
	  arr.push(encodeURIComponent(key) + "=" + encodeURIComponent(value));
	  for (var optionKey in options) {
	    arr.push(optionKey + "=" + options[optionKey]);
	  }
	  document.cookie = arr.join("; ");
	}

	function _delCookie(key, options) {
	  var arr = [];
	  var exp = new Date();
	  exp.setTime(exp.getTime() - 1);

	  if (_getCookie(key)) {
	    arr.push(encodeURIComponent(key) + "=a");
	    for (var optionKey in options) {
	      arr.push(optionKey + "=" + options[optionKey]);
	    }
	    arr.push("max-age=" + 0);
	    document.cookie = arr.join("; ");
	  } else {
	    return;
	  }
	}

	/**
	 * _queryStringParse
	 * @param  {Querystring} querystring already encoded by encodeURIComponent
	 * @return {PlainObjectNotNested} already decoded by decodeURIComponent
	 */
	function _queryStringParse(querystring) {
	  var ret = {};

	  querystring = querystring.replace(/^\?/, "");

	  if (querystring !== "") {
	    querystring.split("&").forEach(function (entry) {
	      var arr = entry.split("=");
	      if (!arr[0]) return;
	      ret[decodeURIComponent(arr[0])] = decodeURIComponent(arr[1] || "");
	    });
	  }

	  return ret;
	}

	/**
	 * _queryStringStringify
	 * @param  {PlainObjectNotNested} query
	 * @return {Querystring}
	 */
	function _queryStringStringify(query) {
	  var arr = [];
	  var validType = ["string", "boolean", "number"];
	  for (var key in query) {
	    if (key === "") continue;
	    if (validType.indexOf(typeof query[key]) > -1) {
	      switch (query[key]) {
	        case true:
	          arr.push(encodeURIComponent(key));
	          break;
	        case false:
	          break;
	        default:
	          arr.push(
	            encodeURIComponent(key) + "=" + encodeURIComponent(query[key])
	          );
	      }
	    }
	  }
	  return arr.length === 0 ? "" : arr.join("&");
	}

	// https://developer.mozilla.org/en-US/docs/Web/API/location
	function _urlParse(url) {
	  var anchor = document.createElement("a");
	  anchor.href = url;
	  return anchor;
	}

	function _post(options) {
	  var xmlhttp = new window.XMLHttpRequest();
	  xmlhttp.onreadystatechange = function () {
	    if (4 == xmlhttp.readyState) {
	      if (200 == xmlhttp.status) {
	        var data = xmlhttp.responseText;
	        options.success(_JSONParseSafty(data));
	      } else {
	        options.error && options.error();
	      }
	    }
	  };

	  xmlhttp.open("POST", options.url, true);
	  xmlhttp.withCredentials = true;
	  if (options) {
	    if (options.timeout) {
	      xmlhttp.timeout = options.timeout;
	    }

	    xmlhttp.setRequestHeader(
	      "Content-Type",
	      "application/x-www-form-urlencoded"
	    );
	    xmlhttp.setRequestHeader("Accept", "application/json", "text/plain, */*");
	  }
	  if (!(options.data instanceof FormData)) {
	    options.data = _queryStringStringify(options.data);
	  }
	  xmlhttp.send(options.data);
	}

	function _isValidSpmValue(str) {
	  var reg = /^[a-zA-Z0-9\-\_]+$/;

	  if (String(str).match(reg) === null) {
	    return false;
	  } else {
	    return true;
	  }
	}

	function _getCookieStoreDomain(hostname) {
	  hostname = hostname || location.hostname;
	  // leadingDot here is for browser compatibility
	  var leadingDot = ".";

	  // 三级域名以下解决方案
	  var subDomains = _get2ndLevelDomain(hostname);
	  var cookieDomain = leadingDot + subDomains;

	  // 多级域名下解决方案
	  // var hostnameLayer = hostname.split(".");
	  // if (hostnameLayer.length === 2) {
	  //     cookieDomain = leadingDot + hostname;
	  // }

	  // if (hostnameLayer.length > 2) {
	  //     cookieDomain = leadingDot + hostnameLayer.slice(1).join(".");
	  // }

	  return cookieDomain;
	}

	function _is3rdPartUrl(url) {
	  var parsedUrl = _urlParse(url);
	  var linkHostname = parsedUrl.hostname;

	  return (
	    !_isEqualPartUrl(linkHostname) &&
	    !_isWDHost(linkHostname) &&
	    !_isWDMainHost(linkHostname)
	  );
	}

	function _isEqualPartUrl(linkHostname) {
	  var docHostname = location.hostname;
	  return _get2ndLevelDomain(linkHostname) === _get2ndLevelDomain(docHostname);
	}

	function _get2ndLevelDomain(hostname) {
	  return hostname
	    .split(".")
	    .slice(-2)
	    .join(".");
	}

	function _extendObj(target) {
	  var to = Object(target);
	  for (var index = 1; index < arguments.length; index++) {
	    var nextSource = arguments[index];

	    // Skip over if undefined or null
	    if (nextSource != null) {
	      for (var nextKey in nextSource) {
	        // Avoid bugs when hasOwnProperty is shadowed
	        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
	          to[nextKey] = nextSource[nextKey];
	        }
	      }
	    }
	  }
	  return to;
	}

	function _generateToken(salt, bits) {
	  salt = salt || "";
	  bits = bits || 16;

	  var now = new Date();
	  var token = sha1(now.getTime() + Math.random() + salt).slice(0, bits);

	  return token;
	}

	function _generateHash(content, bits) {
	  bits = bits || 16;

	  var hash = sha1(content).slice(0, bits);

	  return hash;
	}

	function _getLocalStorageItemSafty(key) {
	  try {
	    var item = localStorage.getItem(key);
	    return item;
	  } catch (e) {
	    console.error("localStorage 不可用");
	    return null;
	  }
	}

	function _setLocalStorageItemSafty(key, item) {
	  try {
	    localStorage.setItem(key, item);
	  } catch (e) {
	    console.error("localStorage 不可用");
	  }
	}

	function _isObjectAndNotNull(obj) {
	  if (typeof obj !== "object") return false;
	  if (obj === null) return false;
	  return true;
	}

	function _isEmptyObject(obj) {
	  console.assert(typeof obj === "object", "必须是一个object");
	  if (obj === null) return false;
	  if (Object.keys(obj).length === 0) {
	    return true;
	  } else {
	    return false;
	  }
	}

	function _JSONStringifySafty(obj) {
	  if (!_isObjectAndNotNull(obj)) return "";
	  if (_isEmptyObject(obj)) return "";
	  try {
	    return JSON.stringify(obj);
	  } catch (e) {
	    // console.warn("非法JSON对象，无法进行 JSON.stringify");
	    return "";
	  }
	}

	// always return a non-null object
	function _JSONParseSafty(str) {
	  // JSON.parse may throw error, return primitive, return null
	  try {
	    var val = JSON.parse(str);
	    if (typeof val === "object" && val !== null) {
	      return val;
	    } else {
	      return {};
	    }
	  } catch (err) {
	    // console.warn("非法JSON字符串，无法进行 JSON.parse");
	    return {};
	  }
	}

	function _closestElementUntilBody(startElement, matcher) {
	  var target = startElement;
	  while (target !== null) {
	    if (target === document.body) return null;
	    if (target === document.documentElement) return null;
	    if (matcher(target)) return target;

	    target = target.parentNode;
	  }

	  // elem.parentNode may return null
	  // @see http://devdocs.io/dom/node/parentnode
	  return null;
	}

	// var camelizeRE = /-(\w)/g;
	// function _camelize(str) {
	//     return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ""; });
	// }

	function _isOpenMultiDomain(key) {
	  var listStr = document.body.dataset.vcollectMultidomain;
	  var list = listStr ? listStr.split(",") : (typeof listStr !== undefined) ? ['pathtracker'] : []
	  // return document.body.getAttribute('data-vcollect-multidomain') !== null;
	  return key ? list.indexOf(key) > -1 : !!list.length
	}

	function _listCustomPlugin() {
	  // var currentScript = document.currentScript || document.querySelector("[data-vcollect-plugin]");
	  // var plugins = currentScript && currentScript.dataset.vcollectPlugin;
	  // var currentScript = document.currentScript || document.querySelector("[data-vcollect-plugin]");
	  var plugins = document.body.dataset.vcollectPlugin;
	  return plugins ? plugins.split(",") : [];
	}

	// 获取禁用的 body设置的 disabled 属性
	function _listDisabledAuto() {
	  // var currentScript = document.currentScript || document.querySelector("[data-vcollect-disabled]");
	  // var disabled = currentScript && currentScript.dataset.vcollectDisabled;

	  // var currentScript = document.currentScript || document.querySelector("[data-vcollect-disabled]");
	  var disabled = document.body.dataset.vcollectDisabled;
	  var formatted = [];
	  if (disabled) {
	    var disabledArray = disabled.split(",");

	    if (disabledArray && disabledArray.length) {
	      for (var i = 0, len = disabledArray.length; i < len; i++) {
	        formatted.push(
	          disabledArray[i].replace(/^\s*/g, "").replace(/\s*/g, "")
	        );
	      }
	    }
	  }

	  return formatted;
	}

	function _getNetwork(callback) {
	  if (typeof SdkLoader !== "function") {
	    console.warn("请引入 v-components/sdk-loader，用于获取网络状态!");
	    return callback(null);
	  }

	  SdkLoader().ready(function (env) {
	    if (env === "wx") {
	      if (window.wx && typeof window.wx.getNetworkType === "function") {
	        window.wx.getNetworkType({
	          success: function (res) {
	            callback(res.networkType, "wx-success");
	          },
	          fail: function () {
	            callback(null, "wx-fail");
	          }
	        });
	      } else {
	        // report test perf
	        callback(null, "in-wx-no-network");
	      }
	    } else if (env === "app" || env === "kdweidian" || env === "vbuyer") {
	      if (window.KDJSBridge2) {
	        window.KDJSBridge2.call("WDJSBridge", "getNetworkStatus", {}, function (
	          res
	        ) {
	          var maps = {
	            "2": "wifi",
	            "3": "2g",
	            "4": "3g",
	            "5": "4g"
	          };
	          if (res && res.param && res.param.network) {
	            callback(maps[res.param.network], "in-jsbridge-success");
	          } else {
	            callback(null, "in-jsbridge-fail");
	          }
	        });
	      } else {
	        callback(null, "in-app-no-jsbridge");
	      }
	    } else {
	      callback(null, "not-in-wx-jsbridge");
	    }
	  });
	}

	function _forEach(arr, callback) {
	  if (typeof arr === "object" && arr.length) {
	    for (var i = 0, len = arr.length; i < len; i++) {
	      callback(arr[i], i);
	    }
	  }
	}

	function _isWDHost(targetHost) {
	  targetHost = targetHost || location.hostname;

	  var writeList = [
	    "koudai.com",
	    "91ruyu.com",
	    "bibikan.cn",
	    "fangxin.com",
	    "youshop01.com",
	    "youshop02.com",
	    "youshop03.com",
	    "youshop04.com",
	    "youshop05.com",
	    "youshop06.com",
	    "youshop07.com",
	    "youshop08.com",
	    "youshop09.com",
	    "youshop10.com",
	    "kou6ai.cn"
	  ];

	  var isWDHost = false;

	  writeList.forEach(function (domain) {
	    if (!isWDHost && targetHost.indexOf(domain) > -1) {
	      isWDHost = true;
	    }
	  });
	  return isWDHost;
	}

	function _isWDMainHost(targetHost) {
	  return targetHost.indexOf("weidian.com") > -1;
	}

	function _normalizeReportData(data) {
	  Object.keys(data).forEach(function (key) {
	    if (data[key] === "") {
	      data[key] = null;
	      return;
	    }

	    if (_isObjectAndNotNull(data[key])) {
	      if (_isEmptyObject(data[key])) {
	        data[key] = null;
	      } else {
	        // notice, todo
	        Object.keys(data[key]).forEach(function (secondKey) {
	          var value = data[key][secondKey];
	          // if (value === "" || typeof value === "object") {
	          //   data[key][secondKey] = null;
	          // }
	          if (value === "") {
	            data[key][secondKey] = null;
	          } else if (typeof value === "object") {
	            data[key][secondKey] = JSON.stringify(value);
	          }
	        });
	      }
	    }
	  });
	  return data;
	}

	function _getMetaFromDom() {
	  var head = document.head;
	  var spma =
	    head.querySelector("meta[name='data-spider']") &&
	    head.querySelector("meta[name='data-spider']").getAttribute("content");
	  var spmaPrior =
	    head.querySelector("meta[name='data-spider-prior']") &&
	    head
	      .querySelector("meta[name='data-spider-prior']")
	      .getAttribute("content");
	  var bizVersion =
	    head.querySelector("meta[name='spider-biz-version']") &&
	    head
	      .querySelector("meta[name='spider-biz-version']")
	      .getAttribute("content");
	  var spmb =
	    document.body.getAttribute("data-spider-prior") ||
	    document.body.getAttribute("data-spider");

	  spma = spmaPrior || spma;

	  return {
	    spma: spma,
	    spmb: spmb,
	    bizVersion: bizVersion
	  };
	}

	function hasOwn(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}

	function _getSearch() {
	  return (window.location.search || "?").replace("?", "");
	}

	function versionCompare(a, b) {
	  if (a === b) {
	    return 0;
	  }
	  var a_components = a.split(".");
	  var b_components = b.split(".");
	  var len = Math.min(a_components.length, b_components.length);
	  // loop while the components are equal
	  for (var i = 0; i < len; i++) {
	    // A bigger than B
	    if (parseInt(a_components[i]) > parseInt(b_components[i])) {
	      return 1;
	    }
	    // B bigger than A
	    if (parseInt(a_components[i]) < parseInt(b_components[i])) {
	      return -1;
	    }
	  }
	  // If one's a prefix of the other, the longer one is greater.
	  if (a_components.length > b_components.length) {
	    return 1;
	  }
	  if (a_components.length < b_components.length) {
	    return -1;
	  }
	  // Otherwise they are the same.
	  return 0;
	}

	module.exports = {
	  _console: console,
	  _post: _post,
	  _getCookie: _getCookie,
	  _setCookie: _setCookie,
	  _delCookie: _delCookie,
	  _getSearch: _getSearch,
	  _queryStringStringify: _queryStringStringify,
	  _queryStringParse: _queryStringParse,
	  _isValidSpmValue: _isValidSpmValue,
	  _getCookieStoreDomain: _getCookieStoreDomain,
	  _get2ndLevelDomain: _get2ndLevelDomain,
	  _is3rdPartUrl: _is3rdPartUrl,
	  _extendObj: _extendObj,
	  _generateToken: _generateToken,
	  _generateHash: _generateHash,
	  _sha1: sha1,
	  _getLocalStorageItemSafty: _getLocalStorageItemSafty,
	  _setLocalStorageItemSafty: _setLocalStorageItemSafty,
	  _JSONParseSafty: _JSONParseSafty,
	  _JSONStringifySafty: _JSONStringifySafty,
	  _urlParse: _urlParse,
	  _isObjectAndNotNull: _isObjectAndNotNull,
	  _isEmptyObject: _isEmptyObject,
	  _listCustomPlugin: _listCustomPlugin,
	  _listDisabledAuto: _listDisabledAuto,
	  _isOpenMultiDomain: _isOpenMultiDomain,
	  _getNetwork: _getNetwork,
	  _noop: function () { },
	  _hasOwn: hasOwn,
	  _forEach: _forEach,
	  _isWDHost: _isWDHost,
	  _isWDMainHost: _isWDMainHost,
	  _isEqualPartUrl: _isEqualPartUrl,
	  _normalizeReportData: _normalizeReportData,
	  _getMetaFromDom: _getMetaFromDom,
	  versionCompare: versionCompare
	};


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	!(function (factory) {
	  if (typeof module !== "undefined" && module.exports) {
	    module.exports = factory();
	  } else {
	    window.SdkLoader = factory();
	  }
	})(function () {
	  __webpack_require__(4);
	  var ua = __webpack_require__(5);
	  var PUBLIC_ID = "gh_c6feb778444d";
	  // sdkloader文件和unti文件存在循环依赖，暂时没有好办法解决。。。
	  // 获取禁用的 body设置的 disabled 属性
	  // function _listDisabledAuto() {
	  //   var disabled = document.body.dataset.vcollectDisabled;
	  //   var formatted = [];
	  //   if (disabled) {
	  //     var disabledArray = disabled.split(",");

	  //     if (disabledArray && disabledArray.length) {
	  //       for (var i = 0, len = disabledArray.length; i < len; i++) {
	  //         formatted.push(
	  //           disabledArray[i].replace(/^\s*/g, "").replace(/\s*/g, "")
	  //         );
	  //       }
	  //     }
	  //   }

	  //   return formatted;
	  // }

	  function Loader() {
	    this._init();
	    var self = this;

	    return function () {
	      return self;
	    };
	  }

	  (function () {
	    var wxSDK =
	      "//assets.geilicdn.com/v-components/cdn/jweixin/1.3.2/index.fix.min.js",
	      qqSDK =
	        "//assets.geilicdn.com/v-components/cdn/qqsdk/default/index.fix.min.js",
	      qqBrowserServer = "//jsapi.qq.com/get?api=app.share",
	      kdjsbridge2 =
	        "https://assets.geilicdn.com/v-components/jsbridge/1.0.3/index.min.js";

	    this._init = function () {
	      this.isReady = false;
	      this.callbackList = [];

	      this._env = ua.name;
	      this.errorCount = 0;
	      this._loadEnv();
	    };

	    this.reset = function (mpid) {
	      this.isReady = false;

	      this._mpid = mpid || PUBLIC_ID;
	      this.errorCount = 0;
	      this._loadEnv(true);
	      return this;
	    };

	    this.block = function () {
	      this.isReady = false;
	      this.callbackList = [];
	    };

	    this.ready = function (cb) {
	      if (this.isReady) {
	        cb(this._env);
	        return;
	      }

	      this.callbackList.push(cb);
	    };

	    this.wxApiList = [
	      "onMenuShareTimeline",
	      "onMenuShareAppMessage",
	      "onMenuShareQQ",
	      "onMenuShareQZone",
	      "hideMenuItems",
	      "showMenuItems",
	      "chooseImage",
	      "getLocalImgData",
	      "previewImage",
	      "downloadImage",
	      "openLocation",
	      "getLocation",
	      "launch3rdApp",
	      "getInstallState",
	      "uploadImage",
	      "scanQRCode"
	    ];

	    this._mpid = PUBLIC_ID;

	    this._loadEnv = function (reset) {
	      var self = this;
	      var env = self._env;

	      var sdkMap = {
	        wx: wxSDK,
	        qq: qqSDK,
	        qqbrowser: qqBrowserServer,
	        app: kdjsbridge2,
	        kdweidian: kdjsbridge2,
	        vbuyer: kdjsbridge2,
	        browser: ""
	      };

	      /**
	       * 11.2.30版本不再支持pathTracker分享，这里只禁止微信微信sdk初始化
	       * weidian app jsbridge初始化功能由于spider依赖，故不做禁止
	       */ 

	      // if (env === ua.constant.WX && typeof window.wx === "object" && _listDisabledAuto().indexOf('pathTracker') < 0) {
	      //   if (reset) {
	      //     self._initWeixinSDK(reset);
	      //   } else {
	      //     window.wx &&
	      //       window.wx.ready(function () {
	      //         self._callback();
	      //       });
	      //   }

	      //   return;
	      // }

	      if (ua.isApp && window.KDJSBridge2 !== undefined) {
	        self._callback();
	        return;
	      }

	      var sdk = sdkMap[env];

	      // 当微信环境且body标签未禁止pathtracker时，才异步加载js
	      // 11.2.30版本默认去掉微信sdk初始化
	      // if (!(env === ua.constant.WX && (_listDisabledAuto().indexOf('pathTracker') > -1))) {
	      if (env !== ua.constant.WX) {
	        this._loadJs(sdk, function () {
	          // if (env == ua.constant.WX) {
	          //   self._initWeixinSDK();
	          //   return;
	          // }
	          self._callback();
	        });
	      }

	    };

	    this._initWeixinSDK = function (reset) {
	      var hostname = location.hostname;
	      var envMatch = hostname.match(/\.(dev|daily|pre)\./);
	      var env = envMatch ? "pre." : "";
	      // var env = "";
	      // if (hostname.match(/\.(dev|daily)\./)) {
	      //   env = "daily.";
	      // } else if (hostname.match(/\.pre\./)) {
	      //   env = "pre.";
	      // }

	      var self = this,
	        url =
	          "https://thor." +
	          env +
	          "weidian.com/weixin/getjsconfig/2.0?param=" +
	          JSON.stringify({
	            url: encodeURIComponent(location.href),
	            mpid: this._mpid || PUBLIC_ID
	          });
	      self._ajax(url, function (res) {
	        if (res.status.code == 0) {
	          var args = res.result;
	          // 配置微信JS-SDK
	          window.wx &&
	            window.wx.config({
	              beta: true,
	              debug: false,
	              appId: args.appId,
	              timestamp: args.timestamp,
	              nonceStr: args.nonceStr,
	              signature: args.signature,
	              jsApiList: self.wxApiList
	            });

	          window.wx &&
	            window.wx.ready(function () {
	              self._callback();
	              // 自定义触发wxsdk加载完成事件
	              self.dispatch("wxJsbridgeLoad", { reset: !!reset });
	            });

	          window.wx &&
	            window.wx.error(function () {
	              self.dispatch("wxJsbridgeLoad", false);
	            });
	        } else {
	          self.dispatch("wxJsbridgeLoad", false);
	        }
	      });
	    };

	    this.dispatch = function (event, detail) {
	      var e = new CustomEvent(event, {
	        bubbles: true,
	        cancelable: true,
	        detail: detail
	      });

	      window.dispatchEvent(e);
	    };

	    this._callback = function () {
	      var callbackList = this.callbackList;
	      var env = this._env;
	      var error = this.errorCount > 2;
	      callbackList.forEach(function (cb) {
	        cb(env, error);
	      });
	      this.callbackList = [];
	      this.isReady = true;
	    };

	    this._ajax = function (url, callback) {
	      var xhr = new XMLHttpRequest();
	      xhr.onload = function () {
	        if ((this.status >= 200 && this.status < 300) || xhr.status == 304) {
	          try {
	            callback && callback(JSON.parse(this.response));
	          } catch (e) { }
	        }
	      };
	      xhr.open("POST", url, true);
	      xhr.setRequestHeader("Accept", "application/json, text/plain, */*");
	      xhr.send();
	    };

	    this._loadJs = function (src, cb) {
	      var _this = this;
	      if (!src) {
	        cb();
	        return;
	      }

	      var script = document.createElement("script");
	      script.src = src;
	      script.crossOrigin = "anonymous";
	      script.addEventListener("load", function () {
	        cb();
	      });

	      script.addEventListener("error", function () {
	        if (_this.errorCount++ >= 2) {
	          cb();
	        } else {
	          _this._loadJs(src, cb);
	        }
	      });

	      document.getElementsByTagName("head")[0].appendChild(script);
	    };
	  }.call(Loader.prototype));

	  return new Loader();
	});


/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = (function() {
	  if (typeof window.CustomEvent === "undefined") {
	    function CustomEvent(event, params) {
	      params = params || {
	        bubbles: false,
	        cancelable: false,
	        detail: undefined
	      };

	      var evt = document.createEvent("Events");

	      var bubbles = true;

	      for (var name in params) {
	        name === "bubbles"
	          ? (bubbles = !!params[name])
	          : (evt[name] = params[name]);
	      }

	      // 默认自定义事件支持冒泡且允许被取消
	      evt.initEvent(event, bubbles, true);

	      return evt;
	    }

	    CustomEvent.prototype = window.Event.prototype;

	    window.CustomEvent = CustomEvent;
	  }
	})();


/***/ }),
/* 5 */
/***/ (function(module, exports) {

	var ua = window.navigator.userAgent;
	var constant = {
	  QQ_BROWSER: "qqbrowser",
	  WX: "wx",
	  QQ: "qq",
	  APP: "app",
	  VBUYER: "vbuyer",
	  WD: "kdweidian"
	};

	function _decideEnv() {
	  var env = "browser";
	  var version = "0.0.0";
	  var match = null;

	  if (/MQQBrowser\//i.test(ua)) {
	    env = "qqbrowser";
	  }

	  if (/MicroMessenger/i.test(ua)) {
	    env = "wx";
	  }

	  if (/QQ\/([\d\.]+)/i.test(ua)) {
	    env = "qq";
	  }

	  if (/WDAPP\(/.test(ua)) {
	    env = "app";
	  }

	  if (/WDAPP\(WDBuyer/.test(ua)) {
	    env = "vbuyer";
	    match = ua.match(/WDAPP\(WDBuyer\/([\d\.]+)/);
	  }

	  if (/WDAPP\(WD\//.test(ua)) {
	    env = "kdweidian";
	    match = ua.match(/WDAPP\(WD\/([\d\.]+)/);
	  }

	  if (match) {
	    version = match && match[1];
	  }
	  return {
	    name: env,
	    version: version,
	    constant: constant,
	    isWx: env === constant.WX,
	    isQQ: env === constant.QQ,
	    isQQBrowser: env === constant.QQ_BROWSER,
	    isVbuyer: env === constant.VBUYER,
	    isWD: env === constant.WD,
	    isApp:
	      env === constant.WD || env === constant.VBUYER || env === constant.APP
	  };
	}

	module.exports = _decideEnv();


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/*
	* https://raw.githubusercontent.com/kvz/locutus/master/src/php/strings/sha1.js 
	*/
	function sha1(str) {
	  var hash;

	  var _rotLeft = function(n, s) {
	    var t4 = (n << s) | (n >>> (32 - s));
	    return t4;
	  };

	  var _cvtHex = function(val) {
	    var str = "";
	    var i;
	    var v;

	    for (i = 7; i >= 0; i--) {
	      v = (val >>> (i * 4)) & 0x0f;
	      str += v.toString(16);
	    }
	    return str;
	  };

	  var blockstart;
	  var i, j;
	  var W = new Array(80);
	  var H0 = 0x67452301;
	  var H1 = 0xefcdab89;
	  var H2 = 0x98badcfe;
	  var H3 = 0x10325476;
	  var H4 = 0xc3d2e1f0;
	  var A, B, C, D, E;
	  var temp;

	  // utf8_encode
	  str = unescape(encodeURIComponent(str));
	  var strLen = str.length;

	  var wordArray = [];
	  for (i = 0; i < strLen - 3; i += 4) {
	    j =
	      (str.charCodeAt(i) << 24) |
	      (str.charCodeAt(i + 1) << 16) |
	      (str.charCodeAt(i + 2) << 8) |
	      str.charCodeAt(i + 3);
	    wordArray.push(j);
	  }

	  switch (strLen % 4) {
	    case 0:
	      i = 0x080000000;
	      break;
	    case 1:
	      i = (str.charCodeAt(strLen - 1) << 24) | 0x0800000;
	      break;
	    case 2:
	      i =
	        (str.charCodeAt(strLen - 2) << 24) |
	        (str.charCodeAt(strLen - 1) << 16) |
	        0x08000;
	      break;
	    case 3:
	      i =
	        (str.charCodeAt(strLen - 3) << 24) |
	        (str.charCodeAt(strLen - 2) << 16) |
	        (str.charCodeAt(strLen - 1) << 8) |
	        0x80;
	      break;
	  }

	  wordArray.push(i);

	  while (wordArray.length % 16 !== 14) {
	    wordArray.push(0);
	  }

	  wordArray.push(strLen >>> 29);
	  wordArray.push((strLen << 3) & 0x0ffffffff);

	  for (blockstart = 0; blockstart < wordArray.length; blockstart += 16) {
	    for (i = 0; i < 16; i++) {
	      W[i] = wordArray[blockstart + i];
	    }
	    for (i = 16; i <= 79; i++) {
	      W[i] = _rotLeft(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
	    }

	    A = H0;
	    B = H1;
	    C = H2;
	    D = H3;
	    E = H4;

	    for (i = 0; i <= 19; i++) {
	      temp =
	        (_rotLeft(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5a827999) &
	        0x0ffffffff;
	      E = D;
	      D = C;
	      C = _rotLeft(B, 30);
	      B = A;
	      A = temp;
	    }

	    for (i = 20; i <= 39; i++) {
	      temp =
	        (_rotLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) & 0x0ffffffff;
	      E = D;
	      D = C;
	      C = _rotLeft(B, 30);
	      B = A;
	      A = temp;
	    }

	    for (i = 40; i <= 59; i++) {
	      temp =
	        (_rotLeft(A, 5) +
	          ((B & C) | (B & D) | (C & D)) +
	          E +
	          W[i] +
	          0x8f1bbcdc) &
	        0x0ffffffff;
	      E = D;
	      D = C;
	      C = _rotLeft(B, 30);
	      B = A;
	      A = temp;
	    }

	    for (i = 60; i <= 79; i++) {
	      temp =
	        (_rotLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) & 0x0ffffffff;
	      E = D;
	      D = C;
	      C = _rotLeft(B, 30);
	      B = A;
	      A = temp;
	    }

	    H0 = (H0 + A) & 0x0ffffffff;
	    H1 = (H1 + B) & 0x0ffffffff;
	    H2 = (H2 + C) & 0x0ffffffff;
	    H3 = (H3 + D) & 0x0ffffffff;
	    H4 = (H4 + E) & 0x0ffffffff;
	  }

	  temp = _cvtHex(H0) + _cvtHex(H1) + _cvtHex(H2) + _cvtHex(H3) + _cvtHex(H4);
	  return temp.toLowerCase();
	}

	module.exports = sha1;


/***/ }),
/* 7 */
/***/ (function(module, exports) {

	// https://www.browserleaks.com/canvas#how-does-it-work
	function getCanvasFootPrint () {
	    var canvas = document.createElement("canvas");
	    canvas.width = 2000;
	    canvas.height = 200;
	    canvas.style.display = "inline";
	    var ctx = canvas.getContext("2d");

	    ctx.textBaseline = "alphabetic";

	    ctx.fillStyle = "#f60";
	    ctx.fillRect(125, 1, 62, 20);

	    ctx.fillStyle = "#069";
	    ctx.font = "11pt Arial";
	    ctx.fillText("Cwm fjordbank glyphs vext quiz, \ud83d\ude03", 2, 15);

	    ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
	    ctx.font = "18pt Arial";
	    ctx.fillText("Cwm fjordbank glyphs vext quiz, \ud83d\ude03", 4, 45);

	    return canvas.toDataURL();
	}

	module.exports = getCanvasFootPrint;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var regex_1 = __webpack_require__(9);
	var UA = navigator.userAgent.toLowerCase();
	/**
	 * 是否是移动端
	 * @returns true/false
	 */
	function isMobile() {
	    return regex_1.MOBILE_REGEXP.test(UA);
	}
	exports.isMobile = isMobile;
	/**
	 * 是否是Android系统
	 * @returns true/false
	 */
	function isAndroid() {
	    return regex_1.ANDROID_REGEXP.test(UA);
	}
	exports.isAndroid = isAndroid;
	/**
	 * 是否是iOS系统
	 * @returns true/false
	 */
	function isIOS() {
	    return regex_1.IOS_REGEXP.test(UA);
	}
	exports.isIOS = isIOS;
	/**
	 * 是否是苹果产品系列
	 * @returns true/false
	 */
	function isApple() {
	    return regex_1.APPLE_REGEXP.test(UA);
	}
	exports.isApple = isApple;
	/**
	 * 是否是iPhone
	 * @returns true/false
	 */
	function isIphone() {
	    return regex_1.IPHONE_REGEXP.test(UA);
	}
	exports.isIphone = isIphone;
	/**
	 * 是否是iPad
	 * @returns true/false
	 */
	function isIpad() {
	    return regex_1.IPAD_REGEXP.test(UA);
	}
	exports.isIpad = isIpad;
	/**
	 * 是否是QQ APP
	 * @returns true/false
	 */
	function isQQ() {
	    return regex_1.QQ_REGEXP.test(UA);
	}
	exports.isQQ = isQQ;
	/**
	 * 是否是微信
	 * @returns true/false
	 */
	function isWeiXin() {
	    return regex_1.WEI_XIN_REGEXP.test(UA) && !isWeiXinWork();
	}
	exports.isWeiXin = isWeiXin;
	/**
	 * 是否是企业微信
	 * @returns true/false
	 */
	function isWeiXinWork() {
	    return regex_1.WEI_XIN_WORK_REGEXP.test(UA);
	}
	exports.isWeiXinWork = isWeiXinWork;
	/**
	 * 是否是微博
	 * @returns true/false
	 */
	function isWeiBo() {
	    return regex_1.WEI_BO_REGEXP.test(UA);
	}
	exports.isWeiBo = isWeiBo;
	/**
	 * 是否是买家版
	 * @returns true/false
	 */
	function isWDBuyer() {
	    return regex_1.WD_BUYER_REGEXP.test(UA);
	}
	exports.isWDBuyer = isWDBuyer;
	/**
	 * 获取买家版,卖家版APP版本，返回版本号字符串，例如 5.5.1
	 * @returns 版本号。 不是买家版、卖家版就返回 undefined
	 */
	function getWDAppVersion() {
	    var version;
	    var match = UA.match(regex_1.WD_APP_VERSION_REGEXP);
	    if (match) {
	        version = match[1];
	    }
	    return version;
	}
	exports.getWDAppVersion = getWDAppVersion;
	/**
	 * 是否是卖家版
	 * @returns true/false
	 */
	function isWDSeller() {
	    return regex_1.WD_SELLER_REGEXP.test(UA);
	}
	exports.isWDSeller = isWDSeller;
	/**
	 * 判断是否在小程序环境
	 * @returns true/false
	 */
	function isMiniProgram() {
	    return (window.__wxjs_environment === 'miniprogram' ||
	        regex_1.MINI_PROGRAM_REGEXP.test(UA));
	}
	exports.isMiniProgram = isMiniProgram;
	/**
	 * 判断是否在支付宝环境
	 * @returns true/false
	 */
	function isAlipay() {
	    return regex_1.ALIPAY_REGEXP.test(UA);
	}
	exports.isAlipay = isAlipay;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// 判断Android系统的正则
	exports.ANDROID_REGEXP = /(Android)\s+([\d.]+)/i;
	// 判断iOS系统的正则
	exports.IOS_REGEXP = /\(i[^;]+;( U;)? cpu.+mac os x/i;
	// 判断移动端正则
	exports.MOBILE_REGEXP = /AppleWebKit.*Mobile.*/i;
	// 判断苹果产品系列正则
	exports.APPLE_REGEXP = /(iPhone|iPad|iPod|iOS|Mac OS X)/i;
	// 判断iPad正则
	exports.IPAD_REGEXP = /(iPad).*OS\s([\d_]+)/i;
	// 判断iPhone正则
	exports.IPHONE_REGEXP = /(iPhone\sOS)\s([\d_]+)/i;
	// 判断QQ APP正则
	exports.QQ_REGEXP = /QQ\/([\d.]+)/i;
	// 判断微信正则
	exports.WEI_XIN_REGEXP = /micromessenger/i;
	// 判断企业微信正则
	exports.WEI_XIN_WORK_REGEXP = /wxwork\/.* MicroMessenger/i;
	// 判断微博正则
	exports.WEI_BO_REGEXP = /WeiBo/i;
	// 判断买家版正则
	exports.WD_BUYER_REGEXP = /WDAPP\(WDBuyer/i;
	// 判断卖家版正则
	exports.WD_SELLER_REGEXP = /WDAPP\(WD\//i;
	// 获取买家版、买家版版本号正则
	exports.WD_APP_VERSION_REGEXP = /WDAPP\((?:wdbuyer|wd)\/([\d.]+)/i;
	// 判断支付宝正则
	exports.ALIPAY_REGEXP = /AlipayClient/i;
	// 判断miniProgram正则
	exports.MINI_PROGRAM_REGEXP = /miniProgram/i;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var lib_1 = __webpack_require__(11);
	exports.collectTapper = lib_1.CollectTapper.getInstance();
	function sendPrevPageData(metaData) {
	    try {
	        var tapData = exports.collectTapper.getTapperData();
	        if (tapData) {
	            exports.collectTapper.sendTapData(metaData, tapData);
	        }
	        exports.collectTapper.changeTapperSend();
	        exports.collectTapper.initTapperData();
	        // 在调用tackPageview之前可能会有日志上报，故加上这段时间的count
	        var lockLogCount = exports.collectTapper.getLockLogCount();
	        if (lockLogCount > 0) {
	            exports.collectTapper.tap(lockLogCount);
	            exports.collectTapper.cleanLockLog();
	        }
	    }
	    catch (_e) { }
	}
	exports.sendPrevPageData = sendPrevPageData;
	function tap(count) {
	    if (count === void 0) { count = 1; }
	    try {
	        if (exports.collectTapper.isTapperSend()) {
	            exports.collectTapper.tap(count);
	        }
	        else {
	            exports.collectTapper.addLockLogCount(count);
	        }
	    }
	    catch (_e) { }
	}
	exports.tap = tap;
	function lockLogTap(count) {
	    if (count === void 0) { count = 1; }
	    try {
	        exports.collectTapper.addLockLogCount(count);
	    }
	    catch (_e) { }
	}
	exports.lockLogTap = lockLogTap;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(12));


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(13);
	var network_1 = __webpack_require__(14);
	// TODO
	// tslint:disable-next-line: no-empty
	function noop() { }
	var CollectTapper = /** @class */ (function () {
	    function CollectTapper() {
	        this.tapperSend = false;
	        this.lockLogCount = 0;
	    }
	    CollectTapper.getInstance = function () {
	        if (!this.instance) {
	            this.instance = new CollectTapper();
	            return this.instance;
	        }
	        return this.instance;
	    };
	    CollectTapper.prototype.initTapperData = function () {
	        this.setStorageData({
	            startTime: +new Date(),
	            logCount: 0
	        });
	    };
	    CollectTapper.prototype.isTapperSend = function () {
	        return this.tapperSend;
	    };
	    CollectTapper.prototype.getLockLogCount = function () {
	        return this.lockLogCount;
	    };
	    CollectTapper.prototype.changeTapperSend = function () {
	        this.tapperSend = true;
	    };
	    CollectTapper.prototype.addLockLogCount = function (count) {
	        if (count === void 0) { count = 1; }
	        this.lockLogCount += count;
	    };
	    CollectTapper.prototype.cleanLockLog = function () {
	        this.lockLogCount = 0;
	    };
	    CollectTapper.prototype.tap = function (count) {
	        if (count === void 0) { count = 1; }
	        var oldData = this.getTapperData();
	        if (!oldData) {
	            return;
	        }
	        var startTime = oldData.startTime, logCount = oldData.logCount;
	        this.setStorageData({
	            startTime: startTime,
	            logCount: logCount + count
	        });
	    };
	    CollectTapper.prototype.getTapperData = function () {
	        return this.getStorageData();
	    };
	    CollectTapper.prototype.sendTapData = function (metaData, data) {
	        return new Promise(function (resolve, reject) {
	            network_1.request({
	                url: constants_1.TAP_URI,
	                data: {
	                    log: network_1.JsonStringfy({
	                        meta: metaData,
	                        data: [
	                            {
	                                detail: data,
	                                message: constants_1.TAPPER_MESSAGE_NAME,
	                                name: 'info',
	                                report_time: +new Date(),
	                                subtype: 'custom',
	                                type: 'log'
	                            }
	                        ]
	                    })
	                },
	                success: resolve,
	                error: reject
	            });
	        }).catch(noop);
	    };
	    CollectTapper.prototype.setStorageData = function (data) {
	        try {
	            constants_1.LOCAL_STORAGE.setItem(constants_1.STORAGE_NAME, JSON.stringify(data));
	        }
	        catch (_e) { }
	    };
	    CollectTapper.prototype.getStorageData = function () {
	        try {
	            var data = JSON.parse(constants_1.LOCAL_STORAGE.getItem(constants_1.STORAGE_NAME) || '');
	            return this.isTapperData(data) ? data : null;
	        }
	        catch (_e) {
	            return null;
	        }
	    };
	    CollectTapper.prototype.isTapperData = function (data) {
	        if (toString.call(data) !== '[object Object]') {
	            return false;
	        }
	        var startTime = data.startTime, logCount = data.logCount;
	        return typeof startTime === 'number' && typeof logCount === 'number';
	    };
	    return CollectTapper;
	}());
	exports.CollectTapper = CollectTapper;


/***/ }),
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.STORAGE_NAME = '__kernel__pecker__tapper';
	exports.GLOBAL = window;
	exports.LOCAL_STORAGE = exports.GLOBAL.localStorage;
	exports.TAP_URI_HOST = /\.(dev|daily|pre)\./.test(exports.GLOBAL.location.hostname)
	    ? 'https://logtake.daily.weidian.com'
	    : 'https://logtake.weidian.com';
	exports.TAP_API = '/h5collector/webcollect/3.0';
	exports.TAP_URI = exports.TAP_URI_HOST + exports.TAP_API;
	exports.TAPPER_MESSAGE_NAME = 'pecker_tapper_data';


/***/ }),
/* 14 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	function JsonStringfy(data) {
	    try {
	        return JSON.stringify(data);
	    }
	    catch (_e) {
	        return '';
	    }
	}
	exports.JsonStringfy = JsonStringfy;
	function queryStringStringify(query) {
	    var arr = [];
	    var validType = ['string', 'boolean', 'number'];
	    for (var key in query) {
	        if (key === '') {
	            continue;
	        }
	        if (validType.indexOf(typeof query[key]) > -1) {
	            switch (query[key]) {
	                case true:
	                    arr.push(encodeURIComponent(key));
	                    break;
	                case false:
	                    break;
	                default:
	                    arr.push(encodeURIComponent(key) +
	                        '=' +
	                        encodeURIComponent(query[key]));
	            }
	        }
	    }
	    return arr.length === 0 ? '' : arr.join('&');
	}
	function parseJson(data) {
	    try {
	        var res = JSON.parse(data);
	        if (typeof res === 'object' && res !== null) {
	            return res;
	        }
	        else {
	            return {};
	        }
	    }
	    catch (err) {
	        return {};
	    }
	}
	function request(options) {
	    var xmlhttp = new window.XMLHttpRequest();
	    xmlhttp.onreadystatechange = function () {
	        if (4 == xmlhttp.readyState) {
	            if (200 == xmlhttp.status) {
	                var data = xmlhttp.responseText;
	                options.success(parseJson(data));
	            }
	            else {
	                options.error && options.error();
	            }
	        }
	    };
	    xmlhttp.open('POST', options.url, true);
	    xmlhttp.withCredentials = true;
	    if (options) {
	        if (options.timeout) {
	            xmlhttp.timeout = options.timeout;
	        }
	        xmlhttp.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	        xmlhttp.setRequestHeader('Accept', 'application/json');
	    }
	    if (!(options.data instanceof FormData)) {
	        options.data = queryStringStringify(options.data);
	    }
	    xmlhttp.send(options.data);
	}
	exports.request = request;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var util = __webpack_require__(2);
	exports.ENABLE_TAPPER = util._listCustomPlugin().indexOf('tapper') > -1

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(17);

	module.exports = function() {
	  var tryjs = __webpack_require__(18);

	  var DATA_SPIDER = "data-spider";
	  var DATA_SPIDER_PRIOR = "data-spider-prior";

	  var body = document.body;
	  var curAttrValue;
	  var preAttrValue =
	    body.getAttribute(DATA_SPIDER_PRIOR) || body.getAttribute(DATA_SPIDER); // 初始化为当前数据

	  var callbacks = [];

	  var observer = new MutationObserver(
	    tryjs(function(mutations) {
	      mutations.forEach(function(record) {
	        if (record.type == "attributes") {
	          var attrName = record.attributeName;
	          if (attrName === DATA_SPIDER_PRIOR || attrName === DATA_SPIDER) {
	            curAttrValue =
	              body.getAttribute(DATA_SPIDER_PRIOR) ||
	              body.getAttribute(DATA_SPIDER);

	            // console.log("监听到 body 属性变化， pre: ", preAttrValue, " cur: ", curAttrValue);
	            if (curAttrValue && curAttrValue !== preAttrValue) {
	              // callback
	              for (var i = 0; i < callbacks.length; i++) {
	                callbacks[i](preAttrValue, curAttrValue);
	              }
	            }

	            preAttrValue = curAttrValue;
	          }
	        }
	      });
	    })
	  );

	  observer.observe(body, { attributes: true });

	  return function(fn) {
	    callbacks.push(fn);
	  };
	};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

	// mutationobserver-shim v0.3.2 (github.com/megawac/MutationObserver.js)
	// Authors: Graeme Yeates (github.com/megawac) 
	window.MutationObserver=window.MutationObserver||function(w){function v(a){this.i=[];this.m=a}function I(a){(function c(){var d=a.takeRecords();d.length&&a.m(d,a);a.h=setTimeout(c,v._period)})()}function p(a){var b={type:null,target:null,addedNodes:[],removedNodes:[],previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null},c;for(c in a)b[c]!==w&&a[c]!==w&&(b[c]=a[c]);return b}function J(a,b){var c=C(a,b);return function(d){var f=d.length,n;b.a&&3===a.nodeType&&
	a.nodeValue!==c.a&&d.push(new p({type:"characterData",target:a,oldValue:c.a}));b.b&&c.b&&A(d,a,c.b,b.f);if(b.c||b.g)n=K(d,a,c,b);if(n||d.length!==f)c=C(a,b)}}function L(a,b){return b.value}function M(a,b){return"style"!==b.name?b.value:a.style.cssText}function A(a,b,c,d){for(var f={},n=b.attributes,k,g,x=n.length;x--;)k=n[x],g=k.name,d&&d[g]===w||(D(b,k)!==c[g]&&a.push(p({type:"attributes",target:b,attributeName:g,oldValue:c[g],attributeNamespace:k.namespaceURI})),f[g]=!0);for(g in c)f[g]||a.push(p({target:b,
	type:"attributes",attributeName:g,oldValue:c[g]}))}function K(a,b,c,d){function f(b,c,f,k,y){var g=b.length-1;y=-~((g-y)/2);for(var h,l,e;e=b.pop();)h=f[e.j],l=k[e.l],d.c&&y&&Math.abs(e.j-e.l)>=g&&(a.push(p({type:"childList",target:c,addedNodes:[h],removedNodes:[h],nextSibling:h.nextSibling,previousSibling:h.previousSibling})),y--),d.b&&l.b&&A(a,h,l.b,d.f),d.a&&3===h.nodeType&&h.nodeValue!==l.a&&a.push(p({type:"characterData",target:h,oldValue:l.a})),d.g&&n(h,l)}function n(b,c){for(var g=b.childNodes,
	q=c.c,x=g.length,v=q?q.length:0,h,l,e,m,t,z=0,u=0,r=0;u<x||r<v;)m=g[u],t=(e=q[r])&&e.node,m===t?(d.b&&e.b&&A(a,m,e.b,d.f),d.a&&e.a!==w&&m.nodeValue!==e.a&&a.push(p({type:"characterData",target:m,oldValue:e.a})),l&&f(l,b,g,q,z),d.g&&(m.childNodes.length||e.c&&e.c.length)&&n(m,e),u++,r++):(k=!0,h||(h={},l=[]),m&&(h[e=E(m)]||(h[e]=!0,-1===(e=F(q,m,r,"node"))?d.c&&(a.push(p({type:"childList",target:b,addedNodes:[m],nextSibling:m.nextSibling,previousSibling:m.previousSibling})),z++):l.push({j:u,l:e})),
	u++),t&&t!==g[u]&&(h[e=E(t)]||(h[e]=!0,-1===(e=F(g,t,u))?d.c&&(a.push(p({type:"childList",target:c.node,removedNodes:[t],nextSibling:q[r+1],previousSibling:q[r-1]})),z--):l.push({j:e,l:r})),r++));l&&f(l,b,g,q,z)}var k;n(b,c);return k}function C(a,b){var c=!0;return function f(a){var k={node:a};!b.a||3!==a.nodeType&&8!==a.nodeType?(b.b&&c&&1===a.nodeType&&(k.b=G(a.attributes,function(c,f){if(!b.f||b.f[f.name])c[f.name]=D(a,f);return c})),c&&(b.c||b.a||b.b&&b.g)&&(k.c=N(a.childNodes,f)),c=b.g):k.a=
	a.nodeValue;return k}(a)}function E(a){try{return a.id||(a.mo_id=a.mo_id||H++)}catch(b){try{return a.nodeValue}catch(c){return H++}}}function N(a,b){for(var c=[],d=0;d<a.length;d++)c[d]=b(a[d],d,a);return c}function G(a,b){for(var c={},d=0;d<a.length;d++)c=b(c,a[d],d,a);return c}function F(a,b,c,d){for(;c<a.length;c++)if((d?a[c][d]:a[c])===b)return c;return-1}v._period=30;v.prototype={observe:function(a,b){for(var c={b:!!(b.attributes||b.attributeFilter||b.attributeOldValue),c:!!b.childList,g:!!b.subtree,
	a:!(!b.characterData&&!b.characterDataOldValue)},d=this.i,f=0;f<d.length;f++)d[f].s===a&&d.splice(f,1);b.attributeFilter&&(c.f=G(b.attributeFilter,function(a,b){a[b]=!0;return a}));d.push({s:a,o:J(a,c)});this.h||I(this)},takeRecords:function(){for(var a=[],b=this.i,c=0;c<b.length;c++)b[c].o(a);return a},disconnect:function(){this.i=[];clearTimeout(this.h);this.h=null}};var B=document.createElement("i");B.style.top=0;var D=(B="null"!=B.attributes.style.value)?L:M,H=1;return v}(void 0);
	//# sourceMappingURL=mutationobserver.map


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	module.exports = function(fn, backupFn) {
	  return function() {
	    try {
	      fn.apply(this, arguments);
	    } catch (err) {
	      console.warn("vcollect err: ", err);

	      if (!backupFn || typeof backupFn !== "function") {
	        return;
	      }

	      var args = Array.prototype.slice.call(arguments, 0);
	      args.unshift(err);

	      backupFn.apply(this, args);
	    }
	  };
	};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	// owl 用于性能监控，因为历史原因，延续 owl 的叫法

	"use strict";
	var performance = __webpack_require__(20);
	var autoComputeFirstScreen = __webpack_require__(22);

	var autoComputeFirstScreenConfig = {
	  request: {
	    excludeUrl: []
	  }
	};
	var handComputeFirstScreenConfig = {
	    request: {
	      excludeUrl: []
	    }
	};

	var afterReport = function() {};
	var showPerfResult = function(result) {
	  try {
	    console.log("[vcollect] performance info:");
	    console.log(" - report type: " + result.type);
	    console.log(" - first screen time: ", result.firstScreenTime, "ms");
	    console.log(" - details: window.vcollectPerf");
	    var lastImgDetail = result.firstScreenImagesDetail[0];

	    if (lastImgDetail) {
	      console.log(" - last-image: ", lastImgDetail);
	    }
	  } catch (err) {}
	};

	function autoCompute() {
	  // 自动上报性能数据
	  autoComputeFirstScreenConfig = autoComputeFirstScreen({
	    onReport: function(result) {
	      // 用于开发者查看详细性能信息
	      window.vcollectPerf = result;

	      if (result.success) {
	        //console.log('auto--ok')
	        performance.reportTime(result.firstScreenTimeStamp, result, "auto");
	        showPerfResult(result);
	      }

	      afterReport && afterReport(result);
	    },
	    // 所有 XHR 请求返回触发回调
	    onAllXhrResolved: function(time) {
	      performance.xhrLoad(time);
	    },

	    delayReport: 300
	  });
	}

	module.exports = {
	  perf: performance,
	  onReport: function(callback) {
	    if (callback && typeof callback === "function") {
	      afterReport = callback;
	    }
	  },
	  init: function(core, options) {
	    var _this = this;
	    performance.install.call(this.perf, core, options);

	    if (options && options.auto) {
	      autoCompute();

	      core.onSpmChange(function(pre) {
	        if (pre && pre.spmb) {
	          _this.reportPerf();
	        }
	      });
	    }
	  },
	  reportPerf: function() {
	    // 手动上报性能数据
	    autoComputeFirstScreen.report({
	      // 所有 XHR 请求返回触发回调
	      onAllXhrResolved: function(time) {
	        performance.xhrLoad(time);
	      },

	      onReport: function(result) {
	        // 用于开发者查看详细性能信息
	        window.vcollectPerf = result;
	        if (result.success) {
	          //console.log('hand--ok')
	          performance.reportTime(result.firstScreenTimeStamp, result, "hand");
	          showPerfResult(result);
	        }

	        afterReport && afterReport(result);
	      },

	        request: handComputeFirstScreenConfig.request
	    });
	  },
	  getFirstScreenInfo: function() {},
	  ignoreRequestUrl:function(urls) {
	    var i = 0;
	    var currentUrl;
	    if(urls instanceof Array){
	      for(;i<urls.length;i++){
	        currentUrl = urls[i];
	        if(typeof currentUrl === 'string'){
	            handComputeFirstScreenConfig.request.excludeUrl.push(currentUrl);
	            autoComputeFirstScreenConfig.request.excludeUrl.push(currentUrl);
	        }
	      }
	    }
	  }
	};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var util = __webpack_require__(2);

	// 一些模块级全局变量
	var perf = {};
	var win = window;
	var performance = win.performance;
	var STORAGE_NAME = "__performance__visit_history";
	var long2shortMap = __webpack_require__(21);

	var debugMode = /debug/.test(window.location.href);

	var globalFirstScreenResult = {};

	function _source2plainObject(target) {
	  var copy = {};
	  for (var key in target) {
	    var shortKey = key;
	    if (typeof target[key] == "function") continue;
	    if (typeof target[key] == "number") {
	      if (key === "navigationStart") {
	        copy[shortKey] = globalFirstScreenResult.navigationStartTimeStamp;
	      } else {
	        copy[shortKey] = Number(target[key].toFixed(3));
	      }
	    } else {
	      copy[shortKey] = target[key];
	    }
	  }
	  return copy;
	}

	// 获取开发者设置的 navigation start time
	// var globalHasSettedPerfStart;
	// 应该废弃了，待验证
	// function getSettedNavigationStartTime() {
	//   var curPerfStartTimeStamp = parseFloat(document.body.getAttribute('perf-start'));

	//   if (curPerfStartTimeStamp) {
	//     if (!globalHasSettedPerfStart) {
	//       return performance.timing.navigationStart;
	//     } else {
	//       return curPerfStartTimeStamp;
	//     }
	//   } else {
	//     return performance.timing.navigationStart;
	//   }
	// }

	function long2shortData(longData) {
	  return longData; // 后端接口暂不支持长短字段名称切换，先直接返回长字段对象

	  var shortData = {};

	  for (var longKey in longData) {
	    if (long2shortMap[longKey]) {
	      shortData[long2shortMap[longKey]] = longData[longKey];
	    } else {
	      shortData[longKey] = longData[longKey];
	    }
	  }

	  return shortData;
	}

	// 初始化各种 API
	function initUserTimingAPI(core) {
	  if (!performance) return;

	  var _originalMark = function(name) {
	    performance.mark(name);
	    var data = performance.getEntriesByName(name, "mark").pop();
	    _reportUserTiming(data);
	  };

	  var _mockMark = function(name) {
	    var data = {
	      duration: 0,
	      entryType: "mark",
	      name: name,
	      startTime: Date.now()
	    };

	    _mockMarkQueue.push(data);
	    _reportUserTiming(data);
	  };

	  var _originalMeasure = function(name, startMark, endMark) {
	    performance.measure(name, startMark, endMark);
	    var data = performance.getEntriesByName(name, "measure").pop();
	    _reportUserTiming(data);
	  };

	  var _mockMeasure = function(name, startMark, endMark) {
	    var startTime, endTime, duration;
	    var mockMarkQueue = _mockMarkQueue;

	    if (startMark === undefined) {
	      startTime = 0;
	    } else {
	      startTime = mockMarkQueue._getMarkStartTime(startMark);
	    }

	    if (endMark === undefined) {
	      endTime = Date.now();
	    } else {
	      endTime = mockMarkQueue._getMarkStartTime(endMark);
	    }

	    duration = endTime - startTime;
	    var data = {
	      duration: duration,
	      entryType: "measure",
	      name: name,
	      startTime: startTime
	    };
	    _reportUserTiming(data);
	  };

	  var _reportUserTiming = function(data) {
	    util._getNetwork(function(network) {
	      data.network = network;
	      var plainData = _source2plainObject(data);
	      core.report("performance", "userTiming", plainData);
	    });
	  };

	  var _mockMarkQueue = {
	    push: function(data) {
	      this._markCache.push(data);
	    },
	    _markCache: [],
	    _getMarkStartTime: function(name) {
	      var startTime;
	      this._markCache.forEach(function(mark) {
	        if (mark.name === name) {
	          startTime = mark.startTime;
	        }
	      });
	      return startTime;
	    }
	  };

	  // 应该废弃了，待验证
	  // function _getHighResolutionTime() {
	  //   if (typeof performance.now === "function") return performance.now();
	  //   return Date.now() - getSettedNavigationStartTime();
	  // }

	  this.mark = (function() {
	    if (typeof performance.mark === "function") {
	      return _originalMark;
	    }
	    return _mockMark;
	  })();

	  this.measure = (function() {
	    if (typeof performance.measure === "function") {
	      return _originalMeasure;
	    }
	    return _mockMeasure;
	  })();
	}

	// 运行主要函数（巨型函数）
	function runPerf(core) {
	  //提前定义接口函数，规避兼容性问题
	  this.recordFirstScreen = function() {};
	  this.docRetrieveStart = function() {};
	  this.docRetrieveEnd = function() {};
	  this.onRecord = false;

	  if (!performance || performance.timing == undefined) return;

	  var _perfQueue = {
	    _firstScreenLoadStart: 0,
	    _firstScreenLoadEnd: 0,
	    _resourceTiming: [],
	    _pageTiming: null,
	    reportData: function(firstScreenResult) {
	      var self = this;

	      if (!firstScreenResult.success) {
	        return;
	      }

	      util._getNetwork(function(network) {
	        var counts = {
	          xhrCounts: 0,
	          cssCounts: 0,
	          imgCounts: 0,
	          jsCounts: 0,
	          fontCounts: 0,
	          unknown: 0,
	          resourceCounts: 0
	        };

	        var formateRequestUrl = function(url) {
	          if (url) {
	            return (url = url
	              .replace(/^http(s)?:/, "")
	              .replace(/^\/\//, "")
	              .replace(/\?[\w\W]*/, ""));
	          } else {
	            return url;
	          }
	        };

	        var matchRequest = function(url, requests) {
	          for (var i = 0, len = requests.length; i < len; i++) {
	            if (formateRequestUrl(requests[i].src) == formateRequestUrl(url)) {
	              return true;
	            }
	          }

	          return false;
	        };

	        var filterResourceAndReport = function(resource) {
	          // 在 navigationStart 之前开始加载的资源不再统计
	          if (resource.startTime < firstScreenResult.navigationStartTime) {
	            return;
	          }

	          var copiedResource = _source2plainObject(resource);

	          // 首屏时间之后再发出的资源请求不再统计
	          if (
	            copiedResource.startTime &&
	            parseInt(copiedResource.startTime) >
	              parseInt(firstScreenResult.firstScreenTime)
	          ) {
	            return;
	          }

	          var resourceUrl = copiedResource.name;
	          // var firstScreenImgs = firstScreenResult.firstScreenImages;

	          var cssReg = /\.((css$)|(css\?)|(css#))/;
	          var jsReg = /\.((js$)|(js\?)|(js#))/;
	          var fontReg = /\.(ttf|woff)$/;
	          var imgReg = /(\.)(png|jpg|jpeg|gif|webp)($|#|\?)/;

	          if (imgReg.test(resourceUrl)) {
	            // if (firstScreenImgs.indexOf(resourceUrl) > -1) {
	            counts.imgCounts++;
	            copiedResource.initiatorType = "img";
	            // 只记录 首屏内的图片
	          } else if (
	            matchRequest(resourceUrl, firstScreenResult.requests) ||
	            /callback=jsonp/i.test(resourceUrl)
	          ) {
	            // 只记录 首屏内的请求
	            counts.xhrCounts++;
	            copiedResource.initiatorType = "xhr";
	          } else if (cssReg.test(resourceUrl)) {
	            // css 文件
	            counts.cssCounts++;
	            copiedResource.initiatorType = "css";
	          } else if (jsReg.test(resourceUrl)) {
	            // js 文件
	            counts.jsCounts++;
	            copiedResource.initiatorType = "script";
	          } else if (fontReg.test(resourceUrl)) {
	            // 未识别的资源记为 unknown
	            counts.fontCounts++;
	            copiedResource.initiatorType = "font";
	          } else {
	            counts.unknown++;
	            copiedResource.initiatorType = "unknown";
	          }

	          counts.resourceCounts++;

	          copiedResource.network = network;
	          core.report(
	            "performance",
	            "resourceTiming",
	            long2shortData(copiedResource)
	          );
	        };

	        // 处理 resourceTiming 样本对象，用于上报自定义数据时生成对象模板
	        self._resourceTiming.forEach(function(resource) {
	          filterResourceAndReport(resource);
	        });

	        // 上报的数据模板
	        var reportDataTemplate = JSON.stringify({
	          network: null,
	          initiatorType: "vcollect-perf",
	          nextHopProtocol: "http/1.1",
	          workerStart: 0,
	          redirectStart: 0,
	          redirectEnd: 0,
	          fetchStart: 0,
	          domainLookupStart: 0,
	          domainLookupEnd: 0,
	          connectStart: 0,
	          connectEnd: 0,
	          secureConnectionStart: 0,
	          requestStart: 0,
	          responseStart: 0,
	          responseEnd: 0,
	          transferSize: 0,
	          encodedBodySize: 0,
	          decodedBodySize: 0,
	          serverTiming: [],
	          name: "",
	          entryType: "resource",
	          startTime: 0,
	          duration: 0
	        });

	        // 从性能监控结果中取出一部分内容上报 （上报到 name 字段），便于后续分析
	        var _getDetails = function() {
	          var details = {};
	          var maxNum = 12;

	          for (var key in firstScreenResult) {
	            if (
	              !/^((firstScreenImages)|(firstScreenImagesDetail)|(network)|(firstScreenTimeStamp)|(requests)|(navigationStartTimeStamp))$/.test(
	                key
	              )
	            ) {
	              details[key] = firstScreenResult[key];
	            }
	          }

	          // 自定义 firstScreenImages
	          if (firstScreenResult.firstScreenImagesDetail) {
	            details.imgDetail = firstScreenResult.firstScreenImagesDetail.slice(
	              0,
	              maxNum
	            );
	            if (firstScreenResult.firstScreenImagesDetail.length > maxNum) {
	              details.imgDetail.push("...");
	            }
	          }

	          return details;
	        };

	        // 上传更多性能监控信息
	        var reportMoreInfo = function() {
	          var reportObj = JSON.parse(reportDataTemplate);
	          var details = _getDetails();

	          reportObj.initiatorType = "vcollect-perf";

	          if (debugMode) {
	            console.log("上报的自定义性能字段：", details);
	          }

	          reportObj.name = JSON.stringify(details);

	          core.report(
	            "performance",
	            "resourceTiming",
	            long2shortData(reportObj)
	          );

	          // todo report spider test data
	        };

	        try {
	          reportMoreInfo();
	        } catch (err) {
	          if (debugMode) {
	            console.log("error in reportMoreInfo: ", err);
	          }
	        }

	        // 如果有性能数据（不等于 -1），则上报，否则不上报
	        if (firstScreenResult.success) {
	          // 处理 pageTiming
	          var pageTiming = self._pageTiming;

	          for (var countsKey in counts) {
	            pageTiming[countsKey] = counts[countsKey];
	          }

	          pageTiming.firstScreenLoadStart = self._firstScreenLoadStart;
	          pageTiming.firstScreenLoadEnd = self._firstScreenLoadEnd;
	          pageTiming.network = network;
	          pageTiming.firstScreen = firstScreenResult.firstScreenTime; // 上报性能数据时运行

	          var plainData = _source2plainObject(pageTiming);

	          // 上报首次二次数据
	          var type = _determineVisitType() === 0 ? "first" : "second";
	          core.report("performance", "pageTiming_" + type, plainData);
	        }
	      });
	    }
	  };

	  // 上报性能数据
	  this.reportTime = function _reportTime(time, firstScreenResult, reportType) {
	    var pageTiming = performance.timing;

	    globalFirstScreenResult = firstScreenResult;

	    pageTiming.name = "document";
	    pageTiming.entryType = "navigation";
	    pageTiming.startTime = 0;
	    pageTiming.duration = globalFirstScreenResult.firstScreenTime;
	    _perfQueue._firstScreenLoadEnd = time;
	    _perfQueue._pageTiming = pageTiming;

	    _setResourceTiming();

	    _perfQueue.reportData(firstScreenResult, reportType);
	  };

	  this.xhrLoad = function _xhrLoad(time) {
	    _perfQueue._firstScreenLoadStart = time;
	  };

	  function _setResourceTiming() {
	    if (typeof performance.getEntries === "function") {
	      var resource = performance.getEntriesByType("resource");
	      _perfQueue._resourceTiming = resource;
	    }
	  }

	  function _determineVisitType() {
	    var historyViewList = util._getLocalStorageItemSafty(STORAGE_NAME);
	    var pageMeta = core.getMeta();
	    var curSpm = [pageMeta.spma, pageMeta.spmb].join(".");
	    var index = -1;

	    var getSourceArray = function() {
	      var arr = [];

	      var scripts = [].slice.call(document.getElementsByTagName("script"), 0);
	      var links = [].slice.call(document.getElementsByTagName("link"), 0);

	      var i;
	      var len;
	      var attr;

	      var formateUrl = function(url) {
	        if (url) {
	          return (url = url.replace(/^http(s)?:/, "").replace(/^\/\//, ""));
	        } else {
	          return url;
	        }
	      };

	      for (i = 0, len = scripts.length; i < len; i++) {
	        attr = scripts[i].getAttribute("src");
	        if (attr && /\.js/.test(attr)) {
	          arr.push(formateUrl(attr));
	        }
	      }

	      for (i = 0, len = links.length; i < len; i++) {
	        attr = links[i].getAttribute("href");
	        if (attr && /\.css/.test(attr)) {
	          arr.push(formateUrl(attr));
	        }
	      }

	      return arr;
	    };

	    // 解析 LS 存储的值
	    var parseLS = function(preValue) {
	      var value = [];
	      try {
	        value = JSON.parse(preValue);
	      } catch (err) {}

	      if (Object.prototype.toString.call(value) !== "[object Array]") {
	        value = [];
	      }

	      return value;
	    };

	    // 页面上 script 和 link 的资源链接数组
	    var sourceArray = getSourceArray();
	    sourceArray.sort();

	    var md5SourceArray = util._generateHash(sourceArray.join(","));
	    historyViewList = historyViewList ? historyViewList.split("|") : [];
	    var secondTimeVisit = historyViewList.some(function(record, i) {
	      record = util._JSONParseSafty(record);
	      if (record.spm === curSpm) {
	        index = i;

	        var prevSourceArray = null;

	        // 兼容处理，以前 record.v 存储的是数组
	        if (/\[/.test(record.v)) {
	          prevSourceArray = parseLS(record.v);
	        }

	        var md5PreSourceArray = prevSourceArray
	          ? util._generateHash(prevSourceArray.join(","))
	          : record.v;

	        // 2592000 * 1000 缓存时间
	        if (
	          md5PreSourceArray === md5SourceArray &&
	          Date.now() - record.time <= 2592000000
	        ) {
	          return true;
	        }
	        return false;
	      }
	      return false;
	    });

	    var viewList = JSON.stringify({
	      spm: curSpm,
	      time: Date.now(),
	      v: md5SourceArray
	    });
	    if (index === -1) {
	      historyViewList.splice(historyViewList.length, 0, viewList);
	    } else {
	      historyViewList.splice(index, 1, viewList);
	    }

	    util._setLocalStorageItemSafty(STORAGE_NAME, historyViewList.join("|"));
	    return secondTimeVisit ? 1 : 0;
	  }
	}

	perf.install = function(core, options) {
	  initUserTimingAPI.call(perf, core);
	  runPerf.call(perf, core);
	};

	module.exports = perf;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = {
	  initiatorType: "it",
	  nextHopProtocol: "nhp",
	  workerStart: "ws",
	  redirectStart: "rs",
	  redirectEnd: "re",
	  fetchStart: "fs",
	  domainLookupStart: "dls",
	  domainLookupEnd: "dle",
	  connectStart: "cs",
	  connectEnd: "ce",
	  secureConnectionStart: "scs",
	  requestStart: "reqs",
	  responseStart: "ress",
	  responseEnd: "rese",
	  transferSize: "ts",
	  encodedBodySize: "ebs",
	  decodedBodySize: "dbs",
	  serverTiming: "st",
	  name: "n",
	  entryType: "et",
	  startTime: "st",
	  duration: "dt"
	};


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * @description compute first screen time of one page with inaccuracy less than 250ms
	 * @author 刘远洋 https://github.com/hoperyy
	 * @date 2018/02/22
	 */
	var supportTiming = window.performance && window.performance.timing;
	var supportPerformance =
	  window.performance &&
	  window.performance.getEntries &&
	  typeof window.performance.getEntries === "function" &&
	  window.performance.getEntries() instanceof Array;

	function noop() {}
	if (supportTiming && supportPerformance) {
	  module.exports = __webpack_require__(23).auto;
	  module.exports.report = __webpack_require__(23).hand;
	} else {
	  module.exports = noop;
	  module.exports.report = noop;
	}


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	// 脚本开始运行的时间，用于各种 log 等
	var scriptStartTime = new Date().getTime();

	var win = window;
	var util = __webpack_require__(24);
	var _global = util.initGlobal();

	function generateApi() {
	  // 所有变量和函数定义在闭包环境，为了支持同时手动上报和自动上报功能
	  function runOnPageStable() {
	    // 标记稳定时刻已经找到
	    if (_global.hasStableFound) {
	      return;
	    }

	    _global.hasStableFound = true;

	    // 标记停止监听请求
	    _global.stopCatchingRequest = true;

	    // 获取当前时刻获取的首屏信息，并根据该信息获取首屏时间
	    var stableObject = recordFirstScreenInfo();

	    // 触发用户注册的回调
	    _global.onStableStatusFound(stableObject);
	  }

	  function _report(resultObj) {
	    resultObj.device = _global.device;
	    resultObj.success = true;

	    if (_global.delayReport) {
	      var timer = setTimeout(function() {
	        if (!_global.hasReported) {
	          _global.hasReported = true;
	          _global.onReport(resultObj); // 上报的内容是定时器之前的数据
	        }
	        clearTimeout(timer);
	      }, _global.delayReport);
	    } else {
	      if (!_global.hasReported) {
	        _global.hasReported = true;
	        _global.onReport(resultObj);
	      }
	    }
	  }

	  // 重操作：记录运行该方法时刻的 dom 信息，主要是 images
	  function recordFirstScreenInfo() {
	    var firstScreenImages = _getImagesInFirstScreen();
	    var firstScreenImagesDetail = [];

	    // 找到最后一个图片加载完成的时刻，作为首屏时刻
	    // 最终呈现给用户的首屏信息对象
	    var resultObj = {
	      type: "perf",
	      isStaticPage: _global.isFirstRequestSent
	        ? false
	        : /auto/.test(_global.reportDesc)
	          ? true
	          : "unknown",
	      firstScreenImages: [],
	      firstScreenImagesLength: 0,
	      firstScreenImagesDetail: firstScreenImagesDetail,
	      requests: util.transRequestDetails2Arr(_global),
	      firstScreenTime: -1, // 需要被覆盖的
	      firstScreenTimeStamp: -1, // 需要被覆盖的
	      // maxErrorTime: 0,
	      navigationStartTimeStamp: _global._originalNavStart,
	      version: util.version,
	      runtime: util.getTime() - scriptStartTime,
	      reportDesc: _global.reportDesc,
	      url: window.location.href.substring(0, 200),
	      // globalIndex: _global.globalIndex,
	      reportTimeFrom: _global.reportTimeFrom // init，后面还会被赋值
	    };

	    var processNoImages = function() {
	      if (/^hand/.test(_global.reportDesc)) {
	        resultObj.firstScreenTimeStamp = _global.handExcuteTime;
	        resultObj.firstScreenTime =
	          _global.handExcuteTime - _global._originalNavStart;

	        resultObj.reportTimeFrom = "perf-hand-from-force";
	        _report(resultObj);
	      } else {
	        util.getDomReadyTime(_global, function(domReadyTimeStamp) {
	          resultObj.firstScreenTimeStamp = domReadyTimeStamp;
	          resultObj.firstScreenTime =
	            domReadyTimeStamp - _global._originalNavStart;
	          resultObj.reportTimeFrom = "domContentLoadedEventStart";
	          _report(resultObj);
	        });
	      }
	    };

	    resultObj.firstScreenImages = firstScreenImages;
	    resultObj.firstScreenImagesLength = firstScreenImages.length;

	    if (!firstScreenImages.length) {
	      processNoImages();
	    } else {
	      util.getByOnload(
	        _global,
	        firstScreenImages,
	        function(imgOnLoadResult) {
	          resultObj.firstScreenTime = imgOnLoadResult.firstScreenTime;
	          resultObj.firstScreenTimeStamp = imgOnLoadResult.firstScreenTimeStamp;
	          resultObj.firstScreenImagesDetail =
	            imgOnLoadResult.firstScreenImagesDetail;
	          resultObj.reportTimeFrom = "perf-img-from-onload";
	          _report(resultObj);
	        },
	        function(performanceResult) {
	          resultObj.firstScreenTime = performanceResult.firstScreenTime;
	          resultObj.firstScreenTimeStamp =
	            performanceResult.firstScreenTimeStamp;
	          resultObj.firstScreenImagesDetail =
	            performanceResult.firstScreenImagesDetail;
	          resultObj.reportTimeFrom = "perf-img-from-performance";
	          _report(resultObj);
	        }
	      );
	    }

	    return resultObj;
	  }

	  function _getImagesInFirstScreen() {
	    var screenHeight = win.innerHeight;
	    var screenWidth = win.innerWidth;

	    // 写入设备信息，用于上报（这里只会执行一次）
	    _global.device.screenHeight = screenHeight;
	    _global.device.screenWidth = screenWidth;

	    var nodeIterator = util.queryAllNode(_global.ignoreTag);
	    var currentNode = nodeIterator.nextNode();
	    var imgList = [];

	    var onImgSrcFound = function(imgSrc) {
	      var parsedImg = util.parseUrl(imgSrc);
	      var protocol = parsedImg.protocol;
	      if (protocol && protocol.indexOf("http") === 0) {
	        // 去重
	        if (imgList.indexOf(parsedImg.href) === -1) {
	          imgList.push(parsedImg.href);
	        }
	      }
	    };

	    while (currentNode) {
	      var imgSrc = util.getImgSrcFromDom(currentNode);

	      if (!imgSrc) {
	        currentNode = nodeIterator.nextNode();
	        continue;
	      }

	      util.recordCurrentPos(currentNode, _global);

	      if (util.isInFirstScreen(currentNode)) {
	        onImgSrcFound(imgSrc);
	      }

	      currentNode = nodeIterator.nextNode();
	    }

	    return imgList;
	  }

	  // 插入脚本，用于获取脚本运行完成时间，这个时间用于获取当前页面是否有异步请求发出
	  function testStaticPage() {
	    util.testStaticPage(function() {
	      runOnPageStable("perf-auto-timeout");
	    }, _global);
	  }

	  function overrideRequest() {
	    util.overrideRequest(_global, function() {
	      runOnPageStable("perf-auto-request-end");
	    });
	  }

	  function monitorPageLeave() {
	    util.monitorPageLeave(function() {
	      runOnPageStable("perf-auto-page-leave");
	    }, _global);
	  }

	  function mergeUserConfig(userConfig) {
	    util.mergeUserConfig(_global, userConfig);
	  }

	  return {
	    mergeUserConfig: mergeUserConfig,
	    testStaticPage: testStaticPage,
	    overrideRequest: overrideRequest,
	    recordFirstScreenInfo: recordFirstScreenInfo,
	    runOnPageStable: runOnPageStable,
	    monitorPageLeave: monitorPageLeave,
	    global: _global
	  };
	}

	module.exports = {
	  auto: function(userConfig) {
	    var api = generateApi("auto");
	    api.global.reportDesc = "auto-perf";
	    api.mergeUserConfig(userConfig);
	    api.testStaticPage();
	    api.overrideRequest();
	    api.monitorPageLeave();
	    return api.global;
	  },
	  hand: function(userConfig) {
	    var api = generateApi("hand");
	    api.global.reportDesc = "hand-perf";
	    api.global.handExcuteTime = new Date().getTime();
	    api.mergeUserConfig(userConfig);
	    api.runOnPageStable("perf-hand");
	    return api.global;
	  }
	};


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	var MutationObserver =
	  window.MutationObserver ||
	  window.WebKitMutationObserver ||
	  window.MozMutationObserver;

	var acftGlobal = __webpack_require__(25);

	var SLICE = Array.prototype.slice;
	var imgFilter = [/(\.)(png|jpg|jpeg|gif|webp)/i]; // 匹配图片的正则表达式

	module.exports = {
	  version: "6.0.0-beta",

	  getDomReadyTime: function(_global, callback) {
	    var count = 0;
	    var handler = function() {
	      if (performance.timing.domContentLoadedEventStart != 0) {
	        callback(performance.timing.domContentLoadedEventStart);
	      }

	      if (++count >= 50 || performance.timing.domContentLoadedEventStart != 0) {
	        clearInterval(timer);
	      }
	    };
	    // 轮询获取 domComplete 的值，最多轮询 10 次
	    var timer = setInterval(handler, 500);

	    handler();
	  },
	  /* 这部分都是获取首屏图片的代码 */
	  getImgSrcFromDom: function(dom) {
	    var src;

	    if (dom.nodeName.toUpperCase() == "IMG") {
	      src = dom.getAttribute("src");
	    } else {
	      var computedStyle = window.getComputedStyle(dom);
	      var bgImg =
	        computedStyle.getPropertyValue("background-image") ||
	        computedStyle.getPropertyValue("background");

	      var match = bgImg.match(/url\(.+\)/);
	      var str = match && match[0];
	      if (str) {
	        str = str.replace(/^url\(['"]?/, "").replace(/['"]?\)$/, "");

	        if (
	          (/^http/.test(str) || /^\/\//.test(str)) &&
	          this._filteImg(str)
	        ) {
	          src = str;
	        }
	      }
	    }

	    return src;
	  },
	  _filteImg: function(src) {
	    for (var i = 0, len = imgFilter.length; i < len; i++) {
	      if (imgFilter[i].test(src)) {
	        return true;
	      }
	    }

	    return false;
	  },

	  currentPos: {
	    scrollTop: 0,
	    top: 0,
	    bottom: 0,
	    left: 0,
	    right: 0
	  },
	  recordCurrentPos: function(currentNode, _global) {
	    var boundingClientRect = currentNode.getBoundingClientRect();

	    var scrollWrapper = document.querySelector(_global.scrollWrapper);
	    var scrollTop;

	    // 优先使用加了 perf-scroll 标志的 dom 节点作为滚动容器
	    if (scrollWrapper) {
	      var scrollWrapperClientRect = scrollWrapper.getBoundingClientRect();

	      if (scrollWrapperClientRect.top < 0) {
	        scrollTop = -scrollWrapperClientRect.top;
	      } else {
	        scrollTop = 0;
	      }
	    } else {
	      scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
	    }

	    var top = boundingClientRect.top; // getBoundingClientRect 会引起重绘
	    var bottom = boundingClientRect.bottom;
	    var left = boundingClientRect.left;
	    var right = boundingClientRect.right;

	    this.currentPos.scrollTop = scrollTop;
	    this.currentPos.top = top;
	    this.currentPos.bottom = bottom;
	    this.currentPos.left = left;
	    this.currentPos.right = right;
	  },
	  isInFirstScreen: function(currentNode) {
	    // 如果已不显示（display: none），top 和 bottom 均为 0
	    if (!this.currentPos.top && !this.currentPos.bottom) {
	      return false;
	    }

	    var screenHeight = window.innerHeight;
	    var screenWidth = window.innerWidth;

	    var scrollTop = this.currentPos.scrollTop;
	    var top = this.currentPos.top;
	    var left = this.currentPos.left;
	    var right = this.currentPos.right;

	    // 如果在结构上的首屏内（上下、左右）
	    // 这边还要考虑 fix 定位的图片 todo.kjc
	    if (scrollTop + top < screenHeight && right > 0 && left < screenWidth) {
	      return true;
	    }

	    return false;
	  },
	  queryAllNode: function(ignoreTag) {
	    var _this = this;
	    var ignoredNodes = document.querySelectorAll(ignoreTag);
	    var firstScreenDom = document.querySelector("[perf-dom]") || document.body;

	    var result = document.createNodeIterator(
	      document.body,
	      NodeFilter.SHOW_ELEMENT,
	      function(node) {
	        // 判断该元素及其父元素是否是需要忽略的元素
	        if (
	          !_this._shouldIgnoreNode(node, ignoredNodes) &&
	          _this._isChild(node, firstScreenDom)
	        ) {
	          return NodeFilter.FILTER_ACCEPT;
	        }
	      },
	      false // fix:此属性在ie11浏览器环境中是必传项，表示实体引用节点的子代对于迭代器是否可见。见文档：https://developer.mozilla.org/zh-CN/docs/Web/API/Document/createNodeIterator
	    );

	    return result;
	  },
	  _shouldIgnoreNode: function(child, ignoredNodes) {
	    for (var i = 0, len = ignoredNodes.length; i < len; i++) {
	      if (this._isChild(child, ignoredNodes[i])) {
	        return true;
	      }
	    }

	    return false;
	  },
	  _isChild: function(child, parent) {
	    var isChild = false;

	    while (child) {
	      if (child === parent) {
	        isChild = true;
	        break;
	      }

	      child = child.parentNode;
	    }

	    return isChild;
	  },
	  parseUrl: function(url) {
	    var anchor = document.createElement("a");
	    anchor.href = url;
	    return anchor;
	  },

	  /* 下面是其他代码 */
	  transRequestDetails2Arr: function(_global) {
	    var requests = [];
	    var requestItem = {};

	    // 规范化 requests
	    for (var requestDetailKey in _global.requestDetails) {
	      var parsedRequestDetailKey = requestDetailKey
	        .split(">time")[0]
	        .replace(/^http(s)?:/, "")
	        .replace(/^\/\//, "");

	      requestItem = {
	        src: parsedRequestDetailKey
	      };

	      for (var requestItemkey in _global.requestDetails[requestDetailKey]) {
	        requestItem[requestItemkey] =
	          _global.requestDetails[requestDetailKey][requestItemkey];
	      }

	      requests.push(requestItem);
	    }

	    return requests;
	  },
	  initGlobal: function() {
	    return {
	      // 是否已经上报的标志
	      stopCatchingRequest: false,

	      // 是否抓取过请求的标志位
	      isFirstRequestSent: false,

	      // 可以抓取请求的时间窗口队列
	      catchRequestTimeSections: [],

	      // 设备信息，用于样本分析
	      device: {},

	      requestDetails: {},

	      ignoreTag: "[perf-ignore]",

	      scrollWrapper: "[perf-scroll]",

	      // 是否已经上报
	      hasReported: false,

	      hasStableFound: false,

	      // 描述上报类型，默认是空
	      reportDesc: "",

	      // 手动上报运行的时刻
	      handExcuteTime: 0,

	      _originalNavStart: window.performance.timing.navigationStart,

	      onReport: function() {},

	      onStableStatusFound: function() {},

	      request: {
	        limitedIn: [],
	        exclude: [/(sockjs)|(socketjs)|(socket\.io)|(logtake)/],
	          excludeUrl:[]
	      },

	      // 获取数据后，认为渲染 dom 的时长；同时也是串联请求的等待间隔
	      renderTimeAfterGettingData: 300,

	      // onload 之后延时一段时间，如果到期后仍然没有异步请求发出，则认为是纯静态页面
	      watingTimeWhenDefineStaticPage: 2000,

	      // 延时执行上报
	      delayReport: 0,

	      // 用于拦截 jsonp 请求，js url 匹配该正则时
	      jsonpFilter: /callback=jsonp/,

	      reportTimeFrom: ""
	    };
	  },

	  getTime: function() {
	    return new Date().getTime();
	  },
	  overrideRequest: function(_global, onStable) {
	    var _this = this;
	    var requestTimerStatusPool = {};

	    var hasAllReuestReturned = function() {
	      for (var key in _global.requestDetails) {
	        if (
	          _global.requestDetails[key] &&
	          _global.requestDetails[key].status !== "complete"
	        ) {
	          return false;
	        }
	      }

	      return true;
	    };

	    var isRequestTimerPoolEmpty = function() {
	      for (var key in requestTimerStatusPool) {
	        if (requestTimerStatusPool[key] !== "stopped") {
	          return false;
	        }
	      }

	      return true;
	    };

	    var shouldCatchThisRequest = function(url) {
	      // 默认抓取该请求到队列，认为其可能影响首屏
	      var shouldCatch = true;

	      if (_global.stopCatchingRequest) {
	        shouldCatch = false;
	      }

	      var sendTime = _this.getTime();

	      // 如果发送数据请求的时间点在时间窗口内，则认为该抓取该请求到队列，主要抓取串联型请求
	      for (
	        var sectionIndex = 0;
	        sectionIndex < _global.catchRequestTimeSections.length;
	        sectionIndex++
	      ) {
	        var poolItem = _global.catchRequestTimeSections[sectionIndex];
	        if (sendTime >= poolItem[0] && sendTime <= poolItem[1]) {
	          break;
	        }
	      }
	      if (
	        _global.catchRequestTimeSections.length &&
	        sectionIndex === _global.catchRequestTimeSections.length
	      ) {
	        shouldCatch = false;
	      }

	      // 如果发送请求地址不符合白名单和黑名单规则。则认为不该抓取该请求到队列
	      for (var i = 0, len = _global.request.limitedIn.length; i < len; i++) {
	        if (!_global.request.limitedIn[i].test(url)) {
	          shouldCatch = false;
	        }
	      }

	      for (i = 0, len = _global.request.exclude.length; i < len; i++) {
	        if (_global.request.exclude[i].test(url)) {
	          shouldCatch = false;
	        }
	      }

	      //可以设置被忽略的 url
	      for (i = 0, len = _global.request.excludeUrl.length; i < len; i++){
	        if(url.indexOf(_global.request.excludeUrl[i]) !== -1){
	          shouldCatch = false;
	          break;
	        }
	      }

	      /*if(!shouldCatch){
	          console.log('被忽略的URL',url)
	      }*/

	      return shouldCatch;
	    };

	    var ensureRequestDetail = function(requestKey) {
	      if (!_global.requestDetails[requestKey]) {
	        _global.requestDetails[requestKey] = {
	          status: "",
	          completeTimeStamp: "",
	          completeTime: "",
	          type: ""
	        };
	      }
	    };

	    var onRequestSend = function(url, type) {
	      if (!_global.isFirstRequestSent) {
	        _global.isFirstRequestSent = true;
	      }

	      var requestKey = url + ">time:" + _this.getTime();
	      ensureRequestDetail(requestKey);

	      _global.requestDetails[requestKey].status = "sent";
	      _global.requestDetails[requestKey].type = type;

	      requestTimerStatusPool[requestKey] = "start";

	      return {
	        requestKey: requestKey
	      };
	    };

	    var afterRequestReturn = function(requestKey) {
	      //  当前时刻
	      var returnTime = _this.getTime();

	      ensureRequestDetail(requestKey);
	      // 标记这个请求完成
	      _global.requestDetails[requestKey].status = "complete";
	      _global.requestDetails[requestKey].completeTimeStamp = returnTime;
	      _global.requestDetails[requestKey].completeTime =
	        returnTime - _global._originalNavStart;

	      // 从这个请求返回的时刻起，延续一段时间，该时间段内的请求也需要被监听
	      _global.catchRequestTimeSections.push([
	        returnTime,
	        returnTime + _global.renderTimeAfterGettingData
	      ]);

	      var renderDelayTimer = setTimeout(function() {
	        requestTimerStatusPool[requestKey] = "stopped";
	        if (hasAllReuestReturned() && isRequestTimerPoolEmpty()) {
	          _global.onAllXhrResolved(Date.now());
	          onStable();
	        }
	        clearTimeout(renderDelayTimer);
	      }, _global.renderTimeAfterGettingData);
	    };

	    var overideXhr = function(onRequestSend, afterRequestReturn) {
	      var XhrProto = XMLHttpRequest.prototype;

	      var oldOpen = XhrProto.open;
	        XhrProto.open = function(method, url) {
	          this._http = this._http || {};
	          this._http.method = method;
	          this._http.url = url;
	          return oldOpen.apply(this, [].slice.call(arguments));
	        };

	      var oldXhrSend = XhrProto.send;
	      XhrProto.send = function() {
	        if (shouldCatchThisRequest(this._http.url)) {
	          var requestKey = onRequestSend(this._http.url, "xhr").requestKey;

	          var oldReadyCallback = this.onreadystatechange;
	          this.onreadystatechange = function() {
	            if (this.readyState === 4) {
	              afterRequestReturn(requestKey);
	            }

	            if (oldReadyCallback && oldReadyCallback.apply) {
	              oldReadyCallback.apply(this, arguments);
	            }
	          };
	        }

	        return oldXhrSend.apply(this, SLICE.call(arguments));
	      };
	    };

	    var overrideFetch = function(onRequestSend, afterRequestReturn) {
	      if (window.fetch && typeof Promise === "function") {
	        // ensure Promise exists. If not, skip cathing request
	        var oldFetch = window.fetch;
	        window.fetch = function() {
	          var _this = this;
	          var args = arguments;

	          return new Promise(function(resolve, reject) {
	            var url;
	            var requestKey;

	            if (typeof args[0] === "string") {
	              url = args[0];
	            } else if (typeof args[0] === "object") {
	              // Request Object
	              url = args[0].url;
	            }

	            // when failed to get fetch url, skip report
	            if (url) {
	              // console.warn('[auto-compute-first-screen-time] no url param found in "fetch(...)"');
	              requestKey = onRequestSend(url, "fetch").requestKey;
	            }

	            oldFetch
	              .apply(_this, args)
	              .then(function(response) {
	                if (requestKey) {
	                  afterRequestReturn(requestKey);
	                }
	                resolve(response);
	              })
	              .catch(function(err) {
	                if (requestKey) {
	                  afterRequestReturn(requestKey);
	                }
	                reject(err);
	              });
	          });
	        };
	      }
	    };
	    // overide fetch first, then xhr, because fetch could be mocked by xhr
	    overrideFetch(onRequestSend, afterRequestReturn);

	    overideXhr(onRequestSend, afterRequestReturn);
	  },

	  monitorPageLeave: function(onStable, _global) {
	    // window.addEventListener("beforeunload", function() {
	    //   if (_global.hasStableFound) {
	    //     // todo
	    //   }
	    // })
	  },
	  mergeUserConfig: function(_global, userConfig) {
	    if (userConfig) {
	      for (var userConfigKey in userConfig) {
	        if (
	          [
	            "watingTimeWhenDefineStaticPage",
	            "onReport",
	            "onStableStatusFound",
	            "renderTimeAfterGettingData",
	            "onAllXhrResolved",
	            "delayReport",
	            "jsonpFilter"
	          ].indexOf(userConfigKey) !== -1
	        ) {
	          _global[userConfigKey] = userConfig[userConfigKey];
	        }
	      }

	      var requestConfig = userConfig.request || userConfig.xhr;
	      if (requestConfig) {
	        if (requestConfig.limitedIn) {
	          _global.request.limitedIn = _global.request.limitedIn.concat(
	            requestConfig.limitedIn
	          );
	        }
	        if (requestConfig.exclude) {
	          _global.request.exclude = _global.request.exclude.concat(
	            requestConfig.exclude
	          );
	        }
	        if (requestConfig.excludeUrl) {
	          _global.request.excludeUrl = _global.request.excludeUrl.concat(
	              requestConfig.excludeUrl
	          );
	        }
	      }

	      if (userConfig.img) {
	        if (
	          typeof userConfig.img === "object" &&
	          typeof userConfig.img.test === "function"
	        ) {
	          _global.img.push(userConfig.img);
	        } else {
	          console.error(
	            '[auto-compute-first-screen-time] param "img" should be type RegExp'
	          );
	        }
	      }
	    }
	  },
	  testStaticPage: function(onStable, _global) {
	    var handler = function() {
	      acftGlobal.onloadFinished = true;

	      // 如果脚本运行完毕，延时一段时间后，再判断页面是否发出异步请求，如果页面还没有发出异步请求，则认为该时刻为稳定时刻，尝试上报
	      var timer = setTimeout(function() {
	        clearTimeout(timer);

	        if (!_global.isFirstRequestSent) {
	          onStable();
	        }
	      }, _global.watingTimeWhenDefineStaticPage);
	    };

	    if (acftGlobal.onloadFinished) {
	      handler();
	    } else {
	      window.addEventListener("load", handler);
	    }
	  },
	  cycleGettingPerformaceTime: function(_global, firstScreenImages, callback) {
	    var maxFetchTimes = 50;
	    var fetchCount = 0;

	    var getPerformanceTime = function() {
	      var source = performance.getEntries();
	      var matchedLength = 0;
	      var i;
	      var len;

	      var firstScreenImagesDetail = []; // reset

	      // source 去重
	      var filteredSource = [];
	      var sourceMap = {};
	      for (i = 0, len = source.length; i < len; i++) {
	        var sourceItem = source[i];
	        var url = sourceItem.name;
	        if (!sourceMap[url]) {
	          sourceMap[url] = true;
	          filteredSource.push(sourceItem);
	        }
	      }

	      // 从 source 中找到图片加载信息
	      for (i = 0, len = filteredSource.length; i < len; i++) {
	        var sourceItem = filteredSource[i];
	        var imgUrl = sourceItem.name;
	        if (firstScreenImages.indexOf(imgUrl) !== -1) {
	          matchedLength++;

	          var responseEnd = parseInt(sourceItem.responseEnd);
	          var fetchStart = parseInt(sourceItem.fetchStart);
	          firstScreenImagesDetail.push({
	            src: imgUrl,
	            responseEnd: responseEnd < 0 ? 0 : responseEnd,
	            fetchStart: fetchStart < 0 ? 0 : fetchStart,
	            from: "performance"
	          });
	        }
	      }

	      // 倒序
	      firstScreenImagesDetail.sort(function(a, b) {
	        return b.responseEnd - a.responseEnd;
	      });

	      if (matchedLength === firstScreenImages.length) {
	        clearInterval(timer);

	        callback({
	          firstScreenTime: parseInt(firstScreenImagesDetail[0].responseEnd),
	          firstScreenTimeStamp:
	            parseInt(firstScreenImagesDetail[0].responseEnd) +
	            _global._originalNavStart,
	          firstScreenImagesDetail: firstScreenImagesDetail
	        });
	      }

	      fetchCount++;
	      if (fetchCount >= maxFetchTimes) {
	        clearInterval(timer);
	      }
	    };

	    // 轮询多次获取 performance 信息，直到 performance 信息能够展示首屏资源情况
	    var timer = setInterval(getPerformanceTime, 1000);

	    getPerformanceTime();
	  },
	  getByOnload: function(_global, firstScreenImages, callbackImg, callbackPerf) {
	    this.cycleGettingPerformaceTime(_global, firstScreenImages, function(
	      performanceResult
	    ) {
	      callbackPerf(performanceResult);
	    });
	  }
	};


/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = {
	  onloadFinished: false
	};


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	/**
	 * 如果业务方在调用上存在错误，spider通过两种方式进行通知
	 * 在必经流程中，使用 throw new Error() 抛出异常  ==> 修正为 console.warn by liuyuanyang 2018/01/27；
	 * 在边界场景中，使用 console API 与 return 特殊值的方式取消本次行为与给予提示
	 */
	var util = __webpack_require__(2);
	var spiderImpression = __webpack_require__(27);
	var spiderFix = __webpack_require__(28).default;
	var uaTool = __webpack_require__(8);
	var urlTool = __webpack_require__(29);
	var spiderDiff = __webpack_require__(35);
	var tapper = __webpack_require__(10);
	var constans = __webpack_require__(15);
	var console = util._console;
	var spider = {};
	var VERSION = "0.1.3";
	var multiDomain = __webpack_require__(180);

	var DATA_SPIDER = "data-spider";
	var DATA_SPIDER_PRIOR = "data-spider-prior";
	var DATA_SPIDER_MODE = "data-spider-mode";
	var DATA_ACTION_NAME = "data-spider-action-name";
	var DATA_ACTION_ARGS = "data-spider-action-args";
	var DATA_SPIDER_IMPRESSION = "data-spider-impression";
	var AUTO_TRACK_SPIDER = "spider-auto";

	var URL_SEARCH_PARAMS_SPM = "spider";
	var URL_SEARCH_PARAMS_ACTION = "spider_action";
	var URL_SEARCH_PARAMS_KEY = "spider_token";
	var VOID_HREF = "javascript:";

	var COOKIE_NAME_PREFIX = "__spider__" + "token" + "_";
	var cookieStoreDomain = util._getCookieStoreDomain();

	var constants = {
	  BUY_NOW: "_buyNow",
	  ADD_TO_CART: "_addToCart",
	  ADD_TO_FAVORITES: "_addToFavorites",
	  CANCEL_TO_FAVORITES: "_cancelToFavorites",
	  SHARE: "_share",
	  LIKE: "_like",
	  EXPOSE: "_expose",
	  ITEM: "_item",
	  SHOP: "_shop",
	  DOWNLOAD: "_download",
	  DEPRECATED: "_deprecated",
	  DYNAMIC: '_dynamic'
	};

	// default value should always be compliant
	var cur_spm_array = [undefined, undefined, undefined, undefined];
	var cur_page_args = {};
	var cur_action_name = "";
	var cur_action_args = {};
	var cur_elem = null;

	// var prevSpmb = "";

	cur_spm_array.toString = function () {
	  return this.join(".");
	};

	function reset() {
	  spider.trackPageview = util._noop;
	  spider.trackAction = util._noop;
	  spider.transferAction = util._noop;
	  spider.transferActionBy = util._noop;
	  spider.getClickElement = util._noop;
	  spider.extractActionFrom = util._noop;

	  spider.disableAutoReport = util._noop;
	  spider.constants = util._noop;

	  spider.getSearchParams = util._noop;
	  spider.getCookie = util._getCookie;
	  spider.VERSION = VERSION;
	}

	// 恢复出厂设置（该逻辑不会报错，用于 catch 到错误后的恢复）
	spider.reset = reset;

	spider.init = function (core) {
	  // 先初始化
	  this.reset();
	  try {
	    spiderFix.init();
	  } catch (error) {
	    console.error("error", error);
	  }
	  var storeKey = _getCurURLSearchParams()[URL_SEARCH_PARAMS_KEY];

	  var timer = null;
	  function trackPageview(pageArgs) {
	    if (!document.body.dataset.spider && !document.body.dataset.spiderPrior) {
	      return;
	    }
	    var args = arguments;
	    var argsCopy = spiderDiff.merge(true, [], [].slice.call(args));
	    clearTimeout(timer);
	    timer = setTimeout(function () {
	      // 参数可变，进行适配
	      if (args.length === 0) {
	        pageArgs = {};
	      } else {
	        pageArgs =
	          typeof args[args.length - 1] === "object"
	            ? args[args.length - 1]
	            : {};
	      }
	      var meta = core.getMeta();
	      cur_spm_array[0] = meta.spma;
	      cur_spm_array[1] = meta.spmb;
	      cur_spm_array[2] = "0";
	      cur_spm_array[3] = "0";

	      if (!cur_spm_array[0] || !cur_spm_array[1]) {
	        // 如果 a、b 位有一个不存在，则不上报
	        // console.warn("[vcollect 提示] meta & body 上必须包含 data-spider 值");
	        return;
	      }
	      var prevInfo = _restorePrevInfo();
	      var prevInfoBackUp = util._extendObj({}, prevInfo);
	      // make to a function, todo
	      if (pageArgs._page) {
	        var actionName = pageArgs._page;
	        delete pageArgs._page;
	        if (_isBuildinActionName(actionName)) {
	          // 这个判断条件很重要，非常重要，要提取成函数
	          if (prevInfo.prev_spm) {
	            prevInfo.prev_action_name = actionName;
	            prevInfo.prev_action_args = util._extendObj(
	              {},
	              pageArgs,
	              prevInfo.prev_action_args
	            );
	          }
	        } else {
	          console.error(
	            "pageArgs._page 需是内置的 actionName 值，详见 spider.contants"
	          );
	        }
	      }
	      // if prevAction still don't have actionName, default to one
	      if (!prevInfo.prev_action_name && prevInfo.prev_spm) {
	        prevInfo.prev_action_name =
	          "_jumpTo_" + cur_spm_array[0] + "." + cur_spm_array[1];
	      }

	      _sendPrevActionIfNeeded(prevInfo);

	      cur_page_args = pageArgs;
	      // always ignore developer-defined ts & wfr
	      cur_page_args.ts = +new Date();
	      cur_page_args.wfr = _getCurURLSearchParams()["wfr"];
	      if (!cur_page_args.wfr) {
	        delete cur_page_args.wfr;
	      }
	      cur_page_args.ifr = _getCurURLSearchParams()["ifr"];
	      if (!cur_page_args.ifr) {
	        delete cur_page_args.ifr;
	      }

	      // 2020.11.19 cur_page_args支持透传链接上的vc_前缀参数
	      cur_page_args = passCommonQuery(cur_page_args, _getCurURLSearchParams());

	      // make to a function like _constructPageviewReportData, todo
	      var curInfo = util._extendObj({}, prevInfo);

	      curInfo.cur_spm = cur_spm_array.toString();
	      curInfo.cur_page_args = cur_page_args;
	      // TODO 重置打点数据，上报上次的打点
	      if (constans.ENABLE_TAPPER) {
	        tapper.sendPrevPageData(core.getMeta())
	      }
	      _report("page_view", curInfo, null, function (oldData) {
	        spiderDiff.diffCheck("trackPageview", argsCopy, oldData, prevInfoBackUp);
	      });

	      clearTimeout(timer);
	    });
	  }

	  function trackAction(action, callback) {
	    var argsCopy = spiderDiff.merge(true, [], [].slice.call(arguments));

	    if (!cur_spm_array[0] || !cur_spm_array[1]) {
	      var meta = core.getMeta();
	      cur_spm_array[0] = meta.spma;
	      cur_spm_array[1] = meta.spmb;
	    }

	    if (!cur_spm_array[0] || !cur_spm_array[1]) {
	      // 如果 a、b 位有一个不存在，则不上报
	      // console.warn("[vcollect 提示] meta & body 上必须包含 data-spider 值");
	      return;
	    }

	    var success = _updateState(action);
	    if (!success) return;

	    var oldData = _constructActionReportData()

	    _report("click", oldData, callback, function (oldData) {
	      spiderDiff.diffCheck("trackAction", argsCopy, oldData);
	    });
	  }

	  function trackImpression(action, callback) {
	    var argsCopy = spiderDiff.merge(true, [], [].slice.call(arguments));

	    if (!cur_spm_array[0] || !cur_spm_array[1]) {
	      var meta = core.getMeta();
	      cur_spm_array[0] = meta.spma;
	      cur_spm_array[1] = meta.spmb;
	    }

	    if (!cur_spm_array[0] || !cur_spm_array[1]) {
	      // 如果 a、b 位有一个不存在，则不上报
	      // console.warn("[vcollect 提示] meta & body 上必须包含 data-spider 值");
	      return;
	    }

	    var success = _updateState(action);
	    if (!success) return;

	    _report("expose", _constructActionReportData(), callback, function (oldData) {
	      spiderDiff.diffCheck("trackImpression", argsCopy, oldData);
	    });
	  }

	  function _restoreDestinationUrl(url) {
	    // 2020.9.23 兼容pecker数据采集上报的策略，document对象下缓存当前新开页面的目标url
	    document.destination = url
	  }

	  function proxyTransferActionBy(fn) {
	    return function () {
	      var oldData = {};

	      var argsCopy = spiderDiff.merge(true, [], [].slice.call(arguments));

	      var url = fn.apply(this, arguments);

	      var spiderToken = spiderDiff.getSpiderTokenFrom(url);

	      var prevInfo = spiderToken && spiderDiff.getPrevInfoDataBy(spiderToken);

	      url && (oldData.url = url);

	      prevInfo && (oldData.prevInfo = prevInfo);

	      spiderDiff.diffCheckNavigation("transferActionBy", argsCopy, oldData);

	      return url;
	    }
	  }

	  //调用该方法 页面可能会跳走
	  var transferActionBy = proxyTransferActionBy(function (url, action) {
	    url = url.trim();

	    _restoreDestinationUrl(url)

	    if (_isPrivateProtocolA(url)) {
	      if (_isWebviewA(url)) {
	        var anchorElem = util._urlParse(url);
	        var queryParams = util._queryStringParse(anchorElem.search);
	        if (!queryParams.url) {
	          trackAction(action);
	          return url;
	        }

	        var redirectUrl = _assignDataToUrl(queryParams.url, action);
	        queryParams.url = redirectUrl;
	        var querystring = util._queryStringStringify(queryParams);
	        // use string replace instead of using URLUtils.toString()
	        // to preserve the original string as far as possible
	        return url.replace(/(\?|#)[\S]*$/, "") + "?" + querystring;
	      } else {
	        trackAction(action);
	        return url;
	      }
	    } else if (!_isHttpOrHttpsUrl(url)) {
	      return url;
	    } else if (util._is3rdPartUrl(url)) {
	      trackAction(action);
	      return url;
	    }

	    // 是否支持转换H5链接到小程序
	    function supportTransformUrl() {
	      var params = _getCurURLSearchParams();
	      var minip = "vc_minip";
	      return params[minip] !== "wx_zhuanzhuan";
	    }

	    // 是否为专享小程序webview
	    function isSpecialMiniProgram() {
	      var params = _getCurURLSearchParams();
	      return params["invoke"] == "thirdApp";
	    }

	    function isMiniProgramPath(path) {
	      return /^\/lib\//.test(path);
	    }

	    //如果是小程序环境
	    if (uaTool.isMiniProgram()) {
	      // 打开H5 url 才需要加 invoke
	      if (isSpecialMiniProgram() && !isMiniProgramPath(url)) {
	        // 专享小程序webview
	        url = urlTool.setQuerystring(url, {
	          invoke: "thirdApp"
	        });
	      }
	      if (supportTransformUrl()) {
	        // 支持转换H5链接到小程序
	        var entry = _resolveMiniProgramEntry(url);
	        var navigateType = 'navigateTo'
	        var shopPage = 'user'
	        var pageMap = {
	          item: {
	            url: "/lib/item/dist/pages/index/index?itemId=",
	            actionName: spider.constants.ITEM
	          },
	          user: {
	            url: "/lib/shop/dist/pages/index/index?shopId=",
	            actionName: spider.constants.SHOP
	          }
	        };

	        if (entry) {
	          if (_isElement(action)) {
	            action = extractActionFrom(action);
	          } else if (!util._isObjectAndNotNull(action)) {
	            console.error("action 必须是一个对象");
	            action = null;
	          }

	          if (action !== null) {
	            action.actionName = pageMap[entry.page].actionName;
	            trackAction(action);
	          }

	          if (isSpecialMiniProgram() && !isMiniProgramPath(url) && entry.page === shopPage) {
	            navigateType = 'switchTab'
	          }

	          window.wx &&
	            window.wx.miniProgram[navigateType]({
	              url: pageMap[entry.page].url + entry.id + "&" + entry.param
	            });
	          return VOID_HREF;
	        }
	      }
	    }
	    return _assignDataToUrl(url, action);
	  })

	  function transferAction(action) {
	    var argsCopy = spiderDiff.merge(true, [], [].slice.call(arguments));
	    
	    var success = _updateState(action);
	    if (!success) {
	      return;
	    } else {
	      core.updateDocReferrer();
	      storeKey = _storeCurInfoToCookie();

	      var prevInfo = spiderDiff.getPrevInfoDataBy(storeKey);

	      spiderDiff.diffCheckNavigation("transferAction", argsCopy, {
	        prevInfo: prevInfo
	      });
	    }
	  }

	  function getClickElement() {
	    return cur_elem;
	  }

	  /**
	   * extractActionFrom, if the input is a valid SpiderElement return action
	   * else return null.  can also be used as isSpiderElement() function
	   *
	   * @param   {HTMLElement}   spiderElement
	   * @returns {Action|null}   not completely validated, just from DOM
	   */
	  function extractActionFrom(spiderElement) {
	    if (!(_isElement(spiderElement) && _isSpiderElementLikely(spiderElement))) {
	      console.error("extractActionFrom() 应接收 spiderElement 作参数");
	      return null;
	    }

	    var dElem = spiderElement;
	    var actionName = dElem.getAttribute(DATA_ACTION_NAME) || "";

	    var actionArgs = util._JSONParseSafty(dElem.getAttribute(DATA_ACTION_ARGS));

	    var cElem = _closestElementUntilBody(dElem.parentNode, _isSpiderCElement);

	    var spmc;
	    var spmd;
	    if (cElem) {
	      spmc =
	        cElem.getAttribute(DATA_SPIDER_PRIOR) ||
	        cElem.getAttribute(DATA_SPIDER);
	      spmd = String(_getIndexOf_From(dElem, cElem) || "_");
	    } else {
	      spmc = "_";
	      spmd = String(_getIndexOfFreeBtn(dElem) || "_");
	    }

	    if (spmc === "_" && actionName === "" && _isNetworkA(dElem)) {
	      var realHref = dElem.getAttribute("href");
	      if (realHref.indexOf("#") !== 0) {
	        spmc = AUTO_TRACK_SPIDER;
	        spmd = String(_getIndexOf_UntrackA(dElem));
	      }
	    }

	    return {
	      spmc: spmc,
	      spmd: spmd,
	      actionName: actionName,
	      actionArgs: actionArgs
	    };
	  }

	  // to fix webkit highlight color, use document.body
	  document.body.addEventListener("click", _eventHandler, true);
	  function disableAutoReport() {
	    document.body.removeEventListener("click", _eventHandler, true);
	    return _eventHandler;
	  }

	  // 透传通用参数
	  function passCommonQuery(query, currentPageQuery) {
	    var PREFIX = "vc_";

	    function isCommonKey(key) {
	      return key.indexOf(PREFIX) === 0 && key.length > PREFIX.length;
	    }

	    for (var key in currentPageQuery) {
	      if (
	        util._hasOwn(currentPageQuery, key) &&
	        isCommonKey(key) &&
	        currentPageQuery[key]
	      ) {
	        query[key] = query[key] || currentPageQuery[key];
	      }
	    }
	    return query;
	  }

	  // 将数据合并到url上
	  function _assignDataToUrl(url, action) {
	    var success = _updateState(action);
	    if (!success) return url;

	    /** 
	     * 1、页面body配置了多域名切换开关且非微店买家app且非微店店长app，则跳转支持多域名替换；
	     * 2、页面未禁用私域独立域名切换（默认开启私域切换）且非微店买家版app且非微店+小程序，则跳转支持私有域名替换；
	    */
	    try {
	      if (window.multiDomainRuleMap && util._isOpenMultiDomain('spider') && !uaTool.isWDBuyer() && !uaTool.isWDSeller()) {
	        url = multiDomain.generateMultidomainUrl(url, window.multiDomainRuleMap)
	      }

	      if (window.multiDomainRuleMap && (util._listDisabledAuto().indexOf('privateDomain') < 0) && !uaTool.isWDBuyer() && !uaTool.isMiniProgram()) {
	        url = multiDomain.generatePrivateUrl(url, window.multiDomainRuleMap)
	      }
	    } catch (error) {
	      console.error(error && error.message);
	    }

	    var parsedUrl = util._urlParse(url);
	    var query = util._queryStringParse(parsedUrl.search.replace("?", ""));

	    // keep here to be compatibility with piwik-spm.js
	    // 解决跨域后 spider_token 无法传递的问题。
	    // TODO 当前页面的点击事件会在下个页面上报 故提前打点
	    if (constans.ENABLE_TAPPER) {
	      tapper.tap()
	    }
	    if (!util._isEqualPartUrl(parsedUrl.hostname)) {
	      query[URL_SEARCH_PARAMS_SPM] = cur_spm_array.toString();
	      if (cur_action_name) {
	        query[URL_SEARCH_PARAMS_ACTION] = cur_action_name;
	      }
	    } else {
	      query[URL_SEARCH_PARAMS_KEY] = _storeCurInfoToCookie();
	    }

	    var curUrlParams = _getCurURLSearchParams();
	    query.wfr = query.wfr || curUrlParams.wfr;
	    query.ifr = query.ifr || curUrlParams.ifr;
	    // share_relation 不能在当前页面生成，只能透传
	    query.share_relation = curUrlParams.share_relation;

	    // 合并参数
	    util._extendObj(query, passCommonQuery(query, curUrlParams));

	    if (!query.wfr) delete query.wfr;
	    if (!query.ifr) delete query.ifr;
	    if (!query.share_relation) delete query.share_relation;

	    var hash = parsedUrl.hash;
	    var querystring = util._queryStringStringify(query);
	    // use string replace instead of using URLUtils.toString()
	    // to preserve the original string as far as possible
	    url = url.replace(/(\?|#)[\S]*$/, "") + "?" + querystring + hash;

	    return url;
	  }

	  function _constructActionReportData() {
	    return {
	      cur_spm: cur_spm_array.toString(),
	      cur_page_args: cur_page_args,
	      cur_action_name: cur_action_name,
	      cur_action_args: cur_action_args
	    };
	  }

	  function _constructPageviewReportData(prevInfo) {
	    // todo init

	    var transformed = _replacePropertyPrefix(prevInfo, "cur_", "prev_");

	    return util._extendObj({}, transformed, {
	      cur_spm: cur_spm_array.toString(),
	      cur_page_args: cur_page_args
	    });
	  }

	  function _closestElementUntilBody(startElement, matcher) {
	    var target = startElement;
	    while (true) {
	      if (target === document.body) return null;
	      if (target === document.documentElement) return null;
	      // elem.parentNode may return null @see http://devdocs.io/dom/node/parentnode
	      if (target === null) return null;
	      if (matcher(target)) return target;

	      target = target.parentNode;
	    }
	  }

	  function _isSpiderElementLikely(elem) {
	    if (elem.hasAttribute(DATA_SPIDER) && elem.getAttribute(DATA_SPIDER) === "")
	      return true;
	    if (
	      elem.getAttribute(DATA_ACTION_NAME) ||
	      // elem.getAttribute(DATA_SPIDER_IMPRESSION) !== undefined
	      elem.hasAttribute(DATA_SPIDER_IMPRESSION)
	    )
	      return true;
	    if (_isNetworkA(elem)) return true;
	    if (_isPrivateProtocolA(elem)) return true;
	    return false;
	  }

	  function _isSpiderCElement(elem) {
	    return !!(
	      elem.getAttribute(DATA_SPIDER_PRIOR) || elem.getAttribute(DATA_SPIDER)
	    );
	  }

	  function _isElement(any) {
	    if (!util._isObjectAndNotNull(any)) return false;
	    return any.nodeType === Node.ELEMENT_NODE ? true : false;
	  }

	  /**
	   * get index of elem from spiderCElement's descendant spiderElement,
	   * index starts from 1
	   * number 0 is used to represent not finding elem in spiderCElement
	   *
	   * @param   {Element} elem
	   * @param   {Element} spiderCElement
	   * @returns {number}
	   */
	  function _getIndexOf_From(elem, spiderCElement) {
	    var MISSING_VALUE = 0;
	    var elements = _getPotentialSpiderElementFrom(spiderCElement);
	    var count = 0;

	    for (var i = 0, len = elements.length; i < len; i++) {
	      var element = elements[i];
	      if (_isSpiderElementLikely(element)) count++;
	      if (element === elem) {
	        return count;
	      }
	    }

	    return MISSING_VALUE;
	  }

	  function _getIndexOfFreeBtn(elem) {
	    var MISSING_VALUE = 0;
	    var count = 0;
	    var elements = document.querySelectorAll(
	      "[" + DATA_ACTION_NAME + "], [" + DATA_SPIDER_IMPRESSION + "]"
	    );

	    for (var i = 0; i < elements.length; i++) {
	      var cElem = _closestElementUntilBody(
	        elements[i].parentNode,
	        _isSpiderCElement
	      );
	      if (cElem === null) count++;
	      if (elem === elements[i]) return count;
	    }

	    return MISSING_VALUE;
	  }

	  function _getIndexOf_UntrackA(elem) {
	    var MISSING_VALUE = 0;
	    var elements = document.querySelectorAll("a");
	    var count = 0;

	    elements = [].filter.call(elements, function (element) {
	      var cElem = _closestElementUntilBody(
	        element.parentNode,
	        _isSpiderCElement
	      );

	      var actionName = element.getAttribute(DATA_ACTION_NAME);
	      var spmd = element.getAttribute(DATA_SPIDER);

	      // 如果 a 链接不存在 c 区块、data-spider 无值(自身非 c 区块)、不存在 actionName
	      // 则被认为是一个未显示申明的 a 元素
	      var untrack = !cElem && !actionName && !spmd;
	      return untrack;
	    });

	    for (var i = 0, len = elements.length; i < len; i++) {
	      var element = elements[i];
	      count++;
	      if (element === elem) {
	        return count;
	      }
	    }

	    return MISSING_VALUE;
	  }

	  function _getPotentialSpiderElementFrom(contextElem) {
	    return contextElem.querySelectorAll(
	      "[" +
	      DATA_SPIDER +
	      "], [" +
	      DATA_ACTION_NAME +
	      "],[" +
	      DATA_SPIDER_IMPRESSION +
	      "], a[href]"
	    );
	  }

	  function _eventHandler(e) {
	    var dElem = _closestElementUntilBody(e.target, _isSpiderElementLikely);
	    if (dElem === null) return;

	    var action = extractActionFrom(dElem);
	    if (action === null) return;

	    // structurally unvalid action should not be treated as SpiderElement
	    // should make the assert here instead of in extractActionFrom
	    if (action.spmc === "_" && action.actionName === "") {
	      return;
	    }

	    var actionMode = dElem.getAttribute(DATA_SPIDER_MODE);
	    cur_elem = dElem;
	    switch (actionMode) {
	      case "none":
	        break;
	      case "transferAction":
	        transferAction(action);
	        break;
	      case "transferActionBy":
	        var url = dElem.getAttribute("data-href");
	        if (url) {
	          dElem.setAttribute("data-href", transferActionBy(url, action));
	        }
	        break;
	      case "trackAction":
	        trackAction(action);
	        break;
	      // absent or invalid of DATA_SPIDER_MODE
	      default:
	        // if dElem itself OR it's ancestor element matches <a>[href]
	        // this will change the action mode to transferActionBy
	        // this is worthy noticing, and need to clarify
	        var aElem = _closestElementUntilBody(dElem, function (elem) {
	          return _isNetworkA(elem) || _isPrivateProtocolA(elem);
	        });

	        if (aElem) {
	          var href = transferActionBy(aElem.href, action);
	          if (href === VOID_HREF) {
	            e.preventDefault();
	          } else {
	            aElem.href = href;
	          }
	        } else {
	          trackAction(action);
	        }
	        break;
	    }
	  }

	  /**
	   *
	   * @param {Action|Element}  action
	   * @returns {boolean}   flag indicates whether it is success
	   */
	  function _updateState(action) {
	    if (_isElement(action)) {
	      action = extractActionFrom(action);
	      if (action === null) return false;
	    } else if (!util._isObjectAndNotNull(action)) {
	      console.error("action 必须是一个对象");
	      return false;
	    } else if (action.spmd === undefined) {
	      action.spmd = 1;
	    }

	    var spmc = String(action.spmc || "_");
	    var spmd = String(action.spmd || "_");

	    var actionName = String(action.actionName || "");
	    // deprecated
	    var actionType = String(action.actionType || "");
	    if (actionType) {
	      actionName = actionName || actionType;
	      console.warn("action.actionType 将废弃，请使用 action.actionName 代替");
	    }

	    if (action.actionArgs && typeof action.actionArgs !== "object") {
	      console.error("actionArgs 必须是一个 object");
	      return false;
	    }
	    var actionArgs = action.actionArgs || {};

	    if (!util._isValidSpmValue(spmc)) {
	      console.error(
	        "spm只允许英文、数字、中划线、下划线组成，" + spmc + "不合法"
	      );
	      return false;
	    }

	    if (!util._isValidSpmValue(spmd)) {
	      console.error(
	        "spm只允许英文、数字、中划线、下划线组成，" + spmd + "不合法"
	      );
	      return false;
	    }

	    if (actionName.indexOf("_") === 0 && !_isBuildinActionName(actionName)) {
	      console.error(
	        "下划线起始的 actionName 代表特定功能，禁止自定义，请查看 spider.constants 了解内置的 actionName"
	      );
	      return false;
	    }

	    if (spmc === "_" && actionName === "") {
	      console.error("spmc, actionName 不能同时为空");
	      return false;
	    }

	    if (spmc !== "_" && spmd === "_") {
	      console.error("spmc 有值时 spmd 不能同时为空");
	      return false;
	    }

	    cur_spm_array[2] = spmc;
	    cur_spm_array[3] = spmd;
	    cur_action_name = actionName;
	    cur_action_args = actionArgs;

	    return true;
	  }

	  // todo, info rename to action
	  function _storeCurInfoToCookie() {
	    // 如果a、b值不存在，则返回
	    if (!cur_spm_array[0] || !cur_spm_array[1]) {
	      return;
	    }
	    var token = util._generateToken(cur_spm_array.toString(), 4);
	    var cookieName = COOKIE_NAME_PREFIX + token;
	    var curInfo = _replacePropertyPrefix(
	      _constructActionReportData(),
	      "cur_",
	      "prev_"
	    );

	    curInfo.prev_action_args = curInfo.prev_action_args || {};
	    curInfo.prev_action_args.realVisitId = core.getMeta().visit_id;
	    util._setCookie(cookieName, util._JSONStringifySafty(curInfo), {
	      domain: cookieStoreDomain,
	      path: "/",
	      "max-age": 30
	    });

	    return token;
	  }

	  function _sendPrevActionIfNeeded(prevInfo) {
	    var spmMissingValue = "";
	    var curInfo = _replacePropertyPrefix(prevInfo, "prev_", "cur_");

	    if (curInfo["cur_spm"] === spmMissingValue) {
	      return;
	    } else {
	      _report("click", curInfo);
	      //TODO 上个页面的click日志已经计数，此处report会导致多1
	      if (constans.ENABLE_TAPPER) {
	        tapper.lockLogTap(-1)
	      }
	    }
	  }

	  function _replacePropertyPrefix(obj, matchPrefix, replacePrefix) {
	    var ret = {};

	    Object.keys(obj).forEach(function (prevName) {
	      var curName = prevName.replace(matchPrefix, replacePrefix);
	      ret[curName] = obj[prevName];
	    });

	    return ret;
	  }

	  // 取出上一页存储的埋点数据
	  function _restorePrevInfo() {
	    var prevInfoDefault = _getDefaultPrevInfo();
	    var prevInfo;
	    // 如果参数中存在storeKey，则从cookie取出，否则从url中取出
	    if (storeKey) {
	      prevInfo = _restorePrevInfoFromCookie(storeKey) || prevInfoDefault;
	    } else {
	      prevInfo = _restorePrevInfoFromURLSearchParams() || prevInfoDefault;
	    }
	    // fix: 调用transferActionBy重复种cookie的问题，原来是在有storeKey的时候清除cookie，现在是任何情况都清除
	    _delPollutedCookies();
	    return prevInfo;
	  }

	  function _getDefaultPrevInfo() {
	    return {
	      prev_spm: "",
	      prev_page_args: {},
	      prev_action_name: "",
	      prev_action_args: {}
	    };
	  }

	  function _isBuildinActionName(str) {
	    return _isBuildinActionName.validList.indexOf(str) >= 0;
	  }
	  _isBuildinActionName.validList = Object.keys(constants).map(function (key) {
	    return constants[key];
	  });

	  function _getCurURLSearchParams() {
	    var search = util._getSearch();
	    return util._queryStringParse(search);
	  }

	  function _restorePrevInfoFromURLSearchParams() {
	    var params = _getCurURLSearchParams();
	    var spm = params[URL_SEARCH_PARAMS_SPM];
	    var actionName = params[URL_SEARCH_PARAMS_ACTION];

	    // 这里也用登录相同的方式来搞

	    if (!spm) {
	      return null;
	    } else {
	      var ret = _getDefaultPrevInfo();
	      ret.prev_spm = spm;
	      ret.prev_action_name = actionName;
	      return ret;
	    }
	  }

	  function _restorePrevInfoFromCookie(key) {
	    var prevInfoStr = _getCookieAndClean(key);
	    if (prevInfoStr === null) return null;

	    return util._JSONParseSafty(prevInfoStr);
	  }

	  function _getCookieAndClean(key) {
	    var cookieName = COOKIE_NAME_PREFIX + key;
	    var val = util._getCookie(cookieName);

	    _delPollutedCookies();

	    return val;
	  }

	  function _delPollutedCookies() {
	    var cookies = util._getCookie();

	    Object.keys(cookies).forEach(function (cookieName) {
	      if (cookieName.indexOf(COOKIE_NAME_PREFIX) === 0) {
	        util._delCookie(cookieName, {
	          domain: cookieStoreDomain,
	          path: "/"
	        });
	      }
	    });
	  }

	  function getParamsString(url) {
	    var matchs;
	    return url && (matchs = url.match(/^[^\?#]*\?([^#]*)/)) && matchs[1];
	  }

	  function _resolveMiniProgramEntry(url) {
	    var itemReg = /weidian.com\/item\.html.*(item)ID=(\d+)/;
	    var shopReg = /weidian\.com\/?\?.*(user)id=(\d+)/;
	    var isItemOrShop = url.match(itemReg) || url.match(shopReg);

	    if (!isItemOrShop) {
	      return false;
	    }

	    var page = isItemOrShop[1];
	    var id = isItemOrShop[2];

	    return {
	      page: page,
	      id: id,
	      // 透传url中的所有参数
	      param: getParamsString(url)
	    };
	  }

	  function _isNetworkA(elem) {
	    var href = elem.getAttribute("href");
	    var jumpA = href && href !== "" && href.indexOf("#") !== 0;
	    if (
	      elem.nodeName === "A" &&
	      elem.protocol &&
	      elem.protocol.indexOf("http") === 0 &&
	      jumpA
	    ) {
	      return true;
	    } else {
	      return false;
	    }
	  }

	  function _isPrivateProtocolA(url) {
	    var anchorElem = util._urlParse(url);
	    return anchorElem.protocol === "weidianbuyer:";
	  }

	  function _isWebviewA(url) {
	    // var anchorElem = util._urlParse(url);
	    /**
	     * 2020-12-8
	     * 兼容bug修复
	     * 动态创建a标签的链接如果为app协议链接（例如：weidianbuyer://wdb/webview）类型
	     * 在pc端 anchorElem.hostname = ''; anchorElem.pathname='//wdb/webview';
	     * 在移动端 anchorElem.hostname= 'wdb'; anchorElem.pathname='/webview';
	    */
	    return url && url.indexOf("weidianbuyer://wdb/webview") >= 0
	    // return (
	    //   anchorElem.protocol === "weidianbuyer:" &&
	    //   // anchorElem.hostname === "wdb" &&
	    //   anchorElem.pathname.indexOf("//wdb/webview") >= 0
	    // );
	  }

	  function _isHttpOrHttpsUrl(url) {
	    var anchorElem = util._urlParse(url);
	    return _isNetworkA(anchorElem);
	  }

	  function _report(subtype, data, callback, onReportFn) {
	    var _data = util._normalizeReportData(data);

	    onReportFn && onReportFn(util._extendObj({}, _data, {
	      type: "spider",
	      subtype: subtype
	    }));

	    core.report("spider", subtype, _data, callback);
	  }

	  (function fixIOSClickBug() {
	    if (!navigator.userAgent.match(/iPhone OS [\d_]+/)) {
	      return;
	    }

	    var style = document.createElement("style");
	    style.type = "text/css";
	    style.innerHTML =
	      '\
	    [data-spider=""], \
	    [data-spider-action-type], \
	    [data-spider-action-name] {\
	        cursor: pointer; \
	    }';
	    document
	      .getElementsByTagName("head")
	      .item(0)
	      .appendChild(style);
	  })();

	  (function autoTrackPageview() {
	    function autoTrack() {
	      cur_spm_array[2] = "0";
	      cur_spm_array[3] = "0";
	      // only modify pageview time and keep other status
	      cur_page_args.ts = +new Date();

	      var curInfo = _getDefaultPrevInfo();
	      curInfo.cur_spm = cur_spm_array.toString();
	      curInfo.cur_page_args = cur_page_args;
	      // TODO 当页面后退时应该触发上报上次打点数据
	      if (constans.ENABLE_TAPPER) {
	        // 避免拿不到meta
	        try {
	          tapper.sendPrevPageData(core.getMeta());
	        } catch (_e) { }
	      }
	      _report("page_view", curInfo);
	    }

	    window.addEventListener("pageshow", function (event) {
	      if (event.persisted === true) {
	        autoTrack();
	      }
	    });

	    // must figure out when this event get called,
	    // and notice the relationship with load and pageshow
	    // window.addEventListener("visibilitychange", function() {
	    //     if (document.visibilityState === "visible") {
	    //         autoTrack();
	    //     }
	    // });
	  })();

	  spider.trackPageview = trackPageview;
	  spider.trackAction = trackAction;
	  spider.trackImpression = trackImpression;
	  spider.transferAction = transferAction;
	  spider.transferActionBy = transferActionBy
	  spider.getClickElement = getClickElement;
	  spider.extractActionFrom = extractActionFrom;

	  spider.disableAutoReport = disableAutoReport;
	  spider.constants = constants;

	  spider.getSearchParams = _getCurURLSearchParams;

	  // 空方法，用于兼容旧式写法 spider.impression.observe
	  spider.impression = {
	    observe: function () { }
	  };

	  var plugins = util._listCustomPlugin();
	  if (plugins.indexOf("impression") > -1) {
	    spiderImpression.init(spider);
	  }

	  // 为 可视化埋点 准备
	  /* istanbul ignore next */
	  function loadVisualScript() {
	    function _loadScript(url, callback) {
	      var script = document.createElement("script");
	      script.src = url;

	      document.head && document.head.appendChild(script);
	      script.onload = function () {
	        callback && callback();
	      };
	    }

	    function _rewriteTrackPageview() {
	      // var spider = spider;
	      var trackPageview = spider.trackPageview;

	      spider.trackPageview = function () {
	        trackPageview.apply(this, [].slice.call(arguments));
	        setTimeout(function () {
	          window.spider_visual.init(cur_spm_array.toString(), cur_page_args);
	        });
	      };

	      if (cur_spm_array[0] !== undefined) {
	        window.spider_visual.init(cur_spm_array.toString(), cur_page_args);
	      }
	    }

	    if (window !== window.top && window.name.indexOf("visual-window:") === 0) {
	      var reg = /^visual-window:([\S\s]+)$/;
	      var whiteList = [
	        "assets.geilicdn.com",
	        "assets.pre.geilicdn.com",
	        "assets.daily.geilicdn.com",
	        "h5.dev.weidian.com"
	      ];

	      var urls = window.name.match(reg)[1];
	      var urlArr = urls.split("|");
	      var scriptCounts = urlArr.length;
	      var loadedScript = 0;
	      urlArr.forEach(function (url) {
	        var anchorElem = util._urlParse(url);

	        if (
	          !_isNetworkA(anchorElem) ||
	          whiteList.indexOf(anchorElem.hostname) < 0
	        ) {
	          return;
	        }

	        _loadScript(url, function () {
	          if (++loadedScript === scriptCounts) {
	            _rewriteTrackPageview();
	          }
	        });
	      });
	    }
	  }

	  /**
	   * 因为 trackPageview 使用了 setTimeout
	   * 在可视化埋点脚本存在浏览器缓存的时候, 无法执行到任何逻辑中完成可视化埋点的初始化
	   * 因此延后执行, 如果要删除, 优先解决上方 trackPageview 的延时问题
	   */

	  /* istanbul ignore next */
	  setTimeout(function () {
	    loadVisualScript();
	  });
	};
	module.exports = spider;


/***/ }),
/* 27 */
/***/ (function(module, exports) {

	var spiderImpression = {};

	spiderImpression.init = function(spider) {
	  var win = window;
	  var doc = document;
	  var ATTR_IMPRESSION = "data-spider-impression";
	  var viewport = {
	    container: win,
	    height: win.innerHeight,
	    scrollHandler: _debounce(_calAndReportImpression, 500),
	    resizeHandler: function() {
	      viewport.height = win.innerHeight;
	      viewport.scrollHandler();
	    }
	  };

	  function observe() {
	    if (spider.impression && !spider.impression.ALREADY_EXEC) {
	      spider.impression.ALREADY_EXEC = true;
	      viewport.scrollHandler();
	      win.addEventListener("resize", viewport.resizeHandler);
	      win.addEventListener("scroll", viewport.scrollHandler);
	    }
	  }

	  function disconnect() {
	    if (spider.impression && spider.impression.ALREADY_EXEC) {
	      spider.impression.ALREADY_EXEC = false;
	      win.removeEventListener("resize", viewport.resizeHandler);
	      win.removeEventListener("scroll", viewport.scrollHandler);
	    }
	  }

	  function _calAndReportImpression() {
	    // in case of dom scripting, we should do the query every time instead of snapshot
	    // unless we use mutationObserver to react to dom change
	    var maybeImpressionElems1 =
	      doc.querySelectorAll("[" + ATTR_IMPRESSION + '=""]') || [];
	    var maybeImpressionElems2 =
	      doc.querySelectorAll("[" + ATTR_IMPRESSION + '="true"]') || [];
	    var maybeImpressionElems = [];
	    for (var i = 0, l1 = maybeImpressionElems1.length; i < l1; i++) {
	      maybeImpressionElems.push(maybeImpressionElems1[i]);
	    }
	    for (var k = 0, l2 = maybeImpressionElems2.length; k < l2; k++) {
	      maybeImpressionElems.push(maybeImpressionElems2[k]);
	    }

	    var containerRect = null;
	    var container = viewport.container;
	    if (
	      container &&
	      container !== win &&
	      typeof container.getBoundingClientRect === "function"
	    ) {
	      containerRect = container.getBoundingClientRect();
	    }

	    [].forEach.call(maybeImpressionElems, function(element) {
	      if (_isInViewport(element, containerRect)) {
	        // element should impress the reader only once
	        _markElementImpressed(element);
	        _reportImpression(element);
	      }
	    });
	  }

	  function _markElementImpressed(element) {
	    element.dataset.spiderImpression = "impressed";
	  }

	  function _reportImpression(element) {
	    var impressiondReport = spider.extractActionFrom(element);
	    if (impressiondReport) {
	      if (!impressiondReport.actionArgs.hasOwnProperty("spoor")) {
	        // console.warn("如果是推荐业务，请在data-spider-action-args中添加曝光埋点所需的spoor值");
	      }
	      spider.trackImpression(impressiondReport);
	    }
	  }

	  // strictly we should use isVisible and isInViewport both
	  function _isInViewport(element, containerRect) {
	    var elemRect = element.getBoundingClientRect();
	    var elemTop = elemRect.top;
	    var elemBottom = elemRect.bottom;
	    var elemHeight = elemBottom - elemTop;
	    var viewportHeight = viewport.height;

	    // todo 这里逻辑应该整合
	    if (containerRect) {
	      return (
	        elemTop - containerRect.top >= -elemHeight / 4 &&
	        elemTop <= containerRect.bottom - (elemHeight * 3) / 4
	      );
	    } else {
	      //元素超过可视区高度情况
	      if (elemHeight > viewportHeight) {
	        return (
	          elemTop >= (-elemHeight * 3) / 4 &&
	          elemTop <= (viewportHeight * 3) / 4
	        );
	      } else {
	        return (
	          elemTop >= -elemHeight / 4 &&
	          elemTop <= viewportHeight - (elemHeight * 3) / 4
	        );
	      }
	    }
	  }

	  function _debounce(cb, delay) {
	    var timer;
	    return function() {
	      if (timer) clearTimeout(timer);
	      timer = setTimeout(function() {
	        cb && cb();
	      }, delay);
	    };
	  }

	  spider.impression = {
	    observe: observe,
	    disconnect: disconnect,
	    traverse: function(container) {
	      viewport.container = container || win;
	      viewport.scrollHandler();
	    }
	  };

	  observe();
	};

	module.exports = spiderImpression;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	!function(e,t){if(true)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var r=t();for(var n in r)("object"==typeof exports?exports:e)[n]=r[n]}}(window,function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=0)}([function(e,t,r){"use strict";var n,i;r.r(t),function(e){e.Create="create",e.Update="update",e.Delete="delete",e.Immutable="immutable",e.sourceIdChanged="sourceIdChanged"}(n||(n={})),function(e){e.DB="DB",e.DOM="DOM"}(i||(i={}));var o="data-v-spiderid",a="data-spider",s="data-spider-vda",u="data-spider-action-name",c="data-spider-impression",d="data-spider-action-args";function f(){var e=document.head,t=e.querySelector("meta[name='data-spider']")&&e.querySelector("meta[name='data-spider']").getAttribute("content");return{spma:t=e.querySelector("meta[name='data-spider-prior']")&&e.querySelector("meta[name='data-spider-prior']").getAttribute("content")||t,spmb:document.body.getAttribute("data-spider-prior")||document.body.getAttribute("data-spider")}}function l(e,t){return(t=t||document).querySelectorAll("["+o+'="'+e+'"]')}function p(e,t,r){if(void 0===r&&(r=!0),e&&0!==e.length)return e&&e.length?Array.from(e).forEach(function(e){p(e,t,r)}):(r&&e.setAttribute(s,""),e.setAttribute(a,t))}function h(e,t,r){if(void 0===r&&(r=!0),e&&0!==e.length)return e&&e.length?Array.from(e).forEach(function(e){h(e,t,r)}):(r&&e.setAttribute(s,""),e.setAttribute(u,t))}function b(e,t){if(void 0===t&&(t=!0),e&&0!==e.length)return e&&e.length?Array.from(e).forEach(function(e){b(e,t)}):(t&&e.setAttribute(s,""),e.setAttribute(a,""))}function m(e,t){if(void 0===t&&(t=!0),e&&0!==e.length)return e&&e.length?Array.from(e).forEach(function(e){m(e,t)}):(t&&e.setAttribute(s,""),e.setAttribute(c,""))}function v(e,t){if(e&&0!==e.length){if(e&&e.length)return Array.from(e).forEach(function(e){v(e,t)});var r={};return t.forEach(function(t){var n=t.sourceId,i=e.getAttribute(o)===n?e:e.querySelector("["+o+'="'+n+'"]')?e.querySelector("["+o+'="'+n+'"]'):e.parentNode.getAttribute(o)===n?e.parentNode:null;i&&("innerText"===t.args?r[t.name]=i.innerText:r[t.name]=i.getAttribute(t.args))}),e.setAttribute(d,JSON.stringify(r))}}var y=function(e,t,r,n){return new(r||(r=Promise))(function(i,o){function a(e){try{u(n.next(e))}catch(e){o(e)}}function s(e){try{u(n.throw(e))}catch(e){o(e)}}function u(e){e.done?i(e.value):new r(function(t){t(e.value)}).then(a,s)}u((n=n.apply(e,t||[])).next())})},g=function(e,t){var r,n,i,o,a={label:0,sent:function(){if(1&i[0])throw i[1];return i[1]},trys:[],ops:[]};return o={next:s(0),throw:s(1),return:s(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function s(o){return function(s){return function(o){if(r)throw new TypeError("Generator is already executing.");for(;a;)try{if(r=1,n&&(i=2&o[0]?n.return:o[0]?n.throw||((i=n.return)&&i.call(n),0):n.next)&&!(i=i.call(n,o[1])).done)return i;switch(n=0,i&&(o=[2&o[0],i.value]),o[0]){case 0:case 1:i=o;break;case 4:return a.label++,{value:o[1],done:!1};case 5:a.label++,n=o[1],o=[0];continue;case 7:o=a.ops.pop(),a.trys.pop();continue;default:if(!(i=(i=a.trys).length>0&&i[i.length-1])&&(6===o[0]||2===o[0])){a=0;continue}if(3===o[0]&&(!i||o[1]>i[0]&&o[1]<i[3])){a.label=o[1];break}if(6===o[0]&&a.label<i[1]){a.label=i[1],i=o;break}if(i&&a.label<i[2]){a.label=i[2],a.ops.push(o);break}i[2]&&a.ops.pop(),a.trys.pop();continue}o=t.call(e,a)}catch(e){o=[6,e],n=0}finally{r=i=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,s])}}},S="";S=location.host.indexOf("dev")>-1||location.href.indexOf("localhost")>-1?"https://thor.daily.weidian.com/vda/spider.getSpiderInfo/1.0":location.host.indexOf("daily")>-1?"https://thor.daily.weidian.com/vda/spider.getSpiderInfo/1.0":location.host.indexOf("pre")>-1?"https://thor.pre.weidian.com/vda/spider.getSpiderInfo/1.0":"https://thor.weidian.com/vda/spider.getSpiderInfo/1.0";var A=A||function(e){var t=Date.now();return setTimeout(function(){e({didTimeout:!1,timeRemaining:function(){return Math.max(0,50-(Date.now()-t))}})},1)};var w=function(e){return y(this,void 0,void 0,function(){var t,r,n,i,o,a,s;return g(this,function(u){switch(u.label){case 0:t=0,r=e,u.label=1;case 1:if(!(t<r.length))return[3,11];switch(n=r[t],i=n.type,i){case"childList":return[3,2];case"subtree":return[3,8]}return[3,9];case 2:return u.trys.push([2,7,,8]),n.addedNodes.length>0?Array.from(n.addedNodes).some(function(e){return 1===e.nodeType&&!e.classList.contains("vda-shade")})?(o=f(),this.cachedMeta.spma===o.spma&&this.cachedMeta.spmb===o.spmb?[3,4]:(this.cachedMeta=o,a=this,[4,this.getSpiderInfo(o.spma,o.spmb)])):[3,5]:[3,6];case 3:a.cachedSpmList=u.sent(),u.label=4;case 4:this.setSpiders(this.cachedSpmList),u.label=5;case 5:return[3,10];case 6:return[3,8];case 7:return s=u.sent(),console.error("observer error",s),[3,8];case 8:case 9:return[3,10];case 10:return t++,[3,1];case 11:return[2]}})})},x={observerConfig:{attributes:!1,childList:!0,subtree:!0},init:function(){return y(this,void 0,void 0,function(){var e,t,r,n;return g(this,function(i){switch(i.label){case 0:return i.trys.push([0,2,,3]),e=this.cachedMeta=f(),t=this,[4,this.getSpiderInfo(e.spma,e.spmb)];case 1:return t.cachedSpmList=i.sent(),this.setSpiders(this.cachedSpmList),o=w,a=100,s=this,u=null,r=function(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];u&&clearTimeout(u),u=setTimeout(function(){o.apply(s,e)},a)},this.observer=new MutationObserver(r),this.observer.observe(document.body,this.observerConfig),[3,3];case 2:return n=i.sent(),console.error("init error",n),[3,3];case 3:return[2]}var o,a,s,u})})},setSpiders:function(e){if(e&&Array.isArray(e)){var t=0,r=e.slice();A(function e(n){for(;t<r.length;t++){var i=r[t];if(!(n.timeRemaining()>0)){A(e);break}var o=l(i.sourceId);i.spmc&&p(o,i.spmc),i.spmd&&b(o),i.actionName&&h(o,i.actionName),1===i.actionType&&m(o),i.actionArgInfo&&v(o,JSON.parse(i.actionArgInfo))}})}},getSpiderInfo:function(e,t){return y(this,void 0,void 0,function(){var r,n;return g(this,function(i){switch(i.label){case 0:return i.trys.push([0,2,,3]),[4,(o=S,a={spma:e,spmb:t},s=new XMLHttpRequest,new Promise(function(e,t){if(s.onreadystatechange=function(){4==s.readyState&&(s.status>=200&&s.status<300||304==s.status?e(JSON.parse(s.responseText)):t(s.status))},"object"==typeof a){o+="?";var r=[];Object.keys(a).forEach(function(e){r.push(e+"="+a[e])}),o+=r.join("&")}s.open("get",o,!0),s.send(null)}))];case 1:return[2,(r=i.sent())&&r.result];case 2:return n=i.sent(),console.error(n),[3,3];case 3:return[2]}var o,a,s})})}};t.default=x}])});
	//# sourceMappingURL=index.js.map

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var constant_1 = __webpack_require__(30);
	var querystring_1 = __webpack_require__(31);
	var util_1 = __webpack_require__(32);
	var url_1 = __webpack_require__(34);
	exports.Url = url_1.default;
	/**
	 * 设置url地址的querystring。
	 * @param url 链接地址，如果url为null/undefined，则以当前页面url作为默认值。
	 * @param params 参数对象。
	 * @param options 设置参数合并规则，具体见参数合并规则。
	 * @returns 设置后的url地址。
	 */
	function setQuerystring(url, params, options) {
	    // get window href
	    var href = constant_1.GLOBAL.location.href;
	    // normalize arguments
	    if (util_1.default.isObject(url)) {
	        options = params;
	        params = url;
	        url = href;
	    }
	    // set href if url is undefined/null
	    if (util_1.default.isUndef(url)) {
	        url = href;
	    }
	    // merge options
	    options = Object.assign({
	        replace: true
	    }, options);
	    var instance = new url_1.default(url);
	    if (options.replace) {
	        // merge params if is replace
	        instance.query = Object.assign(instance.query || {}, params);
	    }
	    else {
	        var search = querystring_1.stringify(params);
	        if (search) {
	            var delimit = instance.search.indexOf(constant_1.SEARCH_DELIMIT) === -1
	                ? constant_1.SEARCH_DELIMIT
	                : constant_1.PARAM_DELIMIT;
	            instance.search += delimit + search;
	        }
	    }
	    return instance.toString();
	}
	exports.setQuerystring = setQuerystring;
	/**
	 * 获取传入url地址的参数对象。
	 * @param url 链接地址 如果url为null/undefined，则以当前页面url作为默认值，如果url为相对地址，不进行url规整化处理。
	 * @returns 序列化后的参数对象。
	 */
	function getQuerystring(url) {
	    if (util_1.default.isUndef(url)) {
	        url = constant_1.GLOBAL.location.href;
	    }
	    return querystring_1.parse(url);
	}
	exports.getQuerystring = getQuerystring;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SEARCH_DELIMIT = '?';
	exports.PARAM_DELIMIT = '&';
	exports.PARAM_VALUE_DELIMIT = '=';
	exports.HASH_DELIMIT = '#';
	exports.GLOBAL = window;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(32);
	var constant_1 = __webpack_require__(30);
	var SEARCH_REGXP = /^[^\?#]*\?([^#]*)/;
	function getSearch(url) {
	    var matchs;
	    return (url && (matchs = url.match(SEARCH_REGXP)) && matchs[1]) || '';
	}
	function encode(value) {
	    return encodeURIComponent(value).replace(/%20/g, '+');
	}
	function decode(value) {
	    return decodeURIComponent(value).replace(/\+/g, ' ');
	}
	function parse(url) {
	    // get search string
	    url = getSearch(url);
	    // split params
	    var parts = url.split(constant_1.PARAM_DELIMIT);
	    var params = {};
	    parts.forEach(function (param) {
	        // if param is empty
	        if (!param) {
	            return;
	        }
	        // split param value
	        var splits = param.split(constant_1.PARAM_VALUE_DELIMIT);
	        var name = splits[0];
	        // set param = '' if querystring is '?param'
	        var value = splits[1] || '';
	        if (name) {
	            name = decode(name);
	            value = decode(value);
	            if (util_1.default.hasOwn(params, name)) {
	                if (!util_1.default.isArray(params[name])) {
	                    params[name] = [params[name]];
	                }
	                // tslint:disable-next-line
	                ;
	                params[name].push(value);
	            }
	            else {
	                params[name] = value;
	            }
	        }
	    });
	    return params;
	}
	exports.parse = parse;
	function stringify(params) {
	    if (!util_1.default.isObject(params)) {
	        return '';
	    }
	    var search = [];
	    util_1.default.forEach(params, function (value, name) {
	        if (!util_1.default.isUndef(value)) {
	            if (!util_1.default.isArray(value)) {
	                value = [value];
	            }
	            name = encode(name);
	            // normalize {name:array} param to name=array[0]&name=array[1]
	            value.forEach(function (val) {
	                search.push("" + name + constant_1.PARAM_VALUE_DELIMIT + encode(val));
	            });
	        }
	    });
	    return search.join(constant_1.PARAM_DELIMIT);
	}
	exports.stringify = stringify;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(33);
	exports.default = util;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * 空函数
	 */
	// tslint:disable-next-line
	function noop() { }
	exports.noop = noop;
	/**
	 * 判断是否是未定义
	 * @param value 入参
	 * @returns true/false，undefined、null返回true
	 */
	function isUndef(value) {
	    return value === undefined || value === null;
	}
	exports.isUndef = isUndef;
	/**
	 * 判断是否为空
	 * @param value 入参
	 * @returns true/false，undefined、null、空字符串返回true
	 */
	function isEmpty(value) {
	    return value === undefined || value === null || value === '';
	}
	exports.isEmpty = isEmpty;
	function isType(type) {
	    return function (value) { return Object.prototype.toString.call(value) === "[object " + type + "]"; };
	}
	/**
	 * 判断是否为Number类型
	 * @param value 入参
	 * @returns true/false
	 */
	function isNumber(value) {
	    return isType('Number')(value);
	}
	exports.isNumber = isNumber;
	/**
	 * 判断是否为String类型
	 * @param value 入参
	 * @returns true/false
	 */
	function isString(value) {
	    return isType('String')(value);
	}
	exports.isString = isString;
	/**
	 * 判断是否为Error类型
	 * @param value 入参
	 * @returns true/false
	 */
	function isError(value) {
	    return isType('Error')(value);
	}
	exports.isError = isError;
	/**
	 * 判断是否为Array类型
	 * @param value 入参
	 * @returns true/false
	 */
	function isArray(value) {
	    return isType('Array')(value);
	}
	exports.isArray = isArray;
	/**
	 * 判断是否为Function类型
	 * @param value 入参
	 * @returns true/false
	 */
	function isFunction(value) {
	    return isType('Function')(value);
	}
	exports.isFunction = isFunction;
	/**
	 * 判断是否为Date类型
	 * @param value 入参
	 * @returns true/false
	 */
	function isDate(value) {
	    return isType('Date')(value);
	}
	exports.isDate = isDate;
	/**
	 * 判断是否为Boolean 类型
	 * @param value 入参
	 * @returns true/false
	 */
	function isBoolean(value) {
	    return isType('Boolean')(value);
	}
	exports.isBoolean = isBoolean;
	/**
	 * 判断是否为严格Object类型
	 * @param value 入参
	 * @returns true/false
	 */
	function isObject(value) {
	    return isType('Object')(value);
	}
	exports.isObject = isObject;
	/**
	 * 判断是否为泛object，不包括null
	 * @param value 入参
	 * @returns true/false
	 */
	function isWideObject(value) {
	    return value !== null && typeof value === 'object';
	}
	exports.isWideObject = isWideObject;
	/**
	 * 是否为FormData实例
	 * @param value - 入参
	 * @returns true/false，不支持FormData时返回false
	 */
	function isFormData(value) {
	    return typeof FormData !== 'undefined' && value instanceof FormData;
	}
	exports.isFormData = isFormData;
	/**
	 * 是否为URLSearchParams实例
	 * @param value - 入参
	 * @returns true/false，不支持URLSearchParams时返回false
	 */
	function isURLSearchParams(value) {
	    return (typeof URLSearchParams !== 'undefined' &&
	        value instanceof URLSearchParams);
	}
	exports.isURLSearchParams = isURLSearchParams;
	/**
	 * 对象是否有某个实例属性hasOwnProperty方法封装
	 * @param obj 对象
	 * @param key 对象的属性
	 * @returns true/false
	 */
	function hasOwn(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	exports.hasOwn = hasOwn;
	/**
	 * 循环对象和数组
	 * @param obj 对象或者数组
	 * @param fn 回调函数
	 * @returns undefined
	 */
	function forEach(obj, fn) {
	    if (isArray(obj)) {
	        // Iterate over array values
	        for (var i = 0, l = obj.length; i < l; i++) {
	            fn.call(null, obj[i], i, obj);
	        }
	    }
	    else if (isObject(obj)) {
	        // Iterate over object keys
	        for (var key in obj) {
	            if (hasOwn(obj, key)) {
	                fn.call(null, obj[key], key, obj);
	            }
	        }
	    }
	}
	exports.forEach = forEach;
	/**
	 * 合并多个对象
	 * @param targetOrDeep 目标对象或者是否深度合并
	 * @param sources 多个源对象
	 * @returns target 目标对象
	 */
	function merge(targetOrDeep) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    var deep;
	    var target;
	    if (isBoolean(targetOrDeep)) {
	        deep = targetOrDeep;
	        target = sources.shift();
	    }
	    else {
	        target = targetOrDeep;
	    }
	    forEach(sources, function (source) {
	        forEach(source, function (value, key) {
	            if (deep && (isArray(value) || isObject(value))) {
	                if (isArray(value)) {
	                    if (!isArray(target[key])) {
	                        target[key] = [];
	                    }
	                }
	                else {
	                    if (!isObject(target[key])) {
	                        target[key] = {};
	                    }
	                }
	                merge(deep, target[key], value);
	            }
	            else {
	                target[key] = value;
	            }
	        });
	    });
	    return target;
	}
	exports.merge = merge;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(32);
	var querystring_1 = __webpack_require__(31);
	var constant_1 = __webpack_require__(30);
	var QUERY_PROPERTY = 'query';
	var NORMAL_PROPERTIES = [
	    'hash',
	    'host',
	    'hostname',
	    'pathname',
	    'port',
	    'protocol'
	];
	var QUERY_RELATED_PROPERTIES = ['href', 'search'];
	var READONLY_PROPERTIES = ['origin'];
	var defineProperty = Object.defineProperty;
	// validate url property
	function validate(name, value) {
	    if (name === QUERY_PROPERTY) {
	        return util_1.default.isObject(value);
	    }
	    return util_1.default.isString(value) || util_1.default.isNumber(value);
	}
	function getSearch(query) {
	    // stringify query to search string
	    var search = querystring_1.stringify(query);
	    // always use query as search string
	    return (search ? constant_1.SEARCH_DELIMIT : '') + search;
	}
	function defineNormalProperties(instance, element) {
	    function handler(name) {
	        defineProperty(instance, name, {
	            get: function () {
	                return element[name];
	            },
	            set: function (value) {
	                if (!validate(name, value)) {
	                    return;
	                }
	                element[name] = value;
	            },
	            enumerable: true
	        });
	    }
	    NORMAL_PROPERTIES.forEach(handler);
	}
	function defineQueryProperty(instance, element) {
	    function handler(name) {
	        defineProperty(instance, name, {
	            get: function () {
	                // set search property then normalize query
	                instance.search = getSearch(element[name]);
	                return element[name];
	            },
	            set: function (value) {
	                if (!validate(name, value)) {
	                    return;
	                }
	                element[name] = value;
	            },
	            enumerable: true
	        });
	    }
	    handler(QUERY_PROPERTY);
	}
	function defineQueryRelatedProperties(instance, element) {
	    function handler(name) {
	        defineProperty(instance, name, {
	            get: function () {
	                element.search = getSearch(element[QUERY_PROPERTY]);
	                return element[name];
	            },
	            set: function (value) {
	                if (!validate(name, value)) {
	                    return;
	                }
	                element[name] = value;
	                // sync query from search
	                element[QUERY_PROPERTY] = querystring_1.parse(element.search);
	            },
	            enumerable: true
	        });
	    }
	    QUERY_RELATED_PROPERTIES.forEach(handler);
	}
	function defineReadonlyProperties(instance, element) {
	    function handler(name) {
	        defineProperty(instance, name, {
	            get: function () {
	                return element[name];
	            },
	            enumerable: true
	        });
	    }
	    READONLY_PROPERTIES.forEach(handler);
	}
	/**
	 * Url类
	 * ```
	 * const url = new Url('https://www.weidian.com/')
	 * // get url href
	 * let href = url.href
	 * // set url href
	 * url.href = 'https://www.koudai.com/a.html'
	 * console.log(url.host) // www.koudai.com
	 * ```
	 */
	var Url = /** @class */ (function () {
	    /**
	     * Url
	     * @param url 链接地址，未传递使用当前页面链接，如果为相对地址，则会以当前页面url作为base url。
	     */
	    function Url(url) {
	        // if url is empty then set default href
	        if (util_1.default.isEmpty(url)) {
	            url = constant_1.GLOBAL.location.href;
	        }
	        // create element
	        var element = (this._element = constant_1.GLOBAL.document.createElement('A'));
	        // refresh href
	        element.href = url;
	        // define normal properties
	        defineNormalProperties(this, this._element);
	        // define query related properties
	        defineQueryRelatedProperties(this, this._element);
	        // define query property
	        defineQueryProperty(this, this._element);
	        // define readonly properties
	        defineReadonlyProperties(this, this._element);
	        // refresh query
	        this.href = element.href;
	    }
	    /**
	     * toString方法，在String(instance)调用。
	     * @returns href属性。
	     */
	    Url.prototype.toString = function () {
	        return this.href;
	    };
	    return Url;
	}());
	exports.default = Url;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.create = void 0;
	// import { forEach } from '@vdian/util'
	var root_1 = __webpack_require__(36);
	var shared_1 = __webpack_require__(38);
	var plugins_1 = __webpack_require__(171);
	// var constans_1 = require("./plugins/collect-tapper/constans");
	// var collect_tapper_1 = require("./plugins/collect-tapper");
	function create() {
	    var root = new root_1.Root();
	    // constans_1.ENABLE_TAPPER && root.use(collect_tapper_1.collectTapperPlugin);
	    shared_1.forEach([
	        plugins_1.navigationPlugin,
	        // plugins_1.spiderVisualPlugin,
	        plugins_1.fixIOSClickBugPlugin
	    ], function (plugin) { return root.use(plugin); });
	    function use(plugin) {
	        // spider.use(plugin)
	        return root.use(plugin);
	    }
	    // 手动触发pageview：判断当前页面是否禁用自动pageview，若没有则抛异常提示需手动禁用
	    function trackPageview(_pageArgs) {
	        /**
	         * 2021.3.10 埋点打点校对
	         * 这里不适合做是否禁用自动上报的校验
	         * 埋点打点场景都是通过手动API方式调用
	         * */
	        // var disableAutoPageview = shared_1.isDisableAuto('spider');
	        var args = arguments;
	        var pageArgs = args.length
	            ? args[args.length - 1]
	            : undefined;

	        return root.trackPageview(pageArgs);
	        // if (disableAutoPageview) {
	        //     return root.trackPageview(pageArgs);
	        // }
	        // else {
	        //     shared_1.warn('手动上报pageview之前需在body上声明禁用spider自动pageview data-spider-disabled=[spider]');
	        //     return;
	        // }
	    }
	    function trackAction(value, callback) {
	        return root.trackAction(value, callback);
	    }
	    function trackImpression(value, callback) {
	        return root.trackImpression(value, callback);
	    }
	    function transferAction(value) {
	        return root.transferAction(value);
	    }
	    function transferActionBy(url, value, immdiately) {
	        return root.transferActionBy(url, value, immdiately);
	    }
	    function diffCheck(methodName, args, oldData, prevInfo) {
	        var _args = [].slice.call(args);
	        /**
	         * 2021.3.10 埋点打点校对 若是pageview类型
	         * 这里为了兼旧版埋点先调pageview上报后会删除cookie中所有的spiderToken信息导致后调新版埋点pageview无法正常获取上一页的prevInfo的场景；
	         * 在调新版埋点pageview之前，手动传入上一页的prevInfo数据.
	         */
	        if (prevInfo && prevInfo.prev_spm) {
	            root.setPrevDataCopy(prevInfo);
	        }
	        var newData = this[methodName].apply(this, _args);

	        shared_1.diff(methodName, _args, oldData, newData, shared_1.filterReportData);
	    }
	    function diffCheckNavigation(methodName, args, oldData) {
	        var _args = [].slice.call(args);

	        var url = this[methodName].apply(this, _args);

	        var newSpiderToken = '';

	        if (methodName === "transferAction") {
	            newSpiderToken = root.get().token;
	        } else {
	            newSpiderToken = url && shared_1.getSpiderTokenFrom(url);
	        }

	        var newPrevInfo = newSpiderToken && shared_1.getPrevInfoDataBy(newSpiderToken);

	        var newData = {};

	        url && (newData.url = url);
	        newPrevInfo && (newData.prevInfo = newPrevInfo);

	        shared_1.diff(methodName, _args, oldData, newData, shared_1.filterNavigationData);
	    }
	    /**
	     * 返回页面点击事件触发的dom声明式的埋点元素
	     */
	    function getClickElement() {
	        return root.get().curSpiderElement;
	    }
	    shared_1.warn('「pecker 提示」cdn升级到pecker v1.0.0之后，已经实现并兼容了v-collect的绝大部分功能，可直接替代v-collect。请不要在页面中同时引入pecker脚本和v-collect脚本，建议下掉v-collect脚本！\n详情参见文档：https://h5.daily.weidian.com/v-components/pecker/books/spider/chapter2/access-steps.html');
	    return {
	        use: use,
	        trackPageview: trackPageview,
	        trackAction: trackAction,
	        trackImpression: trackImpression,
	        transferAction: transferAction,
	        transferActionBy: transferActionBy,
	        extractActionFrom: shared_1.extractActionFrom,
	        constants: shared_1.INTERNAL_ACTION_NAMES,
	        getClickElement: getClickElement,
	        impression: {
	            traverse: shared_1.noop,
	            observe: shared_1.noop,
	            disconnect: shared_1.noop
	        },
	        getCookie: shared_1.getCookie,
	        getSearchParams: shared_1.getSearchParams,
	        disableAutoReport: shared_1.noop,
	        reset: shared_1.noop,
	        init: shared_1.noop,
	        VERSION: '0.1.3',
	        diffCheck: diffCheck,
	        diffCheckNavigation: diffCheckNavigation,
	        getSpiderTokenFrom: shared_1.getSpiderTokenFrom,
	        getPrevInfoDataBy: shared_1.getPrevInfoDataBy,
	        merge: shared_1.merge
	    };
	}

	module.exports = create();


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Root = void 0;
	var pageview_1 = __webpack_require__(37);
	var click_1 = __webpack_require__(165);
	var navigation_1 = __webpack_require__(166);
	var base_1 = __webpack_require__(167);
	var Root = /** @class */ (function (_super) {
	    __extends(Root, _super);
	    function Root() {
	        var _this = _super.call(this) || this;
	        _this.spiderPageview = new pageview_1.SpiderPageview(_this);
	        _this.spiderClick = new click_1.SpiderClick(_this);
	        _this.spiderNavigation = new navigation_1.SpiderNavigation(_this);
	        return _this;
	    }
	    // 手动触发pageview：判断当前页面是否禁用自动pageview，若没有则抛异常提示需手动禁用
	    Root.prototype.trackPageview = function (pageArgs) {
	       return this.spiderPageview.trackPageview(pageArgs);
	    };
	    Root.prototype.trackAction = function (value, _callback) {
	       return this.spiderClick.trackAction(value, "click" /* CLICK */, _callback);
	    };
	    Root.prototype.transferActionBy = function (url, value, immdiately) {
	        return this.spiderNavigation.transferActionBy(url, value, immdiately);
	    };
	    Root.prototype.transferAction = function (value) {
	        return this.spiderNavigation.transferAction(value);
	    };
	    Root.prototype.trackImpression = function (value, _callback) {
	       return this.spiderClick.trackAction(value, "expose" /* EXPOSE */, _callback);
	    };
	    return Root;
	}(base_1.Base));
	exports.Root = Root;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SpiderPageview = void 0;
	var shared_1 = __webpack_require__(38);
	// var constans_1 = require("../../plugins/collect-tapper/constans");
	var SpiderPageview = /** @class */ (function () {
	    function SpiderPageview(root) {
	        this.root = root;
	    }
	    SpiderPageview.prototype.trackPageview = function (pageArgs) {
	        var _a = shared_1.getSpmaAndSpmb(), spma = _a.spma, spmb = _a.spmb;
	        if (!spma || !spmb) {
	            /**
	             * 这里不用error提示因为加载单页应用异步路由页面场景，DOMContentLoaded时机执行trackPageview会拿不到spmb值，需得等待异步组件加载完成后才能拿到spmb值
	             * 由于采集脚本无法区分是异步加载还是同步加载，故将error提示降级为warn
	             */
	            // 如果 a、b 位有一个不存在，则不上报
	            shared_1.warn('[spider 提示] meta & body 上必须包含 data-spider 值');
	            return;
	        }
	        // 跟旧版vcollect代码trackPageview逻辑保持一致，允许埋点上报同时给出警告
	        if (pageArgs && !shared_1.isObject(pageArgs)) {
	            shared_1.error(new shared_1.SpiderError({
	                message: 'pageArgs必须是一个对象,' +
	                    JSON.stringify(pageArgs) +
	                    '不是对象',
	                name: "ValidationError" /* VALIDATION_ERROR */
	            }));
	            pageArgs = {};
	        }
	        this.setBase(spma, spmb, pageArgs);
	        var _b = this.root.get(), prevData = _b.prevData, curPageArgs = _b.curPageArgs, curSpm = _b.curSpm;
	        // 通知SpiderClick类上报上一页埋点的消息
	        shared_1.eventEmitter.emit("report_prev_data" /* REPORT_PREV_DATA */);
	        // 在上报上一页埋点信息完成之后 触发上报pageview事件 进而上报上一页的打点信息
	        // constans_1.ENABLE_TAPPER && shared_1.eventEmitter.emit(constans_1.BEFORE_AUTO_REPORT_PAGE_VIEW);
	        return this.reportSpiderData(prevData, curPageArgs, curSpm);
	    };
	    SpiderPageview.prototype.setBase = function (spma, spmb, pageArgs) {
	        // 初始化curSpm = [spma,spmb,0,0]
	        this.root.setCurSpmArray({
	            spma: spma,
	            spmb: spmb,
	            spmc: '0',
	            spmd: '0'
	        });
	        // 初始化curPageArgs
	        this.root.setCurPageArgs(pageArgs);
	        try {
	            var token = this.root.get().token;
	            /**
	             * 2021.3.10 埋点打点校对
	             * 这里为了兼旧版埋点先调pageview上报后会删除cookie中所有的spiderToken信息导致后调新版埋点pageview无法正常获取上一页的prevInfo的场景；
	             * 在调新版埋点pageview之前，手动传入上一页的prevInfo数据.此处增加一个兜底判断若从cookie未能取到prevInfo，再兜底判断base类是否缓存，才会初始化Base.prevData;否则不做初始化处理；
	             * */ 
	            var prevData = shared_1.getSpiderToken(token) || this.root.get().prevData;
	            // 初始化prevData
	            this.root.setPrevData(prevData);
	        }
	        catch (e) {
	            shared_1.error(e);
	        }
	    };
	    SpiderPageview.prototype.reportSpiderData = function (prevData, pageArgs, spm) {
	        var curInfoData = shared_1.merge(true, {}, prevData);
	        curInfoData.cur_spm = spm;
	        curInfoData.cur_page_args = pageArgs;
	        // curInfoData.navigation_type = getNavigationType()
	        return this.root.report("page_view" /* PAGE_VIEW */, curInfoData);
	    };
	    return SpiderPageview;
	}());
	exports.SpiderPageview = SpiderPageview;


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function () { return m[k]; } });
	}) : (function (o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function (m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.eventEmitter = void 0;
	var shared_1 = __webpack_require__(39);
	__exportStar(__webpack_require__(39), exports);
	__exportStar(__webpack_require__(115), exports);
	__exportStar(__webpack_require__(116), exports);
	exports.eventEmitter = new shared_1.Decoupler();

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	tslib_1.__exportStar(__webpack_require__(41), exports);
	tslib_1.__exportStar(__webpack_require__(55), exports);
	tslib_1.__exportStar(__webpack_require__(56), exports);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*! *****************************************************************************
	Copyright (c) Microsoft Corporation.

	Permission to use, copy, modify, and/or distribute this software for any
	purpose with or without fee is hereby granted.

	THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
	REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
	AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
	INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
	LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
	OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
	PERFORMANCE OF THIS SOFTWARE.
	***************************************************************************** */
	/* global global, define, System, Reflect, Promise */
	var __extends;
	var __assign;
	var __rest;
	var __decorate;
	var __param;
	var __metadata;
	var __awaiter;
	var __generator;
	var __exportStar;
	var __values;
	var __read;
	var __spread;
	var __spreadArrays;
	var __spreadArray;
	var __await;
	var __asyncGenerator;
	var __asyncDelegator;
	var __asyncValues;
	var __makeTemplateObject;
	var __importStar;
	var __importDefault;
	var __classPrivateFieldGet;
	var __classPrivateFieldSet;
	var __createBinding;
	(function (factory) {
	    var root = typeof global === "object" ? global : typeof self === "object" ? self : typeof this === "object" ? this : {};
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [exports], __WEBPACK_AMD_DEFINE_RESULT__ = function (exports) { factory(createExporter(root, createExporter(exports))); }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof module === "object" && typeof module.exports === "object") {
	        factory(createExporter(root, createExporter(module.exports)));
	    }
	    else {
	        factory(createExporter(root));
	    }
	    function createExporter(exports, previous) {
	        if (exports !== root) {
	            if (typeof Object.create === "function") {
	                Object.defineProperty(exports, "__esModule", { value: true });
	            }
	            else {
	                exports.__esModule = true;
	            }
	        }
	        return function (id, v) { return exports[id] = previous ? previous(id, v) : v; };
	    }
	})
	(function (exporter) {
	    var extendStatics = Object.setPrototypeOf ||
	        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };

	    __extends = function (d, b) {
	        if (typeof b !== "function" && b !== null)
	            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };

	    __assign = Object.assign || function (t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
	        }
	        return t;
	    };

	    __rest = function (s, e) {
	        var t = {};
	        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
	            t[p] = s[p];
	        if (s != null && typeof Object.getOwnPropertySymbols === "function")
	            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
	                    t[p[i]] = s[p[i]];
	            }
	        return t;
	    };

	    __decorate = function (decorators, target, key, desc) {
	        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	        return c > 3 && r && Object.defineProperty(target, key, r), r;
	    };

	    __param = function (paramIndex, decorator) {
	        return function (target, key) { decorator(target, key, paramIndex); }
	    };

	    __metadata = function (metadataKey, metadataValue) {
	        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
	    };

	    __awaiter = function (thisArg, _arguments, P, generator) {
	        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
	        return new (P || (P = Promise))(function (resolve, reject) {
	            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
	            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
	            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
	            step((generator = generator.apply(thisArg, _arguments || [])).next());
	        });
	    };

	    __generator = function (thisArg, body) {
	        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
	        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
	        function verb(n) { return function (v) { return step([n, v]); }; }
	        function step(op) {
	            if (f) throw new TypeError("Generator is already executing.");
	            while (_) try {
	                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
	                if (y = 0, t) op = [op[0] & 2, t.value];
	                switch (op[0]) {
	                    case 0: case 1: t = op; break;
	                    case 4: _.label++; return { value: op[1], done: false };
	                    case 5: _.label++; y = op[1]; op = [0]; continue;
	                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
	                    default:
	                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
	                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
	                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
	                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
	                        if (t[2]) _.ops.pop();
	                        _.trys.pop(); continue;
	                }
	                op = body.call(thisArg, _);
	            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
	            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
	        }
	    };

	    __exportStar = function(m, o) {
	        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
	    };

	    __createBinding = Object.create ? (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	    }) : (function(o, m, k, k2) {
	        if (k2 === undefined) k2 = k;
	        o[k2] = m[k];
	    });

	    __values = function (o) {
	        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
	        if (m) return m.call(o);
	        if (o && typeof o.length === "number") return {
	            next: function () {
	                if (o && i >= o.length) o = void 0;
	                return { value: o && o[i++], done: !o };
	            }
	        };
	        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
	    };

	    __read = function (o, n) {
	        var m = typeof Symbol === "function" && o[Symbol.iterator];
	        if (!m) return o;
	        var i = m.call(o), r, ar = [], e;
	        try {
	            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
	        }
	        catch (error) { e = { error: error }; }
	        finally {
	            try {
	                if (r && !r.done && (m = i["return"])) m.call(i);
	            }
	            finally { if (e) throw e.error; }
	        }
	        return ar;
	    };

	    /** @deprecated */
	    __spread = function () {
	        for (var ar = [], i = 0; i < arguments.length; i++)
	            ar = ar.concat(__read(arguments[i]));
	        return ar;
	    };

	    /** @deprecated */
	    __spreadArrays = function () {
	        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
	        for (var r = Array(s), k = 0, i = 0; i < il; i++)
	            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
	                r[k] = a[j];
	        return r;
	    };

	    __spreadArray = function (to, from) {
	        for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
	            to[j] = from[i];
	        return to;
	    };

	    __await = function (v) {
	        return this instanceof __await ? (this.v = v, this) : new __await(v);
	    };

	    __asyncGenerator = function (thisArg, _arguments, generator) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var g = generator.apply(thisArg, _arguments || []), i, q = [];
	        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
	        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
	        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
	        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
	        function fulfill(value) { resume("next", value); }
	        function reject(value) { resume("throw", value); }
	        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
	    };

	    __asyncDelegator = function (o) {
	        var i, p;
	        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
	        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
	    };

	    __asyncValues = function (o) {
	        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
	        var m = o[Symbol.asyncIterator], i;
	        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
	        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
	        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
	    };

	    __makeTemplateObject = function (cooked, raw) {
	        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
	        return cooked;
	    };

	    var __setModuleDefault = Object.create ? (function(o, v) {
	        Object.defineProperty(o, "default", { enumerable: true, value: v });
	    }) : function(o, v) {
	        o["default"] = v;
	    };

	    __importStar = function (mod) {
	        if (mod && mod.__esModule) return mod;
	        var result = {};
	        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
	        __setModuleDefault(result, mod);
	        return result;
	    };

	    __importDefault = function (mod) {
	        return (mod && mod.__esModule) ? mod : { "default": mod };
	    };

	    __classPrivateFieldGet = function (receiver, privateMap) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to get private field on non-instance");
	        }
	        return privateMap.get(receiver);
	    };

	    __classPrivateFieldSet = function (receiver, privateMap, value) {
	        if (!privateMap.has(receiver)) {
	            throw new TypeError("attempted to set private field on non-instance");
	        }
	        privateMap.set(receiver, value);
	        return value;
	    };

	    exporter("__extends", __extends);
	    exporter("__assign", __assign);
	    exporter("__rest", __rest);
	    exporter("__decorate", __decorate);
	    exporter("__param", __param);
	    exporter("__metadata", __metadata);
	    exporter("__awaiter", __awaiter);
	    exporter("__generator", __generator);
	    exporter("__exportStar", __exportStar);
	    exporter("__createBinding", __createBinding);
	    exporter("__values", __values);
	    exporter("__read", __read);
	    exporter("__spread", __spread);
	    exporter("__spreadArrays", __spreadArrays);
	    exporter("__spreadArray", __spreadArray);
	    exporter("__await", __await);
	    exporter("__asyncGenerator", __asyncGenerator);
	    exporter("__asyncDelegator", __asyncDelegator);
	    exporter("__asyncValues", __asyncValues);
	    exporter("__makeTemplateObject", __makeTemplateObject);
	    exporter("__importStar", __importStar);
	    exporter("__importDefault", __importDefault);
	    exporter("__classPrivateFieldGet", __classPrivateFieldGet);
	    exporter("__classPrivateFieldSet", __classPrivateFieldSet);
	});

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	tslib_1.__exportStar(__webpack_require__(42), exports);
	tslib_1.__exportStar(__webpack_require__(43), exports);


/***/ }),
/* 42 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SESSION_ID_KEY = exports.VISITOR_ID_KEY = exports.LOGS_KEY = void 0;
	exports.LOGS_KEY = 'logs';
	exports.VISITOR_ID_KEY = 'visitorid';
	exports.SESSION_ID_KEY = 'sessionid';


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.deepSearch = exports.isCached = exports.nextTick = exports.createError = exports.isNativeFunction = exports.hash = void 0;
	var tslib_1 = __webpack_require__(40);
	__webpack_require__(44);
	// var sha1_1 = require("@vdian/sha1");
	var sha1_1 = tslib_1.__importDefault(__webpack_require__(48));
	var util_1 = __webpack_require__(49);
	var deep_equal_1 = __webpack_require__(50);
	tslib_1.__exportStar(__webpack_require__(51), exports);
	tslib_1.__exportStar(__webpack_require__(52), exports);
	tslib_1.__exportStar(__webpack_require__(50), exports);
	tslib_1.__exportStar(__webpack_require__(53), exports);
	tslib_1.__exportStar(__webpack_require__(54), exports);
	tslib_1.__exportStar(__webpack_require__(49), exports);
	var sha = util_1.cached(sha1_1.default);
	function hash(value, length) {
	    if (length === void 0) { length = 32; }
	    return sha(value).slice(0, length);
	}
	exports.hash = hash;
	function isNativeFunction(value) {
	    return (typeof value === 'function' &&
	        value.toString().indexOf('[native code]') !== -1);
	}
	exports.isNativeFunction = isNativeFunction;
	function createError(_a) {
	    var message = _a.message, type = _a.type;
	    var error = new Error(message);
	    error.type = type;
	    return error;
	}
	exports.createError = createError;
	var p = Promise.resolve();
	function nextTick(fn) {
	    return p.then(fn);
	}
	exports.nextTick = nextTick;
	var cache = Object.create(null);
	function isCached(key, value) {
	    if (util_1.hasOwn(cache, key)) {
	        return {
	            cached: true,
	            value: cache[key]
	        };
	    }
	    cache[key] = util_1.isUndef(value)
	        ? true
	        : util_1.isFunction(value)
	            ? value()
	            : value;
	    return {
	        cached: false,
	        value: cache[key]
	    };
	}
	exports.isCached = isCached;
	function deepSearch(ary, item) {
	    var index = -1;
	    ary.some(function (value, i) {
	        if (deep_equal_1.deepEqual(value, item)) {
	            index = i;
	            return true;
	        }
	        return false;
	    });
	    return index;
	}
	exports.deepSearch = deepSearch;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, global) {'use strict';

	/**
	 * @this {Promise}
	 */
	function finallyConstructor(callback) {
	  var constructor = this.constructor;
	  return this.then(
	    function(value) {
	      // @ts-ignore
	      return constructor.resolve(callback()).then(function() {
	        return value;
	      });
	    },
	    function(reason) {
	      // @ts-ignore
	      return constructor.resolve(callback()).then(function() {
	        // @ts-ignore
	        return constructor.reject(reason);
	      });
	    }
	  );
	}

	// Store setTimeout reference so promise-polyfill will be unaffected by
	// other code modifying setTimeout (like sinon.useFakeTimers())
	var setTimeoutFunc = setTimeout;

	function isArray(x) {
	  return Boolean(x && typeof x.length !== 'undefined');
	}

	function noop() {}

	// Polyfill for Function.prototype.bind
	function bind(fn, thisArg) {
	  return function() {
	    fn.apply(thisArg, arguments);
	  };
	}

	/**
	 * @constructor
	 * @param {Function} fn
	 */
	function Promise(fn) {
	  if (!(this instanceof Promise))
	    throw new TypeError('Promises must be constructed via new');
	  if (typeof fn !== 'function') throw new TypeError('not a function');
	  /** @type {!number} */
	  this._state = 0;
	  /** @type {!boolean} */
	  this._handled = false;
	  /** @type {Promise|undefined} */
	  this._value = undefined;
	  /** @type {!Array<!Function>} */
	  this._deferreds = [];

	  doResolve(fn, this);
	}

	function handle(self, deferred) {
	  while (self._state === 3) {
	    self = self._value;
	  }
	  if (self._state === 0) {
	    self._deferreds.push(deferred);
	    return;
	  }
	  self._handled = true;
	  Promise._immediateFn(function() {
	    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
	      return;
	    }
	    var ret;
	    try {
	      ret = cb(self._value);
	    } catch (e) {
	      reject(deferred.promise, e);
	      return;
	    }
	    resolve(deferred.promise, ret);
	  });
	}

	function resolve(self, newValue) {
	  try {
	    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	    if (newValue === self)
	      throw new TypeError('A promise cannot be resolved with itself.');
	    if (
	      newValue &&
	      (typeof newValue === 'object' || typeof newValue === 'function')
	    ) {
	      var then = newValue.then;
	      if (newValue instanceof Promise) {
	        self._state = 3;
	        self._value = newValue;
	        finale(self);
	        return;
	      } else if (typeof then === 'function') {
	        doResolve(bind(then, newValue), self);
	        return;
	      }
	    }
	    self._state = 1;
	    self._value = newValue;
	    finale(self);
	  } catch (e) {
	    reject(self, e);
	  }
	}

	function reject(self, newValue) {
	  self._state = 2;
	  self._value = newValue;
	  finale(self);
	}

	function finale(self) {
	  if (self._state === 2 && self._deferreds.length === 0) {
	    Promise._immediateFn(function() {
	      if (!self._handled) {
	        Promise._unhandledRejectionFn(self._value);
	      }
	    });
	  }

	  for (var i = 0, len = self._deferreds.length; i < len; i++) {
	    handle(self, self._deferreds[i]);
	  }
	  self._deferreds = null;
	}

	/**
	 * @constructor
	 */
	function Handler(onFulfilled, onRejected, promise) {
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}

	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, self) {
	  var done = false;
	  try {
	    fn(
	      function(value) {
	        if (done) return;
	        done = true;
	        resolve(self, value);
	      },
	      function(reason) {
	        if (done) return;
	        done = true;
	        reject(self, reason);
	      }
	    );
	  } catch (ex) {
	    if (done) return;
	    done = true;
	    reject(self, ex);
	  }
	}

	Promise.prototype['catch'] = function(onRejected) {
	  return this.then(null, onRejected);
	};

	Promise.prototype.then = function(onFulfilled, onRejected) {
	  // @ts-ignore
	  var prom = new this.constructor(noop);

	  handle(this, new Handler(onFulfilled, onRejected, prom));
	  return prom;
	};

	Promise.prototype['finally'] = finallyConstructor;

	Promise.all = function(arr) {
	  return new Promise(function(resolve, reject) {
	    if (!isArray(arr)) {
	      return reject(new TypeError('Promise.all accepts an array'));
	    }

	    var args = Array.prototype.slice.call(arr);
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;

	    function res(i, val) {
	      try {
	        if (val && (typeof val === 'object' || typeof val === 'function')) {
	          var then = val.then;
	          if (typeof then === 'function') {
	            then.call(
	              val,
	              function(val) {
	                res(i, val);
	              },
	              reject
	            );
	            return;
	          }
	        }
	        args[i] = val;
	        if (--remaining === 0) {
	          resolve(args);
	        }
	      } catch (ex) {
	        reject(ex);
	      }
	    }

	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};

	Promise.resolve = function(value) {
	  if (value && typeof value === 'object' && value.constructor === Promise) {
	    return value;
	  }

	  return new Promise(function(resolve) {
	    resolve(value);
	  });
	};

	Promise.reject = function(value) {
	  return new Promise(function(resolve, reject) {
	    reject(value);
	  });
	};

	Promise.race = function(arr) {
	  return new Promise(function(resolve, reject) {
	    if (!isArray(arr)) {
	      return reject(new TypeError('Promise.race accepts an array'));
	    }

	    for (var i = 0, len = arr.length; i < len; i++) {
	      Promise.resolve(arr[i]).then(resolve, reject);
	    }
	  });
	};

	// Use polyfill for setImmediate for performance gains
	Promise._immediateFn =
	  // @ts-ignore
	  (typeof setImmediate === 'function' &&
	    function(fn) {
	      // @ts-ignore
	      setImmediate(fn);
	    }) ||
	  function(fn) {
	    setTimeoutFunc(fn, 0);
	  };

	Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
	  if (typeof console !== 'undefined' && console) {
	    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
	  }
	};

	/** @suppress {undefinedVars} */
	var globalNS = (function() {
	  // the only reliable means to get the global object is
	  // `Function('return this')()`
	  // However, this causes CSP violations in Chrome apps.
	  if (typeof self !== 'undefined') {
	    return self;
	  }
	  if (typeof window !== 'undefined') {
	    return window;
	  }
	  if (typeof global !== 'undefined') {
	    return global;
	  }
	  throw new Error('unable to locate global object');
	})();

	if (!('Promise' in globalNS)) {
	  globalNS['Promise'] = Promise;
	} else if (!globalNS.Promise.prototype['finally']) {
	  globalNS.Promise.prototype['finally'] = finallyConstructor;
	}

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).setImmediate, (function() { return this; }())))

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;

	// DOM APIs, for completeness

	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};

	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};

	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};

	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};

	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);

	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};

	// setimmediate attaches itself to the global object
	__webpack_require__(46);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";

	    if (global.setImmediate) {
	        return;
	    }

	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;

	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }

	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }

	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }

	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }

	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }

	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }

	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };

	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }

	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }

	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };

	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }

	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }

	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }

	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();

	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();

	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();

	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();

	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }

	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(47)))

/***/ }),
/* 47 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};

	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.

	var cachedSetTimeout;
	var cachedClearTimeout;

	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }


	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }



	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;

	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}

	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;

	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}

	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};

	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};

	function noop() {}

	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;

	process.listeners = function (name) { return [] }

	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};

	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	/*
	 * https://raw.githubusercontent.com/kvz/locutus/master/src/php/strings/sha1.js
	 */
	function sha1(str) {
	    var hash

	    var _rotLeft = function(n, s) {
	        var t4 = (n << s) | (n >>> (32 - s))
	        return t4
	    }

	    var _cvtHex = function(val) {
	        var str = ''
	        var i
	        var v

	        for (i = 7; i >= 0; i--) {
	            v = (val >>> (i * 4)) & 0x0f
	            str += v.toString(16)
	        }
	        return str
	    }

	    var blockstart
	    var i, j
	    var W = new Array(80)
	    var H0 = 0x67452301
	    var H1 = 0xefcdab89
	    var H2 = 0x98badcfe
	    var H3 = 0x10325476
	    var H4 = 0xc3d2e1f0
	    var A, B, C, D, E
	    var temp

	    // utf8_encode
	    str = unescape(encodeURIComponent(str))
	    var strLen = str.length

	    var wordArray = []
	    for (i = 0; i < strLen - 3; i += 4) {
	        j =
	            (str.charCodeAt(i) << 24) |
	            (str.charCodeAt(i + 1) << 16) |
	            (str.charCodeAt(i + 2) << 8) |
	            str.charCodeAt(i + 3)
	        wordArray.push(j)
	    }

	    switch (strLen % 4) {
	        case 0:
	            i = 0x080000000
	            break
	        case 1:
	            i = (str.charCodeAt(strLen - 1) << 24) | 0x0800000
	            break
	        case 2:
	            i =
	                (str.charCodeAt(strLen - 2) << 24) |
	                (str.charCodeAt(strLen - 1) << 16) |
	                0x08000
	            break
	        case 3:
	            i =
	                (str.charCodeAt(strLen - 3) << 24) |
	                (str.charCodeAt(strLen - 2) << 16) |
	                (str.charCodeAt(strLen - 1) << 8) |
	                0x80
	            break
	    }

	    wordArray.push(i)

	    while (wordArray.length % 16 !== 14) {
	        wordArray.push(0)
	    }

	    wordArray.push(strLen >>> 29)
	    wordArray.push((strLen << 3) & 0x0ffffffff)

	    for (blockstart = 0; blockstart < wordArray.length; blockstart += 16) {
	        for (i = 0; i < 16; i++) {
	            W[i] = wordArray[blockstart + i]
	        }
	        for (i = 16; i <= 79; i++) {
	            W[i] = _rotLeft(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1)
	        }

	        A = H0
	        B = H1
	        C = H2
	        D = H3
	        E = H4

	        for (i = 0; i <= 19; i++) {
	            temp =
	                (_rotLeft(A, 5) +
	                    ((B & C) | (~B & D)) +
	                    E +
	                    W[i] +
	                    0x5a827999) &
	                0x0ffffffff
	            E = D
	            D = C
	            C = _rotLeft(B, 30)
	            B = A
	            A = temp
	        }

	        for (i = 20; i <= 39; i++) {
	            temp =
	                (_rotLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) &
	                0x0ffffffff
	            E = D
	            D = C
	            C = _rotLeft(B, 30)
	            B = A
	            A = temp
	        }

	        for (i = 40; i <= 59; i++) {
	            temp =
	                (_rotLeft(A, 5) +
	                    ((B & C) | (B & D) | (C & D)) +
	                    E +
	                    W[i] +
	                    0x8f1bbcdc) &
	                0x0ffffffff
	            E = D
	            D = C
	            C = _rotLeft(B, 30)
	            B = A
	            A = temp
	        }

	        for (i = 60; i <= 79; i++) {
	            temp =
	                (_rotLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) &
	                0x0ffffffff
	            E = D
	            D = C
	            C = _rotLeft(B, 30)
	            B = A
	            A = temp
	        }

	        H0 = (H0 + A) & 0x0ffffffff
	        H1 = (H1 + B) & 0x0ffffffff
	        H2 = (H2 + C) & 0x0ffffffff
	        H3 = (H3 + D) & 0x0ffffffff
	        H4 = (H4 + E) & 0x0ffffffff
	    }

	    temp = _cvtHex(H0) + _cvtHex(H1) + _cvtHex(H2) + _cvtHex(H3) + _cvtHex(H4)
	    return temp.toLowerCase()
	}

	module.exports = sha1


/***/ }),
/* 49 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * 空函数
	 */
	// tslint:disable-next-line
	function noop() { }
	exports.noop = noop;
	/**
	 * 判断是否是未定义
	 * @param value 入参cd
	 * @returns true/false，undefined、null返回true
	 */
	function isUndef(value) {
	    return value === undefined || value === null;
	}
	exports.isUndef = isUndef;
	/**
	 * 判断是否为空 undefined、null、空字符串返回true
	 * @param value 入参
	 */
	function isEmpty(value) {
	    return value === undefined || value === null || value === '';
	}
	exports.isEmpty = isEmpty;
	function isType(type) {
	    return function (value) { return Object.prototype.toString.call(value) === "[object " + type + "]"; };
	}
	/**
	 * 判断是否为Number类型
	 * @param value 入参
	 */
	function isNumber(value) {
	    return isType('Number')(value);
	}
	exports.isNumber = isNumber;
	/**
	 * 判断是否为String类型
	 * @param value 入参
	 */
	function isString(value) {
	    return isType('String')(value);
	}
	exports.isString = isString;
	/**
	 * 判断是否为Error类型
	 * @param value 入参
	 */
	function isError(value) {
	    return isType('Error')(value);
	}
	exports.isError = isError;
	/**
	 * 判断是否为Array类型
	 * @param value 入参
	 */
	function isArray(value) {
	    return isType('Array')(value);
	}
	exports.isArray = isArray;
	/**
	 * 判断是否为Function类型，async function为true
	 * @param value 入参
	 */
	function isFunction(value) {
	    return typeof value === 'function';
	}
	exports.isFunction = isFunction;
	/**
	 * 判断是否为Date类型
	 * @param value 入参
	 */
	function isDate(value) {
	    return isType('Date')(value);
	}
	exports.isDate = isDate;
	/**
	 * 判断是否为Boolean 类型
	 * @param value 入参
	 */
	function isBoolean(value) {
	    return isType('Boolean')(value);
	}
	exports.isBoolean = isBoolean;
	/**
	 * 判断是否为严格Object类型
	 * @param value 入参
	 */
	function isObject(value) {
	    return isType('Object')(value);
	}
	exports.isObject = isObject;
	/**
	 * 判断是否为泛object，不包括null
	 * @param value 入参
	 */
	function isWideObject(value) {
	    return value !== null && typeof value === 'object';
	}
	exports.isWideObject = isWideObject;
	/**
	 * 是否为FormData实例 不支持FormData时返回false
	 * @param value - 入参
	 */
	function isFormData(value) {
	    return typeof FormData !== 'undefined' && value instanceof FormData;
	}
	exports.isFormData = isFormData;
	/**
	 * 是否为URLSearchParams实例 不支持URLSearchParams时返回false
	 * @param value - 入参
	 */
	function isURLSearchParams(value) {
	    return (typeof URLSearchParams !== 'undefined' &&
	        value instanceof URLSearchParams);
	}
	exports.isURLSearchParams = isURLSearchParams;
	/**
	 * 对象是否有某个实例属性
	 * @param obj 对象
	 * @param key 对象的属性
	 */
	function hasOwn(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	exports.hasOwn = hasOwn;
	/**
	 * 循环对象和数组
	 * @param obj 对象或者数组
	 * @param fn 回调函数
	 */
	function forEach(obj, fn) {
	    if (isArray(obj)) {
	        // Iterate over array values
	        for (var i = 0, l = obj.length; i < l; i++) {
	            fn.call(null, obj[i], i, obj);
	        }
	    }
	    else if (isObject(obj)) {
	        // Iterate over object keys
	        for (var key in obj) {
	            if (hasOwn(obj, key)) {
	                fn.call(null, obj[key], key, obj);
	            }
	        }
	    }
	}
	exports.forEach = forEach;
	/**
	 * 合并多个对象
	 * @param targetOrDeep 目标对象或者是否深度合并
	 * @param sources 多个源对象
	 * @returns target 目标对象
	 */
	function merge(targetOrDeep) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    var deep;
	    var target;
	    if (isBoolean(targetOrDeep)) {
	        deep = targetOrDeep;
	        target = sources.shift();
	    }
	    else {
	        target = targetOrDeep;
	    }
	    forEach(sources, function (source) {
	        forEach(source, function (value, key) {
	            if (deep && (isArray(value) || isObject(value))) {
	                if (isArray(value)) {
	                    if (!isArray(target[key])) {
	                        target[key] = [];
	                    }
	                }
	                else {
	                    if (!isObject(target[key])) {
	                        target[key] = {};
	                    }
	                }
	                merge(deep, target[key], value);
	            }
	            else {
	                target[key] = value;
	            }
	        });
	    });
	    return target;
	}
	exports.merge = merge;
	/**
	 * 防抖函数
	 * @param fn 执行函数
	 * @param delay 延迟时间
	 * @returns 防抖函数
	 */
	function debounce(fn, delay) {
	    if (delay === void 0) { delay = 200; }
	    var timer;
	    return function () {
	        var _this = this;
	        var args = arguments;
	        clearTimeout(timer);
	        timer = setTimeout(function () {
	            fn.apply(_this, toArray(args));
	        }, delay);
	    };
	}
	exports.debounce = debounce;
	/**
	 * array like to realy array
	 * @param value 类数组
	 * @returns 数组
	 */
	function toArray(value) {
	    return Array.prototype.slice.call(value);
	}
	exports.toArray = toArray;
	/**
	 * 比较两个版本
	 * @param a 版本a
	 * @param b 版本b
	 * @returns 0：a===b，1：a>b，-1：a<b，其余异常情况均为undefined
	 */
	function compareVersion(a, b) {
	    if (isEmpty(a) || isEmpty(b)) {
	        return;
	    }
	    if (a === b) {
	        return 0;
	    }
	    var sa = a.split('.');
	    var sb = b.split('.');
	    var min = Math.min(sa.length, sb.length);
	    // loop while the components are equal
	    for (var i = 0; i < min; i++) {
	        var ai = parseInt(sa[i], 10);
	        var bi = parseInt(sb[i], 10);
	        if (isNaN(ai) || isNaN(bi)) {
	            return;
	        }
	        // A bigger than B
	        if (ai > bi) {
	            return 1;
	        }
	        // B bigger than A
	        if (ai < bi) {
	            return -1;
	        }
	    }
	    // If one's a prefix of the other, the longer one is greater.
	    // 1.2.0 > 1.2
	    if (sa.length > sb.length) {
	        return 1;
	    }
	    if (sa.length < sb.length) {
	        return -1;
	    }
	}
	exports.compareVersion = compareVersion;
	/**
	 * 缓存函数结果
	 * @param fn
	 * @returns function
	 */
	function cached(fn) {
	    // create no prototype object
	    var cache = Object.create(null);
	    return function cachedFn(value) {
	        var hit = cache[value];
	        return hit || (cache[value] = fn(value));
	    };
	}
	exports.cached = cached;
	var camelizeRE = /-(\w)/g;
	/**
	 * 驼峰
	 * @param str
	 * @returns aBC
	 * 例如 输入a-b-c 返回aBC
	 */
	function camelize(str) {
	    var cache = cached(function (str) {
	        return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
	    });
	    return cache(str);
	}
	exports.camelize = camelize;
	var decamelizeRE = /([A-Z])/g;
	/**
	 * 取消驼峰
	 * @param str
	 * @returns a-b-c
	 * 例如 输入aBC 返回a-b-c
	 */
	function decamelize(str) {
	    var cache = cached(function (str) {
	        return str.replace(decamelizeRE, '-$1').toLowerCase();
	    });
	    return cache(str);
	}
	exports.decamelize = decamelize;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.deepEqual = void 0;
	var util_1 = __webpack_require__(49);
	// from https://stackoverflow.com/questions/1068834/object-comparison-in-javascript
	function deepEqual(x, y) {
	    if (x === y) {
	        return true;
	    }
	    // if both x and y are null or undefined and exactly the same
	    if (!(x instanceof Object) || !(y instanceof Object)) {
	        return false;
	    }
	    // if they are not strictly equal, they both need to be Objects
	    if (x.constructor !== y.constructor) {
	        return false;
	    }
	    // they must have the exact same prototype chain, the closest we can do is
	    // test there constructor.
	    var p;
	    for (p in x) {
	        if (!util_1.hasOwn(x, p)) {
	            continue;
	        }
	        // other properties were tested using x.constructor === y.constructor
	        if (!util_1.hasOwn(y, p)) {
	            return false;
	        }
	        // allows to compare x[ p ] and y[ p ] when set to undefined
	        if (x[p] === y[p]) {
	            continue;
	        }
	        // if they have the same strict value or identity then they are equal
	        if (typeof x[p] !== 'object') {
	            return false;
	        }
	        // Numbers, Strings, Functions, Booleans must be strictly equal
	        if (!deepEqual(x[p], y[p])) {
	            return false;
	        }
	        // Objects and Arrays must be tested recursively
	    }
	    for (p in y) {
	        if (util_1.hasOwn(y, p) && !util_1.hasOwn(x, p)) {
	            return false;
	        }
	        // allows x[ p ] to be set to undefined
	    }
	    return true;
	}
	exports.deepEqual = deepEqual;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var _a;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.CacheQueue = void 0;
	var util_1 = __webpack_require__(49);
	var STATUS_TO_METHOD_MAP = (_a = {},
	    _a["rejected" /* REJECTED */] = 'reject',
	    _a["resolved" /* RESOLVED */] = 'resolve',
	    _a);
	var CacheQueue = /** @class */ (function () {
	    function CacheQueue(options) {
	        if (options === void 0) { options = { stateful: true }; }
	        this.queue = [];
	        this.status = "pending" /* PENDING */;
	        this.args = [];
	        this.options = options;
	    }
	    CacheQueue.prototype.push = function (item) {
	        if (this.options.stateful && this.status !== "pending" /* PENDING */) {
	            var fn = item[STATUS_TO_METHOD_MAP[this.status]];
	            util_1.isFunction(fn) &&
	                fn.apply(undefined, this.args);
	            return;
	        }
	        this.queue.indexOf(item) === -1 && this.queue.push(item);
	    };
	    CacheQueue.prototype.resolve = function () {
	        this.execute("resolved" /* RESOLVED */, util_1.toArray(arguments));
	    };
	    CacheQueue.prototype.reject = function () {
	        this.execute("rejected" /* REJECTED */, util_1.toArray(arguments));
	    };
	    CacheQueue.prototype.execute = function (status, args) {
	        this.queue.forEach(function (item) {
	            var fn = item[STATUS_TO_METHOD_MAP[status]];
	            util_1.isFunction(fn) && fn.apply(undefined, args);
	        });
	        // if is stateful cache queue
	        if (this.options.stateful) {
	            this.status = status;
	            this.args = args;
	            this.queue.length = 0;
	        }
	    };
	    return CacheQueue;
	}());
	exports.CacheQueue = CacheQueue;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.stringifyJSON = exports.isEmptyObject = exports.parseJSON = void 0;
	var util_1 = __webpack_require__(49);
	function parseJSON(value) {
	    try {
	        return JSON.parse(value);
	    }
	    catch (e) {
	        return value;
	    }
	}
	exports.parseJSON = parseJSON;
	function isEmptyObject(obj) {
	    return !Object.keys(obj).length;
	}
	exports.isEmptyObject = isEmptyObject;
	function stringifyJSON(value) {
	    try {
	        // empty object,array return ''
	        if (util_1.isWideObject(value) && isEmptyObject(value)) {
	            return '';
	        }
	        return JSON.stringify(value);
	    }
	    catch (e) {
	        return '';
	    }
	}
	exports.stringifyJSON = stringifyJSON;


/***/ }),
/* 53 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Hooks = void 0;
	/**
	 * Hooks类
	 */
	var Hooks = /** @class */ (function () {
	    function Hooks() {
	        this.hooks = Object.create(null);
	    }
	    /**
	     * push方法，该方法作用为插入指定钩子函数。
	     * @param name hook名称
	     * @param callback hook hook回调函数
	     * @returns Hooks实例
	     */
	    Hooks.prototype.push = function (name, callback) {
	        var callbacks = this.hooks[name] || (this.hooks[name] = []);
	        if (typeof callback === 'function') {
	            callbacks.push(callback);
	        }
	        return this;
	    };
	    Hooks.prototype.invoke = function (name, args) {
	        var fns = this.hooks[name];
	        if (!fns || !fns.length) {
	            return this;
	        }
	        fns.forEach(function (fn) {
	            fn(args);
	        });
	        return this;
	    };
	    Hooks.prototype.invokeWaterfall = function (name, args, callback) {
	        var fns = this.hooks[name];
	        if (!fns || !fns.length) {
	            callback();
	            return this;
	        }
	        var i = 0;
	        function next(error) {
	            if (error instanceof Error) {
	                return callback(error);
	            }
	            i++;
	            if (i >= fns.length) {
	                return callback();
	            }
	            fns[i](args, next);
	        }
	        fns[i](args, next);
	        return this;
	    };
	    return Hooks;
	}());
	exports.Hooks = Hooks;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.decoupler = exports.Decoupler = void 0;
	var util_1 = __webpack_require__(49);
	var Decoupler = /** @class */ (function () {
	    function Decoupler() {
	        this.handlers = {};
	    }
	    Decoupler.prototype.on = function (name, handler, excuteEvenThoughEmited) {
	        if (excuteEvenThoughEmited === void 0) { excuteEvenThoughEmited = false; }
	        var events = this.handlers[name] || [];
	        if (typeof handler === 'function') {
	            // 如果事件已被触发，依旧执行新的监听函数
	            if (excuteEvenThoughEmited && events.__emited) {
	                handler.call(undefined, events.__args);
	                return this;
	            }
	            events.push(handler);
	            this.handlers[name] = events;
	        }
	        return this;
	    };
	    Decoupler.prototype.once = function (name, handler, excuteEvenThoughEmited) {
	        if (excuteEvenThoughEmited === void 0) { excuteEvenThoughEmited = false; }
	        var _this = this;
	        if (typeof handler !== 'function') {
	            return this;
	        }
	        function fn() {
	            _this.off(name, fn);
	            handler.apply(this, util_1.toArray(arguments));
	        }
	        return this.on(name, fn, excuteEvenThoughEmited);
	    };
	    Decoupler.prototype.emit = function (name, args) {
	        var events = this.handlers[name] || [];
	        if (events) {
	            events.forEach(function (event) {
	                event.call(undefined, args);
	            });
	            // 记录事件触发状态
	            events.__args = args;
	            events.__emited = true;
	            this.handlers[name] = events;
	        }
	        return this;
	    };
	    Decoupler.prototype.off = function (name, handler) {
	        var events = this.handlers[name];
	        if (events && typeof handler === 'function') {
	            var i = events.indexOf(handler);
	            i !== -1 && events.splice(i, 1);
	        }
	        return this;
	    };
	    return Decoupler;
	}());
	exports.Decoupler = Decoupler;
	exports.decoupler = new Decoupler();


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.PARAM_SOURCE_NAMES = exports.STORAGE_LOGS_KEY = exports.STORAGE_VISITOR_ID_KEY = exports.STORAGE_SESSION_ID_KEY = exports.STORAGE_PREFIX = exports.COOKIE_SPIDER_TOKEN_PREFIX = exports.COOKIE_VISITOR_ID_KEY = exports.COOKIE_SESSION_ID_KEY = exports.COOKIE_PREFIX = exports.SPM_ATTRIBUTE_KEY = exports.MAX_PAGE_LOADED_TIME = exports.SUPPORT_PERFORMANCE = exports.SUPPORT_SEND_BEACON = exports.DOCUMENT = exports.GLOBAL = void 0;
	var shared_1 = __webpack_require__(41);
	exports.GLOBAL = window;
	exports.DOCUMENT = document;
	exports.SUPPORT_SEND_BEACON = !!navigator.sendBeacon;
	exports.SUPPORT_PERFORMANCE = !!(exports.GLOBAL.performance && exports.GLOBAL.performance.getEntries);
	exports.MAX_PAGE_LOADED_TIME = 1500;
	exports.SPM_ATTRIBUTE_KEY = 'data-spider';
	exports.COOKIE_PREFIX = '__spider__';
	exports.COOKIE_SESSION_ID_KEY = exports.COOKIE_PREFIX + shared_1.SESSION_ID_KEY;
	exports.COOKIE_VISITOR_ID_KEY = exports.COOKIE_PREFIX + shared_1.VISITOR_ID_KEY;
	exports.COOKIE_SPIDER_TOKEN_PREFIX = exports.COOKIE_PREFIX + 'token';
	exports.STORAGE_PREFIX = '__kernel__';
	exports.STORAGE_SESSION_ID_KEY = exports.STORAGE_PREFIX + shared_1.SESSION_ID_KEY;
	exports.STORAGE_VISITOR_ID_KEY = exports.STORAGE_PREFIX + shared_1.VISITOR_ID_KEY;
	exports.STORAGE_LOGS_KEY = exports.STORAGE_PREFIX + shared_1.LOGS_KEY;
	// param标签与资源相关的名称
	exports.PARAM_SOURCE_NAMES = ['url', 'src', 'filename'];


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	tslib_1.__exportStar(__webpack_require__(57), exports);
	tslib_1.__exportStar(__webpack_require__(63), exports);
	tslib_1.__exportStar(__webpack_require__(64), exports);
	tslib_1.__exportStar(__webpack_require__(99), exports);
	tslib_1.__exportStar(__webpack_require__(100), exports);
	tslib_1.__exportStar(__webpack_require__(92), exports);
	tslib_1.__exportStar(__webpack_require__(93), exports);
	tslib_1.__exportStar(__webpack_require__(91), exports);
	tslib_1.__exportStar(__webpack_require__(96), exports);
	tslib_1.__exportStar(__webpack_require__(110), exports);
	tslib_1.__exportStar(__webpack_require__(112), exports);
	tslib_1.__exportStar(__webpack_require__(97), exports);
	var storage_1 = __webpack_require__(113);
	Object.defineProperty(exports, "getStorage", { enumerable: true, get: function () { return storage_1.get; } });
	Object.defineProperty(exports, "setStorage", { enumerable: true, get: function () { return storage_1.set; } });
	Object.defineProperty(exports, "removeStorage", { enumerable: true, get: function () { return storage_1.remove; } });


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(58);
	var querystring_1 = __webpack_require__(59);
	var util = __webpack_require__(60);
	var url_1 = __webpack_require__(62);
	exports.Url = url_1.Url;
	/**
	 * 设置url地址的querystring。
	 * @param url 链接地址，如果url为null/undefined，则以当前页面url作为默认值。
	 * @param params 参数对象。
	 * @param options 设置参数合并规则，具体见参数合并规则。
	 * @returns 设置后的url地址。
	 */
	function setQuerystring(url, params, options) {
	    // get window href
	    var href = constants_1.GLOBAL.location.href;
	    // normalize arguments
	    if (util.isObject(url)) {
	        options = params;
	        params = url;
	        url = href;
	    }
	    // set href if url is undefined/null
	    if (util.isUndef(url)) {
	        url = href;
	    }
	    // merge options
	    options = util.merge({
	        replace: true
	    }, options);
	    var instance = new url_1.Url(url);
	    if (options.replace) {
	        // merge params if is replace
	        instance.query = util.merge(instance.query || {}, params);
	    }
	    else {
	        var search = querystring_1.stringify(params);
	        if (search) {
	            var delimit = instance.search.indexOf(constants_1.SEARCH_DELIMIT) === -1
	                ? constants_1.SEARCH_DELIMIT
	                : constants_1.PARAM_DELIMIT;
	            instance.search += delimit + search;
	        }
	    }
	    return instance.toString();
	}
	exports.setQuerystring = setQuerystring;
	/**
	 * 获取传入url地址的参数对象。
	 * @param url 链接地址 如果url为null/undefined，则以当前页面url作为默认值，如果url为相对地址，不进行url规整化处理。
	 * @returns 序列化后的参数对象。
	 */
	function getQuerystring(url) {
	    if (util.isUndef(url)) {
	        url = constants_1.GLOBAL.location.href;
	    }
	    return querystring_1.parse(url);
	}
	exports.getQuerystring = getQuerystring;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SEARCH_DELIMIT = '?';
	exports.PARAM_DELIMIT = '&';
	exports.PARAM_VALUE_DELIMIT = '=';
	exports.HASH_DELIMIT = '#';
	exports.GLOBAL = window;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(60);
	var constants_1 = __webpack_require__(58);
	var SEARCH_REGXP = /^[^\?#]*\?([^#]*)/;
	function getSearch(url) {
	    var matchs;
	    return (url && (matchs = url.match(SEARCH_REGXP)) && matchs[1]) || '';
	}
	// encodeURIComponent将空格转换为%20，浏览器、Java、Php均能转换为空格
	// URLSearchParams、URL将空格转换为+，浏览器、Java、Php均能转换为空格
	// 此处不遵循RFC-1738规范，依旧将空格转换为%20，为了兼容业务或者其他开源库处理参数时，未将+转换为空格，这种做法兼容性更友好
	function encode(value) {
	    return encodeURIComponent(value);
	}
	// 遵循RFC-1738规范，将+转换为空格，%20同时也转换为空格
	// 将Java、Php传递的+转换为对应的空格，兼容RFC-1738规范，前提是参数一定是编码过的，未编码的参数不符合参数处理规范。
	function decode(value) {
	    return decodeURIComponent(value.replace(/\+/g, ' '));
	}
	/**
	 * @ignore
	 */
	function parse(url) {
	    // get search string
	    url = getSearch(url);
	    // split params
	    var parts = url.split(constants_1.PARAM_DELIMIT);
	    var params = {};
	    parts.forEach(function (param) {
	        // if param is empty
	        if (!param) {
	            return;
	        }
	        // split param value
	        var splits = param.split(constants_1.PARAM_VALUE_DELIMIT);
	        var name = splits[0];
	        // param is ?a=a=1&b=1
	        // set param = '' if querystring is '?param'
	        var value = splits.slice(1).join(constants_1.PARAM_VALUE_DELIMIT) || '';
	        if (name) {
	            name = decode(name);
	            value = decode(value);
	            if (util.hasOwn(params, name)) {
	                if (!util.isArray(params[name])) {
	                    params[name] = [params[name]];
	                }
	                // tslint:disable-next-line
	                ;
	                params[name].push(value);
	            }
	            else {
	                params[name] = value;
	            }
	        }
	    });
	    return params;
	}
	exports.parse = parse;
	/**
	 * @ignore
	 */
	function stringify(params) {
	    /* istanbul ignore next */
	    if (!util.isObject(params)) {
	        return '';
	    }
	    var search = [];
	    util.forEach(params, function (value, name) {
	        if (!util.isUndef(value)) {
	            if (!util.isArray(value)) {
	                value = [value];
	            }
	            name = encode(name);
	            // normalize {name:array} param to name=array[0]&name=array[1]
	            value.forEach(function (val) {
	                search.push("" + name + constants_1.PARAM_VALUE_DELIMIT + encode(val));
	            });
	        }
	    });
	    return search.join(constants_1.PARAM_DELIMIT);
	}
	exports.stringify = stringify;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(61));


/***/ }),
/* 61 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * 空函数
	 */
	// tslint:disable-next-line
	function noop() { }
	exports.noop = noop;
	/**
	 * 判断是否是未定义
	 * @param value 入参cd
	 * @returns true/false，undefined、null返回true
	 */
	function isUndef(value) {
	    return value === undefined || value === null;
	}
	exports.isUndef = isUndef;
	/**
	 * 判断是否为空 undefined、null、空字符串返回true
	 * @param value 入参
	 */
	function isEmpty(value) {
	    return value === undefined || value === null || value === '';
	}
	exports.isEmpty = isEmpty;
	function isType(type) {
	    return function (value) { return Object.prototype.toString.call(value) === "[object " + type + "]"; };
	}
	/**
	 * 判断是否为Number类型
	 * @param value 入参
	 */
	function isNumber(value) {
	    return isType('Number')(value);
	}
	exports.isNumber = isNumber;
	/**
	 * 判断是否为String类型
	 * @param value 入参
	 */
	function isString(value) {
	    return isType('String')(value);
	}
	exports.isString = isString;
	/**
	 * 判断是否为Error类型
	 * @param value 入参
	 */
	function isError(value) {
	    return isType('Error')(value);
	}
	exports.isError = isError;
	/**
	 * 判断是否为Array类型
	 * @param value 入参
	 */
	function isArray(value) {
	    return isType('Array')(value);
	}
	exports.isArray = isArray;
	/**
	 * 判断是否为Function类型，async function为true
	 * @param value 入参
	 */
	function isFunction(value) {
	    return typeof value === 'function';
	}
	exports.isFunction = isFunction;
	/**
	 * 判断是否为Date类型
	 * @param value 入参
	 */
	function isDate(value) {
	    return isType('Date')(value);
	}
	exports.isDate = isDate;
	/**
	 * 判断是否为Boolean 类型
	 * @param value 入参
	 */
	function isBoolean(value) {
	    return isType('Boolean')(value);
	}
	exports.isBoolean = isBoolean;
	/**
	 * 判断是否为严格Object类型
	 * @param value 入参
	 */
	function isObject(value) {
	    return isType('Object')(value);
	}
	exports.isObject = isObject;
	/**
	 * 判断是否为泛object，不包括null
	 * @param value 入参
	 */
	function isWideObject(value) {
	    return value !== null && typeof value === 'object';
	}
	exports.isWideObject = isWideObject;
	/**
	 * 是否为FormData实例 不支持FormData时返回false
	 * @param value - 入参
	 */
	function isFormData(value) {
	    return typeof FormData !== 'undefined' && value instanceof FormData;
	}
	exports.isFormData = isFormData;
	/**
	 * 是否为URLSearchParams实例 不支持URLSearchParams时返回false
	 * @param value - 入参
	 */
	function isURLSearchParams(value) {
	    return (typeof URLSearchParams !== 'undefined' &&
	        value instanceof URLSearchParams);
	}
	exports.isURLSearchParams = isURLSearchParams;
	/**
	 * 对象是否有某个实例属性
	 * @param obj 对象
	 * @param key 对象的属性
	 */
	function hasOwn(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	exports.hasOwn = hasOwn;
	/**
	 * 循环对象和数组
	 * @param obj 对象或者数组
	 * @param fn 回调函数
	 */
	function forEach(obj, fn) {
	    if (isArray(obj)) {
	        // Iterate over array values
	        for (var i = 0, l = obj.length; i < l; i++) {
	            fn.call(null, obj[i], i, obj);
	        }
	    }
	    else if (isObject(obj)) {
	        // Iterate over object keys
	        for (var key in obj) {
	            if (hasOwn(obj, key)) {
	                fn.call(null, obj[key], key, obj);
	            }
	        }
	    }
	}
	exports.forEach = forEach;
	/**
	 * 合并多个对象
	 * @param targetOrDeep 目标对象或者是否深度合并
	 * @param sources 多个源对象
	 * @returns target 目标对象
	 */
	function merge(targetOrDeep) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    var deep;
	    var target;
	    if (isBoolean(targetOrDeep)) {
	        deep = targetOrDeep;
	        target = sources.shift();
	    }
	    else {
	        target = targetOrDeep;
	    }
	    forEach(sources, function (source) {
	        forEach(source, function (value, key) {
	            if (deep && (isArray(value) || isObject(value))) {
	                if (isArray(value)) {
	                    if (!isArray(target[key])) {
	                        target[key] = [];
	                    }
	                }
	                else {
	                    if (!isObject(target[key])) {
	                        target[key] = {};
	                    }
	                }
	                merge(deep, target[key], value);
	            }
	            else {
	                target[key] = value;
	            }
	        });
	    });
	    return target;
	}
	exports.merge = merge;
	/**
	 * 防抖函数
	 * @param fn 执行函数
	 * @param delay 延迟时间
	 * @returns 防抖函数
	 */
	function debounce(fn, delay) {
	    if (delay === void 0) { delay = 200; }
	    var timer;
	    return function () {
	        var _this = this;
	        var args = arguments;
	        clearTimeout(timer);
	        timer = setTimeout(function () {
	            fn.apply(_this, toArray(args));
	        }, delay);
	        return timer;
	    };
	}
	exports.debounce = debounce;
	/**
	 * array like to realy array
	 * @param value 类数组
	 * @returns 数组
	 */
	function toArray(value) {
	    return Array.prototype.slice.call(value);
	}
	exports.toArray = toArray;
	/**
	 * 比较两个版本
	 * @param a 版本a
	 * @param b 版本b
	 * @returns 0：a===b，1：a>b，-1：a<b，其余异常情况均为undefined
	 */
	function compareVersion(a, b) {
	    if (isEmpty(a) || isEmpty(b)) {
	        return;
	    }
	    if (a === b) {
	        return 0;
	    }
	    var sa = a.split('.');
	    var sb = b.split('.');
	    var min = Math.min(sa.length, sb.length);
	    // loop while the components are equal
	    for (var i = 0; i < min; i++) {
	        var ai = parseInt(sa[i], 10);
	        var bi = parseInt(sb[i], 10);
	        if (isNaN(ai) || isNaN(bi)) {
	            return;
	        }
	        // A bigger than B
	        if (ai > bi) {
	            return 1;
	        }
	        // B bigger than A
	        if (ai < bi) {
	            return -1;
	        }
	    }
	    // If one's a prefix of the other, the longer one is greater.
	    // 1.2.0 > 1.2
	    if (sa.length > sb.length) {
	        return 1;
	    }
	    if (sa.length < sb.length) {
	        return -1;
	    }
	}
	exports.compareVersion = compareVersion;
	/**
	 * 缓存函数结果
	 * @param fn
	 * @returns function
	 */
	function cached(fn) {
	    // create no prototype object
	    var cache = Object.create(null);
	    return function cachedFn(value) {
	        var hit = cache[value];
	        return hit || (cache[value] = fn(value));
	    };
	}
	exports.cached = cached;
	var camelizeRE = /-(\w)/g;
	/**
	 * 驼峰
	 * @param str
	 * @returns aBC
	 * 例如 输入a-b-c 返回aBC
	 */
	function camelize(str) {
	    var cache = cached(function (str) {
	        return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
	    });
	    return cache(str);
	}
	exports.camelize = camelize;
	var decamelizeRE = /([A-Z])/g;
	/**
	 * 取消驼峰
	 * @param str
	 * @returns a-b-c
	 * 例如 输入aBC 返回a-b-c
	 */
	function decamelize(str) {
	    var cache = cached(function (str) {
	        return str.replace(decamelizeRE, '-$1').toLowerCase();
	    });
	    return cache(str);
	}
	exports.decamelize = decamelize;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(60);
	var querystring_1 = __webpack_require__(59);
	var constants_1 = __webpack_require__(58);
	var QUERY_PROPERTY = 'query';
	var NORMAL_PROPERTIES = [
	    'hash',
	    'host',
	    'hostname',
	    'pathname',
	    'port',
	    'protocol'
	];
	var QUERY_RELATED_PROPERTIES = ['href', 'search'];
	var READONLY_PROPERTIES = ['origin'];
	var defineProperty = Object.defineProperty;
	// validate url property
	function validate(name, value) {
	    if (name === QUERY_PROPERTY) {
	        return util.isObject(value);
	    }
	    return util.isString(value) || util.isNumber(value);
	}
	function getSearch(query) {
	    // stringify query to search string
	    var search = querystring_1.stringify(query);
	    // always use query as search string
	    return (search ? constants_1.SEARCH_DELIMIT : '') + search;
	}
	function defineNormalProperties(instance, element) {
	    function handler(name) {
	        defineProperty(instance, name, {
	            get: function () {
	                return element[name];
	            },
	            set: function (value) {
	                if (!validate(name, value)) {
	                    return;
	                }
	                element[name] = value;
	            },
	            enumerable: true
	        });
	    }
	    NORMAL_PROPERTIES.forEach(handler);
	}
	function defineQueryProperty(instance, element) {
	    function handler(name) {
	        defineProperty(instance, name, {
	            get: function () {
	                // set search property then normalize query
	                instance.search = getSearch(element[name]);
	                return element[name];
	            },
	            set: function (value) {
	                if (!validate(name, value)) {
	                    return;
	                }
	                element[name] = value;
	            },
	            enumerable: true
	        });
	    }
	    handler(QUERY_PROPERTY);
	}
	function defineQueryRelatedProperties(instance, element) {
	    function handler(name) {
	        defineProperty(instance, name, {
	            get: function () {
	                element.search = getSearch(element[QUERY_PROPERTY]);
	                return element[name];
	            },
	            set: function (value) {
	                if (!validate(name, value)) {
	                    return;
	                }
	                element[name] = value;
	                // sync query from search
	                element[QUERY_PROPERTY] = querystring_1.parse(element.search);
	            },
	            enumerable: true
	        });
	    }
	    QUERY_RELATED_PROPERTIES.forEach(handler);
	}
	function defineReadonlyProperties(instance, element) {
	    function handler(name) {
	        defineProperty(instance, name, {
	            get: function () {
	                return element[name];
	            },
	            enumerable: true
	        });
	    }
	    READONLY_PROPERTIES.forEach(handler);
	}
	/**
	 * Url类
	 * ```
	 * const url = new Url('https://www.weidian.com/')
	 * // get url href
	 * let href = url.href
	 * // set url href
	 * url.href = 'https://www.koudai.com/a.html'
	 * console.log(url.host) // www.koudai.com
	 * ```
	 */
	var Url = /** @class */ (function () {
	    /**
	     * Url
	     * @param url 链接地址，未传递使用当前页面链接，如果为相对地址，则会以当前页面url作为base url。
	     */
	    function Url(url) {
	        // if url is empty then set default href
	        if (util.isEmpty(url)) {
	            url = constants_1.GLOBAL.location.href;
	        }
	        // create element
	        var element = (this._element = constants_1.GLOBAL.document.createElement('A'));
	        // refresh href
	        element.href = url;
	        // define normal properties
	        defineNormalProperties(this, this._element);
	        // define query related properties
	        defineQueryRelatedProperties(this, this._element);
	        // define query property
	        defineQueryProperty(this, this._element);
	        // define readonly properties
	        defineReadonlyProperties(this, this._element);
	        // refresh query
	        this.href = element.href;
	    }
	    /**
	     * toString方法，在String(instance)调用。
	     * @returns href属性。
	     */
	    Url.prototype.toString = function () {
	        return this.href;
	    };
	    return Url;
	}());
	exports.Url = Url;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var _a;
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getQQSdk = exports.getWeiDianSdk = exports.getWeiXinSdk = exports.getWxJsConfig = exports.loadScript = void 0;
	var constants_1 = __webpack_require__(55);
	var util_1 = __webpack_require__(61);
	var shared_1 = __webpack_require__(41);
	var request_1 = __webpack_require__(64);
	var util_2 = __webpack_require__(91);
	var log_1 = __webpack_require__(96);
	var error_1 = __webpack_require__(97);
	var WEIDIAN_JSBRIDGE_URL = 'https://assets.geilicdn.com/v-components/jsbridge/1.0.3/index.min.js';
	var WEIXIN_SDK_URL = 'https://assets.geilicdn.com/v-components/cdn/jweixin/1.6.0/index.fix.min.js';
	var QQ_SDK_URL = 'https://assets.geilicdn.com/v-components/cdn/qqsdk/default/index.fix.min.js';
	// 默认wxsdk注册微店客服号公众号原始id
	var PUBLIC_ID = 'gh_c6feb778444d';
	// 默认微店客服号公众号绑定的主域名映射集合
	var PRIMARY_DOMAIN_MAP = (_a = {},
	    _a[PUBLIC_ID] = ['weidian.com', 'koudai.com', 'v5.cc'],
	    _a);
	var DEFAULT_WX_JS_APIS = [
	    'updateAppMessageShareData',
	    'updateTimelineShareData',
	    'onMenuShareTimeline',
	    'onMenuShareAppMessage',
	    'onMenuShareQQ',
	    'onMenuShareQZone',
	    'hideMenuItems',
	    'showMenuItems',
	    'chooseImage',
	    'getLocalImgData',
	    'previewImage',
	    'downloadImage',
	    'openLocation',
	    'getLocation',
	    'launch3rdApp',
	    'getInstallState',
	    'uploadImage',
	    'scanQRCode'
	];
	var DEFAULT_OPTION = {
	    mpid: PUBLIC_ID,
	    jsApiList: DEFAULT_WX_JS_APIS
	};
	function loadScript(url) {
	    return new Promise(function (resolve, reject) {
	        if (!util_1.isString(url)) {
	            reject();
	            return;
	        }
	        var _a = shared_1.isCached("LOAD_SCRIPT_" + url, function () { return new shared_1.CacheQueue(); }), value = _a.value, cached = _a.cached;
	        // push callbacks
	        value.push({ resolve: resolve, reject: reject });
	        if (cached) {
	            return;
	        }
	        var head = constants_1.DOCUMENT.head;
	        var script = constants_1.DOCUMENT.createElement('script');
	        script.addEventListener('load', function () { return value.resolve(); });
	        script.addEventListener('error', function () { return value.reject(); });
	        script.crossOrigin = 'anonymous';
	        script.src = url;
	        head.appendChild(script);
	    });
	}
	exports.loadScript = loadScript;
	function getWxJsConfig(mpid) {
	    return new Promise(function (resolve, reject) {
	        var _a = shared_1.isCached(mpid, function () { return new shared_1.CacheQueue(); }), value = _a.value, cached = _a.cached;
	        value.push({ resolve: resolve, reject: reject });
	        if (cached) {
	            return;
	        }
	        request_1.request(util_2.getWxJsConfigUrl(), {
	            data: {
	                param: {
	                    url: constants_1.GLOBAL.location.href,
	                    mpid: mpid
	                }
	            }
	        })
	            .then(function (res) { return value.resolve(res); })
	            .catch(function () { return value.reject(); });
	    });
	}
	exports.getWxJsConfig = getWxJsConfig;
	// 防止业务代码自行引入wxsdk脚本
	function loadWeiXinSdkScript() {
	    return new Promise(function (resolve, reject) {
	        if (constants_1.GLOBAL.wx) {
	            return resolve();
	        }
	        return loadScript(WEIXIN_SDK_URL)
	            .then(resolve)
	            .catch(reject);
	    });
	}
	function isValidMpId(mpid) {
	    /**
	     * 防止多域名页面初始化配置关联的微店客服号公众号id与当前页域名不一致导致微信初始化签名、证书失败
	     */
	    return new Promise(function (resolve, reject) {
	        try {
	            if (mpid === PUBLIC_ID &&
	                PRIMARY_DOMAIN_MAP[mpid].indexOf(util_2.getPrimaryDomain().slice(1)) <
	                    0) {
	                return reject();
	            }
	            else {
	                return resolve();
	            }
	        }
	        catch (error) {
	            return reject();
	        }
	    });
	}
	// tslint:disable-next-line: max-line-length
	function triggerSdkLoadEvent(eventName, sdkLoadOption) {
	    var cached = shared_1.isCached(eventName).cached;
	    !cached && shared_1.decoupler.emit(eventName, sdkLoadOption);
	}
	function initWxConfig(res, wxSdkOption) {
	    return new Promise(function (resolve, reject) {
	        var status = res.status, result = res.result;
	        if (status && status.code === 0) {
	            var wxConfig = {
	                beta: true,
	                debug: false,
	                appId: result.appId,
	                timestamp: result.timestamp,
	                nonceStr: result.nonceStr,
	                signature: result.signature,
	                jsApiList: util_2.unique(new Array().concat(DEFAULT_OPTION.jsApiList, wxSdkOption.jsApiList || [])),
	                openTagList: ['wx-open-launch-app', 'wx-open-launch-weapp']
	            };
	            constants_1.GLOBAL.wx.config(wxConfig);
	            /**
	             * 采坑：wx.ready 和wx.error 两个方法执行回调时机并非互斥。分享初始化成功和分享失败两个回调均会执行，且执行先后顺序也不固定
	             * 为了保证监听wx.error触发的异常数据能正常上报，在wx.error回调触发时机立即上报自定义错误日志
	             */
	            constants_1.GLOBAL.wx.ready(function () {
	                // emit wsjsbridge load event
	                // triggerWeiXinSdkLoadEvent(true)
	                // emit sdk load event
	                triggerSdkLoadEvent("wxJsbridgeLoad" /* WX_JSBRIDGE_LOAD */, {
	                    result: true
	                });
	                resolve(constants_1.GLOBAL.wx);
	            });
	            constants_1.GLOBAL.wx.error(function (res) {
	                log_1.error(new error_1.KernelError({
	                    message: JSON.stringify(res),
	                    name: '[Pathtracker Error] WxConfigError'
	                }));
	                triggerSdkLoadEvent("wxJsbridgeLoad" /* WX_JSBRIDGE_LOAD */, {
	                    result: false
	                });
	                resolve();
	            });
	        }
	        else {
	            triggerSdkLoadEvent("wxJsbridgeLoad" /* WX_JSBRIDGE_LOAD */, {
	                result: false
	            });
	            reject(res);
	        }
	    });
	}
	function loadWeiXinConfigData(mpid) {
	    return isValidMpId(mpid).then(function () { return getWxJsConfig(mpid); });
	}
	function getWeiXinSdk(option) {
	    var wxSdkOption = option || {};
	    var mpid = wxSdkOption.mpid || PUBLIC_ID;
	    /**
	     * weidian主域域名访问页面，
	     * 第一次默认使用weidian.com域名关联的mpId（微店客服公众号）异步生成微信sdk签名秘钥
	     * 若配置了多域名开关，会第二次以多域名备份域名关联的mpId异步生成微信sdk签名秘钥（微信sdk load事件成功域名以第一次异步请求结果为准）
	     * ================
	     * 多域名场景备份域名访问页面，会调用两次getWeixinSdk；
	     * 第一次因为备份域名不是默认的weidian.com域名必然会失败catch，
	     * 第二次会尝试重新用备份域名关联的公众号mpId异步生成微信sdk签名秘钥（微信sdk load事件成功与否以第二次异步结果为准）
	     */
	    return Promise.all([loadWeiXinSdkScript(), loadWeiXinConfigData(mpid)])
	        .then(function (values) { return initWxConfig(values[1], wxSdkOption); })
	        .catch(function (res) {
	        res &&
	            log_1.error(new error_1.KernelError({
	                message: res.message,
	                name: '[Pathtracker Error] WxConfigError',
	                originalError: res
	            }));
	    });
	}
	exports.getWeiXinSdk = getWeiXinSdk;
	function getWeiDianSdk() {
	    return new Promise(function (resolve, reject) {
	        if (constants_1.GLOBAL.KDJSBridge2) {
	            // decoupler.emit(KERNEL_EVENT_NAMES.WD_JSBRIDGE_LOAD)
	            triggerSdkLoadEvent("wdJsbridgeLoad" /* WD_JSBRIDGE_LOAD */, {
	                result: true
	            });
	            return resolve(constants_1.GLOBAL.KDJSBridge2);
	        }
	        loadScript(WEIDIAN_JSBRIDGE_URL)
	            .then(function () {
	            if (constants_1.GLOBAL.KDJSBridge2) {
	                // decoupler.emit(KERNEL_EVENT_NAMES.WD_JSBRIDGE_LOAD)
	                triggerSdkLoadEvent("wdJsbridgeLoad" /* WD_JSBRIDGE_LOAD */, {
	                    result: true
	                });
	                return resolve(constants_1.GLOBAL.KDJSBridge2);
	            }
	            else {
	                triggerSdkLoadEvent("wdJsbridgeLoad" /* WD_JSBRIDGE_LOAD */, {
	                    result: false
	                });
	                return reject();
	            }
	        })
	            .catch(function () {
	            triggerSdkLoadEvent("wdJsbridgeLoad" /* WD_JSBRIDGE_LOAD */, {
	                result: false
	            });
	            return reject();
	        });
	    });
	}
	exports.getWeiDianSdk = getWeiDianSdk;
	function getQQSdk() {
	    return new Promise(function (resolve, reject) {
	        if (constants_1.GLOBAL.mqq) {
	            // decoupler.emit(KERNEL_EVENT_NAMES.QQ_JSBRIDGE_LOAD)
	            triggerSdkLoadEvent("qqJsbridgeLoad" /* QQ_JSBRIDGE_LOAD */, {
	                result: true
	            });
	            resolve(constants_1.GLOBAL.mqq);
	        }
	        else {
	            loadScript(QQ_SDK_URL)
	                .then(function () {
	                if (constants_1.GLOBAL.mqq) {
	                    // decoupler.emit(KERNEL_EVENT_NAMES.QQ_JSBRIDGE_LOAD)
	                    triggerSdkLoadEvent("qqJsbridgeLoad" /* QQ_JSBRIDGE_LOAD */, { result: true });
	                    resolve(constants_1.GLOBAL.mqq);
	                }
	                else {
	                    triggerSdkLoadEvent("qqJsbridgeLoad" /* QQ_JSBRIDGE_LOAD */, { result: false });
	                    reject();
	                }
	            })
	                .catch(function () {
	                triggerSdkLoadEvent("qqJsbridgeLoad" /* QQ_JSBRIDGE_LOAD */, {
	                    result: false
	                });
	                reject();
	            });
	        }
	    });
	}
	exports.getQQSdk = getQQSdk;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sendBeacon = exports.request = void 0;
	var network_1 = __webpack_require__(65);
	var util_1 = __webpack_require__(61);
	var constants_1 = __webpack_require__(55);
	var shared_1 = __webpack_require__(41);
	var NETWORK = network_1.create();
	function request(url, options) {
	    options = util_1.merge({
	        method: 'post'
	    }, options);
	    return NETWORK.request(url, options);
	}
	exports.request = request;
	function encode(val) {
	    return encodeURIComponent(val).replace(/%20/g, '+');
	}
	function serialize(obj) {
	    var array = [];
	    if (util_1.isObject(obj)) {
	        util_1.forEach(obj, function (value, name) {
	            value =
	                util_1.isObject(value) || util_1.isArray(value) ? shared_1.stringifyJSON(value) : value;
	            array.push(encode(name) + '=' + encode(value));
	        });
	    }
	    return array.join('&');
	}
	function objectToBlob(obj) {
	    try {
	        var data = serialize(obj);
	        if (data) {
	            return new Blob([data], {
	                type: 'application/x-www-form-urlencoded; charset=UTF-8'
	            });
	        }
	    }
	    catch (e) { }
	    return;
	}
	// export function objectToFormData(obj: object) {
	//     const formData = new FormData()
	//     if (isObject(obj)) {
	//         forEach(obj, (value, name) => {
	//             formData.append(
	//                 name as string,
	//                 isObject(value) || isArray(value) ? stringifyJSON(value) : value
	//             )
	//         })
	//     }
	//     return formData
	// }
	/**
	 * 1. 进入队列后依旧可能存在失败
	 * 2. 数据过大时失败，超过65536
	 */
	function sendBeacon(url, options) {
	    if (constants_1.SUPPORT_SEND_BEACON) {
	        var blob = objectToBlob(options.data);
	        return !!blob && navigator.sendBeacon(url, blob);
	    }
	    return false;
	}
	exports.sendBeacon = sendBeacon;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var network_1 = __webpack_require__(66);
	var util = __webpack_require__(68);
	var normal_1 = __webpack_require__(73);
	var thor_1 = __webpack_require__(74);
	var hawk_1 = __webpack_require__(81);
	var HEADERS = {
	    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
	    // prettier-ignore
	    'Accept': 'application/json, */*'
	};
	/**
	 * 创建Network实例，可传入默认请求参数，通过该方法可创建多个实例，例如上传实例、Thor实例等。
	 * @param options 请求参数，与request options保持一致。
	 * @returns Network实例。
	 */
	function create(options) {
	    options = util.merge(true, {}, {
	        headers: HEADERS,
	        cache: false
	    }, options);
	    var instance = new network_1.default(options);
	    instance.use(normal_1.default);
	    return instance;
	}
	exports.create = create;
	var thor = create();
	//  注册拦截插件
	thor.use(hawk_1.default);
	thor.use(thor_1.default);
	/**
	 * 网络请求。
	 * @param url 请求URL。
	 * @param options 请求参数，默认为get请求。
	 * @returns Promise
	 */
	function request(url, options) {
	    return thor.request(url, options);
	}
	exports.request = request;
	/**
	 * 注册插件，插件注册后即被立即执行。
	 * @param plugin 插件函数，函数作用域为Network实例。
	 * @returns Network实例。
	 */
	function use(plugin) {
	    return thor.use(plugin);
	}
	exports.use = use;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var hooks_1 = __webpack_require__(67);
	var xhr_1 = __webpack_require__(71);
	var util = __webpack_require__(68);
	var HOOK_NAMES = [
	    'configured',
	    'beforeRequest',
	    'beforeSuccess',
	    'beforeError'
	];
	function invokeHooks(options, context) {
	    util.forEach(HOOK_NAMES, function (name) {
	        options[name] = function (data, next) {
	            context.hooks.invokeWaterfall(name, data, next);
	        };
	    });
	}
	/**
	 * Network类
	 */
	var Network = /** @class */ (function () {
	    function Network(options) {
	        this.options = options || {};
	        this.hooks = new hooks_1.default();
	        this._installedPlugins = [];
	    }
	    /**
	     * 网络请求
	     * @param url 请求URL
	     * @param opts 请求参数
	     * @returns Promise
	     */
	    Network.prototype.request = function (url, opts) {
	        var _this = this;
	        // merge current options to default options
	        var options = util.merge(true, {}, this.options, opts || {}, { url: url, extra: {} });
	        return new Promise(function (resolve, reject) {
	            if (util.isString(options.url) && options.url) {
	                invokeHooks(options, _this);
	                options.success = resolve;
	                options.error = reject;
	                xhr_1.default(options);
	            }
	            else {
	                reject(new Error('Url Error'));
	            }
	        });
	    };
	    /**
	     * 注册插件，插件注册后即被立即执行。
	     * @param plugin 插件函数
	     * @returns Network实例
	     */
	    Network.prototype.use = function (plugin) {
	        if (this._installedPlugins.indexOf(plugin) > -1 ||
	            !util.isFunction(plugin)) {
	            return this;
	        }
	        plugin.call(this);
	        this._installedPlugins.push(plugin);
	        return this;
	    };
	    return Network;
	}());
	exports.default = Network;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(68);
	/**
	 * @ignore
	 * Hooks类，用于在请求过程中插入钩子函数，方便开发者介入到请求各个过程中。
	 */
	var Hooks = /** @class */ (function () {
	    function Hooks() {
	        this.hooks = {};
	    }
	    /**
	     * push方法，该方法作用为插入指定钩子函数。
	     * @param name hook名称
	     * @param fn hook hook回调函数
	     * @returns Hooks实例
	     */
	    Hooks.prototype.push = function (name, fn) {
	        var fns = this.hooks[name] || (this.hooks[name] = []);
	        if (typeof fn === 'function') {
	            fns.push(fn);
	        }
	        return this;
	    };
	    Hooks.prototype.invokeWaterfall = function (name, args, callback) {
	        var fns = this.hooks[name];
	        if (!fns || !fns.length) {
	            callback();
	            return this;
	        }
	        var i = 0;
	        function next(error) {
	            if (util.isError(error)) {
	                return callback(error);
	            }
	            i++;
	            if (i >= fns.length) {
	                return callback();
	            }
	            fns[i](args, next);
	        }
	        fns[i](args, next);
	        return this;
	    };
	    return Hooks;
	}());
	exports.default = Hooks;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(69);
	__export(__webpack_require__(70));
	/**
	 * @ignore
	 */
	function isResponseOk(status) {
	    return (status >= 200 && status < 300) || status == 304;
	}
	exports.isResponseOk = isResponseOk;
	/**
	 * @ignore
	 */
	function parseJSON(value) {
	    try {
	        return JSON.parse(value);
	    }
	    catch (e) { }
	}
	exports.parseJSON = parseJSON;
	/**
	 * @ignore
	 */
	function isNativeFunction(value) {
	    return (typeof value === 'function' &&
	        value.toString().indexOf('[native code]') !== -1);
	}
	exports.isNativeFunction = isNativeFunction;
	/**
	 * @hidden
	 */
	function goto(url) {
	    url && constants_1.GLOBAL.location.assign(url);
	}
	exports.goto = goto;


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// 全局对象
	exports.GLOBAL = window;
	// document
	exports.DOCUMENT = document;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * 空函数
	 */
	// tslint:disable-next-line
	function noop() { }
	exports.noop = noop;
	/**
	 * 判断是否是未定义
	 * @param value 入参cd
	 * @returns true/false，undefined、null返回true
	 */
	function isUndef(value) {
	    return value === undefined || value === null;
	}
	exports.isUndef = isUndef;
	/**
	 * 判断是否为空 undefined、null、空字符串返回true
	 * @param value 入参
	 */
	function isEmpty(value) {
	    return value === undefined || value === null || value === '';
	}
	exports.isEmpty = isEmpty;
	function isType(type) {
	    return function (value) { return Object.prototype.toString.call(value) === "[object " + type + "]"; };
	}
	/**
	 * 判断是否为Number类型
	 * @param value 入参
	 */
	function isNumber(value) {
	    return isType('Number')(value);
	}
	exports.isNumber = isNumber;
	/**
	 * 判断是否为String类型
	 * @param value 入参
	 */
	function isString(value) {
	    return isType('String')(value);
	}
	exports.isString = isString;
	/**
	 * 判断是否为Error类型
	 * @param value 入参
	 */
	function isError(value) {
	    return isType('Error')(value);
	}
	exports.isError = isError;
	/**
	 * 判断是否为Array类型
	 * @param value 入参
	 */
	function isArray(value) {
	    return isType('Array')(value);
	}
	exports.isArray = isArray;
	/**
	 * 判断是否为Function类型，async function为true
	 * @param value 入参
	 */
	function isFunction(value) {
	    return typeof value === 'function';
	}
	exports.isFunction = isFunction;
	/**
	 * 判断是否为Date类型
	 * @param value 入参
	 */
	function isDate(value) {
	    return isType('Date')(value);
	}
	exports.isDate = isDate;
	/**
	 * 判断是否为Boolean 类型
	 * @param value 入参
	 */
	function isBoolean(value) {
	    return isType('Boolean')(value);
	}
	exports.isBoolean = isBoolean;
	/**
	 * 判断是否为严格Object类型
	 * @param value 入参
	 */
	function isObject(value) {
	    return isType('Object')(value);
	}
	exports.isObject = isObject;
	/**
	 * 判断是否为泛object，不包括null
	 * @param value 入参
	 */
	function isWideObject(value) {
	    return value !== null && typeof value === 'object';
	}
	exports.isWideObject = isWideObject;
	/**
	 * 是否为FormData实例 不支持FormData时返回false
	 * @param value - 入参
	 */
	function isFormData(value) {
	    return typeof FormData !== 'undefined' && value instanceof FormData;
	}
	exports.isFormData = isFormData;
	/**
	 * 是否为URLSearchParams实例 不支持URLSearchParams时返回false
	 * @param value - 入参
	 */
	function isURLSearchParams(value) {
	    return (typeof URLSearchParams !== 'undefined' &&
	        value instanceof URLSearchParams);
	}
	exports.isURLSearchParams = isURLSearchParams;
	/**
	 * 对象是否有某个实例属性
	 * @param obj 对象
	 * @param key 对象的属性
	 */
	function hasOwn(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	exports.hasOwn = hasOwn;
	/**
	 * 循环对象和数组
	 * @param obj 对象或者数组
	 * @param fn 回调函数
	 */
	function forEach(obj, fn) {
	    if (isArray(obj)) {
	        // Iterate over array values
	        for (var i = 0, l = obj.length; i < l; i++) {
	            fn.call(null, obj[i], i, obj);
	        }
	    }
	    else if (isObject(obj)) {
	        // Iterate over object keys
	        for (var key in obj) {
	            if (hasOwn(obj, key)) {
	                fn.call(null, obj[key], key, obj);
	            }
	        }
	    }
	}
	exports.forEach = forEach;
	/**
	 * 合并多个对象
	 * @param targetOrDeep 目标对象或者是否深度合并
	 * @param sources 多个源对象
	 * @returns target 目标对象
	 */
	function merge(targetOrDeep) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    var deep;
	    var target;
	    if (isBoolean(targetOrDeep)) {
	        deep = targetOrDeep;
	        target = sources.shift();
	    }
	    else {
	        target = targetOrDeep;
	    }
	    forEach(sources, function (source) {
	        forEach(source, function (value, key) {
	            if (deep && (isArray(value) || isObject(value))) {
	                if (isArray(value)) {
	                    if (!isArray(target[key])) {
	                        target[key] = [];
	                    }
	                }
	                else {
	                    if (!isObject(target[key])) {
	                        target[key] = {};
	                    }
	                }
	                merge(deep, target[key], value);
	            }
	            else {
	                target[key] = value;
	            }
	        });
	    });
	    return target;
	}
	exports.merge = merge;
	/**
	 * 防抖函数
	 * @param fn 执行函数
	 * @param delay 延迟时间
	 * @returns 防抖函数
	 */
	function debounce(fn, delay) {
	    if (delay === void 0) { delay = 200; }
	    var timer;
	    return function () {
	        var _this = this;
	        var args = arguments;
	        clearTimeout(timer);
	        timer = setTimeout(function () {
	            fn.apply(_this, toArray(args));
	        }, delay);
	    };
	}
	exports.debounce = debounce;
	/**
	 * array like to realy array
	 * @param value 类数组
	 * @returns 数组
	 */
	function toArray(value) {
	    return Array.prototype.slice.call(value);
	}
	exports.toArray = toArray;
	/**
	 * 比较两个版本
	 * @param a 版本a
	 * @param b 版本b
	 * @returns 0：a===b，1：a>b，-1：a<b，其余异常情况均为undefined
	 */
	function compareVersion(a, b) {
	    if (isEmpty(a) || isEmpty(b)) {
	        return;
	    }
	    if (a === b) {
	        return 0;
	    }
	    var sa = a.split('.');
	    var sb = b.split('.');
	    var min = Math.min(sa.length, sb.length);
	    // loop while the components are equal
	    for (var i = 0; i < min; i++) {
	        var ai = parseInt(sa[i], 10);
	        var bi = parseInt(sb[i], 10);
	        if (isNaN(ai) || isNaN(bi)) {
	            return;
	        }
	        // A bigger than B
	        if (ai > bi) {
	            return 1;
	        }
	        // B bigger than A
	        if (ai < bi) {
	            return -1;
	        }
	    }
	    // If one's a prefix of the other, the longer one is greater.
	    // 1.2.0 > 1.2
	    if (sa.length > sb.length) {
	        return 1;
	    }
	    if (sa.length < sb.length) {
	        return -1;
	    }
	}
	exports.compareVersion = compareVersion;
	/**
	 * 缓存函数结果
	 * @param fn
	 * @returns function
	 */
	function cached(fn) {
	    // create no prototype object
	    var cache = Object.create(null);
	    return function cachedFn(value) {
	        var hit = cache[value];
	        return hit || (cache[value] = fn(value));
	    };
	}
	exports.cached = cached;
	var camelizeRE = /-(\w)/g;
	/**
	 * 驼峰
	 * @param str
	 * @returns aBC
	 * 例如 输入a-b-c 返回aBC
	 */
	function camelize(str) {
	    var cache = cached(function (str) {
	        return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
	    });
	    return cache(str);
	}
	exports.camelize = camelize;
	var decamelizeRE = /([A-Z])/g;
	/**
	 * 取消驼峰
	 * @param str
	 * @returns a-b-c
	 * 例如 输入aBC 返回a-b-c
	 */
	function decamelize(str) {
	    var cache = cached(function (str) {
	        return str.replace(decamelizeRE, '-$1').toLowerCase();
	    });
	    return cache(str);
	}
	exports.decamelize = decamelize;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(68);
	var serialize_1 = __webpack_require__(72);
	var GET_METHOD = 'GET';
	var JSON_RESPONSE_TYPE = 'json';
	function normalizeStatus(status, _a) {
	    var url = _a.url;
	    var xhrSuccessStatus = {
	        // Support: IE <=9 only
	        // #1450: sometimes IE returns 1223 when it should be 204
	        1223: 204
	    };
	    // File protocol always yields status code 0, assume 200
	    if (status === 0 && url.indexOf('file:') === 0) {
	        return 200;
	    }
	    return xhrSuccessStatus[status] || status;
	}
	function normalizeUrl(url, _a) {
	    var method = _a.method, cache = _a.cache, data = _a.data;
	    // append params if method is get
	    if (method === GET_METHOD) {
	        url = serialize_1.appendParams(url, data);
	        // append _=times if no cache
	        if (!cache) {
	            url = serialize_1.appendParams(url, {
	                _: Date.now()
	            });
	        }
	    }
	    return url;
	}
	function setWithCredentials(request, _a) {
	    var withCredentials = _a.withCredentials;
	    if (withCredentials) {
	        request.withCredentials = true;
	    }
	}
	function setResponseType(request, _a) {
	    var responseType = _a.responseType;
	    if (responseType) {
	        // try set responseType
	        try {
	            request.responseType = responseType;
	        }
	        catch (e) {
	            // will not throw error if not support responseType in some browser (锥子T1)
	        }
	    }
	}
	function setRequestHeader(request, _a) {
	    var headers = _a.headers, method = _a.method, data = _a.data;
	    if (!util.isObject(headers)) {
	        return;
	    }
	    for (var name_1 in headers) {
	        if (headers.hasOwnProperty(name_1) && !util.isUndef(headers[name_1])) {
	            // if header name is content-type
	            if (name_1.toLowerCase() === 'content-type') {
	                // remove content-type if method is get or data is FormData
	                // FormData: let browser set it
	                // get method has no body, set Content-Type is unnecessary
	                if (method === GET_METHOD || util.isFormData(data)) {
	                    continue;
	                }
	            }
	            request.setRequestHeader(name_1, headers[name_1]);
	        }
	    }
	}
	function getResponse(request, _a) {
	    var responseType = _a.responseType, status = _a.status;
	    var response = request.response;
	    if (responseType === JSON_RESPONSE_TYPE) {
	        // parse response if not support responseType or response is not object
	        if (request.responseType !== JSON_RESPONSE_TYPE &&
	            !util.isObject(response)) {
	            try {
	                response = JSON.parse(request.responseText);
	            }
	            catch (e) {
	                throw e;
	            }
	        }
	    }
	    // normalize response
	    return {
	        data: response,
	        status: status
	    };
	}
	function invokeHook(hook, requestResponse, next) {
	    next = next || util.noop;
	    if (util.isFunction(hook)) {
	        hook(requestResponse, function () {
	            next(requestResponse);
	        });
	    }
	    else {
	        next(requestResponse);
	    }
	}
	function handleReadyStateChange(request, options) {
	    var responseType = options.responseType, url = options.url, success = options.success, error = options.error;
	    if (request.readyState === 4) {
	        var status_1 = normalizeStatus(request.status, { url: url });
	        var response = void 0;
	        if (util.isResponseOk(status_1)) {
	            try {
	                response = getResponse(request, { responseType: responseType, status: status_1 });
	            }
	            catch (e) {
	                // json parse error
	                return invokeHook(options.beforeError, { request: request, response: response, options: options, error: e }, error);
	            }
	            invokeHook(options.beforeSuccess, { request: request, response: response, options: options }, success);
	        }
	        else {
	            // network or server error
	            invokeHook(options.beforeError, {
	                request: request,
	                response: response,
	                options: options,
	                error: new Error('Network Error')
	            }, error);
	        }
	    }
	}
	/**
	 * @ignore
	 */
	function xhr(options) {
	    options = util.merge({
	        method: GET_METHOD,
	        responseType: JSON_RESPONSE_TYPE,
	        withCredentials: true,
	        cache: true
	    }, options);
	    options.method = options.method || GET_METHOD;
	    var request = new XMLHttpRequest();
	    function send(_a) {
	        var request = _a.request, options = _a.options;
	        request.send(options.method === GET_METHOD ? null : serialize_1.serialize(options.data));
	    }
	    function init(_a) {
	        var request = _a.request, options = _a.options;
	        options.method = options.method.toUpperCase();
	        request.open(options.method, normalizeUrl(options.url, options), true);
	        request.onreadystatechange = function () {
	            handleReadyStateChange(request, options);
	        };
	        setWithCredentials(request, options);
	        setResponseType(request, options);
	        setRequestHeader(request, options);
	        invokeHook(options.beforeRequest, { request: request, options: options }, send);
	    }
	    invokeHook(options.configured, { request: request, options: options }, init);
	}
	exports.default = xhr;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(68);
	var HASH_DELIMIT = '#';
	var SEARCH_DELIMIT = '?';
	var PARAM_DELIMIT = '&';
	function encode(val) {
	    return encodeURIComponent(val).replace(/%20/g, '+');
	    // replace(/%40/gi, '@').
	    // replace(/%3A/gi, ':').
	    // replace(/%24/g, '$').
	    // replace(/%2C/gi, ',').
	    // replace(/%5B/gi, '[').
	    // replace(/%5D/gi, ']')
	}
	/**
	 * @ignore
	 */
	function serialize(params) {
	    if (util.isURLSearchParams(params)) {
	        return params.toString();
	    }
	    var serializedParams = params;
	    // only serialize array and object
	    if (util.isObject(params) || util.isArray(params)) {
	        var parts_1 = [];
	        util.forEach(params, function (val, key) {
	            if (util.isUndef(val)) {
	                return;
	            }
	            if (util.isArray(val)) {
	                /*
	                没有明确规范约定数组使用name[]传递，但建议get与post传递参数时均使用name[]作为key，get获取时使用name[]作为key，post获取时使用name
	                1. 由于部分后端语言对name=1&name=2会使用2作为value
	                2. name[]作为key能够更明确传递为数组
	                */
	                key = key + '[]';
	            }
	            else {
	                val = [val];
	            }
	            util.forEach(val, function parseValue(v) {
	                if (util.isDate(v)) {
	                    v = v.toISOString();
	                }
	                else if (util.isWideObject(v)) {
	                    v = JSON.stringify(v);
	                }
	                parts_1.push(encode(key) + '=' + encode(v));
	            });
	        });
	        serializedParams = parts_1.join(PARAM_DELIMIT);
	    }
	    return serializedParams;
	}
	exports.serialize = serialize;
	/**
	 * @ignore
	 */
	function appendParams(url, params) {
	    if (!util.isString(url)) {
	        return '';
	    }
	    var parts = url.split(HASH_DELIMIT);
	    // get url without hash
	    url = parts[0];
	    // serialize params
	    var serializedParams = serialize(params);
	    if (util.isString(serializedParams) && serializedParams) {
	        url +=
	            (url.indexOf(SEARCH_DELIMIT) === -1
	                ? SEARCH_DELIMIT
	                : PARAM_DELIMIT) + serializedParams;
	    }
	    parts[0] = url;
	    return parts.join(HASH_DELIMIT);
	}
	exports.appendParams = appendParams;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(68);
	function serialize(params) {
	    if (util.isObject(params)) {
	        util.forEach(params, function (value, key) {
	            // stringify array and object, most api always use this
	            if (util.isObject(value) || util.isArray(value)) {
	                params[key] = JSON.stringify(value);
	            }
	        });
	    }
	}
	function handleResponse(_a) {
	    var response = _a.response, options = _a.options;
	    var data = response.data;
	    if (options.responseType === 'json' && !util.isWideObject(data)) {
	        return Promise.reject(new Error('JSON Data Error'));
	    }
	    return data;
	}
	/**
	 * @ignore
	 */
	function normal() {
	    var context = this;
	    context.hooks.push('beforeRequest', function (_a, next) {
	        var options = _a.options;
	        serialize(options.data);
	        next();
	    });
	    var request = context.request;
	    // tslint:disable-next-line
	    context.request = function () {
	        return request
	            .apply(context, arguments)
	            .then(handleResponse, function (args) {
	            // get xhr request error
	            var error = util.isError(args) ? args : args.error;
	            return Promise.reject(error);
	        });
	    };
	}
	exports.default = normal;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util = __webpack_require__(68);
	var cookie_1 = __webpack_require__(75);
	var device_id_1 = __webpack_require__(80);
	var CSRF_TOKEN_NAME = 'wdtoken';
	/**
	 * 通过直接打开接口的csrf攻击，如果攻击者将某个接口拼接发给用户，用户直接打开则会导致新增或者删除数据
	 * 全网下发统一的session cookie token，前端获取后通过在接口中追加token参数，在server端对比接口传递的token与cookie中的token
	 */
	function appendCSRFTokenParam(params) {
	    // get wdtoken
	    var token = cookie_1.get(CSRF_TOKEN_NAME);
	    if (token) {
	        // append wdtoken param to url
	        if (util.isObject(params)) {
	            params[CSRF_TOKEN_NAME] = token;
	            return;
	        }
	        if (util.isFormData(params)) {
	            params.append(CSRF_TOKEN_NAME, token);
	            return;
	        }
	        if (util.isURLSearchParams(params)) {
	            params.set(CSRF_TOKEN_NAME, token);
	            return;
	        }
	    }
	}
	// append suid and cuid to context
	function appendDeviceId(params, callback) {
	    device_id_1.getDeviceId(function (deviceId) {
	        // only for object params
	        if (util.isObject(params)) {
	            params.context = util.merge(params.context || {}, deviceId);
	        }
	        callback();
	    });
	}
	// TODO: sieve server error or network error
	function enhanceErrorResponse() {
	    return {
	        status: {
	            code: -1
	        },
	        result: null
	    };
	}
	function handleResponse(data) {
	    // if status.code === 0,resolve response
	    if (data && data.status && data.status.code === 0) {
	        return data;
	    }
	    return Promise.reject(data);
	}
	function handleErrorResponse() {
	    return Promise.reject(enhanceErrorResponse());
	}
	/**
	 * @ignore
	 */
	function thor() {
	    var context = this;
	    context.hooks.push('configured', function (_a, next) {
	        var options = _a.options;
	        // thor froce json response type
	        options.responseType = 'json';
	        options.data = options.data || {};
	        appendCSRFTokenParam(options.data);
	        if (options.extra.deviceId) {
	            appendDeviceId(options.data, function () {
	                next();
	            });
	        }
	        else {
	            next();
	        }
	    });
	    var request = context.request;
	    // tslint:disable-next-line
	    context.request = function () {
	        return request
	            .apply(context, arguments)
	            .then(handleResponse, handleErrorResponse);
	    };
	}
	exports.default = thor;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(76);
	var index_1 = __webpack_require__(77);
	var index_2 = __webpack_require__(78);
	/**
	 * 获取cookie
	 *
	 * 1、可获取当前域名以及父域名下当前路径及父路径cookie。
	 * ```
	 * const value = cookie.get('a')
	 * ```
	 * @param name cookie name
	 * @returns cookie value 如果匹配不到指定cookie name，则返回undefined
	 */
	function get(name) {
	    if (util_1.isEmpty(name)) {
	        return;
	    }
	    var cookies = index_1.GLOBAL.document.cookie.split(index_1.COOKIE_DELIMIT);
	    var value;
	    cookies.some(function (cookie) {
	        // get name and value
	        var matchs = cookie.match(index_1.COOKIE_VALUE_REGXP);
	        if (matchs && index_2.normalize.get.name(matchs[1]) === name) {
	            value = index_2.normalize.get.value(matchs[2]);
	            return true;
	        }
	        return false;
	    });
	    return value;
	}
	exports.get = get;
	// max-age ie8及以下不支持，为了减少影响面，采用expires
	function normalizeExpires(expires) {
	    if (util_1.isNumber(expires)) {
	        expires = new Date(new Date().getTime() + expires * 1000);
	    }
	    if (util_1.isDate(expires)) {
	        return expires.toUTCString();
	    }
	}
	/**
	 * 设置cookie
	 *
	 * 1、可设置当前域名及父域名下任何路径cookie。
	 * ```
	 * // 默认path为'/'
	 * cookie.set('b','e')
	 * // 设置session cookie，但不建议设置session cookie，部分浏览器退出以后并不会清除
	 * cookie.set('b', 'value')
	 * ```
	 * @param name cookie name
	 * @param value cookie value
	 * @param opts cookie attributes
	 */
	function set(name, value, opts) {
	    if (util_1.isEmpty(name) || util_1.isUndef(value)) {
	        return;
	    }
	    var options = util_1.merge({
	        path: '/'
	        // secure: true,
	        // sameSite: 'none'
	    }, opts);
	    options.expires = normalizeExpires(options.expires);
	    var attrs = '';
	    util_1.forEach(options, function (val, key) {
	        if (!val) {
	            return;
	        }
	        // concat attr key
	        attrs += index_1.COOKIE_DELIMIT + key;
	        // if secure is true then set '; secure'
	        if (val === true) {
	            return;
	        }
	        // Considers RFC 6265 section 5.2:
	        val = val.split(';')[0];
	        // concat attr value
	        attrs += index_1.COOKIE_VALUE_DELIMIT + val;
	    });
	    // normalize name and value
	    name = index_2.normalize.set.name(name);
	    value = index_2.normalize.set.value(value);
	    // set cookie
	    index_1.GLOBAL.document.cookie = name + index_1.COOKIE_VALUE_DELIMIT + value + attrs;
	}
	exports.set = set;
	/**
	 * 删除cookie
	 *
	 * 1、删除规则与set保持一致
	 * ```
	 * // 删除当前域名cookie
	 * cookie.remove('a')
	 * ```
	 * @param name cookie name
	 * @param opts cookie attributes
	 */
	function remove(name, opts) {
	    set(name, '', util_1.merge(opts || {}, {
	        expires: -864e5
	    }));
	}
	exports.remove = remove;


/***/ }),
/* 76 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * 空函数
	 */
	// tslint:disable-next-line
	function noop() { }
	exports.noop = noop;
	/**
	 * 判断是否是未定义
	 * @param value 入参cd
	 * @returns true/false，undefined、null返回true
	 */
	function isUndef(value) {
	    return value === undefined || value === null;
	}
	exports.isUndef = isUndef;
	/**
	 * 判断是否为空 undefined、null、空字符串返回true
	 * @param value 入参
	 */
	function isEmpty(value) {
	    return value === undefined || value === null || value === '';
	}
	exports.isEmpty = isEmpty;
	function isType(type) {
	    return function (value) { return Object.prototype.toString.call(value) === "[object " + type + "]"; };
	}
	/**
	 * 判断是否为Number类型
	 * @param value 入参
	 */
	function isNumber(value) {
	    return isType('Number')(value);
	}
	exports.isNumber = isNumber;
	/**
	 * 判断是否为String类型
	 * @param value 入参
	 */
	function isString(value) {
	    return isType('String')(value);
	}
	exports.isString = isString;
	/**
	 * 判断是否为Error类型
	 * @param value 入参
	 */
	function isError(value) {
	    return isType('Error')(value);
	}
	exports.isError = isError;
	/**
	 * 判断是否为Array类型
	 * @param value 入参
	 */
	function isArray(value) {
	    return isType('Array')(value);
	}
	exports.isArray = isArray;
	/**
	 * 判断是否为Function类型，async function为true
	 * @param value 入参
	 */
	function isFunction(value) {
	    return typeof value === 'function';
	}
	exports.isFunction = isFunction;
	/**
	 * 判断是否为Date类型
	 * @param value 入参
	 */
	function isDate(value) {
	    return isType('Date')(value);
	}
	exports.isDate = isDate;
	/**
	 * 判断是否为Boolean 类型
	 * @param value 入参
	 */
	function isBoolean(value) {
	    return isType('Boolean')(value);
	}
	exports.isBoolean = isBoolean;
	/**
	 * 判断是否为严格Object类型
	 * @param value 入参
	 */
	function isObject(value) {
	    return isType('Object')(value);
	}
	exports.isObject = isObject;
	/**
	 * 判断是否为泛object，不包括null
	 * @param value 入参
	 */
	function isWideObject(value) {
	    return value !== null && typeof value === 'object';
	}
	exports.isWideObject = isWideObject;
	/**
	 * 是否为FormData实例 不支持FormData时返回false
	 * @param value - 入参
	 */
	function isFormData(value) {
	    return typeof FormData !== 'undefined' && value instanceof FormData;
	}
	exports.isFormData = isFormData;
	/**
	 * 是否为URLSearchParams实例 不支持URLSearchParams时返回false
	 * @param value - 入参
	 */
	function isURLSearchParams(value) {
	    return (typeof URLSearchParams !== 'undefined' &&
	        value instanceof URLSearchParams);
	}
	exports.isURLSearchParams = isURLSearchParams;
	/**
	 * 对象是否有某个实例属性
	 * @param obj 对象
	 * @param key 对象的属性
	 */
	function hasOwn(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	exports.hasOwn = hasOwn;
	/**
	 * 循环对象和数组
	 * @param obj 对象或者数组
	 * @param fn 回调函数
	 */
	function forEach(obj, fn) {
	    if (isArray(obj)) {
	        // Iterate over array values
	        for (var i = 0, l = obj.length; i < l; i++) {
	            fn.call(null, obj[i], i, obj);
	        }
	    }
	    else if (isObject(obj)) {
	        // Iterate over object keys
	        for (var key in obj) {
	            if (hasOwn(obj, key)) {
	                fn.call(null, obj[key], key, obj);
	            }
	        }
	    }
	}
	exports.forEach = forEach;
	/**
	 * 合并多个对象
	 * @param targetOrDeep 目标对象或者是否深度合并
	 * @param sources 多个源对象
	 * @returns target 目标对象
	 */
	function merge(targetOrDeep) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    var deep;
	    var target;
	    if (isBoolean(targetOrDeep)) {
	        deep = targetOrDeep;
	        target = sources.shift();
	    }
	    else {
	        target = targetOrDeep;
	    }
	    forEach(sources, function (source) {
	        forEach(source, function (value, key) {
	            if (deep && (isArray(value) || isObject(value))) {
	                if (isArray(value)) {
	                    if (!isArray(target[key])) {
	                        target[key] = [];
	                    }
	                }
	                else {
	                    if (!isObject(target[key])) {
	                        target[key] = {};
	                    }
	                }
	                merge(deep, target[key], value);
	            }
	            else {
	                target[key] = value;
	            }
	        });
	    });
	    return target;
	}
	exports.merge = merge;
	/**
	 * 防抖函数
	 * @param fn 执行函数
	 * @param delay 延迟时间
	 * @returns 防抖函数
	 */
	function debounce(fn, delay) {
	    if (delay === void 0) { delay = 200; }
	    var timer;
	    return function () {
	        var _this = this;
	        var args = arguments;
	        clearTimeout(timer);
	        timer = setTimeout(function () {
	            fn.apply(_this, toArray(args));
	        }, delay);
	        return timer;
	    };
	}
	exports.debounce = debounce;
	/**
	 * array like to realy array
	 * @param value 类数组
	 * @returns 数组
	 */
	function toArray(value) {
	    return Array.prototype.slice.call(value);
	}
	exports.toArray = toArray;
	/**
	 * 比较两个版本
	 * @param a 版本a
	 * @param b 版本b
	 * @returns 0：a===b，1：a>b，-1：a<b，其余异常情况均为undefined
	 */
	function compareVersion(a, b) {
	    if (isEmpty(a) || isEmpty(b)) {
	        return;
	    }
	    if (a === b) {
	        return 0;
	    }
	    var sa = a.split('.');
	    var sb = b.split('.');
	    var min = Math.min(sa.length, sb.length);
	    // loop while the components are equal
	    for (var i = 0; i < min; i++) {
	        var ai = parseInt(sa[i], 10);
	        var bi = parseInt(sb[i], 10);
	        if (isNaN(ai) || isNaN(bi)) {
	            return;
	        }
	        // A bigger than B
	        if (ai > bi) {
	            return 1;
	        }
	        // B bigger than A
	        if (ai < bi) {
	            return -1;
	        }
	    }
	    // If one's a prefix of the other, the longer one is greater.
	    // 1.2.0 > 1.2
	    if (sa.length > sb.length) {
	        return 1;
	    }
	    if (sa.length < sb.length) {
	        return -1;
	    }
	}
	exports.compareVersion = compareVersion;
	/**
	 * 缓存函数结果
	 * @param fn
	 * @returns function
	 */
	function cached(fn) {
	    // create no prototype object
	    var cache = Object.create(null);
	    return function cachedFn(value) {
	        var hit = cache[value];
	        return hit || (cache[value] = fn(value));
	    };
	}
	exports.cached = cached;
	var camelizeRE = /-(\w)/g;
	/**
	 * 驼峰
	 * @param str
	 * @returns aBC
	 * 例如 输入a-b-c 返回aBC
	 */
	function camelize(str) {
	    var cache = cached(function (str) {
	        return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
	    });
	    return cache(str);
	}
	exports.camelize = camelize;
	var decamelizeRE = /([A-Z])/g;
	/**
	 * 取消驼峰
	 * @param str
	 * @returns a-b-c
	 * 例如 输入aBC 返回a-b-c
	 */
	function decamelize(str) {
	    var cache = cached(function (str) {
	        return str.replace(decamelizeRE, '-$1').toLowerCase();
	    });
	    return cache(str);
	}
	exports.decamelize = decamelize;


/***/ }),
/* 77 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.GLOBAL = window;
	exports.COOKIE_DELIMIT = '; ';
	exports.COOKIE_VALUE_DELIMIT = '=';
	exports.COOKIE_VALUE_REGXP = new RegExp("([^" + exports.COOKIE_VALUE_DELIMIT + "]+)" + exports.COOKIE_VALUE_DELIMIT + "(.*)");


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var normal_1 = __webpack_require__(79);
	exports.normalize = normal_1.normalize;


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var index_1 = __webpack_require__(77);
	var _decodeURIComponent = index_1.GLOBAL.decodeURIComponent;
	var _encodeURIComponent = index_1.GLOBAL.encodeURIComponent;
	var _escape = index_1.GLOBAL.escape;
	function normalizeGetName(value) {
	    return value.replace(/(%[0-9A-Z]{2})+/g, _decodeURIComponent);
	}
	/**
	 * @ignore
	 */
	exports.normalize = {
	    get: {
	        name: normalizeGetName,
	        value: function (value) {
	            return normalizeGetName(value);
	        }
	    },
	    set: {
	        name: function (name) {
	            return _encodeURIComponent(name)
	                .replace(/%(23|24|26|2B|5E|60|7C)/g, _decodeURIComponent)
	                .replace(/[\(\)]/g, _escape);
	        },
	        value: function (value) {
	            return _encodeURIComponent(value).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, _decodeURIComponent);
	        }
	    }
	};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(68);
	var constants_1 = __webpack_require__(69);
	var DEVICE_ID = {};
	var COMPLETED = false;
	var INITIALIZED = false;
	var DEVICE_ID_CALLBACK_QUEUE = [];
	function push(callback) {
	    DEVICE_ID_CALLBACK_QUEUE.push(callback);
	}
	function flush(value) {
	    // run callback
	    util_1.forEach(DEVICE_ID_CALLBACK_QUEUE, function (callback) {
	        callback(value);
	    });
	    // clear queue
	    DEVICE_ID_CALLBACK_QUEUE.length = 0;
	}
	function getSuid(callback) {
	    if (!util_1.isUndef(constants_1.GLOBAL.KDJSBridge2)) {
	        constants_1.GLOBAL.KDJSBridge2.call('WDJSBridge', 'getSuid', {}, function (res) {
	            if (res && res.param && res.param.suid) {
	                callback(res.param.suid);
	            }
	            else {
	                callback();
	            }
	        });
	    }
	    else {
	        callback();
	    }
	}
	function getCuid(callback) {
	    if (!util_1.isUndef(constants_1.GLOBAL.KDJSBridge2)) {
	        constants_1.GLOBAL.KDJSBridge2.call('WDJSBridge', 'getCuid', {}, function (res) {
	            if (res && res.param && res.param.cuid) {
	                callback(res.param.cuid);
	            }
	            else {
	                callback();
	            }
	        });
	    }
	    else {
	        callback();
	    }
	}
	function init() {
	    if (INITIALIZED) {
	        return;
	    }
	    INITIALIZED = true;
	    var count = 0;
	    function cb() {
	        count++;
	        if (count === 2) {
	            COMPLETED = true;
	            // flush queue , then next get callback call with cache device id
	            flush(DEVICE_ID);
	        }
	    }
	    getSuid(function (suid) {
	        suid && (DEVICE_ID.suid = suid);
	        cb();
	    });
	    getCuid(function (cuid) {
	        cuid && (DEVICE_ID.cuid = cuid);
	        cb();
	    });
	}
	/**
	 * @ignore
	 */
	function getDeviceId(callback) {
	    init();
	    if (COMPLETED) {
	        callback(DEVICE_ID);
	    }
	    else {
	        // push into queue if deviceId has not been got
	        push(callback);
	    }
	}
	exports.getDeviceId = getDeviceId;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var processor_1 = __webpack_require__(82);
	var intercept_1 = __webpack_require__(87);
	var constants_1 = __webpack_require__(69);
	// 暴露全局属性，用于记录是否已初始化
	constants_1.GLOBAL.hawk = constants_1.GLOBAL.hawk || {
	    disabled: false
	};
	// 拦截处理
	function interceptHandler() {
	    intercept_1.default({
	        beforeSuccess: function (response, next) {
	            // 实名认证处理，不符合则执行业务代码
	            if (processor_1.identity(response)) {
	                next();
	            }
	        }
	    });
	}
	/**
	 * @ignore
	 */
	function hawk() {
	    if (constants_1.GLOBAL.hawk.disabled) {
	        return;
	    }
	    interceptHandler();
	    constants_1.GLOBAL.hawk.disabled = true;
	}
	exports.default = hawk;


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	Object.defineProperty(exports, "__esModule", { value: true });
	__export(__webpack_require__(83));


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(68);
	var constants_1 = __webpack_require__(69);
	var url_1 = __webpack_require__(57);
	var util_2 = __webpack_require__(84);
	// 实名认证处理
	var IDENTITY_CODES = 20;
	var IDENTITY_REDIRECT_KEY = 'redirect';
	var IDENTITY_TIMEOUT = 1000;
	/**
	 * @ignore
	 * false：中断后续代码执行，true：不中断执行
	 * @param data 传入的响应数据
	 * @returns boolean
	 */
	function identity(data) {
	    var _a;
	    if (util_1.isObject(data)) {
	        var status_1 = util_1.isObject(data.status) ? data.status : {};
	        var result = util_1.isObject(data.result) ? data.result : {};
	        var url_2 = result.authPageUrl;
	        // 如果符合实名认证条件
	        if (status_1.code == IDENTITY_CODES && url_2) {
	            // 追加当前页面redirect参数
	            url_2 = url_1.setQuerystring(url_2, (_a = {},
	                _a[IDENTITY_REDIRECT_KEY] = constants_1.GLOBAL.location.href,
	                _a));
	            result.message && util_2.toast(result.message);
	            setTimeout(function () {
	                util_1.goto(url_2);
	            }, IDENTITY_TIMEOUT);
	            return false;
	        }
	    }
	    return true;
	}
	exports.identity = identity;


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var user_agent_1 = __webpack_require__(85);
	var constants_1 = __webpack_require__(69);
	var DEFAULT_SCALE = 1;
	var TOAST_DURATION = 1500;
	function getScale() {
	    if (user_agent_1.isMobile()) {
	        var viewports = document.querySelectorAll('meta[name="viewport"]');
	        // 最后一个viewport才生效
	        var viewport = viewports[viewports.length - 1];
	        if (viewport) {
	            // 属性不存在返回null
	            var content = viewport.getAttribute('content');
	            var matchs = content && content.match(/initial\-scale=([\d\.]+)/);
	            return matchs ? 1 / Number(matchs[1]) : DEFAULT_SCALE;
	        }
	    }
	    return DEFAULT_SCALE;
	}
	/**
	 * @ignore
	 */
	function toast(message) {
	    var scale = getScale();
	    // tslint:disable-next-line: max-line-length
	    var html = "<div class=\"hawk-toast\">" + message + "</div><style type=\"text/css\">.hawk-toast{position:fixed;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:10000;width:50%;color:#fff;background:rgba(33,33,33,0.9);line-height:1.5;border-radius:" + 8 *
	        scale + "px;max-width:" + 300 * scale + "px;padding:" + 20 *
	        scale + "px;font-size:" + 16 * scale + "px;}</style>";
	    var body = constants_1.DOCUMENT.body;
	    if (body) {
	        var element_1 = constants_1.DOCUMENT.createElement('div');
	        element_1.innerHTML = html;
	        body.appendChild(element_1);
	        setTimeout(function () {
	            body.removeChild(element_1);
	        }, TOAST_DURATION);
	    }
	}
	exports.toast = toast;


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var regex_1 = __webpack_require__(86);
	var UA = navigator.userAgent.toLowerCase();
	/**
	 * 是否是移动端
	 */
	function isMobile() {
	    return regex_1.MOBILE_REGEXP.test(UA);
	}
	exports.isMobile = isMobile;
	/**
	 * 是否是Android系统
	 */
	function isAndroid() {
	    return regex_1.ANDROID_REGEXP.test(UA);
	}
	exports.isAndroid = isAndroid;
	/**
	 * 是否是iOS系统
	 */
	function isIOS() {
	    return regex_1.IOS_REGEXP.test(UA);
	}
	exports.isIOS = isIOS;
	/**
	 * 是否是苹果产品系列
	 */
	function isApple() {
	    return regex_1.APPLE_REGEXP.test(UA);
	}
	exports.isApple = isApple;
	/**
	 * 是否是iPhone
	 */
	function isIphone() {
	    return regex_1.IPHONE_REGEXP.test(UA);
	}
	exports.isIphone = isIphone;
	/**
	 * 是否是iPad
	 */
	function isIpad() {
	    return regex_1.IPAD_REGEXP.test(UA);
	}
	exports.isIpad = isIpad;
	/**
	 * 是否是QQ APP
	 */
	function isQQ() {
	    return regex_1.QQ_REGEXP.test(UA);
	}
	exports.isQQ = isQQ;
	/**
	 * 是否是微信
	 */
	function isWeiXin() {
	    return regex_1.WEI_XIN_REGEXP.test(UA) && !isWeiXinWork();
	}
	exports.isWeiXin = isWeiXin;
	/**
	 * 是否是企业微信
	 */
	function isWeiXinWork() {
	    return regex_1.WEI_XIN_WORK_REGEXP.test(UA);
	}
	exports.isWeiXinWork = isWeiXinWork;
	/**
	 * 是否是微博
	 */
	function isWeiBo() {
	    return regex_1.WEI_BO_REGEXP.test(UA);
	}
	exports.isWeiBo = isWeiBo;
	/**
	 * 是否是买家版
	 */
	function isWDBuyer() {
	    return regex_1.WD_BUYER_REGEXP.test(UA);
	}
	exports.isWDBuyer = isWDBuyer;
	/**
	 * 获取买家版,卖家版APP版本，返回版本号字符串，例如 5.5.1
	 * @returns 版本号。 不是买家版、卖家版就返回 undefined
	 */
	function getWDAppVersion() {
	    var version;
	    var match = UA.match(regex_1.WD_APP_VERSION_REGEXP);
	    if (match) {
	        version = match[1];
	    }
	    return version;
	}
	exports.getWDAppVersion = getWDAppVersion;
	/**
	 * 是否是卖家版
	 */
	function isWDSeller() {
	    return regex_1.WD_SELLER_REGEXP.test(UA);
	}
	exports.isWDSeller = isWDSeller;
	/**
	 * 判断是否在小程序环境
	 */
	function isMiniProgram() {
	    return (window.__wxjs_environment === 'miniprogram' ||
	        regex_1.MINI_PROGRAM_REGEXP.test(UA));
	}
	exports.isMiniProgram = isMiniProgram;
	/**
	 * 判断是否在支付宝环境
	 */
	function isAlipay() {
	    return regex_1.ALIPAY_REGEXP.test(UA);
	}
	exports.isAlipay = isAlipay;


/***/ }),
/* 86 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// 判断Android系统的正则
	exports.ANDROID_REGEXP = /(Android)\s+([\d.]+)/i;
	// 判断iOS系统的正则
	exports.IOS_REGEXP = /\(i[^;]+;( U;)? cpu.+mac os x/i;
	// 判断移动端正则
	exports.MOBILE_REGEXP = /AppleWebKit.*Mobile.*/i;
	// 判断苹果产品系列正则
	exports.APPLE_REGEXP = /(iPhone|iPad|iPod|iOS|Mac OS X)/i;
	// 判断iPad正则
	exports.IPAD_REGEXP = /(iPad).*OS\s([\d_]+)/i;
	// 判断iPhone正则
	exports.IPHONE_REGEXP = /(iPhone\sOS)\s([\d_]+)/i;
	// 判断QQ APP正则
	exports.QQ_REGEXP = /QQ\/([\d.]+)/i;
	// 判断微信正则
	exports.WEI_XIN_REGEXP = /micromessenger/i;
	// 判断企业微信正则
	exports.WEI_XIN_WORK_REGEXP = /wxwork\/.* MicroMessenger/i;
	// 判断微博正则
	exports.WEI_BO_REGEXP = /WeiBo/i;
	// 判断买家版正则
	exports.WD_BUYER_REGEXP = /WDAPP\(WDBuyer/i;
	// 判断卖家版正则
	exports.WD_SELLER_REGEXP = /WDAPP\(WD\//i;
	// 获取买家版、买家版版本号正则
	exports.WD_APP_VERSION_REGEXP = /WDAPP\((?:wdbuyer|wd)\/([\d.]+)/i;
	// 判断支付宝正则
	exports.ALIPAY_REGEXP = /AlipayClient/i;
	// 判断miniProgram正则
	exports.MINI_PROGRAM_REGEXP = /miniProgram/i;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var ajax_1 = __webpack_require__(88);
	var jsonp_1 = __webpack_require__(89);
	var fetch_1 = __webpack_require__(90);
	var util_1 = __webpack_require__(68);
	/**
	 * @ignore
	 */
	function intercept(options) {
	    if (!util_1.isObject(options) || !util_1.isFunction(options.beforeSuccess)) {
	        return;
	    }
	    ajax_1.default(options);
	    jsonp_1.default(options);
	    fetch_1.default(options);
	}
	exports.default = intercept;


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(68);
	var constants_1 = __webpack_require__(69);
	var XMLHTTPREQUEST = constants_1.GLOBAL.XMLHttpRequest;
	var XHR_PROTOTYPE = XMLHTTPREQUEST && XMLHTTPREQUEST.prototype;
	var ORIGINAL_XHR_SEND = XHR_PROTOTYPE && XHR_PROTOTYPE.send;
	function handleRequestResponse(options, xhr, next) {
	    // try catch
	    try {
	        if (xhr.readyState == 4) {
	            if (util_1.isResponseOk(xhr.status)) {
	                var data = util_1.isObject(xhr.response)
	                    ? xhr.response
	                    : util_1.parseJSON(xhr.responseText);
	                // 返回false表示中断后续代码执行
	                return options.beforeSuccess(data, next);
	            }
	        }
	    }
	    catch (e) { }
	    next();
	}
	/**
	 * @ignore
	 */
	function interceptRequest(options) {
	    // Override send method
	    // istanbul ignore next
	    if (!util_1.isFunction(ORIGINAL_XHR_SEND)) {
	        return;
	    }
	    XHR_PROTOTYPE.send = function () {
	        var args = arguments;
	        var xhr = this;
	        var originalOnreadystatechange = xhr.onreadystatechange;
	        var originalOnload = xhr.onload;
	        var hasIntercepted = false;
	        // zepot use onreadystatechange
	        if (originalOnreadystatechange) {
	            hasIntercepted = true;
	            // tslint:disable-next-line: only-arrow-functions
	            xhr.onreadystatechange = function () {
	                var args = arguments;
	                handleRequestResponse(options, xhr, function () {
	                    originalOnreadystatechange.apply(xhr, args);
	                });
	            };
	        }
	        // other use onload
	        if (originalOnload && !hasIntercepted) {
	            // tslint:disable-next-line: only-arrow-functions
	            xhr.onload = function () {
	                var args = arguments;
	                handleRequestResponse(options, xhr, function () {
	                    originalOnload.apply(xhr, args);
	                });
	            };
	        }
	        return ORIGINAL_XHR_SEND.apply(xhr, args);
	    };
	}
	exports.default = interceptRequest;


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(68);
	var url_1 = __webpack_require__(57);
	var constants_1 = __webpack_require__(69);
	var ELEMENT = constants_1.GLOBAL.Element;
	var ELEMENT_PROTOTYPE = ELEMENT && ELEMENT.prototype;
	var SCRIPT_TAGNAME = 'SCRIPT';
	var JSONP_CALLBACK_NAME = 'callback';
	var PROXY_ELEMENT_METHODS = ['appendChild', 'insertBefore'];
	function handleRequestResponse(options, response, next) {
	    // try catch
	    try {
	        return options.beforeSuccess(response, next);
	    }
	    catch (e) { }
	    next();
	}
	// 获取回调的命名空间、函数定义、函数名称
	function getCallbackDefinition(path) {
	    var segments = path.split('.');
	    var length = segments.length;
	    if (!length) {
	        return;
	    }
	    var namespace = constants_1.GLOBAL;
	    var definition = constants_1.GLOBAL;
	    var name;
	    try {
	        for (var i = 0; i < length; i++) {
	            if (!definition) {
	                return;
	            }
	            name = segments[i];
	            namespace = definition;
	            definition = namespace[name];
	        }
	        if (!util_1.isFunction(definition)) {
	            return;
	        }
	    }
	    catch (e) {
	        return;
	    }
	    return {
	        namespace: namespace,
	        name: name,
	        definition: definition
	    };
	}
	/**
	 * @ignore
	 */
	function interceptJsonp(options) {
	    util_1.forEach(PROXY_ELEMENT_METHODS, function (methodName) {
	        var originalMethod = ELEMENT_PROTOTYPE && ELEMENT_PROTOTYPE[methodName];
	        if (originalMethod) {
	            ELEMENT_PROTOTYPE[methodName] = function (element) {
	                // 如果是外联的script标签
	                if (element &&
	                    element.tagName === SCRIPT_TAGNAME &&
	                    element.src) {
	                    // 如果src上存在callback参数
	                    var callbackName = url_1.getQuerystring(element.src)[JSONP_CALLBACK_NAME];
	                    if (util_1.isString(callbackName)) {
	                        // 如果全局存在callback函数
	                        var def_1 = getCallbackDefinition(callbackName);
	                        if (def_1) {
	                            var originalCallback_1 = def_1.definition;
	                            // tslint:disable-next-line: only-arrow-functions
	                            def_1.namespace[def_1.name] = function (response) {
	                                var args = arguments;
	                                // zepto、jQuery在script load事件中判断responseData是否为存在，如果存在则执行success，不存在则执行error
	                                // 所以jsonp请求均会执行一次成功或者失败，此处让业务执行错误回调
	                                handleRequestResponse(options, response, function () {
	                                    originalCallback_1.apply(def_1.namespace, args);
	                                });
	                            };
	                        }
	                    }
	                }
	                return originalMethod.apply(this, util_1.toArray(arguments));
	            };
	        }
	    });
	}
	exports.default = interceptJsonp;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(68);
	var constants_1 = __webpack_require__(69);
	var FETCH = constants_1.GLOBAL.fetch;
	function handleRequestResponse(options, response, next) {
	    try {
	        if (util_1.isResponseOk(response.status)) {
	            return response
	                .clone()
	                .json()
	                .then(function (data) {
	                options.beforeSuccess(data, next);
	            })
	                .catch(function () {
	                next();
	            });
	        }
	    }
	    catch (e) { }
	    next();
	}
	/**
	 * @ignore
	 */
	function interceptFetch(options) {
	    if (!util_1.isNativeFunction(FETCH)) {
	        return;
	    }
	    constants_1.GLOBAL.fetch = function () {
	        var args = arguments;
	        return FETCH.apply(this, args).then(function (response) {
	            return new Promise(function (resolve) {
	                handleRequestResponse(options, response, function () {
	                    resolve(response);
	                });
	            });
	        });
	    };
	}
	exports.default = interceptFetch;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sleep = exports.isMultipleDomain = exports.isEnablePlugin = exports.isDisableAuto = exports.getMultidomainScenesList = exports.getEnablePluginList = exports.getDisabledAutoReportList = exports.unique = exports.getWindowWidth = exports.getWindowHeight = exports.removeItem = exports.isElement = exports.getElementUrl = exports.getNormalizedUrl = exports.getUrlWithoutQuerstring = exports.isCrossOriginUrl = exports.isHttpProtocol = exports.isApp = exports.getWxJsConfigUrl = exports.getReportUrl = exports.getPerformanceTime = exports.getPrimaryDomain = void 0;
	var tslib_1 = __webpack_require__(40);
	var shared_1 = __webpack_require__(41);
	var user_agent_1 = __webpack_require__(85);
	var environment_1 = __webpack_require__(92);
	var constants_1 = __webpack_require__(55);
	var url_1 = __webpack_require__(57);
	tslib_1.__exportStar(__webpack_require__(94), exports);
	var LINK_ELEMENT = constants_1.GLOBAL.document.createElement('A');
	var BODY = constants_1.DOCUMENT.body;
	function getPrimaryDomain(hostname) {
	    var domain = (hostname || location.hostname).split(':')[0];
	    return ('.' +
	        domain
	            .split('.')
	            .slice(-2)
	            .join('.'));
	}
	exports.getPrimaryDomain = getPrimaryDomain;
	function getPerformanceTime() {
	    return Math.round(performance.now());
	}
	exports.getPerformanceTime = getPerformanceTime;
	function getReportUrl() {
	    // dev,daily,pre 均使用日常环境，只有日常与线上数据存储
	    var env = environment_1.getEnvironment() < 3 ? environment_1.ENVIRONMENT_NAMES[1] + '.' : '';
	    return "https://logtake." + env + "weidian.com/h5collector/webcollect/3.0";
	}
	exports.getReportUrl = getReportUrl;
	function getWxJsConfigUrl() {
	    // 本地、日常、预发都走预发请求
	    var env = environment_1.getEnvironment() < 3 ? environment_1.ENVIRONMENT_NAMES[2] + '.' : '';
	    return "https://thor." + env + "weidian.com/weixin/getjsconfig/2.0";
	}
	exports.getWxJsConfigUrl = getWxJsConfigUrl;
	function isApp() {
	    return user_agent_1.isWDBuyer() || user_agent_1.isWDSeller();
	}
	exports.isApp = isApp;
	function isHttpProtocol(src) {
	    return /^https?:\/\//.test(src);
	}
	exports.isHttpProtocol = isHttpProtocol;
	function isCrossOriginUrl(url) {
	    var instance = new url_1.Url(url);
	    return (instance.host !== location.host ||
	        instance.protocol !== location.protocol);
	}
	exports.isCrossOriginUrl = isCrossOriginUrl;
	function getUrlWithoutQuerstring(url) {
	    return url.split('#')[0].split('?')[0];
	}
	exports.getUrlWithoutQuerstring = getUrlWithoutQuerstring;
	function getNormalizedUrl(url) {
	    LINK_ELEMENT.href = url;
	    return LINK_ELEMENT.href;
	}
	exports.getNormalizedUrl = getNormalizedUrl;
	function getElementUrl(element) {
	    switch (element.nodeName) {
	        case 'AUDIO':
	        case 'VIDEO':
	            element = element;
	            // currentSrc: 表示当前正在播放的媒体文件的绝对路径
	            // src: 表示媒体文件的 URL
	            return element.src || element.currentSrc;
	        case 'OBJECT':
	            element = element;
	            return element.data;
	        case 'PARAM':
	            element = element;
	            if (constants_1.PARAM_SOURCE_NAMES.indexOf(element.name) !== -1) {
	                return element.value;
	            }
	        case 'LINK':
	            element = element;
	            return element.href;
	    }
	    element = element;
	    return element.src;
	}
	exports.getElementUrl = getElementUrl;
	function isElement(value) {
	    return value instanceof Element;
	}
	exports.isElement = isElement;
	function removeItem(ary, item) {
	    var i = ary.indexOf(item);
	    if (i !== -1) {
	        ary.splice(i, 1);
	    }
	}
	exports.removeItem = removeItem;
	function getWindowHeight() {
	    return (window.innerHeight ||
	        (document.documentElement && document.documentElement.clientHeight) ||
	        (document.body && document.body.clientHeight));
	}
	exports.getWindowHeight = getWindowHeight;
	function getWindowWidth() {
	    return (window.innerWidth ||
	        (document.documentElement && document.documentElement.clientWidth) ||
	        (document.body && document.body.clientWidth));
	}
	exports.getWindowWidth = getWindowWidth;
	function unique(array) {
	    if (!shared_1.isArray(array)) {
	        return [];
	    }
	    return array.filter(function (item, index) {
	        // 判断当前元素在原始数组中第一个索引和当前索引值是否相等，若不是则过滤掉
	        return array.indexOf(item, 0) === index;
	    });
	}
	exports.unique = unique;
	function getFormatList(datasetStr) {
	    var formatted = [];
	    if (datasetStr) {
	        var datasets = datasetStr.split(',');
	        if (datasets && datasets.length) {
	            formatted = datasets.map(function (item) {
	                return item.replace(/^\s*/g, '').replace(/\s*/g, '');
	            });
	        }
	    }
	    return formatted;
	}
	function getDisabledAutoReportList() {
	    return getFormatList(BODY && BODY.dataset.vcollectDisabled);
	}
	exports.getDisabledAutoReportList = getDisabledAutoReportList;
	function getEnablePluginList() {
	    return getFormatList(BODY && BODY.dataset.vcollectPlugin);
	}
	exports.getEnablePluginList = getEnablePluginList;
	function getMultidomainScenesList() {
	    var list = getFormatList(BODY && BODY.dataset.vcollectMultidomain);
	    return list.length
	        ? list
	        : BODY && BODY.getAttribute('data-vcollect-multidomain') !== null
	            ? ['pathtracker']
	            : [];
	}
	exports.getMultidomainScenesList = getMultidomainScenesList;
	/**
	 * 后续可能会考虑读取结合脚手架配置信息判断禁用自动上报
	 * key可选项：spider(禁用主动上报pageview事件)、silentlogin（禁用微信场景自动微信静默授权登录）、privateDomain（禁用私有域名拦截跳转）
	 */
	function isDisableAuto(key) {
	    var disabledList = getDisabledAutoReportList();
	    return disabledList.indexOf(key) > -1;
	}
	exports.isDisableAuto = isDisableAuto;
	/**
	 * 后续可能会考虑读取结合脚手架配置信息判断启用内置插件上报
	 * key可选项:impression(开启自动监听页面曝光事件)、newSpider(启用新版spider采集埋点)
	 */
	function isEnablePlugin(key) {
	    var plugins = getEnablePluginList();
	    return plugins.indexOf(key) > -1;
	}
	exports.isEnablePlugin = isEnablePlugin;
	/**
	 * 后续可能会考虑读取结合脚手架配置信息判断启用内置插件上报
	 * key可选项: spider(跳转)、pathtracker（分享）
	 */
	function isMultipleDomain(key) {
	    var multidomainList = getMultidomainScenesList();
	    return key ? multidomainList.indexOf(key) > -1 : !!multidomainList.length;
	}
	exports.isMultipleDomain = isMultipleDomain;
	function sleep(timeout) {
	    if (timeout === void 0) { timeout = 200; }
	    return new Promise(function (resolve) {
	        setTimeout(function () {
	            resolve();
	        }, timeout);
	    });
	}
	exports.sleep = sleep;


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.isProdEnvironment = exports.getEnvironment = exports.ENVIRONMENT_NAMES = void 0;
	var util_1 = __webpack_require__(61);
	var option_1 = __webpack_require__(93);
	exports.ENVIRONMENT_NAMES = ['dev', 'daily', 'pre'];
	var REGEXP = new RegExp("\\.(" + exports.ENVIRONMENT_NAMES.join('|') + ")\\.");
	function getEnvironment() {
	    var environment = option_1.option('environment');
	    if (!util_1.isUndef(environment)) {
	        return environment;
	    }
	    var match = location.hostname.match(REGEXP);
	    if (match && match[1]) {
	        var environment_1 = exports.ENVIRONMENT_NAMES.indexOf(match[1]);
	        return environment_1 !== -1 ? environment_1 : 3 /* PROD */;
	    }
	    return 3 /* PROD */;
	}
	exports.getEnvironment = getEnvironment;
	function isProdEnvironment() {
	    return getEnvironment() === 3 /* PROD */;
	}
	exports.isProdEnvironment = isProdEnvironment;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.option = void 0;
	var constants_1 = __webpack_require__(55);
	var util_1 = __webpack_require__(61);
	// TODO: 配置管理
	var options = util_1.isObject(constants_1.GLOBAL.kernel)
	    ? constants_1.GLOBAL.kernel
	    : {};
	function option(name) {
	    if (util_1.isString(name)) {
	        return options[name];
	    }
	    return;
	}
	exports.option = option;


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getUniqueRandomId = void 0;
	var constants_1 = __webpack_require__(55);
	var shared_1 = __webpack_require__(41);
	var canvas_fingerprint_1 = __webpack_require__(95);
	var UNIQUE_RANDOM_ID;
	function shuffle(ary) {
	    for (var i = ary.length - 1; i > 0; i--) {
	        var j = Math.floor(Math.random() * (i + 1));
	        var temp = ary[i];
	        ary[i] = ary[j];
	        ary[j] = temp;
	    }
	    return ary;
	}
	function generateUniqueRandomId() {
	    var factors = [
	        Math.random(),
	        constants_1.GLOBAL.navigator.userAgent,
	        constants_1.DOCUMENT.cookie,
	        constants_1.GLOBAL.location.href,
	        shared_1.stringifyJSON(constants_1.GLOBAL.performance),
	        Date.now(),
	        constants_1.GLOBAL.screen.availHeight,
	        constants_1.GLOBAL.screen.availWidth,
	        Math.random()
	    ];
	    try {
	        factors.push(canvas_fingerprint_1.getCanvasFingerprint());
	    }
	    catch (e) { }
	    // TODO : 使用更快的hash算法
	    return shared_1.hash(shuffle(factors).join());
	}
	function getUniqueRandomId(salt, length) {
	    if (shared_1.isUndef(UNIQUE_RANDOM_ID)) {
	        UNIQUE_RANDOM_ID = generateUniqueRandomId();
	    }
	    var factors = [UNIQUE_RANDOM_ID, Date.now(), Math.random(), salt];
	    return shared_1.hash(factors.join(), length || 16);
	}
	exports.getUniqueRandomId = getUniqueRandomId;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getCanvasFingerprint = void 0;
	/**
	 *  获取绘画的内容，需要使用到canvas.toDataURL()方法，该方法返回的是图片内容的base64编码字符串。
	 *  对于PNG文件格式，以块(chunk)划分，最后一块是一段32位的CRC校验，提取这段CRC校验码便可以用于用户的唯一标识：
	 *  1、在图片格式上，不同web浏览器使用了不同的图形处理引擎、不同的图片导出选项、不同的默认压缩级别等。
	 *  2、在像素级别来看，操作系统各自使用了不同的设置和算法来进行抗锯齿和子像素渲染操作。
	 *  https://www.browserleaks.com/canvas#how-does-it-work
	 */
	function getCanvasFingerprint() {
	    var result = [];
	    // Very simple now, need to make it more complex (geo shapes etc)
	    var canvas = document.createElement('canvas');
	    canvas.width = 2000;
	    canvas.height = 200;
	    canvas.style.display = 'inline';
	    var ctx = canvas.getContext('2d');
	    // detect browser support of canvas winding
	    // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
	    // https://github.com/Modernizr/Modernizr/blob/master/feature-detects/canvas/winding.js
	    ctx.rect(0, 0, 10, 10);
	    ctx.rect(2, 2, 6, 6);
	    result.push('canvas winding:' +
	        (ctx.isPointInPath(5, 5, 'evenodd') === false ? 'yes' : 'no'));
	    ctx.textBaseline = 'alphabetic';
	    ctx.fillStyle = '#f60';
	    ctx.fillRect(125, 1, 62, 20);
	    ctx.fillStyle = '#069';
	    // https://github.com/Valve/fingerprintjs2/issues/66
	    ctx.font = '11pt no-real-font-123';
	    ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 2, 15);
	    ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
	    ctx.font = '18pt Arial';
	    ctx.fillText('Cwm fjordbank glyphs vext quiz, \ud83d\ude03', 4, 45);
	    // 在小米4下，同一浏览器每刷新一次，umid会变一次，但始终只在两个值中变化，可能由于下面代码导致。可能的原因是硬件问题。
	    // 叠加效果
	    // 将两张图混合在一起，globalCompositeOperation设置采用什么模式进行混合。每个浏览器实现以及每个设备硬件不一致，从而生成的图不一致。
	    // canvas blending
	    // http://blogs.adobe.com/webplatform/2013/01/28/blending-features-in-canvas/
	    // http://jsfiddle.net/NDYV8/16/
	    // 正片叠底模式
	    ctx.globalCompositeOperation = 'multiply';
	    ctx.fillStyle = 'rgb(255,0,255)';
	    ctx.beginPath();
	    ctx.arc(50, 50, 50, 0, Math.PI * 2, true);
	    ctx.closePath();
	    ctx.fill();
	    ctx.fillStyle = 'rgb(0,255,255)';
	    ctx.beginPath();
	    ctx.arc(100, 50, 50, 0, Math.PI * 2, true);
	    ctx.closePath();
	    ctx.fill();
	    ctx.fillStyle = 'rgb(255,255,0)';
	    ctx.beginPath();
	    ctx.arc(75, 100, 50, 0, Math.PI * 2, true);
	    ctx.closePath();
	    ctx.fill();
	    ctx.fillStyle = 'rgb(255,0,255)';
	    // 填充模式
	    // 当绘制一个闭合图形时，canvas根据evenodd或non-zero算法确定内部区域。内部区域需要进行填充。
	    // canvas winding
	    // http://blogs.adobe.com/webplatform/2013/01/30/winding-rules-in-canvas/
	    // http://jsfiddle.net/NDYV8/19/
	    ctx.arc(75, 75, 75, 0, Math.PI * 2, true);
	    ctx.arc(75, 75, 25, 0, Math.PI * 2, true);
	    ctx.fill('evenodd');
	    result.push('canvas fp:' + canvas.toDataURL());
	    return result.join();
	}
	exports.getCanvasFingerprint = getCanvasFingerprint;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.warn = exports.info = exports.error = void 0;
	var environment_1 = __webpack_require__(92);
	var shared_1 = __webpack_require__(41);
	var constants_1 = __webpack_require__(55);
	var util_1 = __webpack_require__(61);
	var error_1 = __webpack_require__(97);
	// tslint:disable-next-line: no-console
	var SUPPORT_CONSOLE = !shared_1.isUndef(console) && !!console.log;
	function error() {
	    var err = arguments[0];
	    if (err instanceof error_1.KernelError) {
	        arguments[0] = err.toString();
	        var detail = util_1.merge(true, {}, err.toJSON(), {
	            message: err.toString()
	        });
	        shared_1.decoupler.emit("reportException" /* REPORT_EXCEPTION */, detail);
	    }
	    SUPPORT_CONSOLE &&
	        !environment_1.isProdEnvironment() &&
	        // tslint:disable-next-line: no-console
	        constants_1.GLOBAL.console.error.apply(console, arguments);
	}
	exports.error = error;
	function info() {
	    SUPPORT_CONSOLE &&
	        !environment_1.isProdEnvironment() &&
	        // tslint:disable-next-line: no-console
	        constants_1.GLOBAL.console.info.apply(console, arguments);
	}
	exports.info = info;
	function warn() {
	    SUPPORT_CONSOLE &&
	        !environment_1.isProdEnvironment() &&
	        // tslint:disable-next-line: no-console
	        constants_1.GLOBAL.console.warn.apply(console, arguments);
	}
	exports.warn = warn;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.KernelError = void 0;
	var tslib_1 = __webpack_require__(40);
	var ts_custom_error_1 = __webpack_require__(98);
	/**
	 * fix:若直接继承Error类，ts编译成es5语法存在兼容bug，会导致new CustomError() instanceof CustomError 失效
	 * 这里采用ts-custom-error这个库修复这个问题
	 * @class KernelError
	 * @extends {CustomError}
	 */
	var KernelError = /** @class */ (function (_super) {
	    tslib_1.__extends(KernelError, _super);
	    function KernelError(option) {
	        var _this = _super.call(this, option.message || '') || this;
	        // option.name && (this.name = option.name)
	        option.name &&
	            Object.defineProperty(_this, 'name', { value: option.name });
	        _this.originalError = option.originalError || null;
	        // 默认不开启采样上报
	        _this.sample = option.sample || false;
	        return _this;
	        // this.originalError && (this.stack = this.originalError.stack)
	    }
	    // public toString() {
	    //     return `[${this.constructor.name}] ${this.name}: ${this.message}`
	    // }
	    KernelError.prototype.toJSON = function () {
	        return {
	            name: this.name,
	            message: this.message,
	            stack: this.originalError ? this.originalError.stack : this.stack,
	            originalError: this.originalError,
	            sample: this.sample
	        };
	    };
	    return KernelError;
	}(ts_custom_error_1.CustomError));
	exports.KernelError = KernelError;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

	function fixProto(target, prototype) {
	  var setPrototypeOf = Object.setPrototypeOf;
	  setPrototypeOf ? setPrototypeOf(target, prototype) : target.__proto__ = prototype;
	}
	function fixStack(target, fn) {
	  if (fn === void 0) {
	    fn = target.constructor;
	  }

	  var captureStackTrace = Error.captureStackTrace;
	  captureStackTrace && captureStackTrace(target, fn);
	}

	var __extends = undefined && undefined.__extends || function () {
	  var extendStatics = function (d, b) {
	    extendStatics = Object.setPrototypeOf || {
	      __proto__: []
	    } instanceof Array && function (d, b) {
	      d.__proto__ = b;
	    } || function (d, b) {
	      for (var p in b) { if (b.hasOwnProperty(p)) { d[p] = b[p]; } }
	    };

	    return extendStatics(d, b);
	  };

	  return function (d, b) {
	    extendStatics(d, b);

	    function __() {
	      this.constructor = d;
	    }

	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	  };
	}();

	var CustomError = function (_super) {
	  __extends(CustomError, _super);

	  function CustomError(message) {
	    var _newTarget = this.constructor;

	    var _this = _super.call(this, message) || this;

	    Object.defineProperty(_this, 'name', {
	      value: _newTarget.name,
	      enumerable: false,
	      configurable: true
	    });
	    fixProto(_this, _newTarget.prototype);
	    fixStack(_this);
	    return _this;
	  }

	  return CustomError;
	}(Error);

	var __spreadArrays = undefined && undefined.__spreadArrays || function () {
	  var arguments$1 = arguments;

	  for (var s = 0, i = 0, il = arguments.length; i < il; i++) { s += arguments$1[i].length; }

	  for (var r = Array(s), k = 0, i = 0; i < il; i++) { for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) { r[k] = a[j]; } }

	  return r;
	};
	function customErrorFactory(fn, parent) {
	  if (parent === void 0) {
	    parent = Error;
	  }

	  function CustomError() {
	    var arguments$1 = arguments;

	    var args = [];

	    for (var _i = 0; _i < arguments.length; _i++) {
	      args[_i] = arguments$1[_i];
	    }

	    if (!(this instanceof CustomError)) { return new (CustomError.bind.apply(CustomError, __spreadArrays([void 0], args)))(); }
	    parent.apply(this, args);
	    Object.defineProperty(this, 'name', {
	      value: fn.name || parent.name,
	      enumerable: false,
	      configurable: true
	    });
	    fn.apply(this, args);
	    fixStack(this, CustomError);
	  }

	  return Object.defineProperties(CustomError, {
	    prototype: {
	      value: Object.create(parent.prototype, {
	        constructor: {
	          value: CustomError,
	          writable: true,
	          configurable: true
	        }
	      })
	    }
	  });
	}

	exports.CustomError = CustomError;
	exports.customErrorFactory = customErrorFactory;
	//# sourceMappingURL=custom-error.js.map


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.pageUnload = exports.pageBeforeUnload = exports.domContentLoaded = exports.visibilitychange = exports.bodyElementLoaded = exports.pageEnsureLoaded = exports.pageLoad = void 0;
	var constants_1 = __webpack_require__(55);
	var shared_1 = __webpack_require__(41);
	var READY_STATE_LOADED_REGEXP = /complete|interactive|loaded/;
	function pageLoad(callback) {
	    constants_1.GLOBAL.addEventListener('load', callback);
	}
	exports.pageLoad = pageLoad;
	var PAGE_LOADED = false;
	pageLoad(function () {
	    PAGE_LOADED = true;
	});
	function pageEnsureLoaded(callback) {
	    if (PAGE_LOADED) {
	        return callback();
	    }
	    pageLoad(callback);
	}
	exports.pageEnsureLoaded = pageEnsureLoaded;
	function bodyElementLoaded(callback) {
	    if (constants_1.DOCUMENT.body) {
	        callback();
	        return;
	    }
	    var loaded = false;
	    constants_1.DOCUMENT.addEventListener('readystatechange', function () {
	        if (!loaded && constants_1.DOCUMENT.body) {
	            loaded = true;
	            callback();
	        }
	    });
	}
	exports.bodyElementLoaded = bodyElementLoaded;
	function visibilitychange(callback) {
	    constants_1.DOCUMENT.addEventListener('visibilitychange', callback, false);
	}
	exports.visibilitychange = visibilitychange;
	function domContentLoaded(callback) {
	    if (READY_STATE_LOADED_REGEXP.test(constants_1.DOCUMENT.readyState)) {
	        callback();
	        return;
	    }
	    // DOMContentLoaded 事件完成时，状态为interactive
	    constants_1.DOCUMENT.addEventListener('DOMContentLoaded', callback, true);
	}
	exports.domContentLoaded = domContentLoaded;
	function createPageUnloadCacheQueue() {
	    var beforeUnloadCacheQueue = new shared_1.CacheQueue();
	    var unloadCacheQueue = new shared_1.CacheQueue();
	    /**
	     * 综合比较采用unload事件
	     * 1. visibilitychange 事件在应用前后台切换时触发，刷新及页面跳转不触发，IOS13 微信，chrome桌面版均触发
	     * 2. unload 事件在应用前后台切换时不触发，但页面刷新、页面跳转等均触发，IOS13 微信、chrome桌面版一致
	     * 3. 应用切换到后台后，IOS13 微信下 异步任务依旧执行，Android需进一步测试
	     * 4. beforeunload IOS13 微信下不执行
	     * https://www.igvita.com/2015/11/20/dont-lose-user-and-app-state-use-page-visibility/
	     */
	    constants_1.GLOBAL.addEventListener('unload', function () {
	        beforeUnloadCacheQueue.resolve();
	        unloadCacheQueue.resolve();
	    }, true);
	    return { beforeUnloadCacheQueue: beforeUnloadCacheQueue, unloadCacheQueue: unloadCacheQueue };
	}
	var _a = createPageUnloadCacheQueue(), beforeUnloadCacheQueue = _a.beforeUnloadCacheQueue, unloadCacheQueue = _a.unloadCacheQueue;
	function pageBeforeUnload(callback) {
	    beforeUnloadCacheQueue.push({
	        resolve: callback
	    });
	}
	exports.pageBeforeUnload = pageBeforeUnload;
	function pageUnload(callback) {
	    unloadCacheQueue.push({
	        resolve: callback
	    });
	}
	exports.pageUnload = pageUnload;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getDocumentUrl = exports.getDocumentReferrer = exports.isLegalDestinationUrl = exports.getDocumentDestination = exports.setDocumentDestination = exports.pageUrlChange = void 0;
	var constants_1 = __webpack_require__(55);
	var shared_1 = __webpack_require__(41);
	var safety_1 = __webpack_require__(101);
	var document_1 = __webpack_require__(99);
	var HISTORY = constants_1.GLOBAL.history;
	var ORIGINAL_PUSHSTATE = HISTORY.pushState;
	var ORIGINAL_REPLACESTATE = HISTORY.replaceState;
	var URL_CHANGE_EVENT_NAME = !!constants_1.GLOBAL.history.pushState
	    ? 'popstate'
	    : 'hashchange';
	var URL_CHANGE_CACHE_QUEUE = new shared_1.CacheQueue({ stateful: false });
	// TODO trigger urlChange custom event
	function urlChange() {
	    var url = getDocumentUrl();
	    function handler(event) {
	        var newUrl = getDocumentUrl();
	        if (newUrl === url) {
	            return;
	        }
	        URL_CHANGE_CACHE_QUEUE.resolve(event, {
	            oldUrl: url,
	            newUrl: newUrl
	        });
	        url = newUrl;
	    }
	    // listen popstate event, hashchange also trigger popstate
	    // pushState and replaceState don't trigger popstate
	    constants_1.GLOBAL.addEventListener(URL_CHANGE_EVENT_NAME, handler);
	    if (ORIGINAL_PUSHSTATE && ORIGINAL_REPLACESTATE) {
	        // proxy pushState,replaceState method
	        HISTORY.pushState = function pushState() {
	            var returnValue = ORIGINAL_PUSHSTATE.apply(HISTORY, arguments);
	            handler();
	            return returnValue;
	        };
	        HISTORY.replaceState = function replaceState() {
	            var returnValue = ORIGINAL_REPLACESTATE.apply(HISTORY, arguments);
	            handler();
	            return returnValue;
	        };
	    }
	}
	urlChange();
	function pageUrlChange(callback) {
	    URL_CHANGE_CACHE_QUEUE.push({
	        resolve: callback
	    });
	}
	exports.pageUrlChange = pageUrlChange;
	// 当页面从隐藏到可视时，将目标URL置为空，防止回到当前页时页面关闭，从而走到设置window.name阶段，无法在当前页上报
	document_1.visibilitychange(function () {
	    // if page is visible
	    if (constants_1.DOCUMENT.visibilityState === 'visible') {
	        setDocumentDestination(null);
	    }
	});
	function setDocumentDestination(value) {
	    constants_1.DOCUMENT.destination = value;
	}
	exports.setDocumentDestination = setDocumentDestination;
	/**
	 * TODO
	 * 监听location.href,window.assign,window.replace,window.open,link click事件，捕获页面跳转前的URL链接
	 * location.href 通过编译工具实现，其他通过代理
	 */
	function getDocumentDestination() {
	    return constants_1.DOCUMENT.destination;
	}
	exports.getDocumentDestination = getDocumentDestination;
	function isLegalDestinationUrl() {
	    var destination = getDocumentDestination();
	    return !!destination && safety_1.isLegalUrl(destination);
	}
	exports.isLegalDestinationUrl = isLegalDestinationUrl;
	var PREV_URL;
	pageUrlChange(function (_event, _a) {
	    var oldUrl = _a.oldUrl;
	    PREV_URL = oldUrl;
	});
	function getDocumentReferrer() {
	    return PREV_URL || constants_1.DOCUMENT.referrer;
	}
	exports.getDocumentReferrer = getDocumentReferrer;
	function getDocumentUrl() {
	    return constants_1.DOCUMENT.URL;
	}
	exports.getDocumentUrl = getDocumentUrl;


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var dom_observe_1 = __webpack_require__(102);
	var util_1 = __webpack_require__(103);
	var escape_1 = __webpack_require__(108);
	exports.escape = escape_1.escape;
	var jump_1 = __webpack_require__(109);
	exports.jump = jump_1.jump;
	var url_legalize_1 = __webpack_require__(107);
	exports.isLegalUrl = url_legalize_1.isLegalUrl;
	exports.legalizeUrl = url_legalize_1.legalizeUrl;
	exports.addWhiteDomain = url_legalize_1.addWhiteDomain;
	// 设置默认值
	util_1.access({
	    observeIframe: true
	});
	/**
	 * 用于配置安全库相关属性
	 * @param options 配置属性
	 */
	function option(options) {
	    util_1.access(options);
	    // observe or disconnect
	    util_1.access("observeDom" /* OBSERVE_DOM */) ? dom_observe_1.observe() : dom_observe_1.disconnect();
	}
	exports.option = option;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(103);
	var constants_1 = __webpack_require__(105);
	var nodes_1 = __webpack_require__(106);
	// tslint:disable-next-line
	var MutationObserver = constants_1.GLOBAL.MutationObserver || constants_1.GLOBAL.WebKitMutationObserver;
	function getNodesByRecords(records) {
	    var nodes = [];
	    records.forEach(function (record) {
	        var addedNodes = util_1.toArray(record.addedNodes);
	        nodes = nodes.concat(addedNodes);
	    });
	    return nodes;
	}
	function immediatelyHandler(records) {
	    var nodes = getNodesByRecords(records);
	    nodes.forEach(function (node) {
	        var nodeName = node.nodeName;
	        if (nodes_1.IMMEDIATELY_NODE_NAMES.indexOf(nodeName) !== -1) {
	            // document.createElement('script')插入的脚本无法阻止执行，其余方式引入的脚本可阻止执行，但无法阻止脚本文件请求
	            // script节点已添加，请求已发送
	            nodes_1.IMMEDIATELY_HANDLERS[nodeName](node);
	        }
	    });
	}
	// 动态插入的节点，addedNodes为插入的节点，无法获取到子节点，需循环遍历
	// 触发mutationCallback时，节点都已添加，请求已发送，所以只能阻止显示，故可合并多次节点改变延时执行
	var delayedHandler = util_1.debounce(function () {
	    var nodes = constants_1.DOCUMENT.querySelectorAll(nodes_1.DELAYED_NODE_NAMES);
	    nodes.forEach(function (node) {
	        nodes_1.DELAYED_HANDLERS[node.nodeName](node);
	    });
	});
	function mutationCallback(records) {
	    immediatelyHandler(records);
	    delayedHandler();
	}
	var observer;
	/**
	 * @ignore
	 */
	function observe() {
	    if (MutationObserver && !observer) {
	        observer = new MutationObserver(mutationCallback);
	        observer.observe(constants_1.DOCUMENT, {
	            childList: true,
	            attributes: true,
	            subtree: true,
	            attributeFilter: ['href', 'src']
	        });
	    }
	}
	exports.observe = observe;
	/**
	 * @ignore
	 */
	function disconnect() {
	    if (observer) {
	        // 由于delayedHandler存在延迟，disconnect后可能会移除不合法节点
	        observer.disconnect();
	        observer = undefined;
	    }
	}
	exports.disconnect = disconnect;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(104);
	exports.debounce = util_1.debounce;
	exports.toArray = util_1.toArray;
	exports.isEmpty = util_1.isEmpty;
	var constants_1 = __webpack_require__(105);
	/**
	 * @ignore
	 */
	function createLink(url) {
	    constants_1.A.href = url;
	    return constants_1.A;
	}
	exports.createLink = createLink;
	/**
	 * @ignore
	 */
	function domContentLoaded(callback) {
	    if (constants_1.READY_STATE_REGEXP.test(constants_1.DOCUMENT.readyState) && constants_1.DOCUMENT.body) {
	        callback();
	        return;
	    }
	    constants_1.GLOBAL.addEventListener('DOMContentLoaded', callback);
	}
	exports.domContentLoaded = domContentLoaded;
	/**
	 * HTML Decode 处理，防止出现10进制或者16进制
	 * @param input 字符串
	 * @returns 处理后的字符串
	 * @ignore
	 */
	function htmlDecode(input) {
	    return input
	        .replace(/&#x([\dabcdef]+);?/gi, function (_e, t) {
	        return constants_1.FROM_CHAR_CODE(parseInt(t, 16));
	    })
	        .replace(/&#(\d+);?/g, function (_e, t) {
	        return constants_1.FROM_CHAR_CODE(parseInt(t, 10));
	    });
	}
	exports.htmlDecode = htmlDecode;
	/**
	 * @ignore
	 */
	function removeChild(node) {
	    if (node.parentNode) {
	        node.parentNode.removeChild(node);
	    }
	}
	exports.removeChild = removeChild;
	var options = {};
	/**
	 * @ignore
	 */
	function access(opts) {
	    if (util_1.isString(opts)) {
	        return options[opts];
	    }
	    util_1.merge(options, opts);
	}
	exports.access = access;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	/**
	 * 空函数
	 */
	// tslint:disable-next-line
	function noop() { }
	exports.noop = noop;
	/**
	 * 判断是否是未定义
	 * @param value 入参cd
	 * @returns true/false，undefined、null返回true
	 */
	function isUndef(value) {
	    return value === undefined || value === null;
	}
	exports.isUndef = isUndef;
	/**
	 * 判断是否为空 undefined、null、空字符串返回true
	 * @param value 入参
	 */
	function isEmpty(value) {
	    return value === undefined || value === null || value === '';
	}
	exports.isEmpty = isEmpty;
	function isType(type) {
	    return function (value) { return Object.prototype.toString.call(value) === "[object " + type + "]"; };
	}
	/**
	 * 判断是否为Number类型
	 * @param value 入参
	 */
	function isNumber(value) {
	    return isType('Number')(value);
	}
	exports.isNumber = isNumber;
	/**
	 * 判断是否为String类型
	 * @param value 入参
	 */
	function isString(value) {
	    return isType('String')(value);
	}
	exports.isString = isString;
	/**
	 * 判断是否为Error类型
	 * @param value 入参
	 */
	function isError(value) {
	    return isType('Error')(value);
	}
	exports.isError = isError;
	/**
	 * 判断是否为Array类型
	 * @param value 入参
	 */
	function isArray(value) {
	    return isType('Array')(value);
	}
	exports.isArray = isArray;
	/**
	 * 判断是否为Function类型，async function为true
	 * @param value 入参
	 */
	function isFunction(value) {
	    return typeof value === 'function';
	}
	exports.isFunction = isFunction;
	/**
	 * 判断是否为Date类型
	 * @param value 入参
	 */
	function isDate(value) {
	    return isType('Date')(value);
	}
	exports.isDate = isDate;
	/**
	 * 判断是否为Boolean 类型
	 * @param value 入参
	 */
	function isBoolean(value) {
	    return isType('Boolean')(value);
	}
	exports.isBoolean = isBoolean;
	/**
	 * 判断是否为严格Object类型
	 * @param value 入参
	 */
	function isObject(value) {
	    return isType('Object')(value);
	}
	exports.isObject = isObject;
	/**
	 * 判断是否为泛object，不包括null
	 * @param value 入参
	 */
	function isWideObject(value) {
	    return value !== null && typeof value === 'object';
	}
	exports.isWideObject = isWideObject;
	/**
	 * 是否为FormData实例 不支持FormData时返回false
	 * @param value - 入参
	 */
	function isFormData(value) {
	    return typeof FormData !== 'undefined' && value instanceof FormData;
	}
	exports.isFormData = isFormData;
	/**
	 * 是否为URLSearchParams实例 不支持URLSearchParams时返回false
	 * @param value - 入参
	 */
	function isURLSearchParams(value) {
	    return (typeof URLSearchParams !== 'undefined' &&
	        value instanceof URLSearchParams);
	}
	exports.isURLSearchParams = isURLSearchParams;
	/**
	 * 对象是否有某个实例属性
	 * @param obj 对象
	 * @param key 对象的属性
	 */
	function hasOwn(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	}
	exports.hasOwn = hasOwn;
	/**
	 * 循环对象和数组
	 * @param obj 对象或者数组
	 * @param fn 回调函数
	 */
	function forEach(obj, fn) {
	    if (isArray(obj)) {
	        // Iterate over array values
	        for (var i = 0, l = obj.length; i < l; i++) {
	            fn.call(null, obj[i], i, obj);
	        }
	    }
	    else if (isObject(obj)) {
	        // Iterate over object keys
	        for (var key in obj) {
	            if (hasOwn(obj, key)) {
	                fn.call(null, obj[key], key, obj);
	            }
	        }
	    }
	}
	exports.forEach = forEach;
	/**
	 * 合并多个对象
	 * @param targetOrDeep 目标对象或者是否深度合并
	 * @param sources 多个源对象
	 * @returns target 目标对象
	 */
	function merge(targetOrDeep) {
	    var sources = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        sources[_i - 1] = arguments[_i];
	    }
	    var deep;
	    var target;
	    if (isBoolean(targetOrDeep)) {
	        deep = targetOrDeep;
	        target = sources.shift();
	    }
	    else {
	        target = targetOrDeep;
	    }
	    forEach(sources, function (source) {
	        forEach(source, function (value, key) {
	            if (deep && (isArray(value) || isObject(value))) {
	                if (isArray(value)) {
	                    if (!isArray(target[key])) {
	                        target[key] = [];
	                    }
	                }
	                else {
	                    if (!isObject(target[key])) {
	                        target[key] = {};
	                    }
	                }
	                merge(deep, target[key], value);
	            }
	            else {
	                target[key] = value;
	            }
	        });
	    });
	    return target;
	}
	exports.merge = merge;
	/**
	 * 防抖函数
	 * @param fn 执行函数
	 * @param delay 延迟时间
	 * @returns 防抖函数
	 */
	function debounce(fn, delay) {
	    if (delay === void 0) { delay = 200; }
	    var timer;
	    return function () {
	        var _this = this;
	        var args = arguments;
	        clearTimeout(timer);
	        timer = setTimeout(function () {
	            fn.apply(_this, toArray(args));
	        }, delay);
	    };
	}
	exports.debounce = debounce;
	/**
	 * array like to realy array
	 * @param value 类数组
	 * @returns 数组
	 */
	function toArray(value) {
	    return Array.prototype.slice.call(value);
	}
	exports.toArray = toArray;
	/**
	 * 比较两个版本
	 * @param a 版本a
	 * @param b 版本b
	 * @returns 0：a===b，1：a>b，-1：a<b，其余异常情况均为undefined
	 */
	function compareVersion(a, b) {
	    if (isEmpty(a) || isEmpty(b)) {
	        return;
	    }
	    if (a === b) {
	        return 0;
	    }
	    var sa = a.split('.');
	    var sb = b.split('.');
	    var min = Math.min(sa.length, sb.length);
	    // loop while the components are equal
	    for (var i = 0; i < min; i++) {
	        var ai = parseInt(sa[i], 10);
	        var bi = parseInt(sb[i], 10);
	        if (isNaN(ai) || isNaN(bi)) {
	            return;
	        }
	        // A bigger than B
	        if (ai > bi) {
	            return 1;
	        }
	        // B bigger than A
	        if (ai < bi) {
	            return -1;
	        }
	    }
	    // If one's a prefix of the other, the longer one is greater.
	    // 1.2.0 > 1.2
	    if (sa.length > sb.length) {
	        return 1;
	    }
	    if (sa.length < sb.length) {
	        return -1;
	    }
	}
	exports.compareVersion = compareVersion;
	/**
	 * 缓存函数结果
	 * @param fn
	 * @returns function
	 */
	function cached(fn) {
	    // create no prototype object
	    var cache = Object.create(null);
	    return function cachedFn(value) {
	        var hit = cache[value];
	        return hit || (cache[value] = fn(value));
	    };
	}
	exports.cached = cached;
	var camelizeRE = /-(\w)/g;
	/**
	 * 驼峰
	 * @param str
	 * @returns aBC
	 * 例如 输入a-b-c 返回aBC
	 */
	function camelize(str) {
	    var cache = cached(function (str) {
	        return str.replace(camelizeRE, function (_, c) { return (c ? c.toUpperCase() : ''); });
	    });
	    return cache(str);
	}
	exports.camelize = camelize;
	var decamelizeRE = /([A-Z])/g;
	/**
	 * 取消驼峰
	 * @param str
	 * @returns a-b-c
	 * 例如 输入aBC 返回a-b-c
	 */
	function decamelize(str) {
	    var cache = cached(function (str) {
	        return str.replace(decamelizeRE, '-$1').toLowerCase();
	    });
	    return cache(str);
	}
	exports.decamelize = decamelize;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	// 全局对象
	exports.GLOBAL = window;
	// document
	exports.DOCUMENT = document;
	exports.A = exports.DOCUMENT.createElement('a');
	exports.READY_STATE_REGEXP = /complete|loaded|interactive/;
	// 白名单域名
	exports.WHITE_DOMAINS = [
	    '.weidian.com',
	    '.koudai.com',
	    '.vdian.com',
	    '.geilicdn.com',
	    '.fangxin.com',
	    '.ruyu.com',
	    '.vdian.net',
	    '.91ruyu.com',
	    '.bibikan.cn',
	    '.youshop01.com',
	    '.youshop02.com',
	    '.youshop03.com',
	    '.youshop04.com',
	    '.youshop05.com',
	    '.youshop06.com',
	    '.youshop07.com',
	    '.youshop08.com',
	    '.youshop09.com',
	    '.youshop10.com',
	    '.kou6ai.cn'
	];
	// 非法的协议头
	exports.ILLEGAL_PROTOCOL_REGEXP = /^(javascript|data):/i;
	// 空链接
	exports.EMPTRY_URL = 'javascript:;';
	// escape 字符
	exports.ESCAPE_MAP = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&#34;',
	    "'": '&#39;',
	    '`': '&#96;'
	};
	// escape 正则，/[&<>"'`]/g
	exports.ESCAPE_REGEXP = new RegExp('[' + Object.keys(exports.ESCAPE_MAP).join('') + ']', 'g');
	// param标签与资源相关的名称
	exports.PARAM_SOURCE_NAMES = ['url', 'src', 'filename'];
	// 节点缓存KEY
	exports.NODE_CACHE_KEY = '__safetyCache';
	exports.FROM_CHAR_CODE = String.fromCharCode;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var url_legalize_1 = __webpack_require__(107);
	var constants_1 = __webpack_require__(105);
	var util_1 = __webpack_require__(103);
	function getUrl(node) {
	    var nodeName = node.nodeName;
	    switch (nodeName) {
	        case 'AUDIO':
	        case 'VIDEO':
	            // currentSrc: 表示当前正在播放的媒体文件的绝对路径
	            // src: 表示媒体文件的 URL
	            return node.src || node.currentSrc;
	        case 'OBJECT':
	            return node.data;
	        case 'A':
	            return node.href;
	        case 'PARAM':
	            if (constants_1.PARAM_SOURCE_NAMES.indexOf(node.name) !== -1) {
	                return node.value;
	            }
	    }
	    return node.src;
	}
	function isCached(node, url) {
	    return node[constants_1.NODE_CACHE_KEY] && node[constants_1.NODE_CACHE_KEY][url];
	}
	// 缓存当前链接操作状态
	function cache(node, url) {
	    node[constants_1.NODE_CACHE_KEY] = node[constants_1.NODE_CACHE_KEY] || {};
	    node[constants_1.NODE_CACHE_KEY][url] = true;
	}
	function remove(node) {
	    var url = getUrl(node);
	    if (!url || isCached(node, url)) {
	        return;
	    }
	    if (!url_legalize_1.isLegalUrl(url)) {
	        util_1.removeChild(node);
	        return;
	    }
	    // mark it if node is not deleted
	    cache(node, url);
	}
	// 延迟处理的节点
	/**
	 * @ignore
	 */
	exports.DELAYED_HANDLERS = {
	    A: remove,
	    IMG: remove,
	    IFRAME: remove,
	    AUDIO: remove,
	    VIDEO: remove,
	    EMBED: remove,
	    OBJECT: remove,
	    PARAM: remove,
	    SOURCE: remove
	};
	/**
	 * @ignore
	 */
	exports.DELAYED_NODE_NAMES = Object.keys(exports.DELAYED_HANDLERS).join(',');
	// 立即执行的节点
	/**
	 * @ignore
	 */
	exports.IMMEDIATELY_HANDLERS = {
	    SCRIPT: remove
	};
	/**
	 * @ignore
	 */
	exports.IMMEDIATELY_NODE_NAMES = Object.keys(exports.IMMEDIATELY_HANDLERS).join(',');


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var util_1 = __webpack_require__(103);
	var constants_1 = __webpack_require__(105);
	var util_2 = __webpack_require__(104);
	var WHITE_DOMAINS_REGEXP = getDomainsRegexp(constants_1.WHITE_DOMAINS);
	function getRegexpString(domain) {
	    // if domain is not start with ., only match like weidian.com
	    if (domain[0] !== '.') {
	        domain = '^' + domain;
	    }
	    else {
	        domain = '(^|.)' + domain.substr(1);
	    }
	    // match from end
	    domain = domain + '$';
	    // replace . to \\.
	    domain = domain.replace(/\./g, '\\.');
	    return domain;
	}
	function getDomainsRegexp(domains) {
	    var regexp = domains.map(getRegexpString).join('|');
	    return new RegExp("(" + regexp + ")");
	}
	// TODO support kdbridge://weidian.com/ private protocol
	// check if protocol contains javascript: or data:
	/**
	 *
	 * @ignore
	 */
	function isLegalProtocol(protocol) {
	    return !constants_1.ILLEGAL_PROTOCOL_REGEXP.test(protocol);
	}
	exports.isLegalProtocol = isLegalProtocol;
	// check if hostname is in white domains
	function isLegalDomain(hostname, options) {
	    if (options && options.whiteDomains.length) {
	        var domains = getWhiteDomains(options);
	        var CUSTOM_WHITE_DOMAINS_REGEXP = getDomainsRegexp(domains);
	        return CUSTOM_WHITE_DOMAINS_REGEXP.test(hostname);
	    }
	    return WHITE_DOMAINS_REGEXP.test(hostname);
	}
	/**
	 *
	 * @param options
	 * @returns string[] 白名单
	 */
	function getWhiteDomains(options) {
	    var option = util_2.merge({ append: true }, options || {});
	    var whiteDomains = option.whiteDomains || [];
	    // 未设置返回默认
	    if (option.append) {
	        var domains_1 = constants_1.WHITE_DOMAINS;
	        whiteDomains.forEach(function (domain) {
	            domains_1.push(domain);
	        });
	        return domains_1;
	    }
	    else {
	        return whiteDomains;
	    }
	}
	/**
	 * 检查是否是合法的链接，非法或者空链接返回false
	 * @param url  链接
	 * @param options  设置白名单
	 */
	function isLegalUrl(url, options) {
	    if (util_1.isEmpty(url)) {
	        return false;
	    }
	    // prevent links from appearing in hexadecimal and decimal encoding
	    url = util_1.htmlDecode(url).trim();
	    var link = util_1.createLink(url);
	    return (isLegalProtocol(link.protocol) && isLegalDomain(link.hostname, options));
	}
	exports.isLegalUrl = isLegalUrl;
	/**
	 * 合法化链接，合法返回绝对路径，不合法返回javascript:;
	 * @param url 链接
	 * @param options  设置白名单
	 * @returns boolean
	 */
	function legalizeUrl(url, options) {
	    url = isLegalUrl(url, options) ? util_1.createLink(url).href : constants_1.EMPTRY_URL;
	    var resolveUrl = util_1.access("resolveUrl" /* RESOLVE_URL */);
	    if (util_2.isFunction(resolveUrl)) {
	        url = resolveUrl(url);
	    }
	    return url;
	}
	exports.legalizeUrl = legalizeUrl;
	/**
	 * 添加域名白名单
	 * @param domain 与Cookie Domain设置规则保持一致，例如 .weidian.com 匹配 www.weidian.com,h5.weidian.com，weidian.com 只匹配 weidian.com
	 */
	function addWhiteDomain(domain) {
	    if (constants_1.WHITE_DOMAINS.indexOf(domain) === -1) {
	        constants_1.WHITE_DOMAINS.push(domain);
	        WHITE_DOMAINS_REGEXP = getDomainsRegexp(constants_1.WHITE_DOMAINS);
	    }
	}
	exports.addWhiteDomain = addWhiteDomain;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var constants_1 = __webpack_require__(105);
	/**
	 * 过滤 < > ' " & ` 字符
	 * @param value 字符串
	 * @returns 过滤后的字符串
	 */
	function escape(value) {
	    return value.replace(constants_1.ESCAPE_REGEXP, function (match) {
	        return constants_1.ESCAPE_MAP[match];
	    });
	}
	exports.escape = escape;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var url_legalize_1 = __webpack_require__(107);
	var constants_1 = __webpack_require__(105);
	var util_1 = __webpack_require__(103);
	/**
	 * 跳转方法
	 * @param url 链接
	 * @param replace boolean，默认为false。true: 使用location.replace，false: 使用location.href
	 */
	function jump(url, replace) {
	    if (replace === void 0) { replace = false; }
	    url = url_legalize_1.legalizeUrl(url);
	    if (url !== constants_1.EMPTRY_URL) {
	        if (replace) {
	            constants_1.GLOBAL.location.replace(url);
	        }
	        else {
	            constants_1.GLOBAL.location.assign(url);
	        }
	    }
	}
	exports.jump = jump;
	// 代理默认方法
	// function proxy() {
	//     // override window.open only support url arguments
	//     const originOpen = GLOBAL.open
	//     // tslint:disable-next-line: only-arrow-functions
	//     GLOBAL.open = function(url: string): Window | null {
	//         const args = toArray(arguments) as any
	//         args[0] = url === '' || url === undefined ? url : legalizeUrl(url)
	//         return originOpen.apply(GLOBAL, args)
	//     } as any
	// }
	// proxy()
	// 处理嵌入第三方iframe中问题，Chrome将阻止父窗口跳转
	function inIframe() {
	    if (util_1.access("observeIframe" /* OBSERVE_IFRAME */)) {
	        var topUrl = constants_1.GLOBAL.document.referrer || '';
	        if (constants_1.GLOBAL.self != constants_1.GLOBAL.top && !url_legalize_1.isLegalUrl(topUrl)) {
	            constants_1.GLOBAL.top.location.href = constants_1.GLOBAL.location.href;
	        }
	    }
	}
	util_1.domContentLoaded(inIframe);


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.ruleMapPromise = void 0;
	var constants_1 = __webpack_require__(55);
	var document_1 = __webpack_require__(99);
	var multidomain_1 = __webpack_require__(111);
	// import { getDocumentUrl } from './url'
	// import { isMultipleDomain } from './util'
	var multidomain_2 = __webpack_require__(111);
	Object.defineProperty(exports, "generateMultidomainUrl", { enumerable: true, get: function () { return multidomain_2.generateMultidomainUrl; } });
	Object.defineProperty(exports, "generateMpId", { enumerable: true, get: function () { return multidomain_2.generateMpId; } });
	Object.defineProperty(exports, "isPrivateDomainUrl", { enumerable: true, get: function () { return multidomain_2.isPrivateUrl; } });
	// generatePrivateUrl,
	Object.defineProperty(exports, "generateIndependentUrl", { enumerable: true, get: function () { return multidomain_2.generateIndependentUrl; } });
	function getRequestConfig() {
	    // body手动配置支持多域名分享 或者当前页链接为私域链接
	    /**
	     * 2021.2.3 默认页面初始化就开始请求获取多域名白名单接口数据
	     */
	    // if (isMultipleDomain() || isPrivateDomainUrl(getDocumentUrl())) {
	    // 当前window.multiDomainRuleMap对象已存在则立即成功回调
	    if (constants_1.GLOBAL.multiDomainRuleMap) {
	        return Promise.resolve(constants_1.GLOBAL.multiDomainRuleMap);
	    }
	    // 防止v-collect和pecker同时引入发起重复请求
	    if (constants_1.GLOBAL.ruleMapPromise) {
	        return constants_1.GLOBAL.ruleMapPromise;
	    }
	    return multidomain_1.requestConfig()
	        .then(function (ruleMap) {
	        constants_1.GLOBAL.multiDomainRuleMap = ruleMap;
	        return Promise.resolve(ruleMap);
	    })
	        .catch(function () { return Promise.reject(); });
	    // }
	}
	var ruleMapPromise;
	exports.ruleMapPromise = ruleMapPromise;
	document_1.bodyElementLoaded(function () {
	    exports.ruleMapPromise = ruleMapPromise = getRequestConfig();
	    // 若body开启了多域名分享，则将promise暴露在window对象上
	    ruleMapPromise && (constants_1.GLOBAL.ruleMapPromise = ruleMapPromise);
	});
	// export const generateMultidomainUrl = multidomain.generateMultidomainUrl
	// export const generateMpId = multidomain.generateMpId
	// export const isPrivateUrl = multidomain.isPrivateUrl
	// export const generatePrivateUrl = multidomain.generatePrivateUrl


/***/ }),
/* 111 */
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var GLOBAL=window,DOCUMENT=document,MOBILE_REGEXP=/AppleWebKit.*Mobile.*/i,WD_BUYER_REGEXP=/WDAPP\(WDBuyer/i,UA=navigator.userAgent.toLowerCase();function isMobile(){return MOBILE_REGEXP.test(UA)}function isWDBuyer(){return WD_BUYER_REGEXP.test(UA)}function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _toConsumableArray(e){return _arrayWithoutHoles(e)||_iterableToArray(e)||_unsupportedIterableToArray(e)||_nonIterableSpread()}function _arrayWithoutHoles(e){if(Array.isArray(e))return _arrayLikeToArray(e)}function _iterableToArray(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}function _unsupportedIterableToArray(e,t){if(e){if("string"==typeof e)return _arrayLikeToArray(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?_arrayLikeToArray(e,t):void 0}}function _arrayLikeToArray(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function noop(){}function isUndef(e){return null==e}function isEmpty(e){return null==e||""===e}function isType(t){return function(e){return Object.prototype.toString.call(e)==="[object "+t+"]"}}function isNumber(e){return isType("Number")(e)}function isString(e){return isType("String")(e)}function isError(e){return isType("Error")(e)}function isArray(e){return isType("Array")(e)}function isFunction(e){return"function"==typeof e}function isDate(e){return isType("Date")(e)}function isBoolean(e){return isType("Boolean")(e)}function isObject(e){return isType("Object")(e)}function isWideObject(e){return null!==e&&"object"===_typeof(e)}function isFormData(e){return"undefined"!=typeof FormData&&e instanceof FormData}function isURLSearchParams(e){return"undefined"!=typeof URLSearchParams&&e instanceof URLSearchParams}function hasOwn(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function forEach(e,t){if(isArray(e))for(var r=0,n=e.length;r<n;r++)t.call(null,e[r],r,e);else if(isObject(e))for(var o in e)hasOwn(e,o)&&t.call(null,e[o],o,e)}function merge(e){for(var r,n,t=[],o=1;o<arguments.length;o++)t[o-1]=arguments[o];return n=isBoolean(e)?(r=e,t.shift()):e,forEach(t,function(e){forEach(e,function(e,t){r&&(isArray(e)||isObject(e))?(isArray(e)?isArray(n[t])||(n[t]=[]):isObject(n[t])||(n[t]={}),merge(r,n[t],e)):n[t]=e})}),n}function toArray(e){return Array.prototype.slice.call(e)}var __extends=function(){var n=function(e,t){return(n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(e,t)};return function(e,t){function r(){this.constructor=e}n(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}}(),NetworkError=function(o){function e(e,t,r){var n=o.call(this,e)||this;return n.code=t,n.subcode=r,n}return __extends(e,o),e}(Error);function createError(e,t,r){return new NetworkError(e,t,r)}function isResponseOk(e){return 200<=e&&e<300||304==e}function parseJSON(e){try{return JSON.parse(e)}catch(e){}}function isNativeFunction(e){return"function"==typeof e&&-1!==e.toString().indexOf("[native code]")}function isUseNative(e){var t;return isWDBuyer()&&(null===(t=null==e?void 0:e.extra)||void 0===t?void 0:t.useNative)}function _goto(e){e&&GLOBAL.location.assign(e)}var Hooks=function(){function e(){this.hooks={}}return e.prototype.push=function(e,t){var r=this.hooks[e]||(this.hooks[e]=[]);return"function"==typeof t&&r.push(t),this},e.prototype.invokeWaterfall=function(e,r,n){var o=this.hooks[e];if(!o||!o.length)return n(),this;var i=0;return o[i](r,function e(t){return isError(t)?n(t):++i>=o.length?n():void o[i](r,e)}),this},e}(),AbstractNetwork=function(){function e(e){this.hooks=new Hooks,this._installedPlugins=[],this.options=e||{},this.hooks=new Hooks,this._installedPlugins=[]}return e.prototype.use=function(e){return-1<this._installedPlugins.indexOf(e)||!isFunction(e)||(e.call(this),this._installedPlugins.push(e)),this},e}(),HASH_DELIMIT="#",SEARCH_DELIMIT="?",PARAM_DELIMIT="&";function encode(e){return encodeURIComponent(e).replace(/%20/g,"+")}function serialize(e){if(isURLSearchParams(e))return e.toString();var r,t=e;return(isObject(e)||isArray(e))&&(r=[],forEach(e,function(e,t){isUndef(e)||(isArray(e)?t+="[]":e=[e],forEach(e,function(e){isDate(e)?e=e.toISOString():isWideObject(e)&&(e=JSON.stringify(e)),r.push(encode(t)+"="+encode(e))}))}),t=r.join(PARAM_DELIMIT)),t}function appendParams(e,t){if(!isString(e))return"";var r=e.split(HASH_DELIMIT);e=r[0];var n=serialize(t);return isString(n)&&n&&(e+=(-1===e.indexOf(SEARCH_DELIMIT)?SEARCH_DELIMIT:PARAM_DELIMIT)+n),r[0]=e,r.join(HASH_DELIMIT)}var GET_METHOD="GET",JSON_RESPONSE_TYPE="json";function normalizeStatus(e,t){var r=t.url;return 0===e&&0===r.indexOf("file:")?200:{1223:204}[e]||e}function normalizeUrl(e,t){var r=t.method,n=t.cache,o=t.data;return r===GET_METHOD&&(e=appendParams(e,o),n||(e=appendParams(e,{_:Date.now()}))),e}function setWithCredentials(e,t){t.withCredentials&&(e.withCredentials=!0)}function setResponseType(e,t){var r=t.responseType;if(r)try{e.responseType=r}catch(e){}}function setRequestHeader(e,t){var r=t.headers,n=t.method,o=t.data;if(isObject(r))for(var i in r)if(r.hasOwnProperty(i)&&!isUndef(r[i])){if("content-type"===i.toLowerCase()&&(n===GET_METHOD||isFormData(o)))continue;e.setRequestHeader(i,r[i])}}function getResponse(e,t){var r=t.responseType,n=t.status,o=e.response;if(r===JSON_RESPONSE_TYPE&&e.responseType!==JSON_RESPONSE_TYPE&&!isObject(o))try{o=JSON.parse(e.responseText)}catch(e){throw e}return{data:o,status:n}}function invokeHook(e,t,r){r=r||noop,isFunction(e)?e(t,function(){r(t)}):r(t)}function handleReadyStateChange(t,r){var e=r.responseType,n=r.url,o=r.success,i=r.error;if(4===t.readyState){var a=normalizeStatus(t.status,{url:n}),s=void 0;if(isResponseOk(a)){try{s=getResponse(t,{responseType:e,status:a})}catch(e){return invokeHook(r.beforeError,{request:t,response:s,options:r,error:e},i)}invokeHook(r.beforeSuccess,{request:t,response:s,options:r},o)}else invokeHook(r.beforeError,{request:t,response:s,options:r,error:new Error("Network Error")},i)}}function xhr(e){(e=merge({method:GET_METHOD,responseType:JSON_RESPONSE_TYPE,withCredentials:!0,cache:!0},e)).method=e.method||GET_METHOD;var t=new XMLHttpRequest;function n(e){var t=e.request,r=e.options;t.send(r.method===GET_METHOD?null:serialize(r.data))}invokeHook(e.configured,{request:t,options:e},function(e){var t=e.request,r=e.options;r.method=r.method.toUpperCase(),t.open(r.method,normalizeUrl(r.url,r),!0),t.onreadystatechange=function(){handleReadyStateChange(t,r)},setWithCredentials(t,r),setResponseType(t,r),setRequestHeader(t,r),invokeHook(r.beforeRequest,{request:t,options:r},n)})}var __extends$1=function(){var n=function(e,t){return(n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(e,t)};return function(e,t){function r(){this.constructor=e}n(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}}(),HOOK_NAMES=["configured","beforeRequest","beforeSuccess","beforeError"];function invokeHooks(e,n){forEach(HOOK_NAMES,function(r){e[r]=function(e,t){n.hooks.invokeWaterfall(r,e,t)}})}var Network=function(t){function e(e){return t.call(this,e)||this}return __extends$1(e,t),e.prototype.request=function(e,t){var r=this,n=merge(!0,{},this.options,t||{},{url:e,extra:{}});return new Promise(function(e,t){isString(n.url)&&n.url?(invokeHooks(n,r),n.success=e,n.error=t,xhr(n)):t({error:createError("Url Error",-2)})})},e}(AbstractNetwork);function isMethodNotImplement(e){var t=e.message;return 10001===e.code||-1!==t.indexOf("暂未实现")||-1!==t.indexOf("not implemented")}function jsbridge(e){var t=e.url,r=e.data;return new Promise(function(n,o){isUndef(GLOBAL.KDJSBridge2)?o(createError("Jsbridge Undefined",-3,1)):GLOBAL.KDJSBridge2.call("WDJSBridge","thorRequest",{url:t,param:r},function(e){var t,r=(null===(t=null==e?void 0:e.param)||void 0===t?void 0:t._errMsg)||{};if(0===r.code)n(e);else{if(isMethodNotImplement(r))return void o(createError("Jsbridge Method Not Implement Error",-3,2));o(createError(r.message||"Jsbridge Method Call Error",-3,3))}})}).then(function(e){return e.param.thorResponse})}var SEARCH_DELIMIT$1="?",PARAM_DELIMIT$1="&",PARAM_VALUE_DELIMIT="=",GLOBAL$1=window,SEARCH_REGXP=/^[^\?#]*\?([^#]*)/;function getSearch(e){var t;return e&&(t=e.match(SEARCH_REGXP))&&t[1]||""}function encode$1(e){return encodeURIComponent(e)}function decode(e){return decodeURIComponent(e.replace(/\+/g," "))}function parse(e){var t=(e=getSearch(e)).split(PARAM_DELIMIT$1),o={};return t.forEach(function(e){var t,r,n;e&&(r=(t=e.split(PARAM_VALUE_DELIMIT))[0],n=t.slice(1).join(PARAM_VALUE_DELIMIT)||"",r&&(r=decode(r),n=decode(n),hasOwn(o,r)?(isArray(o[r])||(o[r]=[o[r]]),o[r].push(n)):o[r]=n))}),o}function stringify(e){if(!isObject(e))return"";var r=[];return forEach(e,function(e,t){isUndef(e)||(isArray(e)||(e=[e]),t=encode$1(t),e.forEach(function(e){r.push(""+t+PARAM_VALUE_DELIMIT+encode$1(e))}))}),r.join(PARAM_DELIMIT$1)}var QUERY_PROPERTY="query",NORMAL_PROPERTIES=["hash","host","hostname","pathname","port","protocol"],QUERY_RELATED_PROPERTIES=["href","search"],READONLY_PROPERTIES=["origin"],defineProperty=Object.defineProperty;function validate(e,t){return e===QUERY_PROPERTY?isObject(t):isString(t)||isNumber(t)}function getSearch$1(e){var t=stringify(e);return(t?SEARCH_DELIMIT$1:"")+t}function defineNormalProperties(e,r){NORMAL_PROPERTIES.forEach(function(t){defineProperty(e,t,{get:function(){return r[t]},set:function(e){validate(t,e)&&(r[t]=e)},enumerable:!0})})}function defineQueryProperty(e,t){var r;defineProperty(e,r=QUERY_PROPERTY,{get:function(){return e.search=getSearch$1(t[r]),t[r]},set:function(e){validate(r,e)&&(t[r]=e)},enumerable:!0})}function defineQueryRelatedProperties(e,r){QUERY_RELATED_PROPERTIES.forEach(function(t){defineProperty(e,t,{get:function(){return r.search=getSearch$1(r[QUERY_PROPERTY]),r[t]},set:function(e){validate(t,e)&&(r[t]=e,r[QUERY_PROPERTY]=parse(r.search))},enumerable:!0})})}function defineReadonlyProperties(t,r){READONLY_PROPERTIES.forEach(function(e){defineProperty(t,e,{get:function(){return r[e]},enumerable:!0})})}var Url=function(){function e(e){isEmpty(e)&&(e=GLOBAL$1.location.href);var t=this._element=GLOBAL$1.document.createElement("A");t.href=e,defineNormalProperties(this,this._element),defineQueryRelatedProperties(this,this._element),defineQueryProperty(this,this._element),defineReadonlyProperties(this,this._element),this.href=t.href}return e.prototype.toString=function(){return this.href},e}();function setQuerystring(e,t,r){var n=GLOBAL$1.location.href;isObject(e)&&(r=t,t=e,e=n),isUndef(e)&&(e=n),r=merge({replace:!0},r);var o,i,a=new Url(e);return r.replace?a.query=merge(a.query||{},t):(o=stringify(t))&&(i=-1===a.search.indexOf(SEARCH_DELIMIT$1)?SEARCH_DELIMIT$1:PARAM_DELIMIT$1,a.search+=i+o),a.toString()}function getQuerystring(e){return isUndef(e)&&(e=GLOBAL$1.location.href),parse(e)}var __extends$2=function(){var n=function(e,t){return(n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(e,t)};return function(e,t){function r(){this.constructor=e}n(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}}();function getRequestUrl(e){return new Url(e).pathname.slice(1)||""}function isLegalRequestUrl(e){if(!isString(e)||!e)return!1;var t=getRequestUrl(e);return t&&3===t.split("/").length}function getRequestData(e){return e&&e.param||{}}var NativeNetwork=function(t){function e(e){return t.call(this,e)||this}return __extends$2(e,t),e.prototype.request=function(e,t){var r=merge({url:getRequestUrl(e),data:getRequestData(t&&t.data)},this.options);return isLegalRequestUrl(e)?jsbridge(r):Promise.reject(createError("Url Error Or Url Pathname Illegal",-2))},e}(AbstractNetwork);function serialize$1(r){isObject(r)&&forEach(r,function(e,t){(isObject(e)||isArray(e))&&(r[t]=JSON.stringify(e))})}function handleResponse(e){var t=e.response,r=e.options,n=t.data;return"json"!==r.responseType||isWideObject(n)?n:Promise.reject(createError("JSON Data Error",-1,1))}function normal(){var e=this;e.hooks.push("beforeRequest",function(e,t){serialize$1(e.options.data),t()});var t=e.request;e.request=function(){return t.apply(e,arguments).then(handleResponse,function(e){var t=isError(e)?e:e.error;return Promise.reject(t)})}}var GLOBAL$2=window,COOKIE_DELIMIT="; ",COOKIE_VALUE_DELIMIT="=",COOKIE_VALUE_REGXP=new RegExp("([^"+COOKIE_VALUE_DELIMIT+"]+)"+COOKIE_VALUE_DELIMIT+"(.*)"),_decodeURIComponent=GLOBAL$2.decodeURIComponent,_encodeURIComponent=GLOBAL$2.encodeURIComponent,_escape=GLOBAL$2.escape;function normalizeGetName(e){return e.replace(/(%[0-9A-Z]{2})+/g,_decodeURIComponent)}var normalize={get:{name:normalizeGetName,value:function(e){return normalizeGetName(e)}},set:{name:function(e){return _encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g,_decodeURIComponent).replace(/[\(\)]/g,_escape)},value:function(e){return _encodeURIComponent(e).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,_decodeURIComponent)}}};function get(r){var n;if(!isEmpty(r))return GLOBAL$2.document.cookie.split(COOKIE_DELIMIT).some(function(e){var t=e.match(COOKIE_VALUE_REGXP);return!(!t||normalize.get.name(t[1])!==r)&&(n=normalize.get.value(t[2]),!0)}),n}var DEVICE_ID={},COMPLETED=!1,INITIALIZED=!1,DEVICE_ID_CALLBACK_QUEUE=[];function push(e){DEVICE_ID_CALLBACK_QUEUE.push(e)}function flush(t){forEach(DEVICE_ID_CALLBACK_QUEUE,function(e){e(t)}),DEVICE_ID_CALLBACK_QUEUE.length=0}function getSuid(t){isUndef(GLOBAL.KDJSBridge2)?t():GLOBAL.KDJSBridge2.call("WDJSBridge","getSuid",{},function(e){e&&e.param&&e.param.suid?t(e.param.suid):t()})}function getCuid(t){isUndef(GLOBAL.KDJSBridge2)?t():GLOBAL.KDJSBridge2.call("WDJSBridge","getCuid",{},function(e){e&&e.param&&e.param.cuid?t(e.param.cuid):t()})}function init(){var e;function t(){2===++e&&(COMPLETED=!0,flush(DEVICE_ID))}INITIALIZED||(INITIALIZED=!0,e=0,getSuid(function(e){e&&(DEVICE_ID.suid=e),t()}),getCuid(function(e){e&&(DEVICE_ID.cuid=e),t()}))}function getDeviceId(e){init(),COMPLETED?e(DEVICE_ID):push(e)}var CSRF_TOKEN_NAME="wdtoken";function appendCSRFTokenParam(e){var t=get(CSRF_TOKEN_NAME);if(t){if(isObject(e))return void(e[CSRF_TOKEN_NAME]=t);if(isFormData(e))return void e.append(CSRF_TOKEN_NAME,t);if(isURLSearchParams(e))return void e.set(CSRF_TOKEN_NAME,t)}}function appendDeviceId(t,r){getDeviceId(function(e){isObject(t)&&(t.context=merge(t.context||{},e)),r()})}function enhanceErrorResponse(e){var t=e.code,r=e.subcode,n=e.message;return{status:{code:isUndef(t)?-1:t,subcode:r,message:n},result:null}}function handleResponse$1(e){return e&&e.status&&0===e.status.code?e:Promise.reject(e)}function handleErrorResponse(e){return Promise.reject(enhanceErrorResponse(e))}function thor(){var e=this;e.hooks.push("configured",function(e,t){var r=e.options;r.responseType="json",r.data=r.data||{},appendCSRFTokenParam(r.data),r.extra.deviceId?appendDeviceId(r.data,function(){t()}):t()});var t=e.request;e.request=function(){return t.apply(e,arguments).then(handleResponse$1,handleErrorResponse)}}var DEFAULT_SCALE=1,TOAST_DURATION=1500;function getScale(){if(isMobile()){var e=document.querySelectorAll('meta[name="viewport"]'),t=e[e.length-1];if(t){var r=t.getAttribute("content"),n=r&&r.match(/initial\-scale=([\d\.]+)/);return n?1/Number(n[1]):DEFAULT_SCALE}}return DEFAULT_SCALE}function toast(e){var t,r=getScale(),n='<div class="hawk-toast">'+e+'</div><style type="text/css">.hawk-toast{position:fixed;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:10000;width:50%;color:#fff;background:rgba(33,33,33,0.9);line-height:1.5;border-radius:'+8*r+"px;max-width:"+300*r+"px;padding:"+20*r+"px;font-size:"+16*r+"px;}</style>",o=DOCUMENT.body;o&&((t=DOCUMENT.createElement("div")).innerHTML=n,o.appendChild(t),setTimeout(function(){o.removeChild(t)},TOAST_DURATION))}var IDENTITY_CODES=20,IDENTITY_REDIRECT_KEY="redirect",IDENTITY_TIMEOUT=1e3;function identity(e){var t;if(isObject(e)){var r=isObject(e.status)?e.status:{},n=isObject(e.result)?e.result:{},o=n.authPageUrl;if(r.code==IDENTITY_CODES&&o)return o=setQuerystring(o,((t={})[IDENTITY_REDIRECT_KEY]=GLOBAL.location.href,t)),n.message&&toast(n.message),setTimeout(function(){_goto(o)},IDENTITY_TIMEOUT),!1}return!0}var XMLHTTPREQUEST=GLOBAL.XMLHttpRequest,XHR_PROTOTYPE=XMLHTTPREQUEST&&XMLHTTPREQUEST.prototype,ORIGINAL_XHR_SEND=XHR_PROTOTYPE&&XHR_PROTOTYPE.send;function handleRequestResponse(e,t,r){try{if(4==t.readyState&&isResponseOk(t.status)){var n=isObject(t.response)?t.response:parseJSON(t.responseText);return e.beforeSuccess(n,r)}}catch(e){}r()}function interceptRequest(i){isFunction(ORIGINAL_XHR_SEND)&&(XHR_PROTOTYPE.send=function(){var e=arguments,t=this,r=t.onreadystatechange,n=t.onload,o=!1;return r&&(o=!0,t.onreadystatechange=function(){var e=arguments;handleRequestResponse(i,t,function(){r.apply(t,e)})}),n&&!o&&(t.onload=function(){var e=arguments;handleRequestResponse(i,t,function(){n.apply(t,e)})}),ORIGINAL_XHR_SEND.apply(t,e)})}var ELEMENT=GLOBAL.Element,ELEMENT_PROTOTYPE=ELEMENT&&ELEMENT.prototype,SCRIPT_TAGNAME="SCRIPT",JSONP_CALLBACK_NAME="callback",PROXY_ELEMENT_METHODS=["appendChild","insertBefore"];function handleRequestResponse$1(e,t,r){try{return e.beforeSuccess(t,r)}catch(e){}r()}function getCallbackDefinition(e){var t=e.split("."),r=t.length;if(r){var n,o=GLOBAL,i=GLOBAL;try{for(var a=0;a<r;a++){if(!i)return;n=t[a],i=(o=i)[n]}if(!isFunction(i))return}catch(e){return}return{namespace:o,name:n,definition:i}}}function interceptJsonp(i){forEach(PROXY_ELEMENT_METHODS,function(e){var o=ELEMENT_PROTOTYPE&&ELEMENT_PROTOTYPE[e];o&&(ELEMENT_PROTOTYPE[e]=function(e){var t,r,n;return e&&e.tagName===SCRIPT_TAGNAME&&e.src&&(!isString(t=getQuerystring(e.src)[JSONP_CALLBACK_NAME])||(r=getCallbackDefinition(t))&&(n=r.definition,r.namespace[r.name]=function(e){var t=arguments;handleRequestResponse$1(i,e,function(){n.apply(r.namespace,t)})})),o.apply(this,toArray(arguments))})})}var FETCH=GLOBAL.fetch;function handleRequestResponse$2(t,e,r){try{if(isResponseOk(e.status))return e.clone().json().then(function(e){t.beforeSuccess(e,r)}).catch(function(){r()})}catch(e){}r()}function interceptFetch(r){isNativeFunction(FETCH)&&(GLOBAL.fetch=function(){var e=arguments;return FETCH.apply(this,e).then(function(t){return new Promise(function(e){handleRequestResponse$2(r,t,function(){e(t)})})})})}function intercept(e){isObject(e)&&isFunction(e.beforeSuccess)&&(interceptRequest(e),interceptJsonp(e),interceptFetch(e))}function interceptHandler(){intercept({beforeSuccess:function(e,t){identity(e)&&t()}})}function hawk(){GLOBAL.hawk.disabled||(interceptHandler(),GLOBAL.hawk.disabled=!0)}function enhanceErrorResponse$1(e){var t=e.code,r=e.subcode,n=e.message;return{status:{code:isUndef(t)?-3:t,subcode:r,message:n},result:null}}function handleResponse$2(e){return e&&e.status&&0===e.status.code?e:Promise.reject(e)}function handleErrorResponse$1(e){return Promise.reject(enhanceErrorResponse$1(e))}function nativeThor(){var e=this,t=e.request;e.request=function(){return t.apply(e,arguments).then(handleResponse$2,handleErrorResponse$1)}}GLOBAL.hawk=GLOBAL.hawk||{disabled:!1};var HEADERS={"Content-Type":"application/x-www-form-urlencoded; charset=UTF-8",Accept:"application/json, */*"};function create(e){e=merge(!0,{},{headers:HEADERS,cache:!1},e);var t=new Network(e);return t.use(normal),t}var thor$1=create();thor$1.use(hawk),thor$1.use(thor);var nativeThor$1=new NativeNetwork;function request(e,t){return isUseNative(t)?nativeThor$1.request(e,t):thor$1.request(e,t)}nativeThor$1.use(nativeThor);var utils={generateEnvStr:function(e){var t=0<arguments.length&&void 0!==e?e:window.location.href,r="";return/\.((daily)|(dev))\./.test(t)?r=".daily":/\.pre\./.test(t)&&(r=".pre"),r},isPrivateUrl:function(e){return/^(http(s)?:)?\/\/shop\w+((\.daily)|(\.pre))?\.v\.weidian\.com/.test(e)},generateConfigDataNameByUrl:function(e){return this.isPrivateUrl(e)?"privateRuleList":/^(http(s)?:)?\/\/.*\.youshop10\.com/.test(e)?"groupRuleList":""},analyzeUrl:function(e){return new Url(e)},isUrl:function(e){if("string"!=typeof e)return!1;var t=e.match(/^(?:\w+:)?\/\/(\S+)$/);if(!t)return!1;var r=t[1];return!!r&&!(!/^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/.test(r)&&!/^[^\s\.]+\.\S{2,}$/.test(r))}},requestConfig=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:utils.generateEnvStr();return request("https://thor".concat(e,".weidian.com/skittles/share.getConfig/1.0")).then(function(e){if(e&&e.result){var t=e.result;return Object.assign({},t,{mpConfigList:t.mpConfigList,privateRuleList:t.privateRuleList,multidomainRuleMap:t.urlRules})}return null}).catch(function(){return null})},href=window.location.href,requestMultidomainUrl=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},t=e.shareUrl,r=void 0===t?href:t,n=e.originUrl,o=void 0===n?href:n;return request("//thor".concat(utils.generateEnvStr(),".weidian.com/skittles/share.getUrlNew/1.0"),{method:"post",data:{param:{shareUrl:r,originUrl:o}}}).then(function(e){return e&&e.result&&e.result.success?{url:e.result.shareUrl,mpId:e.result.mpId}:null}).catch(function(){return null})},href$1=window.location.href,requestShortUrl=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:href$1;return request("//thor".concat(utils.generateEnvStr(),".weidian.com/skittles/share.getShortUrl/1.0"),{method:"post",data:{param:{url:e}}}).then(function(e){return e.result?e.result.shareUrl:""}).catch(function(){return""})},isPrivateUrl=function(e){return utils.isPrivateUrl(e)},generateMultidomanUrl=function(t,e){var r,n,o,i=e.multidomainRuleMap,a=utils.analyzeUrl(t),s=a.protocol,u=a.host,c=a.origin,f=a.pathname,l=f.replace(/^\//,"").replace(/\/$/,"").split("/"),p=t;try{var d=i[u];if(d){for(var E=[],h=0,_=d.length;h<_;h++){var m,v,R,y,g,O=d[h],T=O.backupHosts,A=O.backupPath,I=O.pathRegExp;1==O.status&&new RegExp(I).test(t)&&T.length&&(m=T[r=0,n=T.length,o=void 0,o=Math.random(),r+parseInt(o*(n-r)+"")],y=f,A&&(v=/\/$/.test(f),R=[A].concat(_toConsumableArray(l.slice(1))),y="/".concat(R.join("/")).concat(v?"/":"")),g=t.replace(/\/$/,"").replace("".concat(c).concat(f).replace(/\/$/,""),""),E.push("".concat(s,"//").concat(m).concat(y).concat(g)))}var L=E.length;1<=L&&(p=E[L-1])}}catch(e){p=t}return utils.isUrl(p)||(p=t),p},generateConfigDataNameByUrl=function(e){return utils.generateConfigDataNameByUrl(e)},generateIndependentUrl=function(e,t){var r=t.dataMap,n=t.curUrl,o=void 0===n?window.location.href:n;if(!e||!utils.isUrl(e))return e;var i=generateConfigDataNameByUrl(o);if(!o||!i)return e;var a=r[i];if(!a)return e;for(var s,u,c,f,l,p=utils.analyzeUrl(o),d=p.protocol,E=p.host,h=e,_=-1,m=0,v=a.length;m<v;m++)try{var R=a[m],y=R.status,g=R.pathRegExp,O=new RegExp(g);if(1==y&&O.test(h)){_=m;break}}catch(e){}return-1!==_&&(u=(s=utils.analyzeUrl(e)).pathname,c=s.search,f=s.host,l=s.hash,"privateRuleList"===i&&"i.weidian.com"===f&&(E="".concat(E,"/user")),h="".concat(d,"//").concat(E).concat(u).concat(c).concat(l)),h};function getMpId(e,t){var r="";e=e.replace(/^((www)|(wd)|(rocker)|(h5)|(shop)|(im)|(k))\./,"");for(var n=0,o=t.length;n<o;n++){var i=t[n],a=i.hosts,s=i.mpId;if(-1!==a.indexOf(e)){r=s;break}}return r}var generateMpId=function(e,t){var r="";if(!t)return r;var n=t.mpConfigList,o=t.multidomainRuleMap;if(!n||!o)return r;var i=generateMultidomanUrl(e,{multidomainRuleMap:o}),a=new Url(i).host;return r=getMpId(/weidian\.com/.test(a)?new Url(window.location.href).host:a,n)};exports.generateConfigDataNameByUrl=generateConfigDataNameByUrl,exports.generateIndependentUrl=generateIndependentUrl,exports.generateMpId=generateMpId,exports.generateMultidomainUrl=generateMultidomanUrl,exports.isPrivateUrl=isPrivateUrl,exports.requestConfig=requestConfig,exports.requestMultidomainUrl=requestMultidomainUrl,exports.requestShortUrl=requestShortUrl;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.generateDynamicSampleRate = exports.isMeetCondition = exports.isMeetDynamicSample = exports.isMeetFixedSample = void 0;
	var constants_1 = __webpack_require__(55);
	var SAMPLE_LOGS_MAP = {};
	var TIMER = 0;
	var CLEAR_INTERVAL = 5 * 60 * 1000;
	var TIMES = 4;
	/**
	 * 符合固定采样条件
	 * @param rate 采样率[number]
	 */
	function isMeetFixedSample(rate) {
	    return isMeetCondition(rate);
	}
	exports.isMeetFixedSample = isMeetFixedSample;
	/**
	 * 符合动态采样条件，每5分钟一个计算周期，一个周期内相同级别的相同错误累计错误发生 5 次就开启动态采样
	 * @param key 标识符：能够标明一个唯一日志，比如 message_doucement_url
	 */
	function isMeetDynamicSample(token) {
	    if (!TIMER) {
	        TIMER = constants_1.GLOBAL.setTimeout(function () {
	            SAMPLE_LOGS_MAP = {};
	            TIMER = 0;
	        }, CLEAR_INTERVAL);
	    }
	    var count = SAMPLE_LOGS_MAP[token] || 0;
	    SAMPLE_LOGS_MAP[token] = count + 1;
	    return isMeetCondition(count > TIMES ? generateDynamicSampleRate(count - TIMES) : 1);
	}
	exports.isMeetDynamicSample = isMeetDynamicSample;
	function isMeetCondition(rate) {
	    return Math.random() < rate;
	}
	exports.isMeetCondition = isMeetCondition;
	function generateDynamicSampleRate(count) {
	    return 1 / Math.pow(2, count);
	}
	exports.generateDynamicSampleRate = generateDynamicSampleRate;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.remove = exports.set = exports.get = void 0;
	var window_name_1 = __webpack_require__(114);
	var storage = window_name_1.default();
	function get(name) {
	    return storage.get(name);
	}
	exports.get = get;
	// TODO 对于引用类型，要进行深度复制，防止缓存区的值被修改
	function set(name, value) {
	    storage.set(name, value);
	}
	exports.set = set;
	function remove(name) {
	    storage.remove(name);
	}
	exports.remove = remove;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var shared_1 = __webpack_require__(41);
	var document_1 = __webpack_require__(99);
	var util_1 = __webpack_require__(61);
	var url_1 = __webpack_require__(100);
	var constants_1 = __webpack_require__(55);
	// const NAME_DESCRIPTOR = Object.getOwnPropertyDescriptor(GLOBAL, 'name')
	function isInternal(name) {
	    return name.indexOf(constants_1.STORAGE_PREFIX) !== -1;
	}
	// function disableWriting(name: string) {
	//     Object.defineProperty(GLOBAL, 'name', {
	//         get() {
	//             return name
	//         },
	//         set() {
	//             info(`window.name is used by pecker, forbid write.`)
	//         }
	//     })
	// }
	// function enableWriting() {
	//     delete GLOBAL.name
	//     Object.defineProperty(GLOBAL, 'name', NAME_DESCRIPTOR!)
	// }
	function setWindowName(name) {
	    if (name === void 0) { name = ''; }
	    if (constants_1.GLOBAL.opener) {
	        try {
	            constants_1.GLOBAL.opener.name = name;
	        }
	        catch (e) { }
	    }
	    // clear window name
	    constants_1.GLOBAL.name = name;
	}
	function getWindowName() {
	    var name = '';
	    // pass opener name to window name
	    if (constants_1.GLOBAL.opener) {
	        try {
	            // will throw error when cross-origin
	            name = constants_1.GLOBAL.opener.name;
	        }
	        catch (e) { }
	    }
	    name = name || constants_1.GLOBAL.name;
	    return name;
	}
	function normalize(name) {
	    if (isInternal(name)) {
	        // clear immediately, prevent data leakage
	        setWindowName();
	    }
	    else {
	        // reset name
	        name = '';
	    }
	    return name;
	}
	function windowName() {
	    var name = normalize(getWindowName());
	    // init STORAGE value
	    var storage = shared_1.parseJSON(name);
	    if (!util_1.isObject(storage)) {
	        storage = {};
	    }
	    document_1.pageUnload(function () {
	        // set window.name storage when jump to legal url
	        if (url_1.isLegalDestinationUrl()) {
	            constants_1.GLOBAL.name = shared_1.stringifyJSON(storage);
	        }
	    });
	    return {
	        // 取值和设置值为引用类型
	        get: function (name) {
	            return name ? storage[name] : storage;
	        },
	        set: function (name, value) {
	            storage[name] = value;
	        },
	        remove: function (name) {
	            if (name) {
	                delete storage[name];
	            }
	            else {
	                storage = {};
	            }
	        }
	    };
	}
	exports.default = windowName;


/***/ }),
/* 115 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.INTERNAL_ACTION_NAMES = exports.VOID_HREF = exports.URL_SEARCH_PARAMS_KEY_ALIAS = exports.URL_SEARCH_PARAMS_KEY = exports.URL_SEARCH_PARAMS_ACTION = exports.URL_SEARCH_PARAMS_SPM = exports.AUTO_TRACK_SPIDER = exports.DATA_SPIDER_IMPRESSION = exports.DATA_ACTION_ARGS = exports.DATA_ACTION_NAME = exports.DATA_SPIDER_MODE = exports.DATA_SPIDER_PRIOR = exports.DATA_SPIDER = void 0;
	exports.DATA_SPIDER = 'data-spider';
	exports.DATA_SPIDER_PRIOR = 'data-spider-prior';
	exports.DATA_SPIDER_MODE = 'data-spider-mode';
	exports.DATA_ACTION_NAME = 'data-spider-action-name';
	exports.DATA_ACTION_ARGS = 'data-spider-action-args';
	exports.DATA_SPIDER_IMPRESSION = 'data-spider-impression';
	exports.AUTO_TRACK_SPIDER = 'spider-auto';
	exports.URL_SEARCH_PARAMS_SPM = 'spider';
	exports.URL_SEARCH_PARAMS_ACTION = 'spider_action';
	exports.URL_SEARCH_PARAMS_KEY = 'spider_token';
	exports.URL_SEARCH_PARAMS_KEY_ALIAS = 'spider_token_alias';
	exports.VOID_HREF = 'javascript:';
	/**
	 * spider内置actionName
	 */
	var INTERNAL_ACTION_NAMES;
	(function (INTERNAL_ACTION_NAMES) {
	    /**
	     * 立即购买
	     */
	    INTERNAL_ACTION_NAMES["BUY_NOW"] = "_buyNow";
	    /**
	     * 加入购物车
	     */
	    INTERNAL_ACTION_NAMES["ADD_TO_CART"] = "_addToCart";
	    /**
	     * 关注（店铺）
	     */
	    INTERNAL_ACTION_NAMES["ADD_TO_FAVORITES"] = "_addToFavorites";
	    /**
	     * 收藏（商品）
	     */
	    INTERNAL_ACTION_NAMES["COLLECTION"] = "_collection";
	    /**
	     * 分享
	     */
	    INTERNAL_ACTION_NAMES["SHARE"] = "_share";
	    /**
	     * 点赞
	     */
	    INTERNAL_ACTION_NAMES["LIKE"] = "_like";
	    /**
	     * 联系商家
	     */
	    INTERNAL_ACTION_NAMES["IM"] = "_im";
	    /**
	     * 查看商品详情
	     */
	    INTERNAL_ACTION_NAMES["ITEM"] = "_item";
	    /**
	     * 查看店铺详情
	     */
	    INTERNAL_ACTION_NAMES["SHOP"] = "_shop";
	    /**
	     * 查看动态详情
	     */
	    INTERNAL_ACTION_NAMES["DYNAMIC"] = "_dynamic";
	    /**
	     * 下载&打开微店app
	     */
	    INTERNAL_ACTION_NAMES["DOWNLOAD"] = "_download";
	})(INTERNAL_ACTION_NAMES = exports.INTERNAL_ACTION_NAMES || (exports.INTERNAL_ACTION_NAMES = {}));


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(117), exports);
	__exportStar(__webpack_require__(143), exports);
	__exportStar(__webpack_require__(144), exports);
	__exportStar(__webpack_require__(145), exports);
	__exportStar(__webpack_require__(141), exports);
	__exportStar(__webpack_require__(142), exports);
	__exportStar(__webpack_require__(146), exports);

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getSearchParams = exports.getCookie = exports.deprecatedLog = exports.formatSpiderAction = exports.normalizeParam = exports.getSpmaAndSpmb = exports.getSpiderVisualCdns = exports.getCookies = exports.getCurURLPassProperties = exports.validatePageArgs = exports.convertData = exports.isValidSpiderAction = exports.isInternalActionName = exports.isValidSpmValue = exports.extractActionFrom = exports.getMetaData = exports.getLatestMeta = exports.isSpiderCElement = exports.isSpiderElement = exports.findClosestSpiderElementUntilBody = exports.isHTMLElement = exports.getURLSearchParamBy = exports.parseJsonSafely = exports.isAppProtocolWebviewLink = exports.isAppProtocolLink = exports.isEqualPrimaryDomain = exports.getHtmlAnchorElementBy = exports.isValidNativeALink = exports.isMinaProgramPath = exports.getSpiderReportUrl = void 0;
	var shared_1 = __webpack_require__(39);
	var constants_1 = __webpack_require__(115);
	var kernel_web_1 = __webpack_require__(118);
	var internal_action_1 = __webpack_require__(141);
	var spider_error_1 = __webpack_require__(142);
	function getDElementIndexFrom(spiderCElement, spiderDElement) {
	    var MISSING_VALUE = 0;
	    // tslint:disable-next-line: max-line-length
	    var elements = spiderCElement.querySelectorAll('[' +
	        constants_1.DATA_SPIDER +
	        '],[' +
	        constants_1.DATA_ACTION_NAME +
	        '],[' +
	        constants_1.DATA_SPIDER_IMPRESSION +
	        '], a[href]');
	    var count = 0;
	    // 遍历c区块内所有带d值或actionName值或曝光埋点值或链接的埋点元素
	    for (var i = 0; i < elements.length; i++) {
	        var element = elements[i];
	        if (isSpiderElement(element)) {
	            count++;
	        }
	        if (spiderDElement === elements[i]) {
	            return count;
	        }
	    }
	    return MISSING_VALUE;
	}
	function getAutoTrackActionIndex(targetElement) {
	    var MISSING_VALUE = 0;
	    var elements = shared_1.DOCUMENT.querySelectorAll('[' + constants_1.DATA_ACTION_NAME + '], [' + constants_1.DATA_SPIDER_IMPRESSION + ']');
	    var count = 0;
	    // 遍历整个文档树所有不在c区块包含内的带有actionName值或曝光埋点值属性的埋点元素
	    for (var i = 0; i < elements.length; i++) {
	        var element = elements[i];
	        var cElement = findClosestSpiderElementUntilBody(element.parentElement, isSpiderCElement);
	        if (cElement === null) {
	            count++;
	        }
	        // todo：如果既埋了c值且c值下跟当前元素有相同的actionName值，这里是否需要去重？（不存在重复，因为这里比较的是节点对像是否相等）
	        if (targetElement === elements[i]) {
	            return count;
	        }
	    }
	    return MISSING_VALUE;
	}
	function getAutoTrackAnchorElementIndex(targetElement) {
	    var MISSING_VALUE = 0;
	    var count = 0;
	    // 遍历所有未显示声明的a元素
	    var elements = Array.prototype.filter.call(shared_1.DOCUMENT.querySelectorAll('a'), function (item) {
	        var cElement = findClosestSpiderElementUntilBody(item.parentElement, isSpiderCElement);
	        var actionName = item.getAttribute(constants_1.DATA_ACTION_NAME);
	        var spmd = item.getAttribute(constants_1.DATA_SPIDER);
	        // 如果 a 链接不存在 c 区块、data-spider 无值(自身非 c 区块)、不存在 actionName
	        // 则被认为是一个未显示申明的 a 元素
	        var result = !cElement && !actionName && !spmd;
	        return result;
	    });
	    for (var i = 0; i < elements.length; i++) {
	        count++;
	        if (targetElement === elements[i]) {
	            return count;
	        }
	    }
	    return MISSING_VALUE;
	}
	function getSpiderReportUrl() {
	    // const value = getEnvironment()
	    // const env =
	    //     value < 3
	    //         ? value <= 1
	    //             ? ENVIRONMENT_NAMES[1] + '.'
	    //             : ENVIRONMENT_NAMES[value] + '.'
	    //         : ''
	    // const reportUrl =
	    //     'https://logtake.' + env + 'weidian.com/h5collector/webcollect/3.0'
	    return shared_1.getReportUrl() + '?type=spider';
	}
	exports.getSpiderReportUrl = getSpiderReportUrl;
	function isMinaProgramPath(url) {
	    return url ? /^\/lib\//.test(url) : false;
	}
	exports.isMinaProgramPath = isMinaProgramPath;
	function isValidNativeALink(element) {
	    var href = element.getAttribute('href');
	    var jumpA = href && href !== '' && href.indexOf('#') !== 0;
	    if (element.nodeName === 'A' &&
	        element instanceof HTMLAnchorElement &&
	        element.protocol &&
	        (element.protocol.indexOf('http') === 0 ||
	            element.protocol.indexOf('weidianbuyer:') ===
	            0) &&
	        jumpA &&
	        !isMinaProgramPath(href)) {
	        return true;
	    }
	    else {
	        return false;
	    }
	}
	exports.isValidNativeALink = isValidNativeALink;
	function getHtmlAnchorElementBy(url) {
	    var aElement = shared_1.DOCUMENT.createElement('A');
	    aElement.href = url;
	    return aElement;
	}
	exports.getHtmlAnchorElementBy = getHtmlAnchorElementBy;
	function isEqualPrimaryDomain(hostname) {
	    return shared_1.getPrimaryDomain(hostname) === shared_1.getPrimaryDomain();
	}
	exports.isEqualPrimaryDomain = isEqualPrimaryDomain;
	function isAppProtocolLink(url) {
	    var anchorElem = getHtmlAnchorElementBy(url);
	    return anchorElem.protocol === 'weidianbuyer:';
	}
	exports.isAppProtocolLink = isAppProtocolLink;
	function isAppProtocolWebviewLink(url) {
	    // const anchorElem = getHtmlAnchorElementBy(url)
	    return url && url.indexOf('weidianbuyer://wdb/webview') >= 0;
	    // return (
	    //     anchorElem.protocol === 'weidianbuyer:' &&
	    //     anchorElem.pathname.indexOf('//wdb/webview') >= 0
	    // )
	}
	exports.isAppProtocolWebviewLink = isAppProtocolWebviewLink;
	function parseJsonSafely(value) {
	    var result = shared_1.parseJSON(value);
	    // 严格校验入参字符串解析后是否为JSON对象，不是则统一处理为null
	    return shared_1.isObject(result) ? result : null;
	}
	exports.parseJsonSafely = parseJsonSafely;
	function getURLSearchParamBy(key, url) {
	    var params = shared_1.getQuerystring(url);
	    if (key) {
	        var value = params[key];
	        /**
	         * 这里针对URL search params 参数若存在相同key重复多次，则默认取key数组中最后一个值为准
	         */
	        return shared_1.isArray(value) ? value[value.length - 1] : value;
	    }
	    else {
	        return null;
	    }
	}
	exports.getURLSearchParamBy = getURLSearchParamBy;
	function isHTMLElement(action) {
	    return action instanceof HTMLElement && action.nodeType == Node.ELEMENT_NODE
	        ? true
	        : false;
	}
	exports.isHTMLElement = isHTMLElement;
	function findClosestSpiderElementUntilBody(startElement, matcher) {
	    var targetElement = startElement;
	    while (true) {
	        // 遍历body元素
	        if (targetElement === shared_1.DOCUMENT.body) {
	            return null;
	        }
	        // 遍历html元素
	        if (targetElement === shared_1.DOCUMENT.documentElement) {
	            return null;
	        }
	        // elem.parentNode may return null @see http://devdocs.io/dom/node/parentnode
	        if (targetElement === null) {
	            return null;
	        }
	        // documentfragment don‘t have parentNode
	        if (targetElement.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
	            return null;
	        }
	        if (matcher(targetElement)) {
	            return targetElement;
	        }
	        targetElement = targetElement.parentElement;
	    }
	}
	exports.findClosestSpiderElementUntilBody = findClosestSpiderElementUntilBody;
	function isSpiderElement(element) {
	    /**
	     * dom节点声明为d值元素
	     */
	    if (element.hasAttribute(constants_1.DATA_SPIDER) &&
	        element.getAttribute(constants_1.DATA_SPIDER) === '') {
	        return true;
	    }
	    /**
	     * dom节点声明带有data—spider-action-name（自定义事件名称）
	     */
	    if (element.hasAttribute(constants_1.DATA_ACTION_NAME)) {
	        return true;
	    }
	    /**
	     * dom节点声明为曝光元素data-spider-impression
	     */
	    if (element.hasAttribute(constants_1.DATA_SPIDER_IMPRESSION)) {
	        return true;
	    }
	    /**
	     * dom节点为a链接跳转（有效http链接或者natvie协议链接）
	     */
	    if (isValidNativeALink(element)) {
	        return true;
	    }
	    return false;
	}
	exports.isSpiderElement = isSpiderElement;
	function isSpiderCElement(element) {
	    return !!(element.getAttribute(constants_1.DATA_SPIDER_PRIOR) ||
	        element.getAttribute(constants_1.DATA_SPIDER));
	}
	exports.isSpiderCElement = isSpiderCElement;
	var META_DATA;
	function getLatestMeta(callback) {
	    kernel_web_1.getMeta(function (meta) {
	        var metaData = meta && meta.get();
	        META_DATA = metaData;
	        callback && callback();
	    });
	}
	/**
	 * 2021.3.14 埋点校对打点
	 * 需要页面初始化时立即执行，缓存Meta信息以便后续跳转埋点API执行时机读取meta.visit_id
	*/
	getLatestMeta()
	exports.getLatestMeta = getLatestMeta;
	// 需要等待页面加载完成后才能获取到metadata信息
	function getMetaData() {
	    return META_DATA;
	}
	exports.getMetaData = getMetaData;
	function extractActionFrom(spiderElement) {
	    // 对spiderElement做合法埋点元素校验
	    if (!(isHTMLElement(spiderElement) && isSpiderElement(spiderElement))) {
	        return null;
	    }
	    var actionName = spiderElement.getAttribute(constants_1.DATA_ACTION_NAME) || null;
	    var actionArgs = parseJsonSafely(spiderElement.getAttribute(constants_1.DATA_ACTION_ARGS));
	    var cElement = findClosestSpiderElementUntilBody(spiderElement.parentElement, isSpiderCElement);
	    var dElement = spiderElement;
	    var spmc;
	    var spmd;
	    /**
	     * 若有c值元素节点，则d值从c值元素中遍历所有埋点子元素并找到对应下标位置；
	     * 若没有，则遍历整个文档节点中有data-spider-action-name或者data-spider-impression埋点属性的节点，并找对应下标值；
	     */
	    if (cElement) {
	        spmc =
	            cElement.getAttribute(constants_1.DATA_SPIDER_PRIOR) ||
	            cElement.getAttribute(constants_1.DATA_SPIDER);
	        spmd = String(getDElementIndexFrom(cElement, dElement) || '_');
	    }
	    else {
	        spmc = '_';
	        spmd = String(getAutoTrackActionIndex(dElement) || '_');
	    }
	    // 处理既没有埋c值，又没埋actionName,且是有效a链接元素的场景
	    if (spmc === '_' &&
	        (actionName === '' || actionName === null) &&
	        isValidNativeALink(dElement)) {
	        spmc = constants_1.AUTO_TRACK_SPIDER;
	        spmd = String(getAutoTrackAnchorElementIndex(dElement) || '_');
	    }
	    return {
	        spmc: spmc,
	        spmd: spmd,
	        actionName: actionName,
	        actionArgs: actionArgs
	    };
	}
	exports.extractActionFrom = extractActionFrom;
	function isValidSpmValue(value) {
	    var reg = /^[a-zA-Z0-9\-\_]+$/;
	    return String(value).match(reg) === null ? false : true;
	}
	exports.isValidSpmValue = isValidSpmValue;
	function isInternalActionName(str) {
	    var isValid = Object.keys(constants_1.INTERNAL_ACTION_NAMES).some(function (key) { return constants_1.INTERNAL_ACTION_NAMES[key] === str; });
	    return isValid;
	}
	exports.isInternalActionName = isInternalActionName;
	function isValidSpiderAction(action) {
	    /* istanbul ignore if */
	    if (!shared_1.isObject(action)) {
	        shared_1.error(new spider_error_1.SpiderError({
	            message: 'action 必须是一个对象,' +
	                JSON.stringify(action) +
	                '不是对象类型',
	            name: "ValidationError" /* VALIDATION_ERROR */
	        }));
	        return false;
	    }
	    var spmc = action.spmc;
	    var spmd = action.spmd;
	    var actionName = action.actionName; // 前置默认actionName兜底string类型
	    var actionArgs = action.actionArgs;
	    // 恶心的兼容逻辑
	    if (action.actionType) {
	        shared_1.warn(new spider_error_1.SpiderError({
	            message: 'action.actionType=' +
	                action.actionType +
	                '已废弃，请使用 action.actionName 代替',
	            name: "ValidationError" /* VALIDATION_ERROR */
	        }));
	    }
	    if (!isValidSpmValue(spmc)) {
	        shared_1.error(new spider_error_1.SpiderError({
	            message: 'spm只允许英文、数字、中划线、下划线组成，' +
	                spmc +
	                '不合法',
	            name: "ValidationError" /* VALIDATION_ERROR */
	        }));
	        return false;
	    }
	    if (!isValidSpmValue(spmd)) {
	        shared_1.error(new spider_error_1.SpiderError({
	            message: 'spm只允许英文、数字、中划线、下划线组成，' +
	                spmd +
	                '不合法',
	            name: "ValidationError" /* VALIDATION_ERROR */
	        }));
	        return false;
	    }
	    // 兼容旧版vcollect允许业务开发埋内置actionName不是字符串的场景，允许埋点日志上报同时上报错误日志
	    // if (action.actionName && !isString(action.actionName)) {
	    //     error(
	    //         new SpiderError({
	    //             message: 'actionName 必须为字符串，' + JSON.stringify(action.actionName) + '不是字符串',
	    //             name: SpiderErrorNames.VALIDATION_ERROR
	    //         })
	    //     )
	    //     return true
	    // }
	    if (actionArgs && !shared_1.isObject(actionArgs)) {
	        shared_1.error(new spider_error_1.SpiderError({
	            message: 'actionArgs 必须是一个对象，' +
	                JSON.stringify(actionArgs) +
	                '不是对象类型',
	            name: "ValidationError" /* VALIDATION_ERROR */
	        }));
	        return false;
	    }
	    if (actionName && actionName.indexOf('_') === 0) {
	        if (isInternalActionName(actionName) ||
	            actionName === '_cancelToFavorites' ||
	            actionName === '_deprecated' ||
	            actionName === '_expose') {
	            var result = internal_action_1.validateInternalAction(action);
	            /**
	             * 特殊场景过滤处理：actionName=_item,上游业务方可能无法获取到shopId,故不做actionArgs校验判断
	             * 兼容业务开发埋内置actionName和actionArgs不规范问题，允许埋点日志上报同时上报错误日志
	             */
	            if (actionName !== constants_1.INTERNAL_ACTION_NAMES.ITEM && !result.isOk) {
	                shared_1.error(new spider_error_1.SpiderError({
	                    message: result.message,
	                    name: "InternalActionNameError" /* INTERNAL_ACTION_NAME_ERROR */
	                }));
	                return true;
	            }
	        }
	        else {
	            shared_1.error(new spider_error_1.SpiderError({
	                message: 'actionName=' +
	                    actionName +
	                    '不是内置actionName\n下划线起始的 actionName 代表特定功能，禁止自定义，请查看 spider.constants 了解内置的 actionName',
	                name: "InternalActionNameError" /* INTERNAL_ACTION_NAME_ERROR */
	            }));
	            return false;
	        }
	    }
	    if (spmc === '_' && !actionName) {
	        shared_1.error(new spider_error_1.SpiderError({
	            message: 'spmc, actionName 不能同时为空',
	            name: "ValidationError" /* VALIDATION_ERROR */
	        }));
	        return false;
	    }
	    if (spmc !== '_' && spmd === '_') {
	        shared_1.error(new spider_error_1.SpiderError({
	            message: 'spmc 有值时 spmd 不能为空',
	            name: "ValidationError" /* VALIDATION_ERROR */
	        }));
	        return false;
	    }
	    return true;
	}
	exports.isValidSpiderAction = isValidSpiderAction;
	function convertData(data) {
	    if (data.prev_spm) {
	        return {
	            cur_spm: data.prev_spm,
	            cur_page_args: data.prev_page_args,
	            cur_action_name: data.prev_action_name,
	            cur_action_args: data.prev_action_args
	        };
	    }
	    if (data.cur_spm) {
	        return {
	            prev_spm: data.cur_spm,
	            prev_page_args: data.cur_page_args,
	            prev_action_name: data.cur_action_name,
	            prev_action_args: data.cur_action_args
	        };
	    }
	    return null;
	}
	exports.convertData = convertData;
	function validatePageArgs(pageArgs) {
	    return internal_action_1.validateInternalAction({
	        actionName: pageArgs._page,
	        actionArgs: pageArgs
	    });
	}
	exports.validatePageArgs = validatePageArgs;
	/**
	 * 获取当前链接透传的参数（wfr、ifr、vc_xxx）
	 */
	function getCurURLPassProperties() {
	    var prefix = 'vc_';
	    var curUrlParams = shared_1.getQuerystring();
	    var keys = Object.getOwnPropertyNames(curUrlParams);
	    var commonProperties = {};
	    function isCommonKey(key) {
	        return key.indexOf(prefix) === 0 && key.length > prefix.length;
	    }
	    keys.forEach(function (key) {
	        if (isCommonKey(key) || key === 'wfr' || key === 'ifr') {
	            commonProperties[key] = curUrlParams[key];
	        }
	    });
	    return commonProperties;
	}
	exports.getCurURLPassProperties = getCurURLPassProperties;
	function normalizeGetName(value) {
	    return value.replace(/(%[0-9A-Z]{2})+/g, shared_1.GLOBAL.decodeURIComponent);
	}
	function getCookies() {
	    var cookies = shared_1.GLOBAL.document.cookie.split('; ');
	    var ret = Object.create(null);
	    cookies.forEach(function (cookie) {
	        var arr = cookie.split('=');
	        ret[normalizeGetName(arr[0])] = normalizeGetName(arr[1]);
	    });
	    return ret;
	}
	exports.getCookies = getCookies;
	function getSpiderVisualCdns() {
	    var visualReg = /^visual-window:([\S\s]+)$/;
	    var result = shared_1.GLOBAL.name.match(visualReg);
	    return result && result[1].split('|');
	}
	exports.getSpiderVisualCdns = getSpiderVisualCdns;
	function getSpmaAndSpmb() {
	    return { spma: kernel_web_1.getSpma(), spmb: kernel_web_1.getSpmb() };
	}
	exports.getSpmaAndSpmb = getSpmaAndSpmb;
	function normalizeParam(value, key, obj) {
	    if (shared_1.isWideObject(value) && obj) {
	        obj[key] = shared_1.stringifyJSON(value);
	    }
	}
	exports.normalizeParam = normalizeParam;
	// 和原vcollect _updateState逻辑保持一致
	function formatSpiderAction(action) {
	    if (shared_1.isObject(action)) {
	        action.spmd === undefined && (action.spmd = '1');
	        action.spmc = String(action.spmc || '_');
	        action.spmd = String(action.spmd || '_');
	        var actionName = String(action.actionName || '');
	        // deprecated
	        var actionType = String(action.actionType || '');
	        action.actionName = actionName || actionType;
	        action.actionArgs = action.actionArgs || null;
	    }
	}
	exports.formatSpiderAction = formatSpiderAction;
	function deprecatedLog(oldMethod, newMethod) {
	    shared_1.warn('[Spider Warn] 方法 ' +
	        oldMethod +
	        ' 已经废弃不再维护，请使用其他API替代 ' +
	        (newMethod || '') +
	        '\n详情参见文档：https://h5.daily.weidian.com/v-components/pecker/books/spider/chapter2/access-steps.html');
	}
	exports.deprecatedLog = deprecatedLog;
	function getCookie(key) {
	    deprecatedLog('spider.getCooke');
	    var ret = getCookies();
	    return key ? ret[key] || null : ret;
	}
	exports.getCookie = getCookie;
	function getSearchParams() {
	    deprecatedLog('spider.getSearchParams');
	    return shared_1.getQuerystring();
	}
	exports.getSearchParams = getSearchParams;



/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	tslib_1.__exportStar(__webpack_require__(119), exports);
	tslib_1.__exportStar(__webpack_require__(121), exports);


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	tslib_1.__exportStar(__webpack_require__(120), exports);
	var meta_1 = __webpack_require__(129);
	Object.defineProperty(exports, "getMeta", { enumerable: true, get: function () { return meta_1.get; } });
	Object.defineProperty(exports, "getSpma", { enumerable: true, get: function () { return meta_1.getSpmaAttribute; } });
	Object.defineProperty(exports, "getSpmb", { enumerable: true, get: function () { return meta_1.getSpmbAttribute; } });
	var user_1 = __webpack_require__(131);
	Object.defineProperty(exports, "getVisitorId", { enumerable: true, get: function () { return user_1.getVisitorId; } });
	Object.defineProperty(exports, "getSid", { enumerable: true, get: function () { return user_1.getSid; } });
	Object.defineProperty(exports, "getUid", { enumerable: true, get: function () { return user_1.getUid; } });
	tslib_1.__exportStar(__webpack_require__(137), exports);
	tslib_1.__exportStar(__webpack_require__(138), exports);
	tslib_1.__exportStar(__webpack_require__(139), exports);


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Kernel = void 0;
	var tslib_1 = __webpack_require__(40);
	var kernel_1 = __webpack_require__(121);
	var meta_1 = __webpack_require__(129);
	var Kernel = /** @class */ (function (_super) {
	    tslib_1.__extends(Kernel, _super);
	    function Kernel(options) {
	        var _this = _super.call(this) || this;
	        _this.options = options;
	        return _this;
	    }
	    Kernel.prototype.send = function (recordData) {
	        var _this = this;
	        meta_1.get(function (meta) {
	            if (!meta) {
	                return;
	            }
	            _this.options.report.push(new _this.options.Record(meta, recordData));
	        });
	    };
	    return Kernel;
	}(kernel_1.AbstractKernel));
	exports.Kernel = Kernel;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	tslib_1.__exportStar(__webpack_require__(122), exports);


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var tslib_1 = __webpack_require__(40);
	tslib_1.__exportStar(__webpack_require__(123), exports);
	tslib_1.__exportStar(__webpack_require__(124), exports);
	tslib_1.__exportStar(__webpack_require__(126), exports);
	tslib_1.__exportStar(__webpack_require__(127), exports);
	tslib_1.__exportStar(__webpack_require__(128), exports);


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AbstractKernel = void 0;
	var util_1 = __webpack_require__(49);
	var shared_1 = __webpack_require__(41);
	var AbstractKernel = /** @class */ (function () {
	    function AbstractKernel() {
	        this.hooks = new shared_1.Hooks();
	        this.plugins = [];
	    }
	    AbstractKernel.prototype.use = function (plugin) {
	        if (!util_1.isFunction(plugin) || this.plugins.indexOf(plugin) !== -1) {
	            return this;
	        }
	        plugin.call(this);
	        this.plugins.push(plugin);
	        return this;
	    };
	    return AbstractKernel;
	}());
	exports.AbstractKernel = AbstractKernel;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Meta = void 0;
	var tslib_1 = __webpack_require__(40);
	var abstract_1 = __webpack_require__(125);
	tslib_1.__exportStar(__webpack_require__(125), exports);
	var Meta = /** @class */ (function (_super) {
	    tslib_1.__extends(Meta, _super);
	    function Meta(data) {
	        var _this = _super.call(this) || this;
	        _this.data = data;
	        return _this;
	    }
	    Meta.prototype.get = function () {
	        return this.data;
	    };
	    return Meta;
	}(abstract_1.AbstractMeta));
	exports.Meta = Meta;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AbstractMeta = void 0;
	var AbstractMeta = /** @class */ (function () {
	    function AbstractMeta() {
	    }
	    return AbstractMeta;
	}());
	exports.AbstractMeta = AbstractMeta;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AbstractRecord = void 0;
	var AbstractRecord = /** @class */ (function () {
	    function AbstractRecord(meta, data) {
	        this.date = new Date();
	        this.data = Object.freeze(data);
	        this.meta = meta;
	    }
	    AbstractRecord.prototype.combine = function () {
	        return {
	            name: this.meta.get(),
	            value: this.data
	        };
	    };
	    return AbstractRecord;
	}());
	exports.AbstractRecord = AbstractRecord;


/***/ }),
/* 127 */
/***/ (function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AbstractReport = void 0;
	var AbstractReport = /** @class */ (function () {
	    function AbstractReport() {
	    }
	    return AbstractReport;
	}());
	exports.AbstractReport = AbstractReport;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.AbstractSend = void 0;
	var shared_1 = __webpack_require__(41);
	var AbstractSend = /** @class */ (function () {
	    function AbstractSend() {
	    }
	    AbstractSend.prototype.combine = function (records) {
	        if (records === void 0) { records = []; }
	        var names = [];
	        var values = [];
	        var handler = function (record) {
	            var _a = record.combine(), name = _a.name, value = _a.value;
	            var index = shared_1.deepSearch(names, name);
	            if (index === -1) {
	                names.push(name);
	                values[names.length - 1] = [value];
	                return;
	            }
	            values[index].push(value);
	        };
	        records.forEach(handler);
	        return { names: names, values: values };
	    };
	    return AbstractSend;
	}());
	exports.AbstractSend = AbstractSend;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.get = void 0;
	var normal_1 = __webpack_require__(130);
	var kernel_1 = __webpack_require__(121);
	var shared_1 = __webpack_require__(39);
	var normal_2 = __webpack_require__(130);
	Object.defineProperty(exports, "getSpmaAttribute", { enumerable: true, get: function () { return normal_2.getSpmaAttribute; } });
	Object.defineProperty(exports, "getSpmbAttribute", { enumerable: true, get: function () { return normal_2.getSpmbAttribute; } });
	var META;
	function setMeta(newMeta) {
	    META = newMeta;
	}
	function getMeta() {
	    return META;
	}
	function get(callback) {
	    normal_1.get(function (metaData) {
	        if (!metaData) {
	            return callback();
	        }
	        var meta = getMeta();
	        if (meta && shared_1.deepEqual(meta.get(), metaData)) {
	            callback(meta);
	        }
	        else {
	            setMeta(new kernel_1.Meta(metaData));
	            callback(getMeta());
	        }
	    });
	}
	exports.get = get;


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.get = void 0;
	var user_1 = __webpack_require__(131);
	var spm_1 = __webpack_require__(134);
	var shared_1 = __webpack_require__(39);
	var extend_1 = __webpack_require__(135);
	var spm_2 = __webpack_require__(134);
	Object.defineProperty(exports, "getSpmaAttribute", { enumerable: true, get: function () { return spm_2.getSpmaAttribute; } });
	Object.defineProperty(exports, "getSpmbAttribute", { enumerable: true, get: function () { return spm_2.getSpmbAttribute; } });
	/**
	 * Promise.then属于异步任务，当跳转之前立即上报一条数据时，会导致数据无法被记录，使用callback依旧存在如下失败情况
	 * 1、新用户第一次在APP内打开页面，然后发生页面跳转，由于会优先使用设备ID，设备ID获取处于异步任务内
	 * 2、在未等到spma，spmb获取成功，然后发生页面跳转，建议采集脚本放置在Body内
	 */
	function get(callback) {
	    user_1.getVisitorId(function (visitorId) {
	        extend_1.getExtend(function (extend) {
	            spm_1.getSpma(function (spma) {
	                spm_1.getSpmb(function (spmb) {
	                    if (shared_1.isEmpty(spma) || shared_1.isEmpty(spmb)) {
	                        return callback();
	                    }
	                    callback({
	                        document_ref: shared_1.getDocumentReferrer(),
	                        document_url: shared_1.getDocumentUrl(),
	                        spma: spma,
	                        spmb: spmb,
	                        visit_id: user_1.getVisitId(),
	                        buyer_id: user_1.getUid(),
	                        seller_id: user_1.getSid(),
	                        session_id: user_1.getSessionId(),
	                        visitor_id: visitorId,
	                        extend: extend
	                    });
	                });
	            });
	        });
	    });
	}
	exports.get = get;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getVisitId = exports.getUid = exports.getSid = void 0;
	var tslib_1 = __webpack_require__(40);
	var cookie_1 = __webpack_require__(75);
	var shared_1 = __webpack_require__(39);
	tslib_1.__exportStar(__webpack_require__(132), exports);
	tslib_1.__exportStar(__webpack_require__(133), exports);
	var SID;
	function getSid() {
	    if (SID !== undefined) {
	        return SID;
	    }
	    return (SID = cookie_1.get('sid') || cookie_1.get('WD_s_id') || null);
	}
	exports.getSid = getSid;
	var UID;
	function getUid() {
	    if (UID !== undefined) {
	        return UID;
	    }
	    return (UID = cookie_1.get('duid') || cookie_1.get('uid') || cookie_1.get('WD_b_id') || null);
	}
	exports.getUid = getUid;
	var VISIT_ID;
	function getVisitId() {
	    if (!shared_1.isUndef(VISIT_ID)) {
	        return VISIT_ID;
	    }
	    return (VISIT_ID = shared_1.getUniqueRandomId());
	}
	exports.getVisitId = getVisitId;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getSessionId = void 0;
	var shared_1 = __webpack_require__(39);
	var shared_2 = __webpack_require__(39);
	var cookie_1 = __webpack_require__(75);
	var SESSION_ID;
	// 30 minutes
	var SESSION_ID_EXPIRES = 60 * 30;
	function getFromParentPage() {
	    return shared_2.getStorage(shared_1.STORAGE_SESSION_ID_KEY);
	}
	function getFromCookie() {
	    return cookie_1.get(shared_1.COOKIE_SESSION_ID_KEY);
	}
	function generate() {
	    return getFromParentPage() || getFromCookie() || shared_2.getUniqueRandomId();
	}
	function setSessionId(id) {
	    SESSION_ID = id;
	    // 同步cookie缓存
	    cookie_1.set(shared_1.COOKIE_SESSION_ID_KEY, id, {
	        domain: shared_2.getPrimaryDomain(),
	        expires: SESSION_ID_EXPIRES
	    });
	    // 同步备用缓存
	    shared_1.setStorage(shared_1.STORAGE_SESSION_ID_KEY, id);
	}
	function getSessionId() {
	    if (SESSION_ID) {
	        // 用户停留时间可能会超过30分钟
	        setTimeout(function () {
	            setSessionId(SESSION_ID);
	        });
	        return SESSION_ID;
	    }
	    var id = generate();
	    setSessionId(id);
	    return id;
	}
	exports.getSessionId = getSessionId;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getVisitorId = void 0;
	var shared_1 = __webpack_require__(39);
	var shared_2 = __webpack_require__(39);
	var cookie_1 = __webpack_require__(75);
	var VISITOR_ID;
	// 2years
	var VISITOR_ID_EXPIRES = 60 * 60 * 24 * 365 * 2;
	function getNativeCuid() {
	    return new Promise(function (resolve, reject) {
	        shared_1.getWeiDianSdk()
	            .then(function (jsbridge) {
	            jsbridge.call('WDJSBridge', 'getCuid', {}, function (res) {
	                if (res && res.param && res.param.cuid) {
	                    return resolve(res.param.cuid);
	                }
	                reject();
	            });
	        })
	            .catch(reject);
	    });
	}
	function isNativeCuid(id) {
	    return !!id && id.length > 16;
	}
	function getFromParentPage() {
	    return shared_2.getStorage(shared_1.STORAGE_VISITOR_ID_KEY);
	}
	function getFromCookie() {
	    return cookie_1.get(shared_1.COOKIE_VISITOR_ID_KEY);
	}
	function generate(callback) {
	    function fallback(id) {
	        // TODO: 使用32位精度，
	        callback(id || shared_2.getUniqueRandomId());
	    }
	    // 优先从上一页面设置的缓存中获取，由于存在跨主域，缓存在cookie中的无法取到，通过window.name提高精确度
	    var id = getFromParentPage();
	    if (id) {
	        return callback(id);
	    }
	    // 从cookie中获取，走到此处说明用户是第一次进来，由于APP需强制使用设备ID，需进行设备ID判断
	    id = getFromCookie();
	    if (shared_2.isApp()) {
	        // 如果在APP内且ID是设备ID，则直接返回
	        if (isNativeCuid(id)) {
	            return callback(id);
	        }
	        // 在APP内优先使用设备ID
	        getNativeCuid().then(callback, function () {
	            // 获取失败，先使用cookie中的ID，没有再随机生成
	            fallback(id);
	        });
	    }
	    else {
	        // 不在APP内，先使用cookie中的ID，没有再随机生成
	        fallback(id);
	    }
	}
	function setVisitorId(id) {
	    VISITOR_ID = id;
	    // 同步cookie缓存
	    cookie_1.set(shared_1.COOKIE_VISITOR_ID_KEY, id, {
	        domain: shared_2.getPrimaryDomain(),
	        expires: VISITOR_ID_EXPIRES
	    });
	    // 同步备用缓存
	    shared_2.setStorage(shared_1.STORAGE_VISITOR_ID_KEY, id);
	}
	function getVisitorId(callback) {
	    if (VISITOR_ID) {
	        return callback(VISITOR_ID);
	    }
	    generate(function (id) {
	        setVisitorId(id);
	        callback(id);
	    });
	}
	exports.getVisitorId = getVisitorId;


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getSpma = exports.getSpmb = exports.getSpmbAttribute = exports.getSpmaAttribute = void 0;
	var shared_1 = __webpack_require__(39);
	var SPM_PRIOR_ATTRIBUTE_KEY = 'data-spider-prior';
	function getSpmaAttribute() {
	    var head = shared_1.DOCUMENT.head;
	    var el = head.querySelector("meta[name=\"" + SPM_PRIOR_ATTRIBUTE_KEY + "\"]") ||
	        // 降级
	        head.querySelector("meta[name=\"" + shared_1.SPM_ATTRIBUTE_KEY + "\"]");
	    return el && el.getAttribute('content');
	}
	exports.getSpmaAttribute = getSpmaAttribute;
	function getSpmbAttribute() {
	    var body = shared_1.DOCUMENT.body;
	    return (body.getAttribute(SPM_PRIOR_ATTRIBUTE_KEY) ||
	        // 降级
	        body.getAttribute(shared_1.SPM_ATTRIBUTE_KEY));
	}
	exports.getSpmbAttribute = getSpmbAttribute;
	function getSpmb(callback) {
	    // wait for dom loaded
	    shared_1.domContentLoaded(function () {
	        callback(getSpmbAttribute());
	    });
	}
	exports.getSpmb = getSpmb;
	function getSpma(callback) {
	    // wait for dom loaded, avoid load script before spma meta
	    shared_1.domContentLoaded(function () {
	        callback(getSpmaAttribute());
	    });
	}
	exports.getSpma = getSpma;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getExtend = void 0;
	var shared_1 = __webpack_require__(39);
	var network_type_1 = __webpack_require__(136);
	var EXTEND;
	function getExtend(callback) {
	    if (!shared_1.isUndef(EXTEND)) {
	        return callback(EXTEND);
	    }
	    network_type_1.getNetworkType(function (networkType) {
	        EXTEND = shared_1.stringifyJSON({
	            network_type: networkType
	        });
	        callback(EXTEND);
	    });
	}
	exports.getExtend = getExtend;


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getNetworkType = void 0;
	var shared_1 = __webpack_require__(39);
	var user_agent_1 = __webpack_require__(85);
	var CONNECTION_TYPE;
	function getConnectionType() {
	    var connection = navigator.connection || navigator.webkitConnection;
	    return (connection && connection.type) || 'unknown';
	}
	function getWeiXinNetworkType() {
	    var match = navigator.userAgent.match(/NetType\/(\S*)/i);
	    return match && match[1];
	}
	var WEIDIAN_NETWORK_TYPE_MAP = {
	    '-1': 'offline',
	    '0': 'unknown',
	    '2': 'wifi',
	    '3': '2g',
	    '4': '3g',
	    '5': '4g'
	};
	function getWeiDianNetworkType() {
	    return new Promise(function (resolve, reject) {
	        shared_1.getWeiDianSdk()
	            .then(function (jsbridge) {
	            jsbridge.call('WDJSBridge', 'getNetworkStatus', {}, function (res) {
	                if (res && res.param && res.param.network) {
	                    return resolve(WEIDIAN_NETWORK_TYPE_MAP[res.param.network]);
	                }
	                reject();
	            });
	        })
	            .catch(reject);
	    });
	}
	function getNetworkType(callback) {
	    if (!shared_1.isUndef(CONNECTION_TYPE)) {
	        return callback(CONNECTION_TYPE);
	    }
	    function handler(type) {
	        CONNECTION_TYPE = (type || getConnectionType()).toLowerCase();
	        callback(CONNECTION_TYPE);
	    }
	    if (user_agent_1.isWeiXin()) {
	        return handler(getWeiXinNetworkType());
	    }
	    if (shared_1.isApp()) {
	        return getWeiDianNetworkType().then(handler, handler);
	    }
	    handler();
	}
	exports.getNetworkType = getNetworkType;


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Record = void 0;
	var tslib_1 = __webpack_require__(40);
	var shared_1 = __webpack_require__(39);
	var kernel_1 = __webpack_require__(121);
	var Record = /** @class */ (function (_super) {
	    tslib_1.__extends(Record, _super);
	    function Record(meta, data) {
	        var _this = this;
	        var now = Date.now();
	        // freeze data
	        data = shared_1.merge({
	            report_time: now,
	            uuid: shared_1.getUniqueRandomId(shared_1.stringifyJSON(data) + shared_1.stringifyJSON(meta.get()))
	        }, data);
	        _this = _super.call(this, meta, data) || this;
	        return _this;
	    }
	    return Record;
	}(kernel_1.AbstractRecord));
	exports.Record = Record;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Report = void 0;
	var tslib_1 = __webpack_require__(40);
	var shared_1 = __webpack_require__(39);
	var kernel_1 = __webpack_require__(121);
	var DEFAULT_REPORT_OPTIONS = {
	    delay: 300
	};
	var Report = /** @class */ (function (_super) {
	    tslib_1.__extends(Report, _super);
	    function Report(options) {
	        var _this = _super.call(this) || this;
	        _this.records = [];
	        _this.pageLoaded = false;
	        _this.options = shared_1.merge({}, DEFAULT_REPORT_OPTIONS, options);
	        _this.addEventListener();
	        return _this;
	    }
	    Report.prototype.push = function (record) {
	        var _this = this;
	        // flock logs
	        this.records.indexOf(record) === -1 && this.records.push(record);
	        // delay times to send when page loaded
	        this.pageLoaded && shared_1.debounce(function () { return _this.send(); }, this.options.delay)();
	    };
	    Report.prototype.addEventListener = function () {
	        var _this = this;
	        // 80% of pages will been loaded in 1500 seconds
	        setTimeout(function () {
	            // send parent page records
	            _this.options.send.sendAfterEnter();
	            // send current page records
	            _this.send();
	            // mark page loaded
	            _this.pageLoaded = true;
	        }, shared_1.MAX_PAGE_LOADED_TIME);
	        // beforunload report data, unload will store the data
	        shared_1.pageBeforeUnload(function () { return _this.sendBeforeLeave(); });
	    };
	    Report.prototype.sendBeforeLeave = function () {
	        if (!this.records.length) {
	            return;
	        }
	        this.options.send.sendBeforeLeave({ records: this.records.slice() });
	        // clear current records
	        this.records.length = 0;
	    };
	    Report.prototype.send = function () {
	        var _this = this;
	        if (!this.records.length) {
	            return;
	        }
	        // send copy records
	        this.options.send
	            .send({ records: this.records.slice() })
	            .catch(function (records) {
	            // concat if some records send failed
	            _this.records = _this.records.concat(records);
	        });
	        // clear current records
	        this.records.length = 0;
	    };
	    return Report;
	}(kernel_1.AbstractReport));
	exports.Report = Report;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Send = void 0;
	var tslib_1 = __webpack_require__(40);
	var send_1 = __webpack_require__(140);
	var kernel_1 = __webpack_require__(121);
	var shared_1 = __webpack_require__(39);
	function findByData(records, data) {
	    var value = null;
	    records.some(function (record) {
	        if (shared_1.deepEqual(record.combine().value, data)) {
	            value = record;
	            return true;
	        }
	        return false;
	    });
	    return value;
	}
	/**
	 * 依旧存在如下情况数据丢失或重复上报问题
	 * 1. sendBeacon 方法本身存在丢失可能
	 * 2. 页面跳转到第三方页面如果不支持sendBeacon存在50%丢失可能
	 * 3. 在页面中进行上报，请求使用 request发送后，页面发生跳转，存在50%丢失，可使用sendBeacon、request降级？
	 * 4. 上报上一页面缓存中的值，使用的成功后清除策略，请求使用request发送后，页面发生跳转，存在50%重复上报，与3类似
	 * 5. 应用切换到后台后，可能存在部分手机js线程不执行
	 */
	var Send = /** @class */ (function (_super) {
	    tslib_1.__extends(Send, _super);
	    function Send(options) {
	        var _this = _super.call(this) || this;
	        _this.options = options;
	        return _this;
	    }
	    Send.prototype.sendAfterEnter = function () {
	        return Promise.resolve(send_1.sendAfterEnter());
	    };
	    Send.prototype.send = function (options) {
	        var _this = this;
	        var logs = this.combine(options.records);
	        var rollbackRecords = [];
	        function rollback(data) {
	            data.forEach(function (recordData) {
	                var record = findByData(options.records, recordData);
	                if (record) {
	                    rollbackRecords.push(record);
	                }
	            });
	        }
	        var handler = function (data, meta) {
	            return send_1.send({
	                url: _this.options.url,
	                data: {
	                    log: {
	                        meta: meta,
	                        data: data
	                    }
	                }
	            })
	                .then(function () {
	                // 触发采集上报成功的消息
	                shared_1.decoupler.emit("reportSuccess" /* REPORT_SUCCESS */, { data: data });
	            })
	                .catch(function () { return rollback(data); });
	        };
	        var promises = logs.values.map(function (data, index) {
	            return handler(data, logs.names[index]);
	        });
	        // Promise.allSettled not support
	        return Promise.all(promises).then(function () {
	            if (rollbackRecords.length) {
	                return Promise.reject(rollbackRecords);
	            }
	            return Promise.resolve();
	        });
	    };
	    Send.prototype.sendBeforeLeave = function (options, fallback) {
	        var _this = this;
	        if (fallback === void 0) { fallback = true; }
	        var logs = this.combine(options.records);
	        var handler = function (data, meta) {
	            return send_1.sendBeforeLeave({
	                url: _this.options.url,
	                data: {
	                    log: {
	                        meta: meta,
	                        data: data
	                    }
	                }
	            }, fallback);
	        };
	        var promises = logs.values.map(function (data, index) {
	            return handler(data, logs.names[index]);
	        });
	        return Promise.all(promises);
	    };
	    return Send;
	}(kernel_1.AbstractSend));
	exports.Send = Send;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.sendBeforeLeave = exports.send = exports.sendAfterEnter = void 0;
	var shared_1 = __webpack_require__(39);
	var shared_2 = __webpack_require__(39);
	function pushLog(log) {
	    var logs = getLogs();
	    if (logs.indexOf(log) === -1) {
	        logs.push(log);
	        shared_1.setStorage(shared_2.STORAGE_LOGS_KEY, logs);
	    }
	}
	function getLogs() {
	    return (shared_1.getStorage(shared_2.STORAGE_LOGS_KEY) || []).slice();
	}
	// Examine the fail data later and think about the plan details
	// Four reasons for failure:
	// 1. During operation then network offline
	//  Hard to happen
	// 2. API server fail
	//  If we report the data in next page, API server will not been fixed,fixed time will be tens of minutes.
	// 3. The wrong report data
	//  Rereport, also failure
	// 4. During report then page has leaved, Most probability!
	function sendAfterEnter() {
	    function handler(log) {
	        send(log).then(function () {
	            // refresh storage when successfull
	            // will repeat report in 50% probability during report then page has leaved
	            shared_1.setStorage(shared_2.STORAGE_LOGS_KEY, shared_1.removeItem(getLogs(), log));
	        });
	    }
	    getLogs().forEach(handler);
	}
	exports.sendAfterEnter = sendAfterEnter;
	// TODO : use sendBeacon first then use request?
	// sendBeacon 可能会失败，存在数据量过大问题
	function send(options) {
	    // if report unreasonable data, will return non-zero status, Rereport, also failure.
	    return shared_1.request(options.url, options);
	}
	exports.send = send;
	function sendBeforeLeave(options, fallback) {
	    if (fallback === void 0) { fallback = true; }
	    return new Promise(function (resolve) {
	        // step1 : use sendBeacon
	        var rs = shared_1.sendBeacon(options.url, options);
	        // if sendBeacon failed
	        if (fallback && !rs) {
	            // step2 : use window.name if destination url is legal
	            if (shared_1.isLegalDestinationUrl()) {
	                pushLog({
	                    url: options.url,
	                    data: options.data
	                });
	            }
	            else {
	                // step3 : send records immediately on current page, will failed in 50% probability
	                // if haven't jump or url is illegal
	                send(options).catch(function () { return undefined; });
	            }
	        }
	        // always been resolved status, can do nothing becouse page has leaved
	        resolve();
	    });
	}
	exports.sendBeforeLeave = sendBeforeLeave;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.validateInternalAction = void 0;
	var constants_1 = __webpack_require__(115);
	// interface InternalMap<T extends INTERNAL_ACTION_NAMES = INTERNAL_ACTION_NAMES> {
	//     T: (args?: SpiderInternalActionArgsMap[T] | null) => void
	// }
	function getTypeValue(type) {
	    return type === '' || type === null ? type : Number(type);
	}
	function validateInternalAction(action) {
	    var _a;
	    var actionName = action.actionName, actionArgs = action.actionArgs;
	    var validateResult = Object.create(null);
	    var internalMap = (_a = {},
	        _a[constants_1.INTERNAL_ACTION_NAMES.ITEM] = function (args) {
	            if (args && args.itemId && args.shopId) {
	                validateResult.isOk = true;
	                return;
	            }
	            validateResult.isOk = false;
	            validateResult.message =
	                'pageArgs._page=_item时 pageArgs必须包含itemId和shopId属性';
	        },
	        _a[constants_1.INTERNAL_ACTION_NAMES.SHOP] = function (args) {
	            if (args && args.shopId) {
	                validateResult.isOk = true;
	                return;
	            }
	            validateResult.isOk = false;
	            validateResult.message =
	                'actionName=_shop或者pageArgs._page=_shop时 actionArgs或者pageArgs必须包含shopId属性';
	        },
	        _a[constants_1.INTERNAL_ACTION_NAMES.DYNAMIC] = function (args) {
	            if (args && args.authorId && args.feedId) {
	                validateResult.isOk = true;
	                return;
	            }
	            validateResult.isOk = false;
	            validateResult.message =
	                'actionName=_dynamic或者pageArgs._page=_dynamic时 actionArgs或者pageArgs必须包含authorId属性和feedId属性';
	        },
	        _a[constants_1.INTERNAL_ACTION_NAMES.IM] = function (_args) {
	            validateResult.isOk = true;
	        },
	        _a[constants_1.INTERNAL_ACTION_NAMES.ADD_TO_CART] = function (_args) {
	            validateResult.isOk = true;
	        },
	        // tslint:disable-next-line: max-line-length
	        _a[constants_1.INTERNAL_ACTION_NAMES.ADD_TO_FAVORITES] = function (args) {
	            if (args && args.shopId) {
	                var type = getTypeValue(args.type);
	                if (type === 0 || type === 1) {
	                    validateResult.isOk = true;
	                }
	                else {
	                    validateResult.isOk = false;
	                    validateResult.message =
	                        'actionName=_addToFavorites type属性必须传0(取消)或1(关注)';
	                }
	                return;
	            }
	            validateResult.isOk = false;
	            validateResult.message =
	                'actionName=_addToFavorites actionArgs必须包含shopId和type属性';
	        },
	        _a[constants_1.INTERNAL_ACTION_NAMES.BUY_NOW] = function (_args) {
	            validateResult.isOk = true;
	        },
	        _a[constants_1.INTERNAL_ACTION_NAMES.COLLECTION] = function (args) {
	            if (args && args.itemId) {
	                var type = getTypeValue(args.type);
	                if (type === 0 || type === 1) {
	                    validateResult.isOk = true;
	                }
	                else {
	                    validateResult.isOk = false;
	                    validateResult.message =
	                        'actionName=_collection type属性必须传0(取消)或1(关注)';
	                }
	                return;
	            }
	            validateResult.isOk = false;
	            validateResult.message =
	                'actionName=_collection actionArgs必须包含itemId和type属性';
	        },
	        _a[constants_1.INTERNAL_ACTION_NAMES.LIKE] = function (args) {
	            var type = getTypeValue(args && args.type);
	            if (args && (type === 0 || type === 1)) {
	                validateResult.isOk = true;
	                return;
	            }
	            validateResult.isOk = false;
	            validateResult.message =
	                'actionName=_like actionArgs必须包含type属性且必须传0(取消)或1(关注)';
	        },
	        _a[constants_1.INTERNAL_ACTION_NAMES.SHARE] = function (_args) {
	            validateResult.isOk = true;
	        },
	        _a[constants_1.INTERNAL_ACTION_NAMES.DOWNLOAD] = function (_args) {
	            validateResult.isOk = true;
	        },
	        _a);
	    actionName && internalMap[actionName] && internalMap[actionName](actionArgs);
	    if (validateResult.isOk === undefined) {
	        validateResult.isOk = false;
	        validateResult.message =
	            'actionName ' + actionName + '不是内置actionName';
	    }
	    return validateResult;
	}
	exports.validateInternalAction = validateInternalAction;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SpiderError = void 0;
	var shared_1 = __webpack_require__(39);
	var SpiderError = /** @class */ (function (_super) {
	    __extends(SpiderError, _super);
	    function SpiderError(option) {
	        var _this = this;
	        var name = '[Spider Error]';
	        option.name && (name += ' ' + option.name);
	        _this = _super.call(this, {
	            message: option.message || '',
	            name: name,
	            originalError: option.originalError,
	            sample: option.sample
	        }) || this;
	        return _this;
	    }
	    return SpiderError;
	}(shared_1.KernelError));
	exports.SpiderError = SpiderError;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.getNavigationType = void 0;
	// import { isFunction, hasOwn } from '@vdian/util'
	var shared_1 = __webpack_require__(39);
	var NAVIGATION_TIMING_TYPE_MAP = {
	    0: 'navigate',
	    1: 'reload',
	    2: 'back_forward',
	    255: 'prerender'
	};
	function toJSON(timing) {
	    if (shared_1.isFunction(timing.toJSON)) {
	        return timing.toJSON();
	    }
	    /* istanbul ignore next */
	    try {
	        var json = {};
	        for (var name_1 in timing) {
	            if (shared_1.hasOwn(timing, name_1)) {
	                json[name_1] = timing[name_1];
	            }
	        }
	        return Object.keys(json).length ? json : undefined;
	    }
	    catch (e) { }
	}
	function getNavigationType() {
	    /* istanbul ignore else: hard of Compatibility test */
	    if (shared_1.isFunction(shared_1.GLOBAL.performance.getEntriesByType)) {
	        var entries = shared_1.GLOBAL.performance.getEntriesByType('navigation');
	        if (entries.length) {
	            var navigationTiming = toJSON(entries[0]);
	            return navigationTiming ? navigationTiming.type : null;
	        }
	    }
	    else if (shared_1.GLOBAL.performance.navigation) {
	        var type = shared_1.GLOBAL.performance.navigation.type;
	        return NAVIGATION_TIMING_TYPE_MAP[type];
	    }
	    return null;
	}
	exports.getNavigationType = getNavigationType;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.removeAllSpiderTokens = exports.getSpiderToken = exports.generateSpiderTokenBy = void 0;
	var shared_1 = __webpack_require__(39);
	var cookie_1 = __webpack_require__(75);
	var util_1 = __webpack_require__(117);
	var constants_1 = __webpack_require__(115);
	// import { merge, forEach } from '@vdian/util'
	var DEFAULT_DATA = {
	    prev_spm: '',
	    prev_page_args: null,
	    prev_action_name: null,
	    prev_action_args: null
	};
	/**
	 * 2021.3.1
	 * 兼容买家版app读取cookie中的spider_token_xxx字段，prev_page_args和prev_action_args等于null解析报错导致app崩溃情况
	 * @param data spiderPrevData
	 */
	function formatSpiderPrevData(data) {
	    !data.prev_page_args && (data.prev_page_args = {});
	    !data.prev_action_args && (data.prev_action_args = {});
	}
	/**
	 * 1、新版pecker.spider跳转逻辑：在url追加spider_token且将prevData种在window.name中
	 * 2、兼容实现v-collect跳转逻辑，判断跳转url是否跨主域：
	 * 是则url上追加spider_token_alias&&spider&spider_action参数；
	 * 不是则url追加spider_token且将prevData种在cookie中；
	 */
	function generateSpiderTokenBy(data) {
	    var token = shared_1.getUniqueRandomId(JSON.stringify(data), 4);
	    var _data = shared_1.merge(true, {}, data);
	    formatSpiderPrevData(_data);
	    var SPIDER_TOKEN = shared_1.COOKIE_SPIDER_TOKEN_PREFIX + '_' + token;
	    // 将动态key,prevData同时存进window.name和cookie中
	    shared_1.setStorage(SPIDER_TOKEN, _data);
	    /**
	     * 2020.12.2（待全网接入新版spider后再做兼容，防止跳转case：新1->旧->新2，旧版直接location.href方式跳转到新2，新1的固定key仍然缓存在window.name中）
	     * 向前兼容：
	     * 未来版本会下掉通过__spider__token_xxxx（动态key）缓存上一页跳转埋点数据，而用__spider__token（固定key值）缓存上一页跳转埋点数据替代
	     * 通过url传递动态key的方式未来也会被废弃掉，执行transferActionBy方法会立即跳转
	     */
	    // setStorage(COOKIE_SPIDER_TOKEN_PREFIX, data)
	    cookie_1.set(SPIDER_TOKEN, shared_1.stringifyJSON(_data), {
	        domain: shared_1.getPrimaryDomain(),
	        path: '/',
	        expires: 30
	    });
	    return token;
	}
	exports.generateSpiderTokenBy = generateSpiderTokenBy;
	// export function generateToken(data: SpiderPrevData) {
	//     return getUniqueRandomId(stringifyJSON(data), 4)
	// }
	// export function storeTokenIntoCookie(token: string, data: SpiderPrevData) {
	//     setCookie(COOKIE_PREFIX + token, stringifyJSON(data), {
	//         domain: getPrimaryDomain(),
	//         path: '/',
	//         expires: 30
	//     })
	// }
	// export function storeTokenIntoWindowname(token: string, data: SpiderPrevData) {
	//     setStorage(COOKIE_PREFIX + token, data)
	// }
	function getSpiderToken(token) {
	    var SPIDER_TOKEN = shared_1.COOKIE_SPIDER_TOKEN_PREFIX + '_' + token;
	    /**
	     * 获取spiderToken优先级：window.name > cookie > URL SEARCH PARAMS
	     */
	    var spiderToken = (shared_1.getStorage(SPIDER_TOKEN) ||
	        shared_1.parseJSON(cookie_1.get(SPIDER_TOKEN) || ''));
	    if (!spiderToken) {
	        var preSpm = util_1.getURLSearchParamBy(constants_1.URL_SEARCH_PARAMS_SPM);
	        var preActionName = util_1.getURLSearchParamBy(constants_1.URL_SEARCH_PARAMS_ACTION) || null;
	        spiderToken = preSpm
	            ? shared_1.merge(true, {}, DEFAULT_DATA, {
	                prev_spm: preSpm,
	                prev_action_name: preActionName
	            })
	            : null;
	    }
	    // 防止window.name 和cookie内存数据溢出和防止页面刷新重复上报上页跳转埋点数据
	    removeAllSpiderTokens();
	    return spiderToken;
	}
	exports.getSpiderToken = getSpiderToken;
	function removeAllSpiderTokens() {
	    var cookies = util_1.getCookies();
	    shared_1.forEach(cookies, function (_val, key) {
	        if (typeof key === 'string' &&
	            key.indexOf(shared_1.COOKIE_SPIDER_TOKEN_PREFIX) === 0) {
	            cookie_1.remove(key, {
	                domain: shared_1.getPrimaryDomain(),
	                path: '/'
	            });
	        }
	    });
	    var storage = shared_1.getStorage();
	    shared_1.forEach(storage, function (_val, key) {
	        if (typeof key === 'string' &&
	            key.indexOf(shared_1.COOKIE_SPIDER_TOKEN_PREFIX) === 0) {
	            shared_1.removeStorage(key);
	        }
	    });
	}
	exports.removeAllSpiderTokens = removeAllSpiderTokens;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.spmbObserver = void 0;
	var shared_1 = __webpack_require__(39);
	var constants_1 = __webpack_require__(115);
	function spmbObserver(callback) {
	    shared_1.domContentLoaded(function () {
	        var preSpmb = getSpmb();
	        function handler() {
	            var curSpmb = getSpmb();
	            // mutations.forEach(record => {
	            //     if (
	            //         record.type === 'attributes' &&
	            //         (record.attributeName === DATA_SPIDER ||
	            //             record.attributeName === DATA_SPIDER_PRIOR)
	            //     ) {
	            //         const curSpmb = getSpmb()
	            //         const preSpmb = record.oldValue
	            //         if (curSpmb && preSpmb && curSpmb !== preSpmb) {
	            //             callback(curSpmb, preSpmb)
	            //         }
	            //     }
	            // })
	            if (curSpmb && curSpmb !== preSpmb) {
	                callback(curSpmb, preSpmb);
	                preSpmb = curSpmb;
	            }
	        }
	        var observer = new MutationObserver(handler);
	        observer.observe(shared_1.DOCUMENT.body, {
	            attributes: true
	        });
	    });
	}
	exports.spmbObserver = spmbObserver;
	function getSpmb() {
	    return (shared_1.DOCUMENT.body.getAttribute(constants_1.DATA_SPIDER_PRIOR) ||
	        shared_1.DOCUMENT.body.getAttribute(constants_1.DATA_SPIDER));
	}


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	var jsonDiff = __webpack_require__(147);
	var shared = __webpack_require__(39);
	var util = __webpack_require__(117);

	function diff(methodName, args, oldData, newData, fn) {
	    var result = undefined;

	    try {
	        result = jsonDiff.diff(filter(oldData, fn), filter(newData, fn));
	    } catch (error) {
	        console.error(error)
	    }

	    //如果不同表示新老api上报数据不同，可能存在不兼容的问题
	    if (result) {
	        toInfo({
	            api: methodName,
	            args: args,
	            oldData: oldData,
	            newData: newData,
	            diffInfo: result
	        });
	    }
	}
	exports.diff = diff;

	function toInfo(option) {
	    window.pecker && window.pecker.bat && window.pecker.bat.info && window.pecker.bat.info(
	        shared.merge(true, option, {
	            message: option.message || "spider-diff-check",
	            sample: option.sample || false
	        })
	    )

	    shared.info(option)
	}
	exports.toInfo = toInfo;


	function filter(data, fn) {
	    return fn ? fn(data) : data
	}

	function isNullPrevInfo(data) {
	    try {
	        return ["prev_spm", "prev_page_args", "prev_action_name", "prev_action_args"].every(function (item) {
	            return data[item] === null
	        });
	    } catch (error) {
	        console.error(error)
	        return false;
	    }
	}

	function isUndefinedPrevInfo(data) {
	    try {
	        return ["prev_spm", "prev_page_args", "prev_action_name", "prev_action_args"].every(function (item) {
	            return data[item] === undefined
	        });
	    } catch (error) {
	        console.error(error)
	        return false;
	    }
	}

	function isEmptyObject(obj){
	    try {
	        return JSON.stringify(obj) === '{}';
	    } catch (error) {
	        return false;
	    }
	}

	function filterReportData(data) {
	    if (Object.prototype.toString.call(data) === "[object Object]") {
	        var _data = shared.merge(true, {}, data);
	        var target = {
	            type: _data.type,
	            subtype: _data.subtype,
	            cur_spm: _data.cur_spm,
	            cur_page_args: argsFilter(_data.cur_page_args)
	        }

	        if (_data.subtype === 'page_view' && !isNullPrevInfo(_data) && !isUndefinedPrevInfo(_data)) {
	            shared.merge(target, {
	                prev_spm: _data.prev_spm,
	                prev_page_args: argsFilter(_data.prev_page_args),
	                prev_action_name: _data.prev_action_name,
	                prev_action_args: argsFilter(_data.prev_action_args)
	            })
	        }

	        if (_data.subtype === 'click' || _data.subtype === 'expose') {
	            shared.merge(target, {
	                cur_action_name: _data.cur_action_name,
	                cur_action_args: argsFilter(_data.cur_action_args)
	            })
	        }

	        return target;
	    }

	    return data;
	}
	exports.filterReportData = filterReportData;

	function filterNavigationData(data) { //{jumpUrl, prevInfo}
	    if (Object.prototype.toString.call(data) === "[object Object]") {
	        var _data = shared.merge(true, {}, data);

	        if (_data.prevInfo) {
	            _data.prevInfo.prev_page_args = argsFilter(_data.prevInfo.prev_page_args);
	            _data.prevInfo.prev_action_args = argsFilter(_data.prevInfo.prev_action_args);
	        }

	        return _data;
	    }

	    return data;
	}
	exports.filterNavigationData = filterNavigationData;

	function argsFilter(args) {
	    if ((args === '') || (args === null) || (args === undefined) || isEmptyObject(args)){
	        return null;
	    } 
	    
	    if (Object.prototype.toString.call(args) === "[object Object]"){
	        delete args.ts;
	        delete args.navigation_type;
	        delete args.realVisitId;
	    }

	    return args;
	}

	function getSpiderTokenFrom(url) {
	    return util.getURLSearchParamBy("spider_token", url);
	}
	exports.getSpiderTokenFrom = getSpiderTokenFrom;

	function getPrevInfoDataBy(token) {
	    var cookieName = "__spider__" + "token" + "_";

	    cookieName += token;

	    return shared.parseJSON(util.getCookie(cookieName) || '');
	}
	exports.getPrevInfoDataBy = getPrevInfoDataBy;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var SequenceMatcher, arrayDiff, colorize, descalarize, diff, diffScore, diffString, diffWithScore, extendedTypeOf, findMatchingObject, isScalar, isScalarized, objectDiff, scalarize,
	    hasProp = {}.hasOwnProperty;

	  SequenceMatcher = __webpack_require__(148).SequenceMatcher;

	  extendedTypeOf = __webpack_require__(156).extendedTypeOf;

	  colorize = __webpack_require__(157).colorize;

	  isScalar = function(obj) {
	    return typeof obj !== 'object' || obj === null;
	  };

	  objectDiff = function(obj1, obj2, options) {
	    var change, key, ref, ref1, result, score, subscore, value1, value2;
	    if (options == null) {
	      options = {};
	    }
	    result = {};
	    score = 0;
	    for (key in obj1) {
	      if (!hasProp.call(obj1, key)) continue;
	      value1 = obj1[key];
	      if (!(!(key in obj2))) {
	        continue;
	      }
	      result[key + "__deleted"] = value1;
	      score -= 30;
	    }
	    for (key in obj2) {
	      if (!hasProp.call(obj2, key)) continue;
	      value2 = obj2[key];
	      if (!(!(key in obj1))) {
	        continue;
	      }
	      result[key + "__added"] = value2;
	      score -= 30;
	    }
	    for (key in obj1) {
	      if (!hasProp.call(obj1, key)) continue;
	      value1 = obj1[key];
	      if (!(key in obj2)) {
	        continue;
	      }
	      score += 20;
	      value2 = obj2[key];
	      ref = diffWithScore(value1, value2, options), subscore = ref[0], change = ref[1];
	      if (change) {
	        result[key] = change;
	      }
	      score += Math.min(20, Math.max(-10, subscore / 5));
	    }
	    if (Object.keys(result).length === 0) {
	      ref1 = [100 * Math.max(Object.keys(obj1).length, 0.5), void 0], score = ref1[0], result = ref1[1];
	    } else {
	      score = Math.max(0, score);
	    }
	    return [score, result];
	  };

	  findMatchingObject = function(item, index, fuzzyOriginals) {
	    var bestMatch, candidate, indexDistance, key, matchIndex, score;
	    bestMatch = null;
	    matchIndex = 0;
	    for (key in fuzzyOriginals) {
	      if (!hasProp.call(fuzzyOriginals, key)) continue;
	      candidate = fuzzyOriginals[key];
	      if (!(key !== '__next')) {
	        continue;
	      }
	      indexDistance = Math.abs(matchIndex - index);
	      if (extendedTypeOf(item) === extendedTypeOf(candidate)) {
	        score = diffScore(item, candidate);
	        if (!bestMatch || score > bestMatch.score || (score === bestMatch.score && indexDistance < bestMatch.indexDistance)) {
	          bestMatch = {
	            score: score,
	            key: key,
	            indexDistance: indexDistance
	          };
	        }
	      }
	      matchIndex++;
	    }
	    return bestMatch;
	  };

	  scalarize = function(array, originals, fuzzyOriginals) {
	    var bestMatch, index, item, k, len, proxy, results;
	    results = [];
	    for (index = k = 0, len = array.length; k < len; index = ++k) {
	      item = array[index];
	      if (isScalar(item)) {
	        results.push(item);
	      } else if (fuzzyOriginals && (bestMatch = findMatchingObject(item, index, fuzzyOriginals)) && bestMatch.score > 40 && (originals[bestMatch.key] == null)) {
	        originals[bestMatch.key] = item;
	        results.push(bestMatch.key);
	      } else {
	        proxy = "__$!SCALAR" + originals.__next++;
	        originals[proxy] = item;
	        results.push(proxy);
	      }
	    }
	    return results;
	  };

	  isScalarized = function(item, originals) {
	    return (typeof item === 'string') && (item in originals);
	  };

	  descalarize = function(item, originals) {
	    if (isScalarized(item, originals)) {
	      return originals[item];
	    } else {
	      return item;
	    }
	  };

	  arrayDiff = function(obj1, obj2, options) {
	    var allEqual, change, i, i1, i2, item, item1, item2, j, j1, j2, k, l, len, m, n, o, op, opcodes, originals1, originals2, p, q, ref, ref1, ref10, ref11, ref12, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, result, score, seq1, seq2;
	    if (options == null) {
	      options = {};
	    }
	    originals1 = {
	      __next: 1
	    };
	    seq1 = scalarize(obj1, originals1);
	    originals2 = {
	      __next: originals1.__next
	    };
	    seq2 = scalarize(obj2, originals2, originals1);
	    opcodes = new SequenceMatcher(null, seq1, seq2).getOpcodes();
	    result = [];
	    score = 0;
	    allEqual = true;
	    for (k = 0, len = opcodes.length; k < len; k++) {
	      ref = opcodes[k], op = ref[0], i1 = ref[1], i2 = ref[2], j1 = ref[3], j2 = ref[4];
	      if (!(op === 'equal' || (options.keysOnly && op === 'replace'))) {
	        allEqual = false;
	      }
	      switch (op) {
	        case 'equal':
	          for (i = l = ref1 = i1, ref2 = i2; ref1 <= ref2 ? l < ref2 : l > ref2; i = ref1 <= ref2 ? ++l : --l) {
	            item = seq1[i];
	            if (isScalarized(item, originals1)) {
	              if (!isScalarized(item, originals2)) {
	                throw new AssertionError("internal bug: isScalarized(item, originals1) != isScalarized(item, originals2) for item " + (JSON.stringify(item)));
	              }
	              item1 = descalarize(item, originals1);
	              item2 = descalarize(item, originals2);
	              change = diff(item1, item2, options);
	              if (change) {
	                result.push(['~', change]);
	                allEqual = false;
	              } else {
	                result.push([' ']);
	              }
	            } else {
	              result.push([' ', item]);
	            }
	            score += 10;
	          }
	          break;
	        case 'delete':
	          for (i = m = ref3 = i1, ref4 = i2; ref3 <= ref4 ? m < ref4 : m > ref4; i = ref3 <= ref4 ? ++m : --m) {
	            result.push(['-', descalarize(seq1[i], originals1)]);
	            score -= 5;
	          }
	          break;
	        case 'insert':
	          for (j = n = ref5 = j1, ref6 = j2; ref5 <= ref6 ? n < ref6 : n > ref6; j = ref5 <= ref6 ? ++n : --n) {
	            result.push(['+', descalarize(seq2[j], originals2)]);
	            score -= 5;
	          }
	          break;
	        case 'replace':
	          if (!options.keysOnly) {
	            for (i = o = ref7 = i1, ref8 = i2; ref7 <= ref8 ? o < ref8 : o > ref8; i = ref7 <= ref8 ? ++o : --o) {
	              result.push(['-', descalarize(seq1[i], originals1)]);
	              score -= 5;
	            }
	            for (j = p = ref9 = j1, ref10 = j2; ref9 <= ref10 ? p < ref10 : p > ref10; j = ref9 <= ref10 ? ++p : --p) {
	              result.push(['+', descalarize(seq2[j], originals2)]);
	              score -= 5;
	            }
	          } else {
	            for (i = q = ref11 = i1, ref12 = i2; ref11 <= ref12 ? q < ref12 : q > ref12; i = ref11 <= ref12 ? ++q : --q) {
	              change = diff(descalarize(seq1[i], originals1), descalarize(seq2[i - i1 + j1], originals2), options);
	              if (change) {
	                result.push(['~', change]);
	                allEqual = false;
	              } else {
	                result.push([' ']);
	              }
	            }
	          }
	      }
	    }
	    if (allEqual || (opcodes.length === 0)) {
	      result = void 0;
	      score = 100;
	    } else {
	      score = Math.max(0, score);
	    }
	    return [score, result];
	  };

	  diffWithScore = function(obj1, obj2, options) {
	    var type1, type2;
	    if (options == null) {
	      options = {};
	    }
	    type1 = extendedTypeOf(obj1);
	    type2 = extendedTypeOf(obj2);
	    if (type1 === type2) {
	      switch (type1) {
	        case 'object':
	          return objectDiff(obj1, obj2, options);
	        case 'array':
	          return arrayDiff(obj1, obj2, options);
	      }
	    }
	    if (!options.keysOnly) {
	      if (obj1 !== obj2) {
	        return [
	          0, {
	            __old: obj1,
	            __new: obj2
	          }
	        ];
	      } else {
	        return [100, void 0];
	      }
	    } else {
	      return [100, void 0];
	    }
	  };

	  diff = function(obj1, obj2, options) {
	    var change, ref, score;
	    if (options == null) {
	      options = {};
	    }
	    ref = diffWithScore(obj1, obj2, options), score = ref[0], change = ref[1];
	    return change;
	  };

	  diffScore = function(obj1, obj2, options) {
	    var change, ref, score;
	    if (options == null) {
	      options = {};
	    }
	    ref = diffWithScore(obj1, obj2, options), score = ref[0], change = ref[1];
	    return score;
	  };

	  diffString = function(obj1, obj2, colorizeOptions, diffOptions) {
	    if (diffOptions == null) {
	      diffOptions = {};
	    }
	    return colorize(diff(obj1, obj2, diffOptions), colorizeOptions);
	  };

	  module.exports = {
	    diff: diff,
	    diffString: diffString
	  };

	}).call(this);


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(149);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.3.1

	/*
	Module difflib -- helpers for computing deltas between objects.

	Function getCloseMatches(word, possibilities, n=3, cutoff=0.6):
	    Use SequenceMatcher to return list of the best "good enough" matches.

	Function contextDiff(a, b):
	    For two lists of strings, return a delta in context diff format.

	Function ndiff(a, b):
	    Return a delta: the difference between `a` and `b` (lists of strings).

	Function restore(delta, which):
	    Return one of the two sequences that generated an ndiff delta.

	Function unifiedDiff(a, b):
	    For two lists of strings, return a delta in unified diff format.

	Class SequenceMatcher:
	    A flexible class for comparing pairs of sequences of any type.

	Class Differ:
	    For producing human-readable deltas from sequences of lines of text.
	*/


	(function() {
	  var Differ, Heap, IS_CHARACTER_JUNK, IS_LINE_JUNK, SequenceMatcher, assert, contextDiff, floor, getCloseMatches, max, min, ndiff, restore, unifiedDiff, _any, _arrayCmp, _calculateRatio, _countLeading, _formatRangeContext, _formatRangeUnified, _has,
	    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

	  floor = Math.floor, max = Math.max, min = Math.min;

	  Heap = __webpack_require__(150);

	  assert = __webpack_require__(152);

	  _calculateRatio = function(matches, length) {
	    if (length) {
	      return 2.0 * matches / length;
	    } else {
	      return 1.0;
	    }
	  };

	  _arrayCmp = function(a, b) {
	    var i, la, lb, _i, _ref, _ref1;
	    _ref = [a.length, b.length], la = _ref[0], lb = _ref[1];
	    for (i = _i = 0, _ref1 = min(la, lb); 0 <= _ref1 ? _i < _ref1 : _i > _ref1; i = 0 <= _ref1 ? ++_i : --_i) {
	      if (a[i] < b[i]) {
	        return -1;
	      }
	      if (a[i] > b[i]) {
	        return 1;
	      }
	    }
	    return la - lb;
	  };

	  _has = function(obj, key) {
	    return Object.prototype.hasOwnProperty.call(obj, key);
	  };

	  _any = function(items) {
	    var item, _i, _len;
	    for (_i = 0, _len = items.length; _i < _len; _i++) {
	      item = items[_i];
	      if (item) {
	        return true;
	      }
	    }
	    return false;
	  };

	  SequenceMatcher = (function() {

	    SequenceMatcher.name = 'SequenceMatcher';

	    /*
	      SequenceMatcher is a flexible class for comparing pairs of sequences of
	      any type, so long as the sequence elements are hashable.  The basic
	      algorithm predates, and is a little fancier than, an algorithm
	      published in the late 1980's by Ratcliff and Obershelp under the
	      hyperbolic name "gestalt pattern matching".  The basic idea is to find
	      the longest contiguous matching subsequence that contains no "junk"
	      elements (R-O doesn't address junk).  The same idea is then applied
	      recursively to the pieces of the sequences to the left and to the right
	      of the matching subsequence.  This does not yield minimal edit
	      sequences, but does tend to yield matches that "look right" to people.
	    
	      SequenceMatcher tries to compute a "human-friendly diff" between two
	      sequences.  Unlike e.g. UNIX(tm) diff, the fundamental notion is the
	      longest *contiguous* & junk-free matching subsequence.  That's what
	      catches peoples' eyes.  The Windows(tm) windiff has another interesting
	      notion, pairing up elements that appear uniquely in each sequence.
	      That, and the method here, appear to yield more intuitive difference
	      reports than does diff.  This method appears to be the least vulnerable
	      to synching up on blocks of "junk lines", though (like blank lines in
	      ordinary text files, or maybe "<P>" lines in HTML files).  That may be
	      because this is the only method of the 3 that has a *concept* of
	      "junk" <wink>.
	    
	      Example, comparing two strings, and considering blanks to be "junk":
	    
	      >>> isjunk = (c) -> c is ' '
	      >>> s = new SequenceMatcher(isjunk,
	                                  'private Thread currentThread;',
	                                  'private volatile Thread currentThread;')
	    
	      .ratio() returns a float in [0, 1], measuring the "similarity" of the
	      sequences.  As a rule of thumb, a .ratio() value over 0.6 means the
	      sequences are close matches:
	    
	      >>> s.ratio().toPrecision(3)
	      '0.866'
	    
	      If you're only interested in where the sequences match,
	      .getMatchingBlocks() is handy:
	    
	      >>> for [a, b, size] in s.getMatchingBlocks()
	      ...   console.log("a[#{a}] and b[#{b}] match for #{size} elements");
	      a[0] and b[0] match for 8 elements
	      a[8] and b[17] match for 21 elements
	      a[29] and b[38] match for 0 elements
	    
	      Note that the last tuple returned by .get_matching_blocks() is always a
	      dummy, (len(a), len(b), 0), and this is the only case in which the last
	      tuple element (number of elements matched) is 0.
	    
	      If you want to know how to change the first sequence into the second,
	      use .get_opcodes():
	    
	      >>> for [op, a1, a2, b1, b2] in s.getOpcodes()
	      ...   console.log "#{op} a[#{a1}:#{a2}] b[#{b1}:#{b2}]"
	      equal a[0:8] b[0:8]
	      insert a[8:8] b[8:17]
	      equal a[8:29] b[17:38]
	    
	      See the Differ class for a fancy human-friendly file differencer, which
	      uses SequenceMatcher both to compare sequences of lines, and to compare
	      sequences of characters within similar (near-matching) lines.
	    
	      See also function getCloseMatches() in this module, which shows how
	      simple code building on SequenceMatcher can be used to do useful work.
	    
	      Timing:  Basic R-O is cubic time worst case and quadratic time expected
	      case.  SequenceMatcher is quadratic time for the worst case and has
	      expected-case behavior dependent in a complicated way on how many
	      elements the sequences have in common; best case time is linear.
	    
	      Methods:
	    
	      constructor(isjunk=null, a='', b='')
	          Construct a SequenceMatcher.
	    
	      setSeqs(a, b)
	          Set the two sequences to be compared.
	    
	      setSeq1(a)
	          Set the first sequence to be compared.
	    
	      setSeq2(b)
	          Set the second sequence to be compared.
	    
	      findLongestMatch(alo, ahi, blo, bhi)
	          Find longest matching block in a[alo:ahi] and b[blo:bhi].
	    
	      getMatchingBlocks()
	          Return list of triples describing matching subsequences.
	    
	      getOpcodes()
	          Return list of 5-tuples describing how to turn a into b.
	    
	      ratio()
	          Return a measure of the sequences' similarity (float in [0,1]).
	    
	      quickRatio()
	          Return an upper bound on .ratio() relatively quickly.
	    
	      realQuickRatio()
	          Return an upper bound on ratio() very quickly.
	    */


	    function SequenceMatcher(isjunk, a, b, autojunk) {
	      this.isjunk = isjunk;
	      if (a == null) {
	        a = '';
	      }
	      if (b == null) {
	        b = '';
	      }
	      this.autojunk = autojunk != null ? autojunk : true;
	      /*
	          Construct a SequenceMatcher.
	      
	          Optional arg isjunk is null (the default), or a one-argument
	          function that takes a sequence element and returns true iff the
	          element is junk.  Null is equivalent to passing "(x) -> 0", i.e.
	          no elements are considered to be junk.  For example, pass
	              (x) -> x in ' \t'
	          if you're comparing lines as sequences of characters, and don't
	          want to synch up on blanks or hard tabs.
	      
	          Optional arg a is the first of two sequences to be compared.  By
	          default, an empty string.  The elements of a must be hashable.  See
	          also .setSeqs() and .setSeq1().
	      
	          Optional arg b is the second of two sequences to be compared.  By
	          default, an empty string.  The elements of b must be hashable. See
	          also .setSeqs() and .setSeq2().
	      
	          Optional arg autojunk should be set to false to disable the
	          "automatic junk heuristic" that treats popular elements as junk
	          (see module documentation for more information).
	      */

	      this.a = this.b = null;
	      this.setSeqs(a, b);
	    }

	    SequenceMatcher.prototype.setSeqs = function(a, b) {
	      /* 
	      Set the two sequences to be compared. 
	      
	      >>> s = new SequenceMatcher()
	      >>> s.setSeqs('abcd', 'bcde')
	      >>> s.ratio()
	      0.75
	      */
	      this.setSeq1(a);
	      return this.setSeq2(b);
	    };

	    SequenceMatcher.prototype.setSeq1 = function(a) {
	      /* 
	      Set the first sequence to be compared. 
	      
	      The second sequence to be compared is not changed.
	      
	      >>> s = new SequenceMatcher(null, 'abcd', 'bcde')
	      >>> s.ratio()
	      0.75
	      >>> s.setSeq1('bcde')
	      >>> s.ratio()
	      1.0
	      
	      SequenceMatcher computes and caches detailed information about the
	      second sequence, so if you want to compare one sequence S against
	      many sequences, use .setSeq2(S) once and call .setSeq1(x)
	      repeatedly for each of the other sequences.
	      
	      See also setSeqs() and setSeq2().
	      */
	      if (a === this.a) {
	        return;
	      }
	      this.a = a;
	      return this.matchingBlocks = this.opcodes = null;
	    };

	    SequenceMatcher.prototype.setSeq2 = function(b) {
	      /*
	          Set the second sequence to be compared. 
	      
	          The first sequence to be compared is not changed.
	      
	          >>> s = new SequenceMatcher(null, 'abcd', 'bcde')
	          >>> s.ratio()
	          0.75
	          >>> s.setSeq2('abcd')
	          >>> s.ratio()
	          1.0
	      
	          SequenceMatcher computes and caches detailed information about the
	          second sequence, so if you want to compare one sequence S against
	          many sequences, use .setSeq2(S) once and call .setSeq1(x)
	          repeatedly for each of the other sequences.
	      
	          See also setSeqs() and setSeq1().
	      */
	      if (b === this.b) {
	        return;
	      }
	      this.b = b;
	      this.matchingBlocks = this.opcodes = null;
	      this.fullbcount = null;
	      return this._chainB();
	    };

	    SequenceMatcher.prototype._chainB = function() {
	      var b, b2j, elt, i, idxs, indices, isjunk, junk, n, ntest, popular, _i, _j, _len, _len1, _ref;
	      b = this.b;
	      this.b2j = b2j = {};
	      for (i = _i = 0, _len = b.length; _i < _len; i = ++_i) {
	        elt = b[i];
	        indices = _has(b2j, elt) ? b2j[elt] : b2j[elt] = [];
	        indices.push(i);
	      }
	      junk = {};
	      isjunk = this.isjunk;
	      if (isjunk) {
	        _ref = Object.keys(b2j);
	        for (_j = 0, _len1 = _ref.length; _j < _len1; _j++) {
	          elt = _ref[_j];
	          if (isjunk(elt)) {
	            junk[elt] = true;
	            delete b2j[elt];
	          }
	        }
	      }
	      popular = {};
	      n = b.length;
	      if (this.autojunk && n >= 200) {
	        ntest = floor(n / 100) + 1;
	        for (elt in b2j) {
	          idxs = b2j[elt];
	          if (idxs.length > ntest) {
	            popular[elt] = true;
	            delete b2j[elt];
	          }
	        }
	      }
	      this.isbjunk = function(b) {
	        return _has(junk, b);
	      };
	      return this.isbpopular = function(b) {
	        return _has(popular, b);
	      };
	    };

	    SequenceMatcher.prototype.findLongestMatch = function(alo, ahi, blo, bhi) {
	      /* 
	      Find longest matching block in a[alo...ahi] and b[blo...bhi].  
	      
	      If isjunk is not defined:
	      
	      Return [i,j,k] such that a[i...i+k] is equal to b[j...j+k], where
	          alo <= i <= i+k <= ahi
	          blo <= j <= j+k <= bhi
	      and for all [i',j',k'] meeting those conditions,
	          k >= k'
	          i <= i'
	          and if i == i', j <= j'
	      
	      In other words, of all maximal matching blocks, return one that
	      starts earliest in a, and of all those maximal matching blocks that
	      start earliest in a, return the one that starts earliest in b.
	      
	      >>> isjunk = (x) -> x is ' '
	      >>> s = new SequenceMatcher(isjunk, ' abcd', 'abcd abcd')
	      >>> s.findLongestMatch(0, 5, 0, 9)
	      [1, 0, 4]
	      
	      >>> s = new SequenceMatcher(null, 'ab', 'c')
	      >>> s.findLongestMatch(0, 2, 0, 1)
	      [0, 0, 0]
	      */

	      var a, b, b2j, besti, bestj, bestsize, i, isbjunk, j, j2len, k, newj2len, _i, _j, _len, _ref, _ref1, _ref2, _ref3, _ref4, _ref5;
	      _ref = [this.a, this.b, this.b2j, this.isbjunk], a = _ref[0], b = _ref[1], b2j = _ref[2], isbjunk = _ref[3];
	      _ref1 = [alo, blo, 0], besti = _ref1[0], bestj = _ref1[1], bestsize = _ref1[2];
	      j2len = {};
	      for (i = _i = alo; alo <= ahi ? _i < ahi : _i > ahi; i = alo <= ahi ? ++_i : --_i) {
	        newj2len = {};
	        _ref2 = (_has(b2j, a[i]) ? b2j[a[i]] : []);
	        for (_j = 0, _len = _ref2.length; _j < _len; _j++) {
	          j = _ref2[_j];
	          if (j < blo) {
	            continue;
	          }
	          if (j >= bhi) {
	            break;
	          }
	          k = newj2len[j] = (j2len[j - 1] || 0) + 1;
	          if (k > bestsize) {
	            _ref3 = [i - k + 1, j - k + 1, k], besti = _ref3[0], bestj = _ref3[1], bestsize = _ref3[2];
	          }
	        }
	        j2len = newj2len;
	      }
	      while (besti > alo && bestj > blo && !isbjunk(b[bestj - 1]) && a[besti - 1] === b[bestj - 1]) {
	        _ref4 = [besti - 1, bestj - 1, bestsize + 1], besti = _ref4[0], bestj = _ref4[1], bestsize = _ref4[2];
	      }
	      while (besti + bestsize < ahi && bestj + bestsize < bhi && !isbjunk(b[bestj + bestsize]) && a[besti + bestsize] === b[bestj + bestsize]) {
	        bestsize++;
	      }
	      while (besti > alo && bestj > blo && isbjunk(b[bestj - 1]) && a[besti - 1] === b[bestj - 1]) {
	        _ref5 = [besti - 1, bestj - 1, bestsize + 1], besti = _ref5[0], bestj = _ref5[1], bestsize = _ref5[2];
	      }
	      while (besti + bestsize < ahi && bestj + bestsize < bhi && isbjunk(b[bestj + bestsize]) && a[besti + bestsize] === b[bestj + bestsize]) {
	        bestsize++;
	      }
	      return [besti, bestj, bestsize];
	    };

	    SequenceMatcher.prototype.getMatchingBlocks = function() {
	      /*
	          Return list of triples describing matching subsequences.
	      
	          Each triple is of the form [i, j, n], and means that
	          a[i...i+n] == b[j...j+n].  The triples are monotonically increasing in
	          i and in j.  it's also guaranteed that if
	          [i, j, n] and [i', j', n'] are adjacent triples in the list, and
	          the second is not the last triple in the list, then i+n != i' or
	          j+n != j'.  IOW, adjacent triples never describe adjacent equal
	          blocks.
	      
	          The last triple is a dummy, [a.length, b.length, 0], and is the only
	          triple with n==0.
	      
	          >>> s = new SequenceMatcher(null, 'abxcd', 'abcd')
	          >>> s.getMatchingBlocks()
	          [[0, 0, 2], [3, 2, 2], [5, 4, 0]]
	      */

	      var ahi, alo, bhi, blo, i, i1, i2, j, j1, j2, k, k1, k2, la, lb, matchingBlocks, nonAdjacent, queue, x, _i, _len, _ref, _ref1, _ref2, _ref3, _ref4;
	      if (this.matchingBlocks) {
	        return this.matchingBlocks;
	      }
	      _ref = [this.a.length, this.b.length], la = _ref[0], lb = _ref[1];
	      queue = [[0, la, 0, lb]];
	      matchingBlocks = [];
	      while (queue.length) {
	        _ref1 = queue.pop(), alo = _ref1[0], ahi = _ref1[1], blo = _ref1[2], bhi = _ref1[3];
	        _ref2 = x = this.findLongestMatch(alo, ahi, blo, bhi), i = _ref2[0], j = _ref2[1], k = _ref2[2];
	        if (k) {
	          matchingBlocks.push(x);
	          if (alo < i && blo < j) {
	            queue.push([alo, i, blo, j]);
	          }
	          if (i + k < ahi && j + k < bhi) {
	            queue.push([i + k, ahi, j + k, bhi]);
	          }
	        }
	      }
	      matchingBlocks.sort(_arrayCmp);
	      i1 = j1 = k1 = 0;
	      nonAdjacent = [];
	      for (_i = 0, _len = matchingBlocks.length; _i < _len; _i++) {
	        _ref3 = matchingBlocks[_i], i2 = _ref3[0], j2 = _ref3[1], k2 = _ref3[2];
	        if (i1 + k1 === i2 && j1 + k1 === j2) {
	          k1 += k2;
	        } else {
	          if (k1) {
	            nonAdjacent.push([i1, j1, k1]);
	          }
	          _ref4 = [i2, j2, k2], i1 = _ref4[0], j1 = _ref4[1], k1 = _ref4[2];
	        }
	      }
	      if (k1) {
	        nonAdjacent.push([i1, j1, k1]);
	      }
	      nonAdjacent.push([la, lb, 0]);
	      return this.matchingBlocks = nonAdjacent;
	    };

	    SequenceMatcher.prototype.getOpcodes = function() {
	      /* 
	      Return list of 5-tuples describing how to turn a into b.
	      
	      Each tuple is of the form [tag, i1, i2, j1, j2].  The first tuple
	      has i1 == j1 == 0, and remaining tuples have i1 == the i2 from the
	      tuple preceding it, and likewise for j1 == the previous j2.
	      
	      The tags are strings, with these meanings:
	      
	      'replace':  a[i1...i2] should be replaced by b[j1...j2]
	      'delete':   a[i1...i2] should be deleted.
	                  Note that j1==j2 in this case.
	      'insert':   b[j1...j2] should be inserted at a[i1...i1].
	                  Note that i1==i2 in this case.
	      'equal':    a[i1...i2] == b[j1...j2]
	      
	      >>> s = new SequenceMatcher(null, 'qabxcd', 'abycdf')
	      >>> s.getOpcodes()
	      [ [ 'delete'  , 0 , 1 , 0 , 0 ] ,
	        [ 'equal'   , 1 , 3 , 0 , 2 ] ,
	        [ 'replace' , 3 , 4 , 2 , 3 ] ,
	        [ 'equal'   , 4 , 6 , 3 , 5 ] ,
	        [ 'insert'  , 6 , 6 , 5 , 6 ] ]
	      */

	      var ai, answer, bj, i, j, size, tag, _i, _len, _ref, _ref1, _ref2;
	      if (this.opcodes) {
	        return this.opcodes;
	      }
	      i = j = 0;
	      this.opcodes = answer = [];
	      _ref = this.getMatchingBlocks();
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        _ref1 = _ref[_i], ai = _ref1[0], bj = _ref1[1], size = _ref1[2];
	        tag = '';
	        if (i < ai && j < bj) {
	          tag = 'replace';
	        } else if (i < ai) {
	          tag = 'delete';
	        } else if (j < bj) {
	          tag = 'insert';
	        }
	        if (tag) {
	          answer.push([tag, i, ai, j, bj]);
	        }
	        _ref2 = [ai + size, bj + size], i = _ref2[0], j = _ref2[1];
	        if (size) {
	          answer.push(['equal', ai, i, bj, j]);
	        }
	      }
	      return answer;
	    };

	    SequenceMatcher.prototype.getGroupedOpcodes = function(n) {
	      var codes, group, groups, i1, i2, j1, j2, nn, tag, _i, _len, _ref, _ref1, _ref2, _ref3;
	      if (n == null) {
	        n = 3;
	      }
	      /* 
	      Isolate change clusters by eliminating ranges with no changes.
	      
	      Return a list groups with upto n lines of context.
	      Each group is in the same format as returned by get_opcodes().
	      
	      >>> a = [1...40].map(String)
	      >>> b = a.slice()
	      >>> b[8...8] = 'i'
	      >>> b[20] += 'x'
	      >>> b[23...28] = []
	      >>> b[30] += 'y'
	      >>> s = new SequenceMatcher(null, a, b)
	      >>> s.getGroupedOpcodes()
	      [ [ [ 'equal'  , 5 , 8  , 5 , 8 ],
	          [ 'insert' , 8 , 8  , 8 , 9 ],
	          [ 'equal'  , 8 , 11 , 9 , 12 ] ],
	        [ [ 'equal'   , 16 , 19 , 17 , 20 ],
	          [ 'replace' , 19 , 20 , 20 , 21 ],
	          [ 'equal'   , 20 , 22 , 21 , 23 ],
	          [ 'delete'  , 22 , 27 , 23 , 23 ],
	          [ 'equal'   , 27 , 30 , 23 , 26 ] ],
	        [ [ 'equal'   , 31 , 34 , 27 , 30 ],
	          [ 'replace' , 34 , 35 , 30 , 31 ],
	          [ 'equal'   , 35 , 38 , 31 , 34 ] ] ]
	      */

	      codes = this.getOpcodes();
	      if (!codes.length) {
	        codes = [['equal', 0, 1, 0, 1]];
	      }
	      if (codes[0][0] === 'equal') {
	        _ref = codes[0], tag = _ref[0], i1 = _ref[1], i2 = _ref[2], j1 = _ref[3], j2 = _ref[4];
	        codes[0] = [tag, max(i1, i2 - n), i2, max(j1, j2 - n), j2];
	      }
	      if (codes[codes.length - 1][0] === 'equal') {
	        _ref1 = codes[codes.length - 1], tag = _ref1[0], i1 = _ref1[1], i2 = _ref1[2], j1 = _ref1[3], j2 = _ref1[4];
	        codes[codes.length - 1] = [tag, i1, min(i2, i1 + n), j1, min(j2, j1 + n)];
	      }
	      nn = n + n;
	      groups = [];
	      group = [];
	      for (_i = 0, _len = codes.length; _i < _len; _i++) {
	        _ref2 = codes[_i], tag = _ref2[0], i1 = _ref2[1], i2 = _ref2[2], j1 = _ref2[3], j2 = _ref2[4];
	        if (tag === 'equal' && i2 - i1 > nn) {
	          group.push([tag, i1, min(i2, i1 + n), j1, min(j2, j1 + n)]);
	          groups.push(group);
	          group = [];
	          _ref3 = [max(i1, i2 - n), max(j1, j2 - n)], i1 = _ref3[0], j1 = _ref3[1];
	        }
	        group.push([tag, i1, i2, j1, j2]);
	      }
	      if (group.length && !(group.length === 1 && group[0][0] === 'equal')) {
	        groups.push(group);
	      }
	      return groups;
	    };

	    SequenceMatcher.prototype.ratio = function() {
	      /*
	          Return a measure of the sequences' similarity (float in [0,1]).
	      
	          Where T is the total number of elements in both sequences, and
	          M is the number of matches, this is 2.0*M / T.
	          Note that this is 1 if the sequences are identical, and 0 if
	          they have nothing in common.
	      
	          .ratio() is expensive to compute if you haven't already computed
	          .getMatchingBlocks() or .getOpcodes(), in which case you may
	          want to try .quickRatio() or .realQuickRatio() first to get an
	          upper bound.
	          
	          >>> s = new SequenceMatcher(null, 'abcd', 'bcde')
	          >>> s.ratio()
	          0.75
	          >>> s.quickRatio()
	          0.75
	          >>> s.realQuickRatio()
	          1.0
	      */

	      var match, matches, _i, _len, _ref;
	      matches = 0;
	      _ref = this.getMatchingBlocks();
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        match = _ref[_i];
	        matches += match[2];
	      }
	      return _calculateRatio(matches, this.a.length + this.b.length);
	    };

	    SequenceMatcher.prototype.quickRatio = function() {
	      /*
	          Return an upper bound on ratio() relatively quickly.
	      
	          This isn't defined beyond that it is an upper bound on .ratio(), and
	          is faster to compute.
	      */

	      var avail, elt, fullbcount, matches, numb, _i, _j, _len, _len1, _ref, _ref1;
	      if (!this.fullbcount) {
	        this.fullbcount = fullbcount = {};
	        _ref = this.b;
	        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	          elt = _ref[_i];
	          fullbcount[elt] = (fullbcount[elt] || 0) + 1;
	        }
	      }
	      fullbcount = this.fullbcount;
	      avail = {};
	      matches = 0;
	      _ref1 = this.a;
	      for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
	        elt = _ref1[_j];
	        if (_has(avail, elt)) {
	          numb = avail[elt];
	        } else {
	          numb = fullbcount[elt] || 0;
	        }
	        avail[elt] = numb - 1;
	        if (numb > 0) {
	          matches++;
	        }
	      }
	      return _calculateRatio(matches, this.a.length + this.b.length);
	    };

	    SequenceMatcher.prototype.realQuickRatio = function() {
	      /*
	          Return an upper bound on ratio() very quickly.
	      
	          This isn't defined beyond that it is an upper bound on .ratio(), and
	          is faster to compute than either .ratio() or .quickRatio().
	      */

	      var la, lb, _ref;
	      _ref = [this.a.length, this.b.length], la = _ref[0], lb = _ref[1];
	      return _calculateRatio(min(la, lb), la + lb);
	    };

	    return SequenceMatcher;

	  })();

	  getCloseMatches = function(word, possibilities, n, cutoff) {
	    var result, s, score, x, _i, _j, _len, _len1, _ref, _results;
	    if (n == null) {
	      n = 3;
	    }
	    if (cutoff == null) {
	      cutoff = 0.6;
	    }
	    /*
	      Use SequenceMatcher to return list of the best "good enough" matches.
	    
	      word is a sequence for which close matches are desired (typically a
	      string).
	    
	      possibilities is a list of sequences against which to match word
	      (typically a list of strings).
	    
	      Optional arg n (default 3) is the maximum number of close matches to
	      return.  n must be > 0.
	    
	      Optional arg cutoff (default 0.6) is a float in [0, 1].  Possibilities
	      that don't score at least that similar to word are ignored.
	    
	      The best (no more than n) matches among the possibilities are returned
	      in a list, sorted by similarity score, most similar first.
	    
	      >>> getCloseMatches('appel', ['ape', 'apple', 'peach', 'puppy'])
	      ['apple', 'ape']
	      >>> KEYWORDS = require('coffee-script').RESERVED
	      >>> getCloseMatches('wheel', KEYWORDS)
	      ['when', 'while']
	      >>> getCloseMatches('accost', KEYWORDS)
	      ['const']
	    */

	    if (!(n > 0)) {
	      throw new Error("n must be > 0: (" + n + ")");
	    }
	    if (!((0.0 <= cutoff && cutoff <= 1.0))) {
	      throw new Error("cutoff must be in [0.0, 1.0]: (" + cutoff + ")");
	    }
	    result = [];
	    s = new SequenceMatcher();
	    s.setSeq2(word);
	    for (_i = 0, _len = possibilities.length; _i < _len; _i++) {
	      x = possibilities[_i];
	      s.setSeq1(x);
	      if (s.realQuickRatio() >= cutoff && s.quickRatio() >= cutoff && s.ratio() >= cutoff) {
	        result.push([s.ratio(), x]);
	      }
	    }
	    result = Heap.nlargest(result, n, _arrayCmp);
	    _results = [];
	    for (_j = 0, _len1 = result.length; _j < _len1; _j++) {
	      _ref = result[_j], score = _ref[0], x = _ref[1];
	      _results.push(x);
	    }
	    return _results;
	  };

	  _countLeading = function(line, ch) {
	    /*
	      Return number of `ch` characters at the start of `line`.
	    
	      >>> _countLeading('   abc', ' ')
	      3
	    */

	    var i, n, _ref;
	    _ref = [0, line.length], i = _ref[0], n = _ref[1];
	    while (i < n && line[i] === ch) {
	      i++;
	    }
	    return i;
	  };

	  Differ = (function() {

	    Differ.name = 'Differ';

	    /*
	      Differ is a class for comparing sequences of lines of text, and
	      producing human-readable differences or deltas.  Differ uses
	      SequenceMatcher both to compare sequences of lines, and to compare
	      sequences of characters within similar (near-matching) lines.
	    
	      Each line of a Differ delta begins with a two-letter code:
	    
	          '- '    line unique to sequence 1
	          '+ '    line unique to sequence 2
	          '  '    line common to both sequences
	          '? '    line not present in either input sequence
	    
	      Lines beginning with '? ' attempt to guide the eye to intraline
	      differences, and were not present in either input sequence.  These lines
	      can be confusing if the sequences contain tab characters.
	    
	      Note that Differ makes no claim to produce a *minimal* diff.  To the
	      contrary, minimal diffs are often counter-intuitive, because they synch
	      up anywhere possible, sometimes accidental matches 100 pages apart.
	      Restricting synch points to contiguous matches preserves some notion of
	      locality, at the occasional cost of producing a longer diff.
	    
	      Example: Comparing two texts.
	    
	      >>> text1 = ['1. Beautiful is better than ugly.\n',
	      ...   '2. Explicit is better than implicit.\n',
	      ...   '3. Simple is better than complex.\n',
	      ...   '4. Complex is better than complicated.\n']
	      >>> text1.length
	      4
	      >>> text2 = ['1. Beautiful is better than ugly.\n',
	      ...   '3.   Simple is better than complex.\n',
	      ...   '4. Complicated is better than complex.\n',
	      ...   '5. Flat is better than nested.\n']
	    
	      Next we instantiate a Differ object:
	    
	      >>> d = new Differ()
	    
	      Note that when instantiating a Differ object we may pass functions to
	      filter out line and character 'junk'.
	    
	      Finally, we compare the two:
	    
	      >>> result = d.compare(text1, text2)
	      [ '  1. Beautiful is better than ugly.\n',
	        '- 2. Explicit is better than implicit.\n',
	        '- 3. Simple is better than complex.\n',
	        '+ 3.   Simple is better than complex.\n',
	        '?   ++\n',
	        '- 4. Complex is better than complicated.\n',
	        '?          ^                     ---- ^\n',
	        '+ 4. Complicated is better than complex.\n',
	        '?         ++++ ^                      ^\n',
	        '+ 5. Flat is better than nested.\n' ]
	    
	      Methods:
	    
	      constructor(linejunk=null, charjunk=null)
	          Construct a text differencer, with optional filters.
	      compare(a, b)
	          Compare two sequences of lines; generate the resulting delta.
	    */


	    function Differ(linejunk, charjunk) {
	      this.linejunk = linejunk;
	      this.charjunk = charjunk;
	      /*
	          Construct a text differencer, with optional filters.
	      
	          The two optional keyword parameters are for filter functions:
	      
	          - `linejunk`: A function that should accept a single string argument,
	            and return true iff the string is junk. The module-level function
	            `IS_LINE_JUNK` may be used to filter out lines without visible
	            characters, except for at most one splat ('#').  It is recommended
	            to leave linejunk null. 
	      
	          - `charjunk`: A function that should accept a string of length 1. The
	            module-level function `IS_CHARACTER_JUNK` may be used to filter out
	            whitespace characters (a blank or tab; **note**: bad idea to include
	            newline in this!).  Use of IS_CHARACTER_JUNK is recommended.
	      */

	    }

	    Differ.prototype.compare = function(a, b) {
	      /*
	          Compare two sequences of lines; generate the resulting delta.
	      
	          Each sequence must contain individual single-line strings ending with
	          newlines. Such sequences can be obtained from the `readlines()` method
	          of file-like objects.  The delta generated also consists of newline-
	          terminated strings, ready to be printed as-is via the writeline()
	          method of a file-like object.
	      
	          Example:
	      
	          >>> d = new Differ
	          >>> d.compare(['one\n', 'two\n', 'three\n'],
	          ...           ['ore\n', 'tree\n', 'emu\n'])
	          [ '- one\n',
	            '?  ^\n',
	            '+ ore\n',
	            '?  ^\n',
	            '- two\n',
	            '- three\n',
	            '?  -\n',
	            '+ tree\n',
	            '+ emu\n' ]
	      */

	      var ahi, alo, bhi, blo, cruncher, g, line, lines, tag, _i, _j, _len, _len1, _ref, _ref1;
	      cruncher = new SequenceMatcher(this.linejunk, a, b);
	      lines = [];
	      _ref = cruncher.getOpcodes();
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        _ref1 = _ref[_i], tag = _ref1[0], alo = _ref1[1], ahi = _ref1[2], blo = _ref1[3], bhi = _ref1[4];
	        switch (tag) {
	          case 'replace':
	            g = this._fancyReplace(a, alo, ahi, b, blo, bhi);
	            break;
	          case 'delete':
	            g = this._dump('-', a, alo, ahi);
	            break;
	          case 'insert':
	            g = this._dump('+', b, blo, bhi);
	            break;
	          case 'equal':
	            g = this._dump(' ', a, alo, ahi);
	            break;
	          default:
	            throw new Error("unknow tag (" + tag + ")");
	        }
	        for (_j = 0, _len1 = g.length; _j < _len1; _j++) {
	          line = g[_j];
	          lines.push(line);
	        }
	      }
	      return lines;
	    };

	    Differ.prototype._dump = function(tag, x, lo, hi) {
	      /*
	          Generate comparison results for a same-tagged range.
	      */

	      var i, _i, _results;
	      _results = [];
	      for (i = _i = lo; lo <= hi ? _i < hi : _i > hi; i = lo <= hi ? ++_i : --_i) {
	        _results.push("" + tag + " " + x[i]);
	      }
	      return _results;
	    };

	    Differ.prototype._plainReplace = function(a, alo, ahi, b, blo, bhi) {
	      var first, g, line, lines, second, _i, _j, _len, _len1, _ref;
	      assert(alo < ahi && blo < bhi);
	      if (bhi - blo < ahi - alo) {
	        first = this._dump('+', b, blo, bhi);
	        second = this._dump('-', a, alo, ahi);
	      } else {
	        first = this._dump('-', a, alo, ahi);
	        second = this._dump('+', b, blo, bhi);
	      }
	      lines = [];
	      _ref = [first, second];
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        g = _ref[_i];
	        for (_j = 0, _len1 = g.length; _j < _len1; _j++) {
	          line = g[_j];
	          lines.push(line);
	        }
	      }
	      return lines;
	    };

	    Differ.prototype._fancyReplace = function(a, alo, ahi, b, blo, bhi) {
	      /*
	          When replacing one block of lines with another, search the blocks
	          for *similar* lines; the best-matching pair (if any) is used as a
	          synch point, and intraline difference marking is done on the
	          similar pair. Lots of work, but often worth it.
	      
	          Example:
	          >>> d = new Differ
	          >>> d._fancyReplace(['abcDefghiJkl\n'], 0, 1,
	          ...                 ['abcdefGhijkl\n'], 0, 1)
	          [ '- abcDefghiJkl\n',
	            '?    ^  ^  ^\n',
	            '+ abcdefGhijkl\n',
	            '?    ^  ^  ^\n' ]
	      */

	      var aelt, ai, ai1, ai2, atags, belt, bestRatio, besti, bestj, bj, bj1, bj2, btags, cruncher, cutoff, eqi, eqj, i, j, la, lb, line, lines, tag, _i, _j, _k, _l, _len, _len1, _len2, _len3, _len4, _m, _n, _o, _ref, _ref1, _ref10, _ref11, _ref12, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9;
	      _ref = [0.74, 0.75], bestRatio = _ref[0], cutoff = _ref[1];
	      cruncher = new SequenceMatcher(this.charjunk);
	      _ref1 = [null, null], eqi = _ref1[0], eqj = _ref1[1];
	      lines = [];
	      for (j = _i = blo; blo <= bhi ? _i < bhi : _i > bhi; j = blo <= bhi ? ++_i : --_i) {
	        bj = b[j];
	        cruncher.setSeq2(bj);
	        for (i = _j = alo; alo <= ahi ? _j < ahi : _j > ahi; i = alo <= ahi ? ++_j : --_j) {
	          ai = a[i];
	          if (ai === bj) {
	            if (eqi === null) {
	              _ref2 = [i, j], eqi = _ref2[0], eqj = _ref2[1];
	            }
	            continue;
	          }
	          cruncher.setSeq1(ai);
	          if (cruncher.realQuickRatio() > bestRatio && cruncher.quickRatio() > bestRatio && cruncher.ratio() > bestRatio) {
	            _ref3 = [cruncher.ratio(), i, j], bestRatio = _ref3[0], besti = _ref3[1], bestj = _ref3[2];
	          }
	        }
	      }
	      if (bestRatio < cutoff) {
	        if (eqi === null) {
	          _ref4 = this._plainReplace(a, alo, ahi, b, blo, bhi);
	          for (_k = 0, _len = _ref4.length; _k < _len; _k++) {
	            line = _ref4[_k];
	            lines.push(line);
	          }
	          return lines;
	        }
	        _ref5 = [eqi, eqj, 1.0], besti = _ref5[0], bestj = _ref5[1], bestRatio = _ref5[2];
	      } else {
	        eqi = null;
	      }
	      _ref6 = this._fancyHelper(a, alo, besti, b, blo, bestj);
	      for (_l = 0, _len1 = _ref6.length; _l < _len1; _l++) {
	        line = _ref6[_l];
	        lines.push(line);
	      }
	      _ref7 = [a[besti], b[bestj]], aelt = _ref7[0], belt = _ref7[1];
	      if (eqi === null) {
	        atags = btags = '';
	        cruncher.setSeqs(aelt, belt);
	        _ref8 = cruncher.getOpcodes();
	        for (_m = 0, _len2 = _ref8.length; _m < _len2; _m++) {
	          _ref9 = _ref8[_m], tag = _ref9[0], ai1 = _ref9[1], ai2 = _ref9[2], bj1 = _ref9[3], bj2 = _ref9[4];
	          _ref10 = [ai2 - ai1, bj2 - bj1], la = _ref10[0], lb = _ref10[1];
	          switch (tag) {
	            case 'replace':
	              atags += Array(la + 1).join('^');
	              btags += Array(lb + 1).join('^');
	              break;
	            case 'delete':
	              atags += Array(la + 1).join('-');
	              break;
	            case 'insert':
	              btags += Array(lb + 1).join('+');
	              break;
	            case 'equal':
	              atags += Array(la + 1).join(' ');
	              btags += Array(lb + 1).join(' ');
	              break;
	            default:
	              throw new Error("unknow tag (" + tag + ")");
	          }
	        }
	        _ref11 = this._qformat(aelt, belt, atags, btags);
	        for (_n = 0, _len3 = _ref11.length; _n < _len3; _n++) {
	          line = _ref11[_n];
	          lines.push(line);
	        }
	      } else {
	        lines.push('  ' + aelt);
	      }
	      _ref12 = this._fancyHelper(a, besti + 1, ahi, b, bestj + 1, bhi);
	      for (_o = 0, _len4 = _ref12.length; _o < _len4; _o++) {
	        line = _ref12[_o];
	        lines.push(line);
	      }
	      return lines;
	    };

	    Differ.prototype._fancyHelper = function(a, alo, ahi, b, blo, bhi) {
	      var g;
	      g = [];
	      if (alo < ahi) {
	        if (blo < bhi) {
	          g = this._fancyReplace(a, alo, ahi, b, blo, bhi);
	        } else {
	          g = this._dump('-', a, alo, ahi);
	        }
	      } else if (blo < bhi) {
	        g = this._dump('+', b, blo, bhi);
	      }
	      return g;
	    };

	    Differ.prototype._qformat = function(aline, bline, atags, btags) {
	      /*
	          Format "?" output and deal with leading tabs.
	      
	          Example:
	      
	          >>> d = new Differ
	          >>> d._qformat('\tabcDefghiJkl\n', '\tabcdefGhijkl\n',
	          [ '- \tabcDefghiJkl\n',
	            '? \t ^ ^  ^\n',
	            '+ \tabcdefGhijkl\n',
	            '? \t ^ ^  ^\n' ]
	      */

	      var common, lines;
	      lines = [];
	      common = min(_countLeading(aline, '\t'), _countLeading(bline, '\t'));
	      common = min(common, _countLeading(atags.slice(0, common), ' '));
	      common = min(common, _countLeading(btags.slice(0, common), ' '));
	      atags = atags.slice(common).replace(/\s+$/, '');
	      btags = btags.slice(common).replace(/\s+$/, '');
	      lines.push('- ' + aline);
	      if (atags.length) {
	        lines.push("? " + (Array(common + 1).join('\t')) + atags + "\n");
	      }
	      lines.push('+ ' + bline);
	      if (btags.length) {
	        lines.push("? " + (Array(common + 1).join('\t')) + btags + "\n");
	      }
	      return lines;
	    };

	    return Differ;

	  })();

	  IS_LINE_JUNK = function(line, pat) {
	    if (pat == null) {
	      pat = /^\s*#?\s*$/;
	    }
	    /*
	      Return 1 for ignorable line: iff `line` is blank or contains a single '#'.
	        
	      Examples:
	    
	      >>> IS_LINE_JUNK('\n')
	      true
	      >>> IS_LINE_JUNK('  #   \n')
	      true
	      >>> IS_LINE_JUNK('hello\n')
	      false
	    */

	    return pat.test(line);
	  };

	  IS_CHARACTER_JUNK = function(ch, ws) {
	    if (ws == null) {
	      ws = ' \t';
	    }
	    /*
	      Return 1 for ignorable character: iff `ch` is a space or tab.
	    
	      Examples:
	      >>> IS_CHARACTER_JUNK(' ').should.be.true
	      true
	      >>> IS_CHARACTER_JUNK('\t').should.be.true
	      true
	      >>> IS_CHARACTER_JUNK('\n').should.be.false
	      false
	      >>> IS_CHARACTER_JUNK('x').should.be.false
	      false
	    */

	    return __indexOf.call(ws, ch) >= 0;
	  };

	  _formatRangeUnified = function(start, stop) {
	    /*
	      Convert range to the "ed" format'
	    */

	    var beginning, length;
	    beginning = start + 1;
	    length = stop - start;
	    if (length === 1) {
	      return "" + beginning;
	    }
	    if (!length) {
	      beginning--;
	    }
	    return "" + beginning + "," + length;
	  };

	  unifiedDiff = function(a, b, _arg) {
	    var file1Range, file2Range, first, fromdate, fromfile, fromfiledate, group, i1, i2, j1, j2, last, line, lines, lineterm, n, started, tag, todate, tofile, tofiledate, _i, _j, _k, _l, _len, _len1, _len2, _len3, _len4, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
	    _ref = _arg != null ? _arg : {}, fromfile = _ref.fromfile, tofile = _ref.tofile, fromfiledate = _ref.fromfiledate, tofiledate = _ref.tofiledate, n = _ref.n, lineterm = _ref.lineterm;
	    /*
	      Compare two sequences of lines; generate the delta as a unified diff.
	    
	      Unified diffs are a compact way of showing line changes and a few
	      lines of context.  The number of context lines is set by 'n' which
	      defaults to three.
	    
	      By default, the diff control lines (those with ---, +++, or @@) are
	      created with a trailing newline.  
	    
	      For inputs that do not have trailing newlines, set the lineterm
	      argument to "" so that the output will be uniformly newline free.
	    
	      The unidiff format normally has a header for filenames and modification
	      times.  Any or all of these may be specified using strings for
	      'fromfile', 'tofile', 'fromfiledate', and 'tofiledate'.
	      The modification times are normally expressed in the ISO 8601 format.
	    
	      Example:
	    
	      >>> unifiedDiff('one two three four'.split(' '),
	      ...             'zero one tree four'.split(' '), {
	      ...               fromfile: 'Original'
	      ...               tofile: 'Current',
	      ...               fromfiledate: '2005-01-26 23:30:50',
	      ...               tofiledate: '2010-04-02 10:20:52',
	      ...               lineterm: ''
	      ...             })
	      [ '--- Original\t2005-01-26 23:30:50',
	        '+++ Current\t2010-04-02 10:20:52',
	        '@@ -1,4 +1,4 @@',
	        '+zero',
	        ' one',
	        '-two',
	        '-three',
	        '+tree',
	        ' four' ]
	    */

	    if (fromfile == null) {
	      fromfile = '';
	    }
	    if (tofile == null) {
	      tofile = '';
	    }
	    if (fromfiledate == null) {
	      fromfiledate = '';
	    }
	    if (tofiledate == null) {
	      tofiledate = '';
	    }
	    if (n == null) {
	      n = 3;
	    }
	    if (lineterm == null) {
	      lineterm = '\n';
	    }
	    lines = [];
	    started = false;
	    _ref1 = (new SequenceMatcher(null, a, b)).getGroupedOpcodes();
	    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	      group = _ref1[_i];
	      if (!started) {
	        started = true;
	        fromdate = fromfiledate ? "\t" + fromfiledate : '';
	        todate = tofiledate ? "\t" + tofiledate : '';
	        lines.push("--- " + fromfile + fromdate + lineterm);
	        lines.push("+++ " + tofile + todate + lineterm);
	      }
	      _ref2 = [group[0], group[group.length - 1]], first = _ref2[0], last = _ref2[1];
	      file1Range = _formatRangeUnified(first[1], last[2]);
	      file2Range = _formatRangeUnified(first[3], last[4]);
	      lines.push("@@ -" + file1Range + " +" + file2Range + " @@" + lineterm);
	      for (_j = 0, _len1 = group.length; _j < _len1; _j++) {
	        _ref3 = group[_j], tag = _ref3[0], i1 = _ref3[1], i2 = _ref3[2], j1 = _ref3[3], j2 = _ref3[4];
	        if (tag === 'equal') {
	          _ref4 = a.slice(i1, i2);
	          for (_k = 0, _len2 = _ref4.length; _k < _len2; _k++) {
	            line = _ref4[_k];
	            lines.push(' ' + line);
	          }
	          continue;
	        }
	        if (tag === 'replace' || tag === 'delete') {
	          _ref5 = a.slice(i1, i2);
	          for (_l = 0, _len3 = _ref5.length; _l < _len3; _l++) {
	            line = _ref5[_l];
	            lines.push('-' + line);
	          }
	        }
	        if (tag === 'replace' || tag === 'insert') {
	          _ref6 = b.slice(j1, j2);
	          for (_m = 0, _len4 = _ref6.length; _m < _len4; _m++) {
	            line = _ref6[_m];
	            lines.push('+' + line);
	          }
	        }
	      }
	    }
	    return lines;
	  };

	  _formatRangeContext = function(start, stop) {
	    /*
	      Convert range to the "ed" format'
	    */

	    var beginning, length;
	    beginning = start + 1;
	    length = stop - start;
	    if (!length) {
	      beginning--;
	    }
	    if (length <= 1) {
	      return "" + beginning;
	    }
	    return "" + beginning + "," + (beginning + length - 1);
	  };

	  contextDiff = function(a, b, _arg) {
	    var file1Range, file2Range, first, fromdate, fromfile, fromfiledate, group, i1, i2, j1, j2, last, line, lines, lineterm, n, prefix, started, tag, todate, tofile, tofiledate, _, _i, _j, _k, _l, _len, _len1, _len2, _len3, _len4, _m, _ref, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6;
	    _ref = _arg != null ? _arg : {}, fromfile = _ref.fromfile, tofile = _ref.tofile, fromfiledate = _ref.fromfiledate, tofiledate = _ref.tofiledate, n = _ref.n, lineterm = _ref.lineterm;
	    /*
	      Compare two sequences of lines; generate the delta as a context diff.
	    
	      Context diffs are a compact way of showing line changes and a few
	      lines of context.  The number of context lines is set by 'n' which
	      defaults to three.
	    
	      By default, the diff control lines (those with *** or ---) are
	      created with a trailing newline.  This is helpful so that inputs
	      created from file.readlines() result in diffs that are suitable for
	      file.writelines() since both the inputs and outputs have trailing
	      newlines.
	    
	      For inputs that do not have trailing newlines, set the lineterm
	      argument to "" so that the output will be uniformly newline free.
	    
	      The context diff format normally has a header for filenames and
	      modification times.  Any or all of these may be specified using
	      strings for 'fromfile', 'tofile', 'fromfiledate', and 'tofiledate'.
	      The modification times are normally expressed in the ISO 8601 format.
	      If not specified, the strings default to blanks.
	    
	      Example:
	      >>> a = ['one\n', 'two\n', 'three\n', 'four\n']
	      >>> b = ['zero\n', 'one\n', 'tree\n', 'four\n']
	      >>> contextDiff(a, b, {fromfile: 'Original', tofile: 'Current'})
	      [ '*** Original\n',
	        '--- Current\n',
	        '***************\n',
	        '*** 1,4 ****\n',
	        '  one\n',
	        '! two\n',
	        '! three\n',
	        '  four\n',
	        '--- 1,4 ----\n',
	        '+ zero\n',
	        '  one\n',
	        '! tree\n',
	        '  four\n' ]
	    */

	    if (fromfile == null) {
	      fromfile = '';
	    }
	    if (tofile == null) {
	      tofile = '';
	    }
	    if (fromfiledate == null) {
	      fromfiledate = '';
	    }
	    if (tofiledate == null) {
	      tofiledate = '';
	    }
	    if (n == null) {
	      n = 3;
	    }
	    if (lineterm == null) {
	      lineterm = '\n';
	    }
	    prefix = {
	      insert: '+ ',
	      "delete": '- ',
	      replace: '! ',
	      equal: '  '
	    };
	    started = false;
	    lines = [];
	    _ref1 = (new SequenceMatcher(null, a, b)).getGroupedOpcodes();
	    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	      group = _ref1[_i];
	      if (!started) {
	        started = true;
	        fromdate = fromfiledate ? "\t" + fromfiledate : '';
	        todate = tofiledate ? "\t" + tofiledate : '';
	        lines.push("*** " + fromfile + fromdate + lineterm);
	        lines.push("--- " + tofile + todate + lineterm);
	        _ref2 = [group[0], group[group.length - 1]], first = _ref2[0], last = _ref2[1];
	        lines.push('***************' + lineterm);
	        file1Range = _formatRangeContext(first[1], last[2]);
	        lines.push("*** " + file1Range + " ****" + lineterm);
	        if (_any((function() {
	          var _j, _len1, _ref3, _results;
	          _results = [];
	          for (_j = 0, _len1 = group.length; _j < _len1; _j++) {
	            _ref3 = group[_j], tag = _ref3[0], _ = _ref3[1], _ = _ref3[2], _ = _ref3[3], _ = _ref3[4];
	            _results.push(tag === 'replace' || tag === 'delete');
	          }
	          return _results;
	        })())) {
	          for (_j = 0, _len1 = group.length; _j < _len1; _j++) {
	            _ref3 = group[_j], tag = _ref3[0], i1 = _ref3[1], i2 = _ref3[2], _ = _ref3[3], _ = _ref3[4];
	            if (tag !== 'insert') {
	              _ref4 = a.slice(i1, i2);
	              for (_k = 0, _len2 = _ref4.length; _k < _len2; _k++) {
	                line = _ref4[_k];
	                lines.push(prefix[tag] + line);
	              }
	            }
	          }
	        }
	        file2Range = _formatRangeContext(first[3], last[4]);
	        lines.push("--- " + file2Range + " ----" + lineterm);
	        if (_any((function() {
	          var _l, _len3, _ref5, _results;
	          _results = [];
	          for (_l = 0, _len3 = group.length; _l < _len3; _l++) {
	            _ref5 = group[_l], tag = _ref5[0], _ = _ref5[1], _ = _ref5[2], _ = _ref5[3], _ = _ref5[4];
	            _results.push(tag === 'replace' || tag === 'insert');
	          }
	          return _results;
	        })())) {
	          for (_l = 0, _len3 = group.length; _l < _len3; _l++) {
	            _ref5 = group[_l], tag = _ref5[0], _ = _ref5[1], _ = _ref5[2], j1 = _ref5[3], j2 = _ref5[4];
	            if (tag !== 'delete') {
	              _ref6 = b.slice(j1, j2);
	              for (_m = 0, _len4 = _ref6.length; _m < _len4; _m++) {
	                line = _ref6[_m];
	                lines.push(prefix[tag] + line);
	              }
	            }
	          }
	        }
	      }
	    }
	    return lines;
	  };

	  ndiff = function(a, b, linejunk, charjunk) {
	    if (charjunk == null) {
	      charjunk = IS_CHARACTER_JUNK;
	    }
	    /*
	      Compare `a` and `b` (lists of strings); return a `Differ`-style delta.
	    
	      Optional keyword parameters `linejunk` and `charjunk` are for filter
	      functions (or None):
	    
	      - linejunk: A function that should accept a single string argument, and
	        return true iff the string is junk.  The default is null, and is
	        recommended; 
	    
	      - charjunk: A function that should accept a string of length 1. The
	        default is module-level function IS_CHARACTER_JUNK, which filters out
	        whitespace characters (a blank or tab; note: bad idea to include newline
	        in this!).
	    
	      Example:
	      >>> a = ['one\n', 'two\n', 'three\n']
	      >>> b = ['ore\n', 'tree\n', 'emu\n']
	      >>> ndiff(a, b)
	      [ '- one\n',
	        '?  ^\n',
	        '+ ore\n',
	        '?  ^\n',
	        '- two\n',
	        '- three\n',
	        '?  -\n',
	        '+ tree\n',
	        '+ emu\n' ]
	    */

	    return (new Differ(linejunk, charjunk)).compare(a, b);
	  };

	  restore = function(delta, which) {
	    /*
	      Generate one of the two sequences that generated a delta.
	    
	      Given a `delta` produced by `Differ.compare()` or `ndiff()`, extract
	      lines originating from file 1 or 2 (parameter `which`), stripping off line
	      prefixes.
	    
	      Examples:
	      >>> a = ['one\n', 'two\n', 'three\n']
	      >>> b = ['ore\n', 'tree\n', 'emu\n']
	      >>> diff = ndiff(a, b)
	      >>> restore(diff, 1)
	      [ 'one\n',
	        'two\n',
	        'three\n' ]
	      >>> restore(diff, 2)
	      [ 'ore\n',
	        'tree\n',
	        'emu\n' ]
	    */

	    var line, lines, prefixes, tag, _i, _len, _ref;
	    tag = {
	      1: '- ',
	      2: '+ '
	    }[which];
	    if (!tag) {
	      throw new Error("unknow delta choice (must be 1 or 2): " + which);
	    }
	    prefixes = ['  ', tag];
	    lines = [];
	    for (_i = 0, _len = delta.length; _i < _len; _i++) {
	      line = delta[_i];
	      if (_ref = line.slice(0, 2), __indexOf.call(prefixes, _ref) >= 0) {
	        lines.push(line.slice(2));
	      }
	    }
	    return lines;
	  };

	  exports._arrayCmp = _arrayCmp;

	  exports.SequenceMatcher = SequenceMatcher;

	  exports.getCloseMatches = getCloseMatches;

	  exports._countLeading = _countLeading;

	  exports.Differ = Differ;

	  exports.IS_LINE_JUNK = IS_LINE_JUNK;

	  exports.IS_CHARACTER_JUNK = IS_CHARACTER_JUNK;

	  exports._formatRangeUnified = _formatRangeUnified;

	  exports.unifiedDiff = unifiedDiff;

	  exports._formatRangeContext = _formatRangeContext;

	  exports.contextDiff = contextDiff;

	  exports.ndiff = ndiff;

	  exports.restore = restore;

	}).call(this);


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(151);


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Generated by CoffeeScript 1.8.0
	(function() {
	  var Heap, defaultCmp, floor, heapify, heappop, heappush, heappushpop, heapreplace, insort, min, nlargest, nsmallest, updateItem, _siftdown, _siftup;

	  floor = Math.floor, min = Math.min;


	  /*
	  Default comparison function to be used
	   */

	  defaultCmp = function(x, y) {
	    if (x < y) {
	      return -1;
	    }
	    if (x > y) {
	      return 1;
	    }
	    return 0;
	  };


	  /*
	  Insert item x in list a, and keep it sorted assuming a is sorted.
	  
	  If x is already in a, insert it to the right of the rightmost x.
	  
	  Optional args lo (default 0) and hi (default a.length) bound the slice
	  of a to be searched.
	   */

	  insort = function(a, x, lo, hi, cmp) {
	    var mid;
	    if (lo == null) {
	      lo = 0;
	    }
	    if (cmp == null) {
	      cmp = defaultCmp;
	    }
	    if (lo < 0) {
	      throw new Error('lo must be non-negative');
	    }
	    if (hi == null) {
	      hi = a.length;
	    }
	    while (lo < hi) {
	      mid = floor((lo + hi) / 2);
	      if (cmp(x, a[mid]) < 0) {
	        hi = mid;
	      } else {
	        lo = mid + 1;
	      }
	    }
	    return ([].splice.apply(a, [lo, lo - lo].concat(x)), x);
	  };


	  /*
	  Push item onto heap, maintaining the heap invariant.
	   */

	  heappush = function(array, item, cmp) {
	    if (cmp == null) {
	      cmp = defaultCmp;
	    }
	    array.push(item);
	    return _siftdown(array, 0, array.length - 1, cmp);
	  };


	  /*
	  Pop the smallest item off the heap, maintaining the heap invariant.
	   */

	  heappop = function(array, cmp) {
	    var lastelt, returnitem;
	    if (cmp == null) {
	      cmp = defaultCmp;
	    }
	    lastelt = array.pop();
	    if (array.length) {
	      returnitem = array[0];
	      array[0] = lastelt;
	      _siftup(array, 0, cmp);
	    } else {
	      returnitem = lastelt;
	    }
	    return returnitem;
	  };


	  /*
	  Pop and return the current smallest value, and add the new item.
	  
	  This is more efficient than heappop() followed by heappush(), and can be
	  more appropriate when using a fixed size heap. Note that the value
	  returned may be larger than item! That constrains reasonable use of
	  this routine unless written as part of a conditional replacement:
	      if item > array[0]
	        item = heapreplace(array, item)
	   */

	  heapreplace = function(array, item, cmp) {
	    var returnitem;
	    if (cmp == null) {
	      cmp = defaultCmp;
	    }
	    returnitem = array[0];
	    array[0] = item;
	    _siftup(array, 0, cmp);
	    return returnitem;
	  };


	  /*
	  Fast version of a heappush followed by a heappop.
	   */

	  heappushpop = function(array, item, cmp) {
	    var _ref;
	    if (cmp == null) {
	      cmp = defaultCmp;
	    }
	    if (array.length && cmp(array[0], item) < 0) {
	      _ref = [array[0], item], item = _ref[0], array[0] = _ref[1];
	      _siftup(array, 0, cmp);
	    }
	    return item;
	  };


	  /*
	  Transform list into a heap, in-place, in O(array.length) time.
	   */

	  heapify = function(array, cmp) {
	    var i, _i, _j, _len, _ref, _ref1, _results, _results1;
	    if (cmp == null) {
	      cmp = defaultCmp;
	    }
	    _ref1 = (function() {
	      _results1 = [];
	      for (var _j = 0, _ref = floor(array.length / 2); 0 <= _ref ? _j < _ref : _j > _ref; 0 <= _ref ? _j++ : _j--){ _results1.push(_j); }
	      return _results1;
	    }).apply(this).reverse();
	    _results = [];
	    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
	      i = _ref1[_i];
	      _results.push(_siftup(array, i, cmp));
	    }
	    return _results;
	  };


	  /*
	  Update the position of the given item in the heap.
	  This function should be called every time the item is being modified.
	   */

	  updateItem = function(array, item, cmp) {
	    var pos;
	    if (cmp == null) {
	      cmp = defaultCmp;
	    }
	    pos = array.indexOf(item);
	    if (pos === -1) {
	      return;
	    }
	    _siftdown(array, 0, pos, cmp);
	    return _siftup(array, pos, cmp);
	  };


	  /*
	  Find the n largest elements in a dataset.
	   */

	  nlargest = function(array, n, cmp) {
	    var elem, result, _i, _len, _ref;
	    if (cmp == null) {
	      cmp = defaultCmp;
	    }
	    result = array.slice(0, n);
	    if (!result.length) {
	      return result;
	    }
	    heapify(result, cmp);
	    _ref = array.slice(n);
	    for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	      elem = _ref[_i];
	      heappushpop(result, elem, cmp);
	    }
	    return result.sort(cmp).reverse();
	  };


	  /*
	  Find the n smallest elements in a dataset.
	   */

	  nsmallest = function(array, n, cmp) {
	    var elem, i, los, result, _i, _j, _len, _ref, _ref1, _results;
	    if (cmp == null) {
	      cmp = defaultCmp;
	    }
	    if (n * 10 <= array.length) {
	      result = array.slice(0, n).sort(cmp);
	      if (!result.length) {
	        return result;
	      }
	      los = result[result.length - 1];
	      _ref = array.slice(n);
	      for (_i = 0, _len = _ref.length; _i < _len; _i++) {
	        elem = _ref[_i];
	        if (cmp(elem, los) < 0) {
	          insort(result, elem, 0, null, cmp);
	          result.pop();
	          los = result[result.length - 1];
	        }
	      }
	      return result;
	    }
	    heapify(array, cmp);
	    _results = [];
	    for (i = _j = 0, _ref1 = min(n, array.length); 0 <= _ref1 ? _j < _ref1 : _j > _ref1; i = 0 <= _ref1 ? ++_j : --_j) {
	      _results.push(heappop(array, cmp));
	    }
	    return _results;
	  };

	  _siftdown = function(array, startpos, pos, cmp) {
	    var newitem, parent, parentpos;
	    if (cmp == null) {
	      cmp = defaultCmp;
	    }
	    newitem = array[pos];
	    while (pos > startpos) {
	      parentpos = (pos - 1) >> 1;
	      parent = array[parentpos];
	      if (cmp(newitem, parent) < 0) {
	        array[pos] = parent;
	        pos = parentpos;
	        continue;
	      }
	      break;
	    }
	    return array[pos] = newitem;
	  };

	  _siftup = function(array, pos, cmp) {
	    var childpos, endpos, newitem, rightpos, startpos;
	    if (cmp == null) {
	      cmp = defaultCmp;
	    }
	    endpos = array.length;
	    startpos = pos;
	    newitem = array[pos];
	    childpos = 2 * pos + 1;
	    while (childpos < endpos) {
	      rightpos = childpos + 1;
	      if (rightpos < endpos && !(cmp(array[childpos], array[rightpos]) < 0)) {
	        childpos = rightpos;
	      }
	      array[pos] = array[childpos];
	      pos = childpos;
	      childpos = 2 * pos + 1;
	    }
	    array[pos] = newitem;
	    return _siftdown(array, startpos, pos, cmp);
	  };

	  Heap = (function() {
	    Heap.push = heappush;

	    Heap.pop = heappop;

	    Heap.replace = heapreplace;

	    Heap.pushpop = heappushpop;

	    Heap.heapify = heapify;

	    Heap.updateItem = updateItem;

	    Heap.nlargest = nlargest;

	    Heap.nsmallest = nsmallest;

	    function Heap(cmp) {
	      this.cmp = cmp != null ? cmp : defaultCmp;
	      this.nodes = [];
	    }

	    Heap.prototype.push = function(x) {
	      return heappush(this.nodes, x, this.cmp);
	    };

	    Heap.prototype.pop = function() {
	      return heappop(this.nodes, this.cmp);
	    };

	    Heap.prototype.peek = function() {
	      return this.nodes[0];
	    };

	    Heap.prototype.contains = function(x) {
	      return this.nodes.indexOf(x) !== -1;
	    };

	    Heap.prototype.replace = function(x) {
	      return heapreplace(this.nodes, x, this.cmp);
	    };

	    Heap.prototype.pushpop = function(x) {
	      return heappushpop(this.nodes, x, this.cmp);
	    };

	    Heap.prototype.heapify = function() {
	      return heapify(this.nodes, this.cmp);
	    };

	    Heap.prototype.updateItem = function(x) {
	      return updateItem(this.nodes, x, this.cmp);
	    };

	    Heap.prototype.clear = function() {
	      return this.nodes = [];
	    };

	    Heap.prototype.empty = function() {
	      return this.nodes.length === 0;
	    };

	    Heap.prototype.size = function() {
	      return this.nodes.length;
	    };

	    Heap.prototype.clone = function() {
	      var heap;
	      heap = new Heap();
	      heap.nodes = this.nodes.slice(0);
	      return heap;
	    };

	    Heap.prototype.toArray = function() {
	      return this.nodes.slice(0);
	    };

	    Heap.prototype.insert = Heap.prototype.push;

	    Heap.prototype.top = Heap.prototype.peek;

	    Heap.prototype.front = Heap.prototype.peek;

	    Heap.prototype.has = Heap.prototype.contains;

	    Heap.prototype.copy = Heap.prototype.clone;

	    return Heap;

	  })();

	  (function(root, factory) {
	    if (true) {
	      return !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	      return module.exports = factory();
	    } else {
	      return root.Heap = factory();
	    }
	  })(this, function() {
	    return Heap;
	  });

	}).call(this);


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';

	// compare and isBuffer taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
	// original notice:

	/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	function compare(a, b) {
	  if (a === b) {
	    return 0;
	  }

	  var x = a.length;
	  var y = b.length;

	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i];
	      y = b[i];
	      break;
	    }
	  }

	  if (x < y) {
	    return -1;
	  }
	  if (y < x) {
	    return 1;
	  }
	  return 0;
	}
	function isBuffer(b) {
	  if (global.Buffer && typeof global.Buffer.isBuffer === 'function') {
	    return global.Buffer.isBuffer(b);
	  }
	  return !!(b != null && b._isBuffer);
	}

	// based on node assert, original notice:

	// http://wiki.commonjs.org/wiki/Unit_Testing/1.0
	//
	// THIS IS NOT TESTED NOR LIKELY TO WORK OUTSIDE V8!
	//
	// Originally from narwhal.js (http://narwhaljs.org)
	// Copyright (c) 2009 Thomas Robinson <280north.com>
	//
	// Permission is hereby granted, free of charge, to any person obtaining a copy
	// of this software and associated documentation files (the 'Software'), to
	// deal in the Software without restriction, including without limitation the
	// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
	// sell copies of the Software, and to permit persons to whom the Software is
	// furnished to do so, subject to the following conditions:
	//
	// The above copyright notice and this permission notice shall be included in
	// all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
	// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
	// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

	var util = __webpack_require__(153);
	var hasOwn = Object.prototype.hasOwnProperty;
	var pSlice = Array.prototype.slice;
	var functionsHaveNames = (function () {
	  return function foo() {}.name === 'foo';
	}());
	function pToString (obj) {
	  return Object.prototype.toString.call(obj);
	}
	function isView(arrbuf) {
	  if (isBuffer(arrbuf)) {
	    return false;
	  }
	  if (typeof global.ArrayBuffer !== 'function') {
	    return false;
	  }
	  if (typeof ArrayBuffer.isView === 'function') {
	    return ArrayBuffer.isView(arrbuf);
	  }
	  if (!arrbuf) {
	    return false;
	  }
	  if (arrbuf instanceof DataView) {
	    return true;
	  }
	  if (arrbuf.buffer && arrbuf.buffer instanceof ArrayBuffer) {
	    return true;
	  }
	  return false;
	}
	// 1. The assert module provides functions that throw
	// AssertionError's when particular conditions are not met. The
	// assert module must conform to the following interface.

	var assert = module.exports = ok;

	// 2. The AssertionError is defined in assert.
	// new assert.AssertionError({ message: message,
	//                             actual: actual,
	//                             expected: expected })

	var regex = /\s*function\s+([^\(\s]*)\s*/;
	// based on https://github.com/ljharb/function.prototype.name/blob/adeeeec8bfcc6068b187d7d9fb3d5bb1d3a30899/implementation.js
	function getName(func) {
	  if (!util.isFunction(func)) {
	    return;
	  }
	  if (functionsHaveNames) {
	    return func.name;
	  }
	  var str = func.toString();
	  var match = str.match(regex);
	  return match && match[1];
	}
	assert.AssertionError = function AssertionError(options) {
	  this.name = 'AssertionError';
	  this.actual = options.actual;
	  this.expected = options.expected;
	  this.operator = options.operator;
	  if (options.message) {
	    this.message = options.message;
	    this.generatedMessage = false;
	  } else {
	    this.message = getMessage(this);
	    this.generatedMessage = true;
	  }
	  var stackStartFunction = options.stackStartFunction || fail;
	  if (Error.captureStackTrace) {
	    Error.captureStackTrace(this, stackStartFunction);
	  } else {
	    // non v8 browsers so we can have a stacktrace
	    var err = new Error();
	    if (err.stack) {
	      var out = err.stack;

	      // try to strip useless frames
	      var fn_name = getName(stackStartFunction);
	      var idx = out.indexOf('\n' + fn_name);
	      if (idx >= 0) {
	        // once we have located the function frame
	        // we need to strip out everything before it (and its line)
	        var next_line = out.indexOf('\n', idx + 1);
	        out = out.substring(next_line + 1);
	      }

	      this.stack = out;
	    }
	  }
	};

	// assert.AssertionError instanceof Error
	util.inherits(assert.AssertionError, Error);

	function truncate(s, n) {
	  if (typeof s === 'string') {
	    return s.length < n ? s : s.slice(0, n);
	  } else {
	    return s;
	  }
	}
	function inspect(something) {
	  if (functionsHaveNames || !util.isFunction(something)) {
	    return util.inspect(something);
	  }
	  var rawname = getName(something);
	  var name = rawname ? ': ' + rawname : '';
	  return '[Function' +  name + ']';
	}
	function getMessage(self) {
	  return truncate(inspect(self.actual), 128) + ' ' +
	         self.operator + ' ' +
	         truncate(inspect(self.expected), 128);
	}

	// At present only the three keys mentioned above are used and
	// understood by the spec. Implementations or sub modules can pass
	// other keys to the AssertionError's constructor - they will be
	// ignored.

	// 3. All of the following functions must throw an AssertionError
	// when a corresponding condition is not met, with a message that
	// may be undefined if not provided.  All assertion methods provide
	// both the actual and expected values to the assertion error for
	// display purposes.

	function fail(actual, expected, message, operator, stackStartFunction) {
	  throw new assert.AssertionError({
	    message: message,
	    actual: actual,
	    expected: expected,
	    operator: operator,
	    stackStartFunction: stackStartFunction
	  });
	}

	// EXTENSION! allows for well behaved errors defined elsewhere.
	assert.fail = fail;

	// 4. Pure assertion tests whether a value is truthy, as determined
	// by !!guard.
	// assert.ok(guard, message_opt);
	// This statement is equivalent to assert.equal(true, !!guard,
	// message_opt);. To test strictly for the value true, use
	// assert.strictEqual(true, guard, message_opt);.

	function ok(value, message) {
	  if (!value) fail(value, true, message, '==', assert.ok);
	}
	assert.ok = ok;

	// 5. The equality assertion tests shallow, coercive equality with
	// ==.
	// assert.equal(actual, expected, message_opt);

	assert.equal = function equal(actual, expected, message) {
	  if (actual != expected) fail(actual, expected, message, '==', assert.equal);
	};

	// 6. The non-equality assertion tests for whether two objects are not equal
	// with != assert.notEqual(actual, expected, message_opt);

	assert.notEqual = function notEqual(actual, expected, message) {
	  if (actual == expected) {
	    fail(actual, expected, message, '!=', assert.notEqual);
	  }
	};

	// 7. The equivalence assertion tests a deep equality relation.
	// assert.deepEqual(actual, expected, message_opt);

	assert.deepEqual = function deepEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'deepEqual', assert.deepEqual);
	  }
	};

	assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
	  if (!_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'deepStrictEqual', assert.deepStrictEqual);
	  }
	};

	function _deepEqual(actual, expected, strict, memos) {
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	  } else if (isBuffer(actual) && isBuffer(expected)) {
	    return compare(actual, expected) === 0;

	  // 7.2. If the expected value is a Date object, the actual value is
	  // equivalent if it is also a Date object that refers to the same time.
	  } else if (util.isDate(actual) && util.isDate(expected)) {
	    return actual.getTime() === expected.getTime();

	  // 7.3 If the expected value is a RegExp object, the actual value is
	  // equivalent if it is also a RegExp object with the same source and
	  // properties (`global`, `multiline`, `lastIndex`, `ignoreCase`).
	  } else if (util.isRegExp(actual) && util.isRegExp(expected)) {
	    return actual.source === expected.source &&
	           actual.global === expected.global &&
	           actual.multiline === expected.multiline &&
	           actual.lastIndex === expected.lastIndex &&
	           actual.ignoreCase === expected.ignoreCase;

	  // 7.4. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if ((actual === null || typeof actual !== 'object') &&
	             (expected === null || typeof expected !== 'object')) {
	    return strict ? actual === expected : actual == expected;

	  // If both values are instances of typed arrays, wrap their underlying
	  // ArrayBuffers in a Buffer each to increase performance
	  // This optimization requires the arrays to have the same type as checked by
	  // Object.prototype.toString (aka pToString). Never perform binary
	  // comparisons for Float*Arrays, though, since e.g. +0 === -0 but their
	  // bit patterns are not identical.
	  } else if (isView(actual) && isView(expected) &&
	             pToString(actual) === pToString(expected) &&
	             !(actual instanceof Float32Array ||
	               actual instanceof Float64Array)) {
	    return compare(new Uint8Array(actual.buffer),
	                   new Uint8Array(expected.buffer)) === 0;

	  // 7.5 For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else if (isBuffer(actual) !== isBuffer(expected)) {
	    return false;
	  } else {
	    memos = memos || {actual: [], expected: []};

	    var actualIndex = memos.actual.indexOf(actual);
	    if (actualIndex !== -1) {
	      if (actualIndex === memos.expected.indexOf(expected)) {
	        return true;
	      }
	    }

	    memos.actual.push(actual);
	    memos.expected.push(expected);

	    return objEquiv(actual, expected, strict, memos);
	  }
	}

	function isArguments(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	}

	function objEquiv(a, b, strict, actualVisitedObjects) {
	  if (a === null || a === undefined || b === null || b === undefined)
	    return false;
	  // if one is a primitive, the other must be same
	  if (util.isPrimitive(a) || util.isPrimitive(b))
	    return a === b;
	  if (strict && Object.getPrototypeOf(a) !== Object.getPrototypeOf(b))
	    return false;
	  var aIsArgs = isArguments(a);
	  var bIsArgs = isArguments(b);
	  if ((aIsArgs && !bIsArgs) || (!aIsArgs && bIsArgs))
	    return false;
	  if (aIsArgs) {
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return _deepEqual(a, b, strict);
	  }
	  var ka = objectKeys(a);
	  var kb = objectKeys(b);
	  var key, i;
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length !== kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] !== kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!_deepEqual(a[key], b[key], strict, actualVisitedObjects))
	      return false;
	  }
	  return true;
	}

	// 8. The non-equivalence assertion tests for any deep inequality.
	// assert.notDeepEqual(actual, expected, message_opt);

	assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, false)) {
	    fail(actual, expected, message, 'notDeepEqual', assert.notDeepEqual);
	  }
	};

	assert.notDeepStrictEqual = notDeepStrictEqual;
	function notDeepStrictEqual(actual, expected, message) {
	  if (_deepEqual(actual, expected, true)) {
	    fail(actual, expected, message, 'notDeepStrictEqual', notDeepStrictEqual);
	  }
	}


	// 9. The strict equality assertion tests strict equality, as determined by ===.
	// assert.strictEqual(actual, expected, message_opt);

	assert.strictEqual = function strictEqual(actual, expected, message) {
	  if (actual !== expected) {
	    fail(actual, expected, message, '===', assert.strictEqual);
	  }
	};

	// 10. The strict non-equality assertion tests for strict inequality, as
	// determined by !==.  assert.notStrictEqual(actual, expected, message_opt);

	assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
	  if (actual === expected) {
	    fail(actual, expected, message, '!==', assert.notStrictEqual);
	  }
	};

	function expectedException(actual, expected) {
	  if (!actual || !expected) {
	    return false;
	  }

	  if (Object.prototype.toString.call(expected) == '[object RegExp]') {
	    return expected.test(actual);
	  }

	  try {
	    if (actual instanceof expected) {
	      return true;
	    }
	  } catch (e) {
	    // Ignore.  The instanceof check doesn't work for arrow functions.
	  }

	  if (Error.isPrototypeOf(expected)) {
	    return false;
	  }

	  return expected.call({}, actual) === true;
	}

	function _tryBlock(block) {
	  var error;
	  try {
	    block();
	  } catch (e) {
	    error = e;
	  }
	  return error;
	}

	function _throws(shouldThrow, block, expected, message) {
	  var actual;

	  if (typeof block !== 'function') {
	    throw new TypeError('"block" argument must be a function');
	  }

	  if (typeof expected === 'string') {
	    message = expected;
	    expected = null;
	  }

	  actual = _tryBlock(block);

	  message = (expected && expected.name ? ' (' + expected.name + ').' : '.') +
	            (message ? ' ' + message : '.');

	  if (shouldThrow && !actual) {
	    fail(actual, expected, 'Missing expected exception' + message);
	  }

	  var userProvidedMessage = typeof message === 'string';
	  var isUnwantedException = !shouldThrow && util.isError(actual);
	  var isUnexpectedException = !shouldThrow && actual && !expected;

	  if ((isUnwantedException &&
	      userProvidedMessage &&
	      expectedException(actual, expected)) ||
	      isUnexpectedException) {
	    fail(actual, expected, 'Got unwanted exception' + message);
	  }

	  if ((shouldThrow && actual && expected &&
	      !expectedException(actual, expected)) || (!shouldThrow && actual)) {
	    throw actual;
	  }
	}

	// 11. Expected to throw an error:
	// assert.throws(block, Error_opt, message_opt);

	assert.throws = function(block, /*optional*/error, /*optional*/message) {
	  _throws(true, block, error, message);
	};

	// EXTENSION! This is annoying to write outside this module.
	assert.doesNotThrow = function(block, /*optional*/error, /*optional*/message) {
	  _throws(false, block, error, message);
	};

	assert.ifError = function(err) { if (err) throw err; };

	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    if (hasOwn.call(obj, key)) keys.push(key);
	  }
	  return keys;
	};

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.

	var formatRegExp = /%[sdj%]/g;
	exports.format = function(f) {
	  if (!isString(f)) {
	    var objects = [];
	    for (var i = 0; i < arguments.length; i++) {
	      objects.push(inspect(arguments[i]));
	    }
	    return objects.join(' ');
	  }

	  var i = 1;
	  var args = arguments;
	  var len = args.length;
	  var str = String(f).replace(formatRegExp, function(x) {
	    if (x === '%%') return '%';
	    if (i >= len) return x;
	    switch (x) {
	      case '%s': return String(args[i++]);
	      case '%d': return Number(args[i++]);
	      case '%j':
	        try {
	          return JSON.stringify(args[i++]);
	        } catch (_) {
	          return '[Circular]';
	        }
	      default:
	        return x;
	    }
	  });
	  for (var x = args[i]; i < len; x = args[++i]) {
	    if (isNull(x) || !isObject(x)) {
	      str += ' ' + x;
	    } else {
	      str += ' ' + inspect(x);
	    }
	  }
	  return str;
	};


	// Mark that a method should not be used.
	// Returns a modified function which warns once by default.
	// If --no-deprecation is set, then it is a no-op.
	exports.deprecate = function(fn, msg) {
	  // Allow for deprecating things in the process of starting up.
	  if (isUndefined(global.process)) {
	    return function() {
	      return exports.deprecate(fn, msg).apply(this, arguments);
	    };
	  }

	  if (process.noDeprecation === true) {
	    return fn;
	  }

	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (process.throwDeprecation) {
	        throw new Error(msg);
	      } else if (process.traceDeprecation) {
	        console.trace(msg);
	      } else {
	        console.error(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }

	  return deprecated;
	};


	var debugs = {};
	var debugEnviron;
	exports.debuglog = function(set) {
	  if (isUndefined(debugEnviron))
	    debugEnviron = process.env.NODE_DEBUG || '';
	  set = set.toUpperCase();
	  if (!debugs[set]) {
	    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
	      var pid = process.pid;
	      debugs[set] = function() {
	        var msg = exports.format.apply(exports, arguments);
	        console.error('%s %d: %s', set, pid, msg);
	      };
	    } else {
	      debugs[set] = function() {};
	    }
	  }
	  return debugs[set];
	};


	/**
	 * Echos the value of a value. Trys to print the value out
	 * in the best way possible given the different types.
	 *
	 * @param {Object} obj The object to print out.
	 * @param {Object} opts Optional options object that alters the output.
	 */
	/* legacy: obj, showHidden, depth, colors*/
	function inspect(obj, opts) {
	  // default options
	  var ctx = {
	    seen: [],
	    stylize: stylizeNoColor
	  };
	  // legacy...
	  if (arguments.length >= 3) ctx.depth = arguments[2];
	  if (arguments.length >= 4) ctx.colors = arguments[3];
	  if (isBoolean(opts)) {
	    // legacy...
	    ctx.showHidden = opts;
	  } else if (opts) {
	    // got an "options" object
	    exports._extend(ctx, opts);
	  }
	  // set default options
	  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
	  if (isUndefined(ctx.depth)) ctx.depth = 2;
	  if (isUndefined(ctx.colors)) ctx.colors = false;
	  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
	  if (ctx.colors) ctx.stylize = stylizeWithColor;
	  return formatValue(ctx, obj, ctx.depth);
	}
	exports.inspect = inspect;


	// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
	inspect.colors = {
	  'bold' : [1, 22],
	  'italic' : [3, 23],
	  'underline' : [4, 24],
	  'inverse' : [7, 27],
	  'white' : [37, 39],
	  'grey' : [90, 39],
	  'black' : [30, 39],
	  'blue' : [34, 39],
	  'cyan' : [36, 39],
	  'green' : [32, 39],
	  'magenta' : [35, 39],
	  'red' : [31, 39],
	  'yellow' : [33, 39]
	};

	// Don't use 'blue' not visible on cmd.exe
	inspect.styles = {
	  'special': 'cyan',
	  'number': 'yellow',
	  'boolean': 'yellow',
	  'undefined': 'grey',
	  'null': 'bold',
	  'string': 'green',
	  'date': 'magenta',
	  // "name": intentionally not styling
	  'regexp': 'red'
	};


	function stylizeWithColor(str, styleType) {
	  var style = inspect.styles[styleType];

	  if (style) {
	    return '\u001b[' + inspect.colors[style][0] + 'm' + str +
	           '\u001b[' + inspect.colors[style][1] + 'm';
	  } else {
	    return str;
	  }
	}


	function stylizeNoColor(str, styleType) {
	  return str;
	}


	function arrayToHash(array) {
	  var hash = {};

	  array.forEach(function(val, idx) {
	    hash[val] = true;
	  });

	  return hash;
	}


	function formatValue(ctx, value, recurseTimes) {
	  // Provide a hook for user-specified inspect functions.
	  // Check that value is an object with an inspect function on it
	  if (ctx.customInspect &&
	      value &&
	      isFunction(value.inspect) &&
	      // Filter out the util module, it's inspect function is special
	      value.inspect !== exports.inspect &&
	      // Also filter out any prototype objects using the circular check.
	      !(value.constructor && value.constructor.prototype === value)) {
	    var ret = value.inspect(recurseTimes, ctx);
	    if (!isString(ret)) {
	      ret = formatValue(ctx, ret, recurseTimes);
	    }
	    return ret;
	  }

	  // Primitive types cannot have properties
	  var primitive = formatPrimitive(ctx, value);
	  if (primitive) {
	    return primitive;
	  }

	  // Look up the keys of the object.
	  var keys = Object.keys(value);
	  var visibleKeys = arrayToHash(keys);

	  if (ctx.showHidden) {
	    keys = Object.getOwnPropertyNames(value);
	  }

	  // IE doesn't make error fields non-enumerable
	  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
	  if (isError(value)
	      && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
	    return formatError(value);
	  }

	  // Some type of object without properties can be shortcutted.
	  if (keys.length === 0) {
	    if (isFunction(value)) {
	      var name = value.name ? ': ' + value.name : '';
	      return ctx.stylize('[Function' + name + ']', 'special');
	    }
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    }
	    if (isDate(value)) {
	      return ctx.stylize(Date.prototype.toString.call(value), 'date');
	    }
	    if (isError(value)) {
	      return formatError(value);
	    }
	  }

	  var base = '', array = false, braces = ['{', '}'];

	  // Make Array say that they are Array
	  if (isArray(value)) {
	    array = true;
	    braces = ['[', ']'];
	  }

	  // Make functions say that they are functions
	  if (isFunction(value)) {
	    var n = value.name ? ': ' + value.name : '';
	    base = ' [Function' + n + ']';
	  }

	  // Make RegExps say that they are RegExps
	  if (isRegExp(value)) {
	    base = ' ' + RegExp.prototype.toString.call(value);
	  }

	  // Make dates with properties first say the date
	  if (isDate(value)) {
	    base = ' ' + Date.prototype.toUTCString.call(value);
	  }

	  // Make error with message first say the error
	  if (isError(value)) {
	    base = ' ' + formatError(value);
	  }

	  if (keys.length === 0 && (!array || value.length == 0)) {
	    return braces[0] + base + braces[1];
	  }

	  if (recurseTimes < 0) {
	    if (isRegExp(value)) {
	      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
	    } else {
	      return ctx.stylize('[Object]', 'special');
	    }
	  }

	  ctx.seen.push(value);

	  var output;
	  if (array) {
	    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
	  } else {
	    output = keys.map(function(key) {
	      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
	    });
	  }

	  ctx.seen.pop();

	  return reduceToSingleString(output, base, braces);
	}


	function formatPrimitive(ctx, value) {
	  if (isUndefined(value))
	    return ctx.stylize('undefined', 'undefined');
	  if (isString(value)) {
	    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '')
	                                             .replace(/'/g, "\\'")
	                                             .replace(/\\"/g, '"') + '\'';
	    return ctx.stylize(simple, 'string');
	  }
	  if (isNumber(value))
	    return ctx.stylize('' + value, 'number');
	  if (isBoolean(value))
	    return ctx.stylize('' + value, 'boolean');
	  // For some reason typeof null is "object", so special case here.
	  if (isNull(value))
	    return ctx.stylize('null', 'null');
	}


	function formatError(value) {
	  return '[' + Error.prototype.toString.call(value) + ']';
	}


	function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
	  var output = [];
	  for (var i = 0, l = value.length; i < l; ++i) {
	    if (hasOwnProperty(value, String(i))) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          String(i), true));
	    } else {
	      output.push('');
	    }
	  }
	  keys.forEach(function(key) {
	    if (!key.match(/^\d+$/)) {
	      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys,
	          key, true));
	    }
	  });
	  return output;
	}


	function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
	  var name, str, desc;
	  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
	  if (desc.get) {
	    if (desc.set) {
	      str = ctx.stylize('[Getter/Setter]', 'special');
	    } else {
	      str = ctx.stylize('[Getter]', 'special');
	    }
	  } else {
	    if (desc.set) {
	      str = ctx.stylize('[Setter]', 'special');
	    }
	  }
	  if (!hasOwnProperty(visibleKeys, key)) {
	    name = '[' + key + ']';
	  }
	  if (!str) {
	    if (ctx.seen.indexOf(desc.value) < 0) {
	      if (isNull(recurseTimes)) {
	        str = formatValue(ctx, desc.value, null);
	      } else {
	        str = formatValue(ctx, desc.value, recurseTimes - 1);
	      }
	      if (str.indexOf('\n') > -1) {
	        if (array) {
	          str = str.split('\n').map(function(line) {
	            return '  ' + line;
	          }).join('\n').substr(2);
	        } else {
	          str = '\n' + str.split('\n').map(function(line) {
	            return '   ' + line;
	          }).join('\n');
	        }
	      }
	    } else {
	      str = ctx.stylize('[Circular]', 'special');
	    }
	  }
	  if (isUndefined(name)) {
	    if (array && key.match(/^\d+$/)) {
	      return str;
	    }
	    name = JSON.stringify('' + key);
	    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
	      name = name.substr(1, name.length - 2);
	      name = ctx.stylize(name, 'name');
	    } else {
	      name = name.replace(/'/g, "\\'")
	                 .replace(/\\"/g, '"')
	                 .replace(/(^"|"$)/g, "'");
	      name = ctx.stylize(name, 'string');
	    }
	  }

	  return name + ': ' + str;
	}


	function reduceToSingleString(output, base, braces) {
	  var numLinesEst = 0;
	  var length = output.reduce(function(prev, cur) {
	    numLinesEst++;
	    if (cur.indexOf('\n') >= 0) numLinesEst++;
	    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
	  }, 0);

	  if (length > 60) {
	    return braces[0] +
	           (base === '' ? '' : base + '\n ') +
	           ' ' +
	           output.join(',\n  ') +
	           ' ' +
	           braces[1];
	  }

	  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
	}


	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	function isArray(ar) {
	  return Array.isArray(ar);
	}
	exports.isArray = isArray;

	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;

	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;

	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;

	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;

	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;

	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;

	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;

	function isRegExp(re) {
	  return isObject(re) && objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;

	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;

	function isDate(d) {
	  return isObject(d) && objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;

	function isError(e) {
	  return isObject(e) &&
	      (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;

	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;

	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;

	exports.isBuffer = __webpack_require__(154);

	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}


	function pad(n) {
	  return n < 10 ? '0' + n.toString(10) : n.toString(10);
	}


	var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep',
	              'Oct', 'Nov', 'Dec'];

	// 26 Feb 16:19:34
	function timestamp() {
	  var d = new Date();
	  var time = [pad(d.getHours()),
	              pad(d.getMinutes()),
	              pad(d.getSeconds())].join(':');
	  return [d.getDate(), months[d.getMonth()], time].join(' ');
	}


	// log is just a thin wrapper to console.log that prepends a timestamp
	exports.log = function() {
	  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
	};


	/**
	 * Inherit the prototype methods from one constructor into another.
	 *
	 * The Function.prototype.inherits from lang.js rewritten as a standalone
	 * function (not on Function.prototype). NOTE: If this file is to be loaded
	 * during bootstrapping this function needs to be rewritten using some native
	 * functions as prototype setup using normal JavaScript does not work as
	 * expected during bootstrapping (see mirror.js in r114903).
	 *
	 * @param {function} ctor Constructor function which needs to inherit the
	 *     prototype.
	 * @param {function} superCtor Constructor function to inherit prototype from.
	 */
	exports.inherits = __webpack_require__(155);

	exports._extend = function(origin, add) {
	  // Don't do anything if add isn't an object
	  if (!add || !isObject(add)) return origin;

	  var keys = Object.keys(add);
	  var i = keys.length;
	  while (i--) {
	    origin[keys[i]] = add[keys[i]];
	  }
	  return origin;
	};

	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}

	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(47)))

/***/ }),
/* 154 */
/***/ (function(module, exports) {

	module.exports = function isBuffer(arg) {
	  return arg && typeof arg === 'object'
	    && typeof arg.copy === 'function'
	    && typeof arg.fill === 'function'
	    && typeof arg.readUInt8 === 'function';
	}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ }),
/* 156 */
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var extendedTypeOf;

	  extendedTypeOf = function(obj) {
	    var result;
	    result = typeof obj;
	    if (obj == null) {
	      return 'null';
	    } else if (result === 'object' && obj.constructor === Array) {
	      return 'array';
	    } else {
	      return result;
	    }
	  };

	  module.exports = {
	    extendedTypeOf: extendedTypeOf
	  };

	}).call(this);


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	// Generated by CoffeeScript 1.12.7
	(function() {
	  var Theme, color, colorize, colorizeToArray, colorizeToCallback, extendedTypeOf, subcolorizeToCallback,
	    hasProp = {}.hasOwnProperty;

	  color = __webpack_require__(158);

	  extendedTypeOf = __webpack_require__(156).extendedTypeOf;

	  Theme = {
	    ' ': function(s) {
	      return s;
	    },
	    '+': color.green,
	    '-': color.red
	  };

	  subcolorizeToCallback = function(key, diff, output, color, indent) {
	    var i, item, j, k, len, len1, len2, looksLikeDiff, m, op, prefix, ref, ref1, subindent, subkey, subvalue;
	    prefix = key ? key + ": " : '';
	    subindent = indent + '  ';
	    switch (extendedTypeOf(diff)) {
	      case 'object':
	        if (('__old' in diff) && ('__new' in diff) && (Object.keys(diff).length === 2)) {
	          subcolorizeToCallback(key, diff.__old, output, '-', indent);
	          return subcolorizeToCallback(key, diff.__new, output, '+', indent);
	        } else {
	          output(color, "" + indent + prefix + "{");
	          for (subkey in diff) {
	            if (!hasProp.call(diff, subkey)) continue;
	            subvalue = diff[subkey];
	            if (m = subkey.match(/^(.*)__deleted$/)) {
	              subcolorizeToCallback(m[1], subvalue, output, '-', subindent);
	            } else if (m = subkey.match(/^(.*)__added$/)) {
	              subcolorizeToCallback(m[1], subvalue, output, '+', subindent);
	            } else {
	              subcolorizeToCallback(subkey, subvalue, output, color, subindent);
	            }
	          }
	          return output(color, indent + "}");
	        }
	        break;
	      case 'array':
	        output(color, "" + indent + prefix + "[");
	        looksLikeDiff = true;
	        for (i = 0, len = diff.length; i < len; i++) {
	          item = diff[i];
	          if ((extendedTypeOf(item) !== 'array') || !((item.length === 2) || ((item.length === 1) && (item[0] === ' '))) || !(typeof item[0] === 'string') || item[0].length !== 1 || !((ref = item[0]) === ' ' || ref === '-' || ref === '+' || ref === '~')) {
	            looksLikeDiff = false;
	          }
	        }
	        if (looksLikeDiff) {
	          for (j = 0, len1 = diff.length; j < len1; j++) {
	            ref1 = diff[j], op = ref1[0], subvalue = ref1[1];
	            if (op === ' ' && (subvalue == null)) {
	              output(' ', subindent + '...');
	            } else {
	              if (op !== ' ' && op !== '~' && op !== '+' && op !== '-') {
	                throw new Error("Unexpected op '" + op + "' in " + (JSON.stringify(diff, null, 2)));
	              }
	              if (op === '~') {
	                op = ' ';
	              }
	              subcolorizeToCallback('', subvalue, output, op, subindent);
	            }
	          }
	        } else {
	          for (k = 0, len2 = diff.length; k < len2; k++) {
	            subvalue = diff[k];
	            subcolorizeToCallback('', subvalue, output, color, subindent);
	          }
	        }
	        return output(color, indent + "]");
	      default:
	        if (diff === 0 || diff === null || diff === false || diff) {
	          return output(color, indent + prefix + JSON.stringify(diff));
	        }
	    }
	  };

	  colorizeToCallback = function(diff, output) {
	    return subcolorizeToCallback('', diff, output, ' ', '');
	  };

	  colorizeToArray = function(diff) {
	    var output;
	    output = [];
	    colorizeToCallback(diff, function(color, line) {
	      return output.push("" + color + line);
	    });
	    return output;
	  };

	  colorize = function(diff, options) {
	    var output;
	    if (options == null) {
	      options = {};
	    }
	    output = [];
	    colorizeToCallback(diff, function(color, line) {
	      var ref, ref1, ref2;
	      if ((ref = options.color) != null ? ref : true) {
	        return output.push(((ref1 = (ref2 = options.theme) != null ? ref2[color] : void 0) != null ? ref1 : Theme[color])("" + color + line) + "\n");
	      } else {
	        return output.push("" + color + line + "\n");
	      }
	    });
	    return output.join('');
	  };

	  module.exports = {
	    colorize: colorize,
	    colorizeToArray: colorizeToArray,
	    colorizeToCallback: colorizeToCallback
	  };

	}).call(this);


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var defineProperties = Object.defineProperties
	  , map              = __webpack_require__(159)

	  , toString, codes, properties, init;

	toString = function (code, str) {
		return '\x1b[' + code[0] + 'm' + (str || "") + '\x1b[' + code[1] + 'm';
	};

	codes = {
		// styles
		bold:      [1, 22],
		italic:    [3, 23],
		underline: [4, 24],
		inverse:   [7, 27],
		strike:    [9, 29]
	};

	['black', 'red', 'green', 'yellow', 'blue', 'magenta', 'cyan', 'white'].forEach(
		function (color, index) {
			// foreground
			codes[color] = [30 + index, 39];
			// background
			codes['bg' + color[0].toUpperCase() + color.slice(1)] = [40 + index, 49];
		}
	);
	codes.gray = [90, 39];

	properties = map(codes, function (code) {
		return {
			get: function () {
				this.style.push(code);
				return this;
			},
			enumerable: true
		};
	});
	properties.bright = {
		get: function () {
			this._bright = true;
			return this;
		},
		enumerable: true
	};
	properties.bgBright = {
		get: function () {
			this._bgBright = true;
			return this;
		},
		enumerable: true
	};

	init = function () {
		var o = defineProperties(function self(msg) {
			return self.style.reduce(function (msg, code) {
				if ((self._bright && (code[0] >= 30) && (code[0] < 38)) ||
						(self._bgBright && (code[0] >= 40) && (code[0] < 48))) {
					code = [code[0] + 60, code[1]];
				}
				return toString(code, msg);
			}, msg);
		}, properties);
		o.style = [];
		return o[this];
	};

	module.exports = defineProperties(function (msg) {
		return msg;
	}, map(properties, function (code, name) {
		return {
			get: init.bind(name),
			enumerable: true
		};
	}));


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var forEach = __webpack_require__(160);

	module.exports = function (obj, cb) {
		var o = {};
		forEach(obj, function (value, key) {
			o[key] = cb.call(this, value, key, obj);
		}, arguments[2]);
		return o;
	};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	module.exports = __webpack_require__(161)('forEach');


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	// Internal method, used by iteration functions.
	// Calls a function for each key-value pair found in object
	// Optionally takes compareFn to iterate object in specific order

	'use strict';

	var call       = Function.prototype.call
	  , keys       = Object.keys
	  , isCallable = __webpack_require__(162)
	  , callable   = __webpack_require__(163)
	  , value      = __webpack_require__(164);

	module.exports = function (method) {
		return function (obj, cb) {
			var list, thisArg = arguments[2], compareFn = arguments[3];
			value(obj);
			callable(cb);

			list = keys(obj);
			if (compareFn) {
				list.sort(isCallable(compareFn) ? compareFn : undefined);
			}
			return list[method](function (key, index) {
				return call.call(cb, thisArg, obj[key], key, obj, index);
			});
		};
	};


/***/ }),
/* 162 */
/***/ (function(module, exports) {

	// Inspired by: http://www.davidflanagan.com/2009/08/typeof-isfuncti.html

	'use strict';

	var forEach = Array.prototype.forEach.bind([]);

	module.exports = function (obj) {
		var type;
		if (!obj) {
			return false;
		}
		type = typeof obj;
		if (type === 'function') {
			return true;
		}
		if (type !== 'object') {
			return false;
		}

		try {
			forEach(obj);
			return true;
		} catch (e) {
			if (e instanceof TypeError) {
				return false;
			}
			throw e;
		}
	};


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';

	var isCallable = __webpack_require__(162);

	module.exports = function (fn) {
		if (!isCallable(fn)) {
			throw new TypeError(fn + " is not a function");
		}
		return fn;
	};


/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';

	module.exports = function (value) {
		if (value == null) {
			throw new TypeError("Cannot use null or undefined");
		}
		return value;
	};


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __assign = (this && this.__assign) || function () {
	    __assign = Object.assign || function(t) {
	        for (var s, i = 1, n = arguments.length; i < n; i++) {
	            s = arguments[i];
	            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
	                t[p] = s[p];
	        }
	        return t;
	    };
	    return __assign.apply(this, arguments);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SpiderClick = void 0;
	var shared_1 = __webpack_require__(38);
	var SpiderClick = /** @class */ (function () {
	    function SpiderClick(root) {
	        this.root = root;
	        this.onCustomEvents();
	    }
	    SpiderClick.prototype.trackAction = function (value, subtype, _callback) {
	        /**
	         * 1、校验的当前action数据是否合法，抽离成公共方法
	         * 2、校验spma、spmb值是否有埋
	         * 3、获取当前cur_spm、cur_page_args、cur_action_name、cur_action_args值
	         * 4、请求上报
	         */
	        var _a = this.root.get(), curPageArgs = _a.curPageArgs, prevData = _a.prevData;
	        var action;
	        try {
	            this.root.updateSpmaAndSpmb();
	        }
	        catch (e) {
	            shared_1.error(e);
	            return;
	        }
	        // 判断是否hmtl元素节点，是则获取对应节点的埋点信息
	        action = shared_1.isHTMLElement(value)
	            ? shared_1.extractActionFrom(value)
	            : shared_1.merge(true, {}, value);
	        shared_1.formatSpiderAction(action);
	        if (!shared_1.isValidSpiderAction(action)) {
	            return;
	        }
	        this.root.setCurSpmArray({
	            spmc: String(action.spmc || '_'),
	            spmd: String(action.spmd || '_')
	        });
	        var curSpm = this.root.get().curSpm;
	        return this.root.report(subtype, __assign({ cur_spm: curSpm, cur_page_args: curPageArgs, cur_action_name: action.actionName || null, cur_action_args: action.actionArgs || null }, prevData));
	    };
	    SpiderClick.prototype.onCustomEvents = function () {
	        var _this = this;
	        // 订阅上一页跳转埋点上报的消息事件
	        shared_1.eventEmitter.on("report_prev_data" /* REPORT_PREV_DATA */, function () {
	            var prevData = _this.root.get().prevData;
	            prevData &&
	                prevData.prev_spm &&
	                _this.root.report("click" /* CLICK */, shared_1.convertData(prevData));
	        });
	    };
	    return SpiderClick;
	}());
	exports.SpiderClick = SpiderClick;


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SpiderNavigation = void 0;
	var shared_1 = __webpack_require__(38);
	// var constans_1 = require("../../plugins/collect-tapper/constans");
	function restoreDestinationUrl(url) {
	    // 2020.9.23 兼容pecker数据采集上报的策略，document对象下缓存当前新开页面的目标url
	    shared_1.DOCUMENT.destination = url;
	}
	var SpiderNavigation = /** @class */ (function () {
	    function SpiderNavigation(root) {
	        this.root = root;
	    }
	    // 非单页型跳转
	    SpiderNavigation.prototype.transferActionBy = function (url, value, immdiately) {
	        var _this = this;
	        if (immdiately === void 0) { immdiately = false; }
	        // 在下个页面上报点击日志，故此处需提前打点
	        // shared_1.eventEmitter.emit(constans_1.BEFORE_REPORT_SPIDER_LOG);
	        restoreDestinationUrl(url);
	        try {
	            this.root.updateSpmaAndSpmb();
	        }
	        catch (e) {
	            shared_1.error(e);
	            return url;
	        }
	        // 判断url是否合法的http协议跳转链接
	        if (!shared_1.isValidNativeALink(shared_1.getHtmlAnchorElementBy(url))) {
	            shared_1.error(new shared_1.SpiderError({
	                message: 'url仅支持透传http协议跳转链接',
	                name: "ValidationError" /* VALIDATION_ERROR */
	            }));
	            return url;
	        }
	        // 判断是否hmtl元素节点，是则获取对应节点的埋点信息
	        var action = shared_1.isHTMLElement(value)
	            ? shared_1.extractActionFrom(value)
	            : shared_1.merge(true, {}, value);
	        shared_1.formatSpiderAction(action);
	        if (!shared_1.isValidSpiderAction(action)) {
	            return url;
	        }
	        var navigateArgs = { url: url, action: action, value: value, context: this };
	        /**
	         * 1、在生命周期执行跳转埋点逻辑之前（before_navigate）时机,依次执行跳转钩子插件瀑布流函数；
	         * 2、跳转埋点插件函数内部逻辑必须是同步操作，否则会导致返回url不是最新的链接
	         */
	        this.root.hooks.invokeWaterfall("beforeNavigate" /* BEFORE_NAVIGATE */, navigateArgs, function (e) {
	            !(e instanceof Error) && _this.handleSpiderToken(navigateArgs);
	        });
	        if (immdiately) {
	            shared_1.GLOBAL.location.href = navigateArgs.url;
	            return shared_1.VOID_HREF;
	        }
	        return navigateArgs.url;
	    };
	    // 单页型跳转
	    SpiderNavigation.prototype.transferAction = function (value) {
	        try {
	            this.root.updateSpmaAndSpmb();
	        }
	        catch (e) {
	            shared_1.error(e);
	            return;
	        }
	        // 判断是否hmtl元素节点，是则获取对应节点的埋点信息
	        var action = shared_1.isHTMLElement(value)
	            ? shared_1.extractActionFrom(value)
	            : shared_1.merge(true, {}, value);
	        shared_1.formatSpiderAction(action);
	        if (!shared_1.isValidSpiderAction(action)) {
	            return;
	        }
	        this.root.setCurSpmArray({
	            spmc: String(action.spmc || '_'),
	            spmd: String(action.spmd || '_')
	        });
	        var token = shared_1.generateSpiderTokenBy(this.generatePrevData(action));
	        this.root.setToken(token);
	    };
	    SpiderNavigation.prototype.handleSpiderToken = function (navigateArgs) {
	        this.root.setCurSpmArray({
	            spmc: String(navigateArgs.action.spmc || '_'),
	            spmd: String(navigateArgs.action.spmd || '_')
	        });
	        var token = shared_1.generateSpiderTokenBy(this.generatePrevData(navigateArgs.action));
	        this.root.setToken(token);
	        // const extendParams = this.getExtendParams(
	        //     navigateArgs.url,
	        //     navigateArgs.action
	        // )
	        var spiderTokenParams = this.getSpiderTokenParams(navigateArgs);
	        navigateArgs.url = shared_1.setQuerystring(navigateArgs.url, spiderTokenParams);
	    };
	    SpiderNavigation.prototype.generatePrevData = function (action) {
	        var _a = this.root.get(), curSpm = _a.curSpm, curPageArgs = _a.curPageArgs;
	        var metaData = shared_1.getMetaData();
	        var prevData = shared_1.convertData({
	            cur_spm: curSpm,
	            cur_page_args: curPageArgs,
	            cur_action_name: action.actionName || null,
	            cur_action_args: shared_1.merge({}, action.actionArgs, {
	                realVisitId: metaData && metaData.visit_id
	            })
	        });
	        return prevData;
	    };
	    // private getExtendParams(url: string, action: SpiderAction) {
	    //     const extendParams: URLExtendParams = Object.create(null)
	    //     const shareRelation = getURLSearchParamBy('share_relation') // share_reation 不能在当前页生成，只能透传
	    //     // 追加wfr、ifr、vc_xxx 等参数顺序：1、优先取跳转url参数；2、其次取当前URL参数
	    //     merge(extendParams, getCurURLPassProperties(), getQuerystring(url))
	    //     shareRelation && (extendParams.share_relation = shareRelation)
	    //     // tips: merge wfr\ifr\vc_xxx 和appendToken顺序不能变，防止新生成的spider_token被旧的覆盖掉
	    //     this.appendTokenParam(extendParams, { url, action })
	    //     return extendParams
	    // }
	    SpiderNavigation.prototype.getSpiderTokenParams = function (option) {
	        var extendParams = Object.create(null);
	        var _a = this.root.get(), curSpm = _a.curSpm, token = _a.token;
	        var anchorElement = shared_1.getHtmlAnchorElementBy(option.url);
	        if (shared_1.isEqualPrimaryDomain(anchorElement.hostname)) {
	            token && (extendParams[shared_1.URL_SEARCH_PARAMS_KEY] = token);
	        }
	        else {
	            /**
	             * 兼容跨域跳转场景 url上追加spider_token_alias字段以便下一个页面优先从window.name中读取上一页跳转埋点信息
	             * 后续会去掉url上追加spider&spider_action这种方式上报上一页埋点
	             */
	            extendParams[shared_1.URL_SEARCH_PARAMS_KEY_ALIAS] = token;
	            extendParams[shared_1.URL_SEARCH_PARAMS_SPM] = curSpm;
	            option.action.actionName &&
	                (extendParams[shared_1.URL_SEARCH_PARAMS_ACTION] =
	                    option.action.actionName);
	        }
	        return extendParams;
	    };
	    return SpiderNavigation;
	}());
	exports.SpiderNavigation = SpiderNavigation;


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.Base = void 0;
	var shared_1 = __webpack_require__(38);
	// import { merge, forEach } from '@vdian/util'
	var shared_2 = __webpack_require__(38);
	var override_1 = __webpack_require__(168);
	var Base = /** @class */ (function (_super) {
	    __extends(Base, _super);
	    function Base() {
	        var _this = _super.call(this) || this;
	        _this.curSpmArray = [];
	        _this.curPageArgs = null;
	        _this.prevData = null;
	        // 初始化从当前页链接URL参数spider_token或者spider_token_alias字段获取
	        _this.token =
	            shared_2.getURLSearchParamBy(shared_2.URL_SEARCH_PARAMS_KEY) ||
	                shared_2.getURLSearchParamBy(shared_2.URL_SEARCH_PARAMS_KEY_ALIAS);
	        _this.timestamp = String(+new Date());
	        _this.curSpiderElement = null;
	        return _this;
	    }
	    Base.prototype.updateSpmaAndSpmb = function () {
	        var _a = shared_2.getSpmaAndSpmb(), spma = _a.spma, spmb = _a.spmb;
	        spma = this.curSpmArray[0] || spma;
	        spmb = this.curSpmArray[1] || spmb;
	        if (!spma || !spmb) {
	            throw new shared_2.SpiderError({
	                message: 'meta & body 上必须包含 data-spider 值',
	                name: "ValidationError" /* VALIDATION_ERROR */
	            });
	        }
	        else {
	            this.setCurSpmArray({ spma: spma, spmb: spmb });
	        }
	    };
	    Base.prototype.setCurSpmArray = function (spiderSpm) {
	        var spma = spiderSpm.spma, spmb = spiderSpm.spmb, spmc = spiderSpm.spmc, spmd = spiderSpm.spmd;
	        spma && (this.curSpmArray[0] = spma);
	        spmb && (this.curSpmArray[1] = spmb);
	        spmc && (this.curSpmArray[2] = spmc);
	        spmd && (this.curSpmArray[3] = spmd);
	        // 坑：merge([],['a','b','c','d'],[undefined,undefined,'_','2']) -> [undefined,undefined,'_','2']
	        // this.curSpmArray = merge([], this.curSpmArray, [spma, spmb, spmc, spmd])
	    };
	    Base.prototype.setCurPageArgs = function (pageArgs) {
	        var curPageArgs = shared_1.merge(true, {}, pageArgs);
	        shared_1.merge(true, curPageArgs, shared_2.getCurURLPassProperties());
	        curPageArgs.navigation_type = shared_2.getNavigationType();
	        /**
	         * 优化点：优化上一个页面停留时长的计算精确度，提前缓存页面加载完成的时间戳，pageview上报时机只从缓存中获取该时间戳
	         * 上一页面停留时长计算公式：duration = cur_page_args.ts - prev_page_args.ts
	         */
	        curPageArgs.ts = this.timestamp;
	        shared_1.forEach(curPageArgs, shared_2.normalizeParam);
	        this.curPageArgs = curPageArgs;
	    };
	    /**
	     * 2021.3.14 埋点校对
	     * 这里为了模拟从cookie中获取上一页埋点数据场景
	     * 保证从上一页跳转过来上报pageview的场景能读到prevData
	     */
	    Base.prototype.setPrevDataCopy = function(prevData){
	         var _prevData = shared_1.merge(true, {}, prevData);

	         this.prevData = _prevData;
	    }
	    Base.prototype.setPrevData = function (prevData) {
	        var _prevData = shared_1.merge(true, {}, prevData);
	        if (!_prevData.prev_spm) {
	            this.prevData = null;
	            return;
	        }
	        if (this.curPageArgs &&
	            this.curPageArgs._page &&
	            shared_2.isInternalActionName(this.curPageArgs._page)) {
	            var result = shared_2.validatePageArgs(this.curPageArgs);
	            if (!result.isOk) {
	                shared_1.error(new shared_2.SpiderError({
	                    message: result.message,
	                    name: "InternalActionNameError" /* INTERNAL_ACTION_NAME_ERROR */
	                }));
	            }
	            var actionName = this.curPageArgs._page;
	            delete this.curPageArgs._page;
	            _prevData.prev_action_name = actionName;
	            _prevData.prev_action_args = shared_1.merge(true, {}, this.curPageArgs, _prevData.prev_action_args);
	        }
	        // if prevAction still don't have actionName, default to one
	        if (!_prevData.prev_action_name) {
	            _prevData.prev_action_name =
	                '_jumpTo_' + this.curSpmArray[0] + '.' + this.curSpmArray[1];
	        }
	        this.prevData = _prevData;
	    };
	    Base.prototype.setToken = function (token) {
	        this.token = token;
	    };
	    /**
	     * 每次待页面domContentLoaded时机或者单页路由跳转刷新时，缓存该页面dom加载完成的时间戳
	     * @param timestamp pageview的时间戳（用于计算上一页面停留时长）
	     */
	    Base.prototype.refreshTimestamp = function () {
	        this.timestamp = String(+new Date());
	    };
	    Base.prototype.setCurSpiderElement = function (curSpiderElement) {
	        this.curSpiderElement = curSpiderElement;
	    };
	    Base.prototype.get = function () {
	        var curSpm = this.curSpmArray.join('.');
	        return {
	            curSpmArray: this.curSpmArray,
	            curSpm: curSpm,
	            curPageArgs: this.curPageArgs,
	            prevData: this.prevData,
	            timestamp: this.timestamp,
	            token: this.token,
	            curSpiderElement: this.curSpiderElement
	        };
	    };
	    return Base;
	}(override_1.KernelSpider));
	exports.Base = Base;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(169), exports);
	__exportStar(__webpack_require__(170), exports);


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.SpiderRecord = void 0;
	var kernel_web_1 = __webpack_require__(118);
	var shared_1 = __webpack_require__(38);
	// import { isObject, forEach } from '@vdian/util'
	function normalize(data) {
	    var detail = data.detail || {};
	    if (shared_1.isObject(detail)) {
	        detail.startTime = shared_1.getPerformanceTime();
	        shared_1.forEach(detail, shared_1.normalizeParam);
	        data.detail = detail;
	    }
	    // if (data.subtype === SpiderSubtypes.PAGE_VIEW) {
	    //     const curPageArgs = data.cur_page_args
	    //     isObject(curPageArgs) && forEach(curPageArgs, normalizeParam)
	    //     data.cur_page_args = curPageArgs
	    // }
	    if (data.subtype !== "page_view" /* PAGE_VIEW */) {
	        var curActionArgs = data.cur_action_args;
	        shared_1.isObject(curActionArgs)
	            ? shared_1.forEach(curActionArgs, shared_1.normalizeParam)
	            : (curActionArgs = null);
	        data.cur_action_args = curActionArgs;
	    }
	}
	var SpiderRecord = /** @class */ (function (_super) {
	    __extends(SpiderRecord, _super);
	    function SpiderRecord(meta, data) {
	        var _this = this;
	        data.type = "spider" /* SPIDER */;
	        // data.startTime = performance.now()
	        normalize(data);
	        _this = _super.call(this, meta, data) || this;
	        return _this;
	    }
	    return SpiderRecord;
	}(kernel_web_1.Record));
	exports.SpiderRecord = SpiderRecord;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || (function () {
	    var extendStatics = function (d, b) {
	        extendStatics = Object.setPrototypeOf ||
	            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
	            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
	        return extendStatics(d, b);
	    };
	    return function (d, b) {
	        extendStatics(d, b);
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	})();
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.KernelSpider = void 0;
	var kernel_web_1 = __webpack_require__(118);
	var record_1 = __webpack_require__(169);
	var shared_1 = __webpack_require__(38);
	// var constans_1 = require("../plugins/collect-tapper/constans");
	var KernelSpider = /** @class */ (function (_super) {
	    __extends(KernelSpider, _super);
	    function KernelSpider() {
	        return _super.call(this, {
	            report: new kernel_web_1.Report({
	                send: new kernel_web_1.Send({
	                    url: shared_1.getSpiderReportUrl()
	                })
	            }),
	            Record: record_1.SpiderRecord
	        }) || this;
	    }
	    KernelSpider.prototype.report = function (subtype, data) {
	        // 每次调用report方法则触发BEFORE_AUTO_REPORT_PAGE_VIEW事件打点
	        // shared_1.eventEmitter.emit(constans_1.BEFORE_REPORT_SPIDER_LOG);
	        // this.send(shared_1.merge({}, data, { subtype: subtype }));

	        return shared_1.merge({}, data, {
	            type: "spider",
	            subtype: subtype 
	        })
	    };
	    return KernelSpider;
	}(kernel_web_1.Kernel));
	exports.KernelSpider = KernelSpider;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
	}) : (function(o, m, k, k2) {
	    if (k2 === undefined) k2 = k;
	    o[k2] = m[k];
	}));
	var __exportStar = (this && this.__exportStar) || function(m, exports) {
	    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	__exportStar(__webpack_require__(172), exports);
	__exportStar(__webpack_require__(178), exports);
	__exportStar(__webpack_require__(179), exports);


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.navigationPlugin = void 0;
	var app_protocol_link_1 = __webpack_require__(173);
	var third_link_1 = __webpack_require__(174);
	var mina_program_1 = __webpack_require__(175);
	var multiple_domain_1 = __webpack_require__(176);
	var extend_params_1 = __webpack_require__(177);
	function navigationPlugin() {
	    // app协议链接跳转插件
	    app_protocol_link_1.appProtocolLinkPlugin.call(this);
	    // 第三方链接跳转插件
	    third_link_1.thirdLinkPlugin.call(this);
	    // 小程序跳转插件
	    mina_program_1.minaProgramPlugin.call(this);
	    // 多域名插件
	    multiple_domain_1.multiDomainPlugin.call(this);
	    // 默认透传参数插件
	    extend_params_1.extendParamsPlugin.call(this);
	}
	exports.navigationPlugin = navigationPlugin;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.appProtocolLinkPlugin = void 0;
	var shared_1 = __webpack_require__(38);
	// app协议链接跳转处理
	function appProtocolLinkPlugin() {
	    var _this = this;
	    this.hooks.push("beforeNavigate" /* BEFORE_NAVIGATE */, function (args, next) {
	        var url = args.url, value = args.value, context = args.context;
	        if (shared_1.isAppProtocolLink(url)) {
	            if (shared_1.isAppProtocolWebviewLink(url)) {
	                var webviewUrl = shared_1.getURLSearchParamBy('url', url);
	                if (webviewUrl) {
	                    var webviewUrl2 = context.transferActionBy(webviewUrl, value);
	                    args.url = shared_1.setQuerystring(url, { url: webviewUrl2 });
	                }
	                else {
	                    _this.trackAction(value);
	                    args.url = url;
	                }
	            }
	            else {
	                _this.trackAction(value);
	                args.url = url;
	            }
	            // 命中app 协议链接，则直接中断后续插件执行
	            next && next(new Error(''));
	        }
	        else {
	            next && next();
	        }
	    });
	    // const transferActionBy = this.transferActionBy
	    // if (isAppProtocolWebviewLink(url)) {
	    //     const webviewUrl = getURLSearchParamBy('url', url)
	    //     if (webviewUrl) {
	    //         const webviewUrl2 = transferActionBy(webviewUrl, value)
	    //         return setQuerystring(url, {
	    //             url: webviewUrl2
	    //         })
	    //     } else {
	    //         this.trackAction(value)
	    //         return url
	    //     }
	    // } else {
	    //     this.trackAction(value)
	    //     return url
	    // }
	}
	exports.appProtocolLinkPlugin = appProtocolLinkPlugin;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.thirdLinkPlugin = void 0;
	var safety_1 = __webpack_require__(101);
	// 第三方链接（非微店域）跳转处理
	function thirdLinkPlugin() {
	    // this.trackAction(value)
	    var _this = this;
	    // return url
	    this.hooks.push("beforeNavigate" /* BEFORE_NAVIGATE */, function (args, next) {
	        var url = args.url, value = args.value;
	        if (!safety_1.isLegalUrl(url)) {
	            _this.trackAction(value);
	            args.url = url;
	            // 命中第三方链接逻辑，直接中断后续插件执行，返回当前url
	            next && next(new Error(''));
	        }
	        else {
	            next && next();
	        }
	    });
	}
	exports.thirdLinkPlugin = thirdLinkPlugin;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.minaProgramPlugin = void 0;
	var shared_1 = __webpack_require__(38);
	var user_agent_1 = __webpack_require__(8);
	// import { merge } from '@vdian/util'
	var ITEM_REGEXP = /weidian.com\/item\.html.*(item)ID=(\d+)/;
	var SHOP_REGEXP = /weidian\.com\/?\?.*(user)id=(\d+)/;
	var NAVIGATE_METHOD = {
	    NAVIGATE_TO: 'navigateTo',
	    SWITCH_TAB: 'switchTab'
	};
	var pageMap = {
	    item: {
	        minaPath: '/lib/item/dist/pages/index/index?itemId=',
	        actionName: shared_1.INTERNAL_ACTION_NAMES.ITEM
	    },
	    user: {
	        minaPath: '/lib/shop/dist/pages/index/index?shopId=',
	        actionName: shared_1.INTERNAL_ACTION_NAMES.SHOP
	    }
	};
	function isSpecialMinaProgramParam() {
	    return shared_1.getURLSearchParamBy('invoke') === 'thirdApp';
	}
	function isProxyItemOrShopUrl() {
	    return shared_1.getURLSearchParamBy('vc_minip') !== 'wx_zhuanzhuan';
	}
	// function isMinaProgramPath(url: string) {
	//     return /^\/lib\//.test(url)
	// }
	function getParamsString(url) {
	    var matchs = url.match(/^[^\?#]*\?([^#]*)/);
	    return matchs ? matchs[1] : '';
	}
	function getProxyRegxpResult(url) {
	    return url.match(ITEM_REGEXP) || url.match(SHOP_REGEXP);
	}
	function getMinaProgramPath(regexpResult, url) {
	    var path = pageMap[regexpResult[1]].minaPath + regexpResult[2];
	    var params = getParamsString(url);
	    params && (path += '&' + params);
	    return path;
	}
	function report(regexpResult, action, root) {
	    if (regexpResult[1] === 'item') {
	        action.actionName = shared_1.INTERNAL_ACTION_NAMES.ITEM;
	        action.actionArgs = shared_1.merge({}, action.actionArgs, {
	            itemId: regexpResult[2]
	        });
	    }
	    if (regexpResult[1] === 'user') {
	        action.actionName = shared_1.INTERNAL_ACTION_NAMES.SHOP;
	        action.actionArgs = shared_1.merge({}, action.actionArgs, {
	            shopId: regexpResult[2]
	        });
	    }
	    root.trackAction(action);
	}
	// 小程序场景跳转处理
	function minaProgramPlugin() {
	    var _this = this;
	    var method = NAVIGATE_METHOD.NAVIGATE_TO;
	    this.hooks.push("beforeNavigate" /* BEFORE_NAVIGATE */, function (args, next) {
	        // tslint:disable-next-line: prefer-const
	        var url = args.url, action = args.action;
	        if (!user_agent_1.isMiniProgram()) {
	            next && next();
	            return;
	        }
	        // web端spider跳转埋点不支持小程序路径跳转埋点上报 （放在前置逻辑处理掉了）
	        // if (isMinaProgramPath(url)) {
	        //     args.url = url
	        //     next && next(new Error(''))
	        //     return
	        // }
	        // 专享小程序业务逻辑特定透传参数invoke=‘thirdApp’
	        if (isSpecialMinaProgramParam()) {
	            url = shared_1.setQuerystring(url, {
	                invoke: 'thirdApp'
	            });
	        }
	        var regexpResult = getProxyRegxpResult(url);
	        if (isProxyItemOrShopUrl() && regexpResult) {
	            // 处理上报经典电商actionName 点击事件
	            report(regexpResult, action, _this);
	            // 专享小程序跳转店详需要调switchTab方法
	            if (isSpecialMinaProgramParam() && regexpResult[1] === 'user') {
	                method = NAVIGATE_METHOD.SWITCH_TAB;
	            }
	            shared_1.GLOBAL.wx &&
	                shared_1.GLOBAL.wx.miniProgram[method]({
	                    url: getMinaProgramPath(regexpResult, url)
	                });
	            args.url = 'javascript:';
	            next && next(new Error(''));
	        }
	        else {
	            args.url = url;
	            next && next();
	        }
	    });
	}
	exports.minaProgramPlugin = minaProgramPlugin;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.multiDomainPlugin = void 0;
	var shared_1 = __webpack_require__(38);
	var user_agent_1 = __webpack_require__(8);
	function isWeiTuanTuanMiniProgram() {
	    return user_agent_1.isMiniProgram() && shared_1.getURLSearchParamBy('vc_invoke') === 'weituantuan';
	}
	// 多域名切换跳转处理
	function multiDomainPlugin() {
	    // url = generateMultidomainUrl(url, GLOBAL.multiDomainRuleMap)
	    // return this.transferActionBy(url, value)
	    this.hooks.push("beforeNavigate" /* BEFORE_NAVIGATE */, function (args, next) {
	        /**
	         * 1、页面body配置了多域名切换开关且非微店买家app且非微店店长app，则跳转支持多域名替换；
	         * 2、页面未禁用私域独立域名切换（默认开启私域切换）且非微店买家版app且非微店+小程序（或者上车团小程序），则跳转支持私有域名替换；
	         * 3、注意：这里不能使用ruleMapPromise处理，跳转行为是同步行为，不能异步操作
	         */
	        try {
	            if (shared_1.GLOBAL.multiDomainRuleMap &&
	                shared_1.isMultipleDomain('spider') &&
	                !user_agent_1.isWDBuyer() &&
	                !user_agent_1.isWDSeller()) {
	                args.url = shared_1.generateMultidomainUrl(args.url, shared_1.GLOBAL.multiDomainRuleMap);
	            }
	            if (shared_1.GLOBAL.multiDomainRuleMap &&
	                !shared_1.isDisableAuto('privateDomain') &&
	                !user_agent_1.isWDBuyer()) {
	                // 默认spider私域跳转不作小程序环境处理
	                if (!user_agent_1.isMiniProgram()) {
	                    args.url = shared_1.generateIndependentUrl(args.url, {
	                        dataMap: shared_1.GLOBAL.multiDomainRuleMap
	                    });
	                }
	                // spider独立域名跳转针对上车团（微团团）小程序支持特殊处理
	                if (isWeiTuanTuanMiniProgram()) {
	                    args.url = shared_1.generateIndependentUrl(args.url, {
	                        dataMap: shared_1.GLOBAL.multiDomainRuleMap
	                    });
	                }
	            }
	        }
	        catch (e) {
	            shared_1.error(e);
	        }
	        next && next();
	    });
	}
	exports.multiDomainPlugin = multiDomainPlugin;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.extendParamsPlugin = void 0;
	var url_1 = __webpack_require__(29);
	var shared_1 = __webpack_require__(38);
	// import { merge } from '@vdian/util'
	// 该插件目前支持transferActionBy透传wfr、ifr、vc_xxx、share_relation参数
	function extendParamsPlugin() {
	    this.hooks.push("beforeNavigate" /* BEFORE_NAVIGATE */, function (args, next) {
	        var extendParams = Object.create(null);
	        var shareRelation = shared_1.getURLSearchParamBy('share_relation'); // share_reation 不能在当前页生成，只能透传
	        // 追加wfr、ifr、vc_xxx 等参数顺序：1、优先取跳转url参数；2、其次取当前URL参数
	        shared_1.merge(extendParams, shared_1.getCurURLPassProperties(), url_1.getQuerystring(args.url));
	        shareRelation && (extendParams.share_relation = shareRelation);
	        args.url = url_1.setQuerystring(args.url, extendParams);
	        next && next();
	    });
	}
	exports.extendParamsPlugin = extendParamsPlugin;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.spiderVisualPlugin = void 0;
	var shared_1 = __webpack_require__(38);
	/* istanbul ignore next */
	function loadSpiderVisual(root) {
	    var cdns = shared_1.getSpiderVisualCdns();
	    var whiteList = [
	        'assets.geilicdn.com',
	        'assets.pre.geilicdn.com',
	        'assets.daily.geilicdn.com',
	        'h5.dev.weidian.com'
	    ];
	    if (shared_1.GLOBAL !== shared_1.GLOBAL.top && cdns && cdns.length) {
	        if (shared_1.GLOBAL.spider_visual) {
	            initSpiderVisual(root);
	            return;
	        }
	        cdns = cdns.filter(function (cdn) {
	            var anchorElement = shared_1.getHtmlAnchorElementBy(cdn);
	            return (shared_1.isValidNativeALink(anchorElement) &&
	                whiteList.indexOf(anchorElement.hostname) > -1);
	        });
	        var promises_1 = [];
	        cdns && cdns.forEach(function (cdn) { return promises_1.push(shared_1.loadScript(cdn)); });
	        Promise.all(promises_1).then(function () { return initSpiderVisual(root); });
	    }
	}
	/* istanbul ignore next */
	function initSpiderVisual(root) {
	    var _a = root.get(), curSpm = _a.curSpm, curPageArgs = _a.curPageArgs;
	    /**
	     * tips：此时可能trackPageview尚未被初始化调用，因此curSpm,curPageArgs可能为空(废弃)
	     * 因此直接读取html、body的spmab值（废弃）
	     * 全局spider_pageview上报事件此时表明trackPageview已经被初始化，因此认为此时curspm、curPageArgs是已经初始化了
	     */
	    // getLatestMeta(() => {
	    //     const metaData = getMetaData()
	    //     const spma = metaData && metaData.spma
	    //     const spmb = metaData && metaData.spmb
	    //     spma && spmb && GLOBAL.spider_visual.init([spma, spmb, 0, 0].join('.'), curPageArgs)
	    // })
	    curSpm && shared_1.GLOBAL.spider_visual.init(curSpm, curPageArgs);
	}
	function spiderVisualPlugin() {
	    var _this = this;
	    /**
	     * congo可视化埋点初始化
	     * 监听全局spider_pageview上报事件
	     */
	    shared_1.decoupler.on("reportSpiderPageview" /* REPORT_SPIDER_PAGEVIEW */, function () {
	        loadSpiderVisual(_this);
	    });
	}
	exports.spiderVisualPlugin = spiderVisualPlugin;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	exports.fixIOSClickBugPlugin = void 0;
	var shared_1 = __webpack_require__(38);
	function fixIOSClickBugPlugin() {
	    if (!navigator.userAgent.match(/iPhone OS [\d_]+/)) {
	        return;
	    }
	    var style = shared_1.DOCUMENT.createElement('style');
	    style.type = 'text/css';
	    style.innerHTML =
	        '\
	    [data-spider=""], \
	    [data-spider-action-type], \
	    [data-spider-action-name] {\
	        cursor: pointer; \
	    }';
	    try {
	        var headElement = shared_1.DOCUMENT.getElementsByTagName('head').item(0);
	        headElement.appendChild(style);
	    }
	    catch (error) { }
	}
	exports.fixIOSClickBugPlugin = fixIOSClickBugPlugin;


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

	var multiDomainWrapper = __webpack_require__(181);

	function requestRuleMap() {
	    if (window.multiDomainRuleMap) {
	        return Promise.resolve(window.multiDomainRuleMap)
	    }
	    // 防止v-collect和pecker同时引入发起重复请求
	    if(window.ruleMapPromise){
	        return window.ruleMapPromise
	    }
	    return multiDomainWrapper.requestConfig()
	        .then(function (ruleMap) {
	            window.multiDomainRuleMap = ruleMap;

	            return Promise.resolve(ruleMap);
	        }).catch(function () {
	            return Promise.reject();
	        })
	}

	module.exports = {
	    ruleMapPromise: requestRuleMap(),
	    generateMultidomainUrl: multiDomainWrapper.generateMultidomainUrl,
	    generatePrivateUrl: multiDomainWrapper.generatePrivateUrl,
	    isPrivateDomainUrl: multiDomainWrapper.isPrivateUrl
	};


/***/ }),
/* 181 */
/***/ (function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var GLOBAL=window,DOCUMENT=document,MOBILE_REGEXP=/AppleWebKit.*Mobile.*/i,WD_BUYER_REGEXP=/WDAPP\(WDBuyer/i,UA=navigator.userAgent.toLowerCase();function isMobile(){return MOBILE_REGEXP.test(UA)}function isWDBuyer(){return WD_BUYER_REGEXP.test(UA)}function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _toConsumableArray(e){return _arrayWithoutHoles(e)||_iterableToArray(e)||_unsupportedIterableToArray(e)||_nonIterableSpread()}function _arrayWithoutHoles(e){if(Array.isArray(e))return _arrayLikeToArray(e)}function _iterableToArray(e){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e))return Array.from(e)}function _unsupportedIterableToArray(e,t){if(e){if("string"==typeof e)return _arrayLikeToArray(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);return"Object"===r&&e.constructor&&(r=e.constructor.name),"Map"===r||"Set"===r?Array.from(e):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?_arrayLikeToArray(e,t):void 0}}function _arrayLikeToArray(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function _nonIterableSpread(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function noop(){}function isUndef(e){return null==e}function isEmpty(e){return null==e||""===e}function isType(t){return function(e){return Object.prototype.toString.call(e)==="[object "+t+"]"}}function isNumber(e){return isType("Number")(e)}function isString(e){return isType("String")(e)}function isError(e){return isType("Error")(e)}function isArray(e){return isType("Array")(e)}function isFunction(e){return"function"==typeof e}function isDate(e){return isType("Date")(e)}function isBoolean(e){return isType("Boolean")(e)}function isObject(e){return isType("Object")(e)}function isWideObject(e){return null!==e&&"object"===_typeof(e)}function isFormData(e){return"undefined"!=typeof FormData&&e instanceof FormData}function isURLSearchParams(e){return"undefined"!=typeof URLSearchParams&&e instanceof URLSearchParams}function hasOwn(e,t){return Object.prototype.hasOwnProperty.call(e,t)}function forEach(e,t){if(isArray(e))for(var r=0,n=e.length;r<n;r++)t.call(null,e[r],r,e);else if(isObject(e))for(var o in e)hasOwn(e,o)&&t.call(null,e[o],o,e)}function merge(e){for(var r,n,t=[],o=1;o<arguments.length;o++)t[o-1]=arguments[o];return n=isBoolean(e)?(r=e,t.shift()):e,forEach(t,function(e){forEach(e,function(e,t){r&&(isArray(e)||isObject(e))?(isArray(e)?isArray(n[t])||(n[t]=[]):isObject(n[t])||(n[t]={}),merge(r,n[t],e)):n[t]=e})}),n}function toArray(e){return Array.prototype.slice.call(e)}var __extends=function(){var n=function(e,t){return(n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(e,t)};return function(e,t){function r(){this.constructor=e}n(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}}(),NetworkError=function(o){function e(e,t,r){var n=o.call(this,e)||this;return n.code=t,n.subcode=r,n}return __extends(e,o),e}(Error);function createError(e,t,r){return new NetworkError(e,t,r)}function isResponseOk(e){return 200<=e&&e<300||304==e}function parseJSON(e){try{return JSON.parse(e)}catch(e){}}function isNativeFunction(e){return"function"==typeof e&&-1!==e.toString().indexOf("[native code]")}function isUseNative(e){var t;return isWDBuyer()&&(null===(t=null==e?void 0:e.extra)||void 0===t?void 0:t.useNative)}function _goto(e){e&&GLOBAL.location.assign(e)}var Hooks=function(){function e(){this.hooks={}}return e.prototype.push=function(e,t){var r=this.hooks[e]||(this.hooks[e]=[]);return"function"==typeof t&&r.push(t),this},e.prototype.invokeWaterfall=function(e,r,n){var o=this.hooks[e];if(!o||!o.length)return n(),this;var i=0;return o[i](r,function e(t){return isError(t)?n(t):++i>=o.length?n():void o[i](r,e)}),this},e}(),AbstractNetwork=function(){function e(e){this.hooks=new Hooks,this._installedPlugins=[],this.options=e||{},this.hooks=new Hooks,this._installedPlugins=[]}return e.prototype.use=function(e){return-1<this._installedPlugins.indexOf(e)||!isFunction(e)||(e.call(this),this._installedPlugins.push(e)),this},e}(),HASH_DELIMIT="#",SEARCH_DELIMIT="?",PARAM_DELIMIT="&";function encode(e){return encodeURIComponent(e).replace(/%20/g,"+")}function serialize(e){if(isURLSearchParams(e))return e.toString();var r,t=e;return(isObject(e)||isArray(e))&&(r=[],forEach(e,function(e,t){isUndef(e)||(isArray(e)?t+="[]":e=[e],forEach(e,function(e){isDate(e)?e=e.toISOString():isWideObject(e)&&(e=JSON.stringify(e)),r.push(encode(t)+"="+encode(e))}))}),t=r.join(PARAM_DELIMIT)),t}function appendParams(e,t){if(!isString(e))return"";var r=e.split(HASH_DELIMIT);e=r[0];var n=serialize(t);return isString(n)&&n&&(e+=(-1===e.indexOf(SEARCH_DELIMIT)?SEARCH_DELIMIT:PARAM_DELIMIT)+n),r[0]=e,r.join(HASH_DELIMIT)}var GET_METHOD="GET",JSON_RESPONSE_TYPE="json";function normalizeStatus(e,t){var r=t.url;return 0===e&&0===r.indexOf("file:")?200:{1223:204}[e]||e}function normalizeUrl(e,t){var r=t.method,n=t.cache,o=t.data;return r===GET_METHOD&&(e=appendParams(e,o),n||(e=appendParams(e,{_:Date.now()}))),e}function setWithCredentials(e,t){t.withCredentials&&(e.withCredentials=!0)}function setResponseType(e,t){var r=t.responseType;if(r)try{e.responseType=r}catch(e){}}function setRequestHeader(e,t){var r=t.headers,n=t.method,o=t.data;if(isObject(r))for(var i in r)if(r.hasOwnProperty(i)&&!isUndef(r[i])){if("content-type"===i.toLowerCase()&&(n===GET_METHOD||isFormData(o)))continue;e.setRequestHeader(i,r[i])}}function getResponse(e,t){var r=t.responseType,n=t.status,o=e.response;if(r===JSON_RESPONSE_TYPE&&e.responseType!==JSON_RESPONSE_TYPE&&!isObject(o))try{o=JSON.parse(e.responseText)}catch(e){throw e}return{data:o,status:n}}function invokeHook(e,t,r){r=r||noop,isFunction(e)?e(t,function(){r(t)}):r(t)}function handleReadyStateChange(t,r){var e=r.responseType,n=r.url,o=r.success,i=r.error;if(4===t.readyState){var a=normalizeStatus(t.status,{url:n}),s=void 0;if(isResponseOk(a)){try{s=getResponse(t,{responseType:e,status:a})}catch(e){return invokeHook(r.beforeError,{request:t,response:s,options:r,error:e},i)}invokeHook(r.beforeSuccess,{request:t,response:s,options:r},o)}else invokeHook(r.beforeError,{request:t,response:s,options:r,error:new Error("Network Error")},i)}}function xhr(e){(e=merge({method:GET_METHOD,responseType:JSON_RESPONSE_TYPE,withCredentials:!0,cache:!0},e)).method=e.method||GET_METHOD;var t=new XMLHttpRequest;function n(e){var t=e.request,r=e.options;t.send(r.method===GET_METHOD?null:serialize(r.data))}invokeHook(e.configured,{request:t,options:e},function(e){var t=e.request,r=e.options;r.method=r.method.toUpperCase(),t.open(r.method,normalizeUrl(r.url,r),!0),t.onreadystatechange=function(){handleReadyStateChange(t,r)},setWithCredentials(t,r),setResponseType(t,r),setRequestHeader(t,r),invokeHook(r.beforeRequest,{request:t,options:r},n)})}var __extends$1=function(){var n=function(e,t){return(n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(e,t)};return function(e,t){function r(){this.constructor=e}n(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}}(),HOOK_NAMES=["configured","beforeRequest","beforeSuccess","beforeError"];function invokeHooks(e,n){forEach(HOOK_NAMES,function(r){e[r]=function(e,t){n.hooks.invokeWaterfall(r,e,t)}})}var Network=function(t){function e(e){return t.call(this,e)||this}return __extends$1(e,t),e.prototype.request=function(e,t){var r=this,n=merge(!0,{},this.options,t||{},{url:e,extra:{}});return new Promise(function(e,t){isString(n.url)&&n.url?(invokeHooks(n,r),n.success=e,n.error=t,xhr(n)):t({error:createError("Url Error",-2)})})},e}(AbstractNetwork);function isMethodNotImplement(e){var t=e.message;return 10001===e.code||-1!==t.indexOf("暂未实现")||-1!==t.indexOf("not implemented")}function jsbridge(e){var t=e.url,r=e.data;return new Promise(function(n,o){isUndef(GLOBAL.KDJSBridge2)?o(createError("Jsbridge Undefined",-3,1)):GLOBAL.KDJSBridge2.call("WDJSBridge","thorRequest",{url:t,param:r},function(e){var t,r=(null===(t=null==e?void 0:e.param)||void 0===t?void 0:t._errMsg)||{};if(0===r.code)n(e);else{if(isMethodNotImplement(r))return void o(createError("Jsbridge Method Not Implement Error",-3,2));o(createError(r.message||"Jsbridge Method Call Error",-3,3))}})}).then(function(e){return e.param.thorResponse})}var SEARCH_DELIMIT$1="?",PARAM_DELIMIT$1="&",PARAM_VALUE_DELIMIT="=",GLOBAL$1=window,SEARCH_REGXP=/^[^\?#]*\?([^#]*)/;function getSearch(e){var t;return e&&(t=e.match(SEARCH_REGXP))&&t[1]||""}function encode$1(e){return encodeURIComponent(e)}function decode(e){return decodeURIComponent(e.replace(/\+/g," "))}function parse(e){var t=(e=getSearch(e)).split(PARAM_DELIMIT$1),o={};return t.forEach(function(e){var t,r,n;e&&(r=(t=e.split(PARAM_VALUE_DELIMIT))[0],n=t.slice(1).join(PARAM_VALUE_DELIMIT)||"",r&&(r=decode(r),n=decode(n),hasOwn(o,r)?(isArray(o[r])||(o[r]=[o[r]]),o[r].push(n)):o[r]=n))}),o}function stringify(e){if(!isObject(e))return"";var r=[];return forEach(e,function(e,t){isUndef(e)||(isArray(e)||(e=[e]),t=encode$1(t),e.forEach(function(e){r.push(""+t+PARAM_VALUE_DELIMIT+encode$1(e))}))}),r.join(PARAM_DELIMIT$1)}var QUERY_PROPERTY="query",NORMAL_PROPERTIES=["hash","host","hostname","pathname","port","protocol"],QUERY_RELATED_PROPERTIES=["href","search"],READONLY_PROPERTIES=["origin"],defineProperty=Object.defineProperty;function validate(e,t){return e===QUERY_PROPERTY?isObject(t):isString(t)||isNumber(t)}function getSearch$1(e){var t=stringify(e);return(t?SEARCH_DELIMIT$1:"")+t}function defineNormalProperties(e,r){NORMAL_PROPERTIES.forEach(function(t){defineProperty(e,t,{get:function(){return r[t]},set:function(e){validate(t,e)&&(r[t]=e)},enumerable:!0})})}function defineQueryProperty(e,t){var r;defineProperty(e,r=QUERY_PROPERTY,{get:function(){return e.search=getSearch$1(t[r]),t[r]},set:function(e){validate(r,e)&&(t[r]=e)},enumerable:!0})}function defineQueryRelatedProperties(e,r){QUERY_RELATED_PROPERTIES.forEach(function(t){defineProperty(e,t,{get:function(){return r.search=getSearch$1(r[QUERY_PROPERTY]),r[t]},set:function(e){validate(t,e)&&(r[t]=e,r[QUERY_PROPERTY]=parse(r.search))},enumerable:!0})})}function defineReadonlyProperties(t,r){READONLY_PROPERTIES.forEach(function(e){defineProperty(t,e,{get:function(){return r[e]},enumerable:!0})})}var Url=function(){function e(e){isEmpty(e)&&(e=GLOBAL$1.location.href);var t=this._element=GLOBAL$1.document.createElement("A");t.href=e,defineNormalProperties(this,this._element),defineQueryRelatedProperties(this,this._element),defineQueryProperty(this,this._element),defineReadonlyProperties(this,this._element),this.href=t.href}return e.prototype.toString=function(){return this.href},e}();function setQuerystring(e,t,r){var n=GLOBAL$1.location.href;isObject(e)&&(r=t,t=e,e=n),isUndef(e)&&(e=n),r=merge({replace:!0},r);var o,i,a=new Url(e);return r.replace?a.query=merge(a.query||{},t):(o=stringify(t))&&(i=-1===a.search.indexOf(SEARCH_DELIMIT$1)?SEARCH_DELIMIT$1:PARAM_DELIMIT$1,a.search+=i+o),a.toString()}function getQuerystring(e){return isUndef(e)&&(e=GLOBAL$1.location.href),parse(e)}var __extends$2=function(){var n=function(e,t){return(n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)t.hasOwnProperty(r)&&(e[r]=t[r])})(e,t)};return function(e,t){function r(){this.constructor=e}n(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}}();function getRequestUrl(e){return new Url(e).pathname.slice(1)||""}function isLegalRequestUrl(e){if(!isString(e)||!e)return!1;var t=getRequestUrl(e);return t&&3===t.split("/").length}function getRequestData(e){return e&&e.param||{}}var NativeNetwork=function(t){function e(e){return t.call(this,e)||this}return __extends$2(e,t),e.prototype.request=function(e,t){var r=merge({url:getRequestUrl(e),data:getRequestData(t&&t.data)},this.options);return isLegalRequestUrl(e)?jsbridge(r):Promise.reject(createError("Url Error Or Url Pathname Illegal",-2))},e}(AbstractNetwork);function serialize$1(r){isObject(r)&&forEach(r,function(e,t){(isObject(e)||isArray(e))&&(r[t]=JSON.stringify(e))})}function handleResponse(e){var t=e.response,r=e.options,n=t.data;return"json"!==r.responseType||isWideObject(n)?n:Promise.reject(createError("JSON Data Error",-1,1))}function normal(){var e=this;e.hooks.push("beforeRequest",function(e,t){serialize$1(e.options.data),t()});var t=e.request;e.request=function(){return t.apply(e,arguments).then(handleResponse,function(e){var t=isError(e)?e:e.error;return Promise.reject(t)})}}var GLOBAL$2=window,COOKIE_DELIMIT="; ",COOKIE_VALUE_DELIMIT="=",COOKIE_VALUE_REGXP=new RegExp("([^"+COOKIE_VALUE_DELIMIT+"]+)"+COOKIE_VALUE_DELIMIT+"(.*)"),_decodeURIComponent=GLOBAL$2.decodeURIComponent,_encodeURIComponent=GLOBAL$2.encodeURIComponent,_escape=GLOBAL$2.escape;function normalizeGetName(e){return e.replace(/(%[0-9A-Z]{2})+/g,_decodeURIComponent)}var normalize={get:{name:normalizeGetName,value:function(e){return normalizeGetName(e)}},set:{name:function(e){return _encodeURIComponent(e).replace(/%(23|24|26|2B|5E|60|7C)/g,_decodeURIComponent).replace(/[\(\)]/g,_escape)},value:function(e){return _encodeURIComponent(e).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,_decodeURIComponent)}}};function get(r){var n;if(!isEmpty(r))return GLOBAL$2.document.cookie.split(COOKIE_DELIMIT).some(function(e){var t=e.match(COOKIE_VALUE_REGXP);return!(!t||normalize.get.name(t[1])!==r)&&(n=normalize.get.value(t[2]),!0)}),n}var DEVICE_ID={},COMPLETED=!1,INITIALIZED=!1,DEVICE_ID_CALLBACK_QUEUE=[];function push(e){DEVICE_ID_CALLBACK_QUEUE.push(e)}function flush(t){forEach(DEVICE_ID_CALLBACK_QUEUE,function(e){e(t)}),DEVICE_ID_CALLBACK_QUEUE.length=0}function getSuid(t){isUndef(GLOBAL.KDJSBridge2)?t():GLOBAL.KDJSBridge2.call("WDJSBridge","getSuid",{},function(e){e&&e.param&&e.param.suid?t(e.param.suid):t()})}function getCuid(t){isUndef(GLOBAL.KDJSBridge2)?t():GLOBAL.KDJSBridge2.call("WDJSBridge","getCuid",{},function(e){e&&e.param&&e.param.cuid?t(e.param.cuid):t()})}function init(){var e;function t(){2===++e&&(COMPLETED=!0,flush(DEVICE_ID))}INITIALIZED||(INITIALIZED=!0,e=0,getSuid(function(e){e&&(DEVICE_ID.suid=e),t()}),getCuid(function(e){e&&(DEVICE_ID.cuid=e),t()}))}function getDeviceId(e){init(),COMPLETED?e(DEVICE_ID):push(e)}var CSRF_TOKEN_NAME="wdtoken";function appendCSRFTokenParam(e){var t=get(CSRF_TOKEN_NAME);if(t){if(isObject(e))return void(e[CSRF_TOKEN_NAME]=t);if(isFormData(e))return void e.append(CSRF_TOKEN_NAME,t);if(isURLSearchParams(e))return void e.set(CSRF_TOKEN_NAME,t)}}function appendDeviceId(t,r){getDeviceId(function(e){isObject(t)&&(t.context=merge(t.context||{},e)),r()})}function enhanceErrorResponse(e){var t=e.code,r=e.subcode,n=e.message;return{status:{code:isUndef(t)?-1:t,subcode:r,message:n},result:null}}function handleResponse$1(e){return e&&e.status&&0===e.status.code?e:Promise.reject(e)}function handleErrorResponse(e){return Promise.reject(enhanceErrorResponse(e))}function thor(){var e=this;e.hooks.push("configured",function(e,t){var r=e.options;r.responseType="json",r.data=r.data||{},appendCSRFTokenParam(r.data),r.extra.deviceId?appendDeviceId(r.data,function(){t()}):t()});var t=e.request;e.request=function(){return t.apply(e,arguments).then(handleResponse$1,handleErrorResponse)}}var DEFAULT_SCALE=1,TOAST_DURATION=1500;function getScale(){if(isMobile()){var e=document.querySelectorAll('meta[name="viewport"]'),t=e[e.length-1];if(t){var r=t.getAttribute("content"),n=r&&r.match(/initial\-scale=([\d\.]+)/);return n?1/Number(n[1]):DEFAULT_SCALE}}return DEFAULT_SCALE}function toast(e){var t,r=getScale(),n='<div class="hawk-toast">'+e+'</div><style type="text/css">.hawk-toast{position:fixed;left:50%;top:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:10000;width:50%;color:#fff;background:rgba(33,33,33,0.9);line-height:1.5;border-radius:'+8*r+"px;max-width:"+300*r+"px;padding:"+20*r+"px;font-size:"+16*r+"px;}</style>",o=DOCUMENT.body;o&&((t=DOCUMENT.createElement("div")).innerHTML=n,o.appendChild(t),setTimeout(function(){o.removeChild(t)},TOAST_DURATION))}var IDENTITY_CODES=20,IDENTITY_REDIRECT_KEY="redirect",IDENTITY_TIMEOUT=1e3;function identity(e){var t;if(isObject(e)){var r=isObject(e.status)?e.status:{},n=isObject(e.result)?e.result:{},o=n.authPageUrl;if(r.code==IDENTITY_CODES&&o)return o=setQuerystring(o,((t={})[IDENTITY_REDIRECT_KEY]=GLOBAL.location.href,t)),n.message&&toast(n.message),setTimeout(function(){_goto(o)},IDENTITY_TIMEOUT),!1}return!0}var XMLHTTPREQUEST=GLOBAL.XMLHttpRequest,XHR_PROTOTYPE=XMLHTTPREQUEST&&XMLHTTPREQUEST.prototype,ORIGINAL_XHR_SEND=XHR_PROTOTYPE&&XHR_PROTOTYPE.send;function handleRequestResponse(e,t,r){try{if(4==t.readyState&&isResponseOk(t.status)){var n=isObject(t.response)?t.response:parseJSON(t.responseText);return e.beforeSuccess(n,r)}}catch(e){}r()}function interceptRequest(i){isFunction(ORIGINAL_XHR_SEND)&&(XHR_PROTOTYPE.send=function(){var e=arguments,t=this,r=t.onreadystatechange,n=t.onload,o=!1;return r&&(o=!0,t.onreadystatechange=function(){var e=arguments;handleRequestResponse(i,t,function(){r.apply(t,e)})}),n&&!o&&(t.onload=function(){var e=arguments;handleRequestResponse(i,t,function(){n.apply(t,e)})}),ORIGINAL_XHR_SEND.apply(t,e)})}var ELEMENT=GLOBAL.Element,ELEMENT_PROTOTYPE=ELEMENT&&ELEMENT.prototype,SCRIPT_TAGNAME="SCRIPT",JSONP_CALLBACK_NAME="callback",PROXY_ELEMENT_METHODS=["appendChild","insertBefore"];function handleRequestResponse$1(e,t,r){try{return e.beforeSuccess(t,r)}catch(e){}r()}function getCallbackDefinition(e){var t=e.split("."),r=t.length;if(r){var n,o=GLOBAL,i=GLOBAL;try{for(var a=0;a<r;a++){if(!i)return;n=t[a],i=(o=i)[n]}if(!isFunction(i))return}catch(e){return}return{namespace:o,name:n,definition:i}}}function interceptJsonp(i){forEach(PROXY_ELEMENT_METHODS,function(e){var o=ELEMENT_PROTOTYPE&&ELEMENT_PROTOTYPE[e];o&&(ELEMENT_PROTOTYPE[e]=function(e){var t,r,n;return e&&e.tagName===SCRIPT_TAGNAME&&e.src&&(!isString(t=getQuerystring(e.src)[JSONP_CALLBACK_NAME])||(r=getCallbackDefinition(t))&&(n=r.definition,r.namespace[r.name]=function(e){var t=arguments;handleRequestResponse$1(i,e,function(){n.apply(r.namespace,t)})})),o.apply(this,toArray(arguments))})})}var FETCH=GLOBAL.fetch;function handleRequestResponse$2(t,e,r){try{if(isResponseOk(e.status))return e.clone().json().then(function(e){t.beforeSuccess(e,r)}).catch(function(){r()})}catch(e){}r()}function interceptFetch(r){isNativeFunction(FETCH)&&(GLOBAL.fetch=function(){var e=arguments;return FETCH.apply(this,e).then(function(t){return new Promise(function(e){handleRequestResponse$2(r,t,function(){e(t)})})})})}function intercept(e){isObject(e)&&isFunction(e.beforeSuccess)&&(interceptRequest(e),interceptJsonp(e),interceptFetch(e))}function interceptHandler(){intercept({beforeSuccess:function(e,t){identity(e)&&t()}})}function hawk(){GLOBAL.hawk.disabled||(interceptHandler(),GLOBAL.hawk.disabled=!0)}function enhanceErrorResponse$1(e){var t=e.code,r=e.subcode,n=e.message;return{status:{code:isUndef(t)?-3:t,subcode:r,message:n},result:null}}function handleResponse$2(e){return e&&e.status&&0===e.status.code?e:Promise.reject(e)}function handleErrorResponse$1(e){return Promise.reject(enhanceErrorResponse$1(e))}function nativeThor(){var e=this,t=e.request;e.request=function(){return t.apply(e,arguments).then(handleResponse$2,handleErrorResponse$1)}}GLOBAL.hawk=GLOBAL.hawk||{disabled:!1};var HEADERS={"Content-Type":"application/x-www-form-urlencoded; charset=UTF-8",Accept:"application/json, */*"};function create(e){e=merge(!0,{},{headers:HEADERS,cache:!1},e);var t=new Network(e);return t.use(normal),t}var thor$1=create();thor$1.use(hawk),thor$1.use(thor);var nativeThor$1=new NativeNetwork;function request(e,t){return isUseNative(t)?nativeThor$1.request(e,t):thor$1.request(e,t)}nativeThor$1.use(nativeThor);var href=window.location.href,envStr="";/\.((daily)|(dev))\./.test(href)?envStr=".daily":/\.pre\./.test(href)&&(envStr=".pre");var utils={envStr:envStr,isPrivateUrl:function(e){return/^(http(s)?:)?\/\/shop\w+((\.daily)|(\.pre))?\.v\.weidian\.com/.test(e)},analyzeUrl:function(e){return new Url(e)},isUrl:function(e){if("string"!=typeof e)return!1;var t=e.match(/^(?:\w+:)?\/\/(\S+)$/);if(!t)return!1;var r=t[1];return!!r&&!(!/^localhost[\:?\d]*(?:[^\:?\d]\S*)?$/.test(r)&&!/^[^\s\.]+\.\S{2,}$/.test(r))}},requestConfig=function(){return request("//thor".concat(utils.envStr,".weidian.com/skittles/share.getConfig/1.0")).then(function(e){if(e&&e.result){var t=e.result;return{mpConfigList:t.mpConfigList,privateRuleList:t.privateRuleList,multidomainRuleMap:t.urlRules}}return null}).catch(function(){return null})},href$1=window.location.href,requestMultidomainUrl=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:{},t=e.shareUrl,r=void 0===t?href$1:t,n=e.originUrl,o=void 0===n?href$1:n;return request("//thor".concat(utils.envStr,".weidian.com/skittles/share.getUrlNew/1.0"),{method:"post",data:{param:{shareUrl:r,originUrl:o}}}).then(function(e){return e&&e.result&&e.result.success?{url:e.result.shareUrl,mpId:e.result.mpId}:null}).catch(function(){return null})},href$2=window.location.href,requestShortUrl=function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:href$2;return request("//thor".concat(utils.envStr,".weidian.com/skittles/share.getShortUrl/1.0"),{method:"post",data:{param:{url:e}}}).then(function(e){return e.result?e.result.shareUrl:""}).catch(function(){return""})},generateMultidomanUrl=function(t,e){var r,n,o,i=e.multidomainRuleMap,a=utils.analyzeUrl(t),s=a.protocol,u=a.host,c=a.origin,f=a.pathname,l=f.replace(/^\//,"").replace(/\/$/,"").split("/"),p=t;try{var d=i[u];if(d){for(var E=[],h=0,_=d.length;h<_;h++){var v,m,R,y,O,T=d[h],g=T.backupHosts,A=T.backupPath,I=T.pathRegExp;1==T.status&&new RegExp(I).test(t)&&g.length&&(v=g[r=0,n=g.length,o=void 0,o=Math.random(),r+parseInt(o*(n-r)+"")],y=f,A&&(m=/\/$/.test(f),R=[A].concat(_toConsumableArray(l.slice(1))),y="/".concat(R.join("/")).concat(m?"/":"")),O=t.replace("".concat(c).concat(f),""),E.push("".concat(s,"//").concat(v).concat(y).concat(O)))}var L=E.length;1<=L&&(p=E[L-1])}}catch(e){p=t}return utils.isUrl(p)||(p=t),p},generatePrivateUrl=function(e,t){var r=t.privateRuleList,n=t.redirectOrigin,o=void 0===n?"":n;if(!e||!utils.isUrl(e))return e;var i=o||"undefined"!=typeof window&&window.location.href||"";if(!i||!utils.isPrivateUrl(i))return e;for(var a,s,u,c,f,l=utils.analyzeUrl(i),p=l.protocol,d=l.host,E=e,h=-1,_=0,v=r.length;_<v;_++)try{var m=r[_],R=m.status,y=m.pathRegExp,O=new RegExp(y);if(1==R&&O.test(E)){h=_;break}}catch(e){}return-1!==h&&(s=(a=utils.analyzeUrl(e)).pathname,u=a.search,c=a.host,f=a.hash,"i.weidian.com"===c&&(d="".concat(d,"/user")),E="".concat(p,"//").concat(d).concat(s).concat(u).concat(f)),E};function getMpId(e,t){var r="";e=e.replace(/^((www)|(wd)|(rocker)|(h5)|(shop)|(im)|(k))\./,"");for(var n=0,o=t.length;n<o;n++){var i=t[n],a=i.hosts,s=i.mpId;if(-1!==a.indexOf(e)){r=s;break}}return r}var generateMpId=function(e,t){var r="";if(!t)return r;var n=t.mpConfigList,o=t.multidomainRuleMap;if(!n||!o)return r;var i=generateMultidomanUrl(e,{multidomainRuleMap:o}),a=new Url(i).host;return r=getMpId(/weidian\.com/.test(a)?new Url(window.location.href).host:a,n)},isPrivateUrl=function(e){return utils.isPrivateUrl(e)};exports.generateMpId=generateMpId,exports.generateMultidomainUrl=generateMultidomanUrl,exports.generatePrivateUrl=generatePrivateUrl,exports.isPrivateUrl=isPrivateUrl,exports.requestConfig=requestConfig,exports.requestMultidomainUrl=requestMultidomainUrl,exports.requestShortUrl=requestShortUrl;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";

	var util = __webpack_require__(2);
	var sha1 = util._sha1;
	var canvasFp = __webpack_require__(7);
	var Share = __webpack_require__(183);
	var console = util._console;
	var urlTool = __webpack_require__(29);
	var uaTool = __webpack_require__(8);
	var login = __webpack_require__(185);

	var tracker = {};
	var VERSION = "1.0.9";

	/*关系透传参数key & value：
	* key: share_relation
	* value:${分享唯一ID}_${分享来源WD_b_id}_${分享level}
	* */
	var TRAKC_QUERY_NAME = "share_relation";
	var TRACK_TYPE = "pathtracker";
	var TRACK_SUB_TYPE = {
	  click: "share_click",
	  first: "share_first",
	  reshare: "share_reshare"
	};
	tracker.version = VERSION;
	tracker.share = util._noop;
	tracker.getShareUrl = util._noop;
	tracker.successTrack = util._noop;

	tracker.init = function(core) {
	  var isDebug = location.search.indexOf("share_debug") != -1;

	  function _report(subtype, data, callback) {
	    core.report(TRACK_TYPE, subtype, util._normalizeReportData(data), callback);
	  }

	  function _getSearchParams(key) {
	    var search = (window.location.search || "?").replace("?", "");
	    return key
	      ? util._queryStringParse(search)[key] || null
	      : util._queryStringParse(search);
	  }

	  function _getPathInfo(path) {
	    var arr = path.split("_");
	    return {
	      share_id: arr[0] || "",
	      share_buyer_id: arr[1] || "",
	      share_level: arr[2] || ""
	    };
	  }

	  //生成分享唯一id
	  function _getShareId() {
	    try {
	      var salt = canvasFp();
	      var now = new Date();
	      var shareId = sha1(
	        (navigator.userAgent || "") + now.getTime() + Math.random() + salt
	      ).slice(0, 16);

	      return shareId;
	    } catch (e) {
	      return "";
	    }
	  }

	  //获取分享渠道
	  function _getChannel() {
	    var wfr = _getSearchParams("wfr");
	    if (!wfr) {
	      return "unknown";
	    }
	    var result = wfr;
	    return result;
	  }

	  //通过方法从cookie中实时获取登录用户信息
	  function _getUserInfoFromCookie(){
	    return {
	      sellerId: util._getCookie("sid") || util._getCookie("WD_s_id") || "",
	      // 支持一人多店需求，buyerId兼容新增的duid字段
	      buyerId: util._getCookie("duid") || util._getCookie("uid") || util._getCookie("WD_b_id") || ""
	    }
	  }

	  //生成当前用户分享的链接
	  var share_id_first = "";
	  function _getShareUrl(url) {
	    try {
	      if (!url) {
	        return "";
	      }

	      var pathQuery = _getSearchParams(TRAKC_QUERY_NAME);
	      var value = "";
	      var share_buyer_id = _getUserInfoFromCookie().buyerId;
	      var share_id = "";
	      var share_level = "";
	      if (pathQuery) {
	        //再次分享
	        var pathInfo = _getPathInfo(pathQuery);
	        share_id = pathInfo.share_id;
	        share_level = parseInt(pathInfo.share_level || 0) + 1;
	      } else {
	        //首次分享
	        share_id = _getShareId();
	        share_id_first = share_id;
	        share_level = 1;
	      }
	      value = [share_id, share_buyer_id, share_level].join("_");

	      var urlParam = {};
	      urlParam[TRAKC_QUERY_NAME] = value;
	      return urlTool.setQuerystring(url, urlParam);
	    } catch (e) {
	      return url;
	    }
	  }

	  //基于不同的类型获取上报的数据信息
	  function _getTrackOption(type) {
	    try {
	      var pathQuery = _getSearchParams(TRAKC_QUERY_NAME);
	      var metaInfo = util._getMetaFromDom();
	      var pathInfo = pathQuery ? _getPathInfo(pathQuery) : null;
	      var page_id = "";
	      if (metaInfo.spma && metaInfo.spmb) {
	        page_id = metaInfo.spma + "." + metaInfo.spmb;
	      }

	      if (type == TRACK_SUB_TYPE.click) {
	        //click数据类型
	        if (!pathQuery) {
	          return {};
	        } else {
	          return {
	            share_id: pathInfo.share_id,
	            page_id: page_id,
	            share_buyer_id: pathInfo.share_buyer_id,
	            share_channel: _getChannel(),
	            click_buyer_id: _getUserInfoFromCookie().buyerId,
	            click_seller_id: _getUserInfoFromCookie().sellerId,
	            share_level: parseInt(pathInfo.share_level),
	            gmt_action: Date.now().toString(),
	            business_type: null,
	            business_id: null
	          };
	        }
	      } else if (type == TRACK_SUB_TYPE.first) {
	        //首次分享数据类型
	        return {
	          share_id: share_id_first || _getShareId(),
	          page_id: page_id,
	          share_buyer_id: _getUserInfoFromCookie().buyerId,
	          share_seller_id: _getUserInfoFromCookie().sellerId,
	          share_level: 1,
	          gmt_action: Date.now().toString(),
	          business_type: null,
	          business_id: null
	        };
	      } else if (type == TRACK_SUB_TYPE.reshare) {
	        //再次分享数据类型
	        return {
	          share_id: pathInfo.share_id,
	          page_id: page_id,
	          share_buyer_id: pathInfo.share_buyer_id,
	          reshare_buyer_id: _getUserInfoFromCookie().buyerId,
	          reshare_seller_id: _getUserInfoFromCookie().sellerId,
	          share_level: parseInt(pathInfo.share_level || 0) + 1,
	          gmt_action: Date.now().toString(),
	          business_type: null,
	          business_id: null
	        };
	      } else {
	        return {};
	      }
	    } catch (e) {
	      console.log(e);
	      return {};
	    }
	  }

	  //自动上报通过分享点击的数据内容
	  function _trackByPageView() {
	    try {
	      // core.init("unknown", "unknown", "0.0.0");
	      var option = _getTrackOption(TRACK_SUB_TYPE.click);
	      isDebug && console.log("share_click:", option);
	      if (Object.keys(option).length != 0) {
	        _report(TRACK_SUB_TYPE.click, option);
	      }
	    } catch (e) {
	      console.log(e);
	    }
	  }

	  //上报当前用户主动分享成功的数据内容
	  function _trackByShare(channel) {
	    try {
	      var pathQuery = _getSearchParams(TRAKC_QUERY_NAME);
	      channel = channel || "unknown";
	      if (pathQuery) {
	        //再次分享上报
	        var option = _getTrackOption(TRACK_SUB_TYPE.reshare);
	        option["reshare_channel"] = channel;
	        isDebug && console.log("share_reshare:", option);
	        _report(TRACK_SUB_TYPE.reshare, option);
	      } else {
	        //首次分享上报
	        var option = _getTrackOption(TRACK_SUB_TYPE.first);
	        option["share_channel"] = channel;
	        isDebug && console.log("share_first:", option);
	        _report(TRACK_SUB_TYPE.first, option);
	      }
	    } catch (e) {}
	  }

	  (function() {
	    //微信环境，如果未登录进行静默登录
	    try {
	      if (uaTool.isMiniProgram()) {
	        return;
	      }
	      if (
	        util._getCookie("is_login") != "true" &&
	        uaTool.isWeiXin() &&
	        util._listDisabledAuto().indexOf("silentlogin") < 0
	      ) {
	        var redirectUrl = location.href;
	        var hash = location.hash;
	        var ua = navigator.userAgent;
	        var isAndorid = /Android/.test(ua);
	        var query = util._queryStringParse(location.search);
	        var SLIENT_LOGIN_KEY = "slr";
	        if (hash !== "" && isAndorid) {
	          var salt = query[SLIENT_LOGIN_KEY] || "";
	          query[SLIENT_LOGIN_KEY] = util._generateToken(salt, 4);
	        } else if (query[SLIENT_LOGIN_KEY]) {
	          delete query[SLIENT_LOGIN_KEY];
	        }

	        var querystring = util._queryStringStringify(query);
	        redirectUrl = location.href.replace(/(\?|#)[\S]*$/, "") + "?" + querystring + hash;

	        // var domain = util._get2ndLevelDomain(location.hostname);
	        // // 这里是对特殊域名做特殊判断

	        // if (util._isWDHost()) {
	        //   var redirectApi = "https://sso.weidian.com/user/synclogin";
	        //   if (location.host.match(/\.daily\./) !== null) {
	        //     redirectApi = "https://sso-daily.test.weidian.com/user/synclogin";
	        //   }
	        //   if (location.host.match(/\.pre\./) !== null) {
	        //     redirectApi = "https://sso-pre.test.weidian.com/user/synclogin";
	        //   }
	        //   redirectUrl =
	        //     redirectApi +
	        //     "?type=" +
	        //     domain +
	        //     "&redirect=" +
	        //     encodeURIComponent(redirectUrl);
	        // }

	        // var slientLoginUrl =
	        //   "https://sso.weidian.com/user/oauth/wechat/silentlogin?redirect=";
	        // if (location.host.match(/\.daily\./) !== null) {
	        //   slientLoginUrl =
	        //     "https://sso-daily.test.weidian.com/user/oauth/wechat/silentlogin?redirect=";
	        // }
	        // if (location.host.match(/\.pre\./) !== null) {
	        //   slientLoginUrl =
	        //     "https://sso-pre.test.weidian.com/user/oauth/wechat/silentlogin?redirect=";
	        // }

	        // location.href = slientLoginUrl + encodeURIComponent(redirectUrl);

	        location.href = login.wechatSlientLogin({ url: redirectUrl })
	      } else {
	        window.addEventListener("DOMContentLoaded", function(event) {
	          _trackByPageView();
	        });
	      }
	    } catch (e) {
	      console.log(e);
	    }
	  })();

	  tracker.version = VERSION;

	  var old = Share.prototype.resetUserConfig;
	  Share.prototype.resetUserConfig = function(config, notSyncTopRight) {
	    if (config.url) {
	      var url = config.url;
	      config.url = _getShareUrl(url);
	    }

	    old.call(this, config, notSyncTopRight);
	  };

	  tracker.share = function(option) {
	    try {
	      option = option || {};
	      var url = option.config.url;
	      //修改分享url share_realtion的值
	      if (url) {
	        option.config.url = _getShareUrl(url);
	      }

	      if (typeof option.option === "object") {
	        var _wxCallback = option.option.wxSuccessCb;
	        //修改微信分享成功的回到函数
	        option.option.wxSuccessCb = function(wfr, res) {
	          _trackByShare(wfr);
	          if (_wxCallback && typeof _wxCallback == "function") {
	            _wxCallback(wfr, res);
	          }
	        };
	      } else {
	        option.option = {
	          wxSuccessCb: function(wfr) {
	            _trackByShare(wfr);
	          }
	        };
	      }
	      return new Share(option);
	    } catch (e) {
	      console.log(e);
	    }
	  };

	  tracker.share.CONSTANT = {
	    CHATS: "1",
	    MOMENT: "2",
	    QQ: "3",
	    QZONE: "4",
	    WEIBO: "5"
	  };
	  /*
	    * 生成当前分享的url，
	    * @param url {string} 指定的url
	    * return {string} 带有share_relation关系的url
	    * */
	  tracker.getShareUrl = _getShareUrl;

	  /*
	    * 分享成功,上报数据
	    * @param channel {string} 分享渠道，默认unkonwn
	    * */
	  tracker.successTrack = _trackByShare;
	};
	module.exports = tracker;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

	!(function (factory) {
	  if (typeof module !== "undefined" && module.exports) {
	    module.exports = factory();
	  } else {
	    window.ShareV2 = factory();
	  }
	})(function () {
	  var SdkLoader = __webpack_require__(3);
	  var ua = __webpack_require__(5);
	  var util = __webpack_require__(2);
	  var cssFactory = __webpack_require__(184);
	  // var multiDomain = require('../../lib/multiple-domain');
	  cssFactory();

	  var WFR_MAP = {
	    qq: "qfriendh5",
	    qzone: "qzoneh5",
	    chats: "wxh5",
	    moments: "wxph5"
	  };

	  function Share(setting) {
	    var _this = this;
	    this.errorFn = null;
	    SdkLoader().ready(function (env, error) {
	      if (error) {
	        _this.errorFn && _this.errorFn();
	        return;
	      }

	      _this._setShareOption(setting.option);
	      _this._setUserConfig(setting.config, _this._initShareDOM);
	    });
	  }

	  /**
	     * 默认分享渠道配置参数
	     * @type {{isInApp: boolean, appName: string}}
	     * @scene 卖家版 native 面板渠道
	      {1:微信好友,2:朋友圈,3:qq好友,4:qq空间,5:微博,6复制链接}
	     * @momentMode 卖家版 native 面板朋友圈分享方式
	      {0:普通分享,1:多图分享,2:大图分享,3:小程序分享}
	     */
	  var defaultOption = {
	    vbuyerShare: true,
	    wdShare: true,
	    scene: [1, 2, 3, 4, 5],
	    prependHtml: "",
	    wxShareTipImge: "",
	    wxSuccessCb: null,
	    appSuccessCb: null,
	    hideMenuItems: [],
	    showMenuItems: [],
	    momentMode: 0,
	    panel: [1]
	  };

	  Share.prototype.direct = function (channel) {
	    /* istanbul ignore next */
	    if (ua.isQQBrowser) {
	      this._shareInQQBrowser(channel);
	      return;
	    }

	    if (ua.isApp) {
	      this._showNativeShare(channel);
	      return;
	    }

	    this.showPanel();
	  };

	  Share.prototype.sharePyq = function () {
	    this.share("moments");
	  };

	  Share.prototype.shareChats = function () {
	    this.share("chats");
	  };

	  Share.prototype.shareQZone = function () {
	    this.share("qzone");
	  };

	  Share.prototype.shareQQ = function () {
	    this.share("qq");
	  };

	  /**
	   * 对外接口，用来重设分享配置
	   */
	  Share.prototype.resetShareOption = function (option) {
	    if (!option.showMenuItems) {
	      option.showMenuItems = defaultOption.showMenuItems;
	    }
	    if (!option.hideMenuItems) {
	      option.hideMenuItems = defaultOption.hideMenuItems;
	    }
	    var _this = this;
	    SdkLoader().ready(function () {
	      var newOption = assgin(option, _this.option);
	      _this._setShareOption(newOption);
	      _this._initShareDOM(true);
	      if (ua.isWx) {
	        _this._setWXMenuEvent();
	      }
	    });
	  };

	  /**
	   * 对外接口，用来重设用户分享信息
	   */
	  Share.prototype.resetUserConfig = function (
	    config,
	    notSyncTopRight,
	    callback
	  ) {
	    var _this = this;
	    if (typeof notSyncTopRight === "function") {
	      callback = notSyncTopRight;

	      notSyncTopRight = false;
	    }

	    //merge参数
	    SdkLoader().ready(function (env) {
	      var newConfig = assgin(config, _this.config);

	      _this._setUserConfig(newConfig, function () {
	        // 若resetConfig回调优先于初始化config回调返回，则_this.option.$dom 等于undefined
	        if (!_this.option.$dom) {
	          _this._initShareDOM()
	        } else {
	          // todo
	          if (ua.isWx) {
	            _this._setWXMenuEvent();
	          }

	          // 需要jsbridge 加载完毕
	          if (
	            ua.isVbuyer &&
	            window.KDJSBridge2 !== undefined &&
	            _this.option.vbuyerShare &&
	            !notSyncTopRight
	          ) {
	            _this._showVbuyerShare();
	          }

	          if (
	            ua.isWD &&
	            window.KDJSBridge2 !== undefined &&
	            _this.option.wdShare &&
	            !notSyncTopRight
	          ) {
	            _this._showWDShare();
	          }
	        }

	        typeof callback === "function" && callback();
	      });
	    });
	  };

	  /**
	   * 对外接口,直接显示分享面板
	   */
	  Share.prototype.showPanel = function () {
	    var self = this;
	    var config = self.config;
	    var errorCallback = null;

	    SdkLoader().ready(function (env, error) {
	      if (error) {
	        errorCallback && errorCallback();
	        return;
	      }

	      if (self.option.isInApp !== false) {
	        self._showNativeShare();
	      } else {
	        if (self.option.$dom) {
	          self.option.$dom.style.display = "block";
	          document.body.classList.add("ui-share__hidden");
	          document.querySelector(".copy-href") &&
	            (document.querySelector(".copy-href").value = config.url);
	        } else {
	          setTimeout(function () {
	            self.option.$dom.style.display = "block";
	            document.body.classList.add("ui-share__hidden");
	            document.querySelector(".copy-href") &&
	              (document.querySelector(".copy-href").value = config.url);
	          }, 300);
	        }
	      }
	    });

	    return {
	      catch: function (callback) {
	        if (typeof callback === "function") {
	          errorCallback = callback;
	        }
	      }
	    };
	  };

	  /**
	   * 对外接口,捕获分享初始化错误
	   */
	  Share.prototype.catch = function (callback) {
	    if (typeof callback === "function") {
	      this.errorFn = callback;
	    } else {
	      console.log("错误处理必须为函数");
	    }
	    return this;
	  };

	  /**
	   * 根据当前环境，配置参数
	   * @private
	   */
	  Share.prototype._setShareOption = function (option) {
	    var self = this,
	      newOption = {};

	    newOption.isInApp = ua.isApp;

	    if (option && option.vbuyerShare !== undefined) {
	      newOption.vbuyerShare = option.vbuyerShare;
	    } else {
	      newOption.vbuyerShare = defaultOption.vbuyerShare;
	    }

	    if (option && option.wdShare !== undefined) {
	      newOption.wdShare = option.wdShare;
	    } else {
	      newOption.wdShare = defaultOption.wdShare;
	    }

	    if (option && option.scene !== undefined && option.scene.length > 0) {
	      newOption.scene = option.scene;
	    } else {
	      newOption.scene = defaultOption.scene;
	    }

	    if (option && option.panel !== undefined && option.panel.length > 0) {
	      newOption.panel = option.panel;
	    } else {
	      newOption.panel = defaultOption.panel;
	    }

	    newOption.wxShareTipImge =
	      (option && option.wxShareTipImge) || defaultOption.wxShareTipImge;
	    newOption.wxSuccessCb =
	      (option && option.wxSuccessCb) || defaultOption.wxSuccessCb;
	    newOption.appSuccessCb =
	      (option && option.appSuccessCb) || defaultOption.appSuccessCb;
	    newOption.hideMenuItems =
	      (option && option.hideMenuItems) || defaultOption.hideMenuItems;
	    newOption.showMenuItems =
	      (option && option.showMenuItems) || defaultOption.showMenuItems;
	    newOption.momentMode =
	      (option && option.momentMode) || defaultOption.momentMode;

	    newOption.$dom = self.option && self.option.$dom;

	    newOption.prependHtml =
	      option && option.prependHtml !== undefined
	        ? option.prependHtml
	        : defaultOption.prependHtml;

	    self.option = newOption;
	  };

	  /**
	   * 配置用户分享信息
	   * @private
	   */
	  var fixDomainQueue = []; //缓存多域名切换的回调记录
	  Share.prototype._setUserConfig = function (config, callback) {
	    var urlChanged = false;
	    var multiDomain = util._isOpenMultiDomain();

	    var prevShareUrl = (this.config && this.config.url) || "";
	    var curShareUrl = config.url || "";

	    if (prevShareUrl !== curShareUrl && multiDomain) {
	      urlChanged = true;
	    }

	    var _this = this;
	    this.config = {};
	    var shareConfig = config;
	    shareConfig.pyq = shareConfig.pyq || shareConfig.title;

	    if (Object.getOwnPropertyNames(shareConfig).length > 0) {
	      for (var key in shareConfig) {
	        this["config"][key] = shareConfig[key];
	      }
	    }

	    if (urlChanged) {
	      // 每次请求生成唯一的时间戳
	      var _callbackId = +new Date();

	      fixDomainQueue.push(_callbackId);

	      SdkLoader().block();
	      // 根据window下rulemap规则，去获取替换后多备份域名url
	      // multiDomain.ruleMapPromise.then(function (ruleMap) {
	      //   _this.config.url = multiDomain.getNewUrlByRuleMap(_this.config.url, window.multiDomainRuleMap)
	      //   // TODO 获取当前url对应映射规则的mpid（微信公众号原始id）
	      //   SdkLoader().reset(mpid).ready(function () {
	      //     callback.call(_this);
	      //   });
	      // }).catch(function () {

	      // })
	      this._getDomianFixedUrl(function (res) {
	        // 保证最后一次一定执行，且立即清空当前请求消息队列
	        if (
	          fixDomainQueue.length === 0 ||
	          fixDomainQueue.indexOf(_callbackId) < 0
	        ) {
	          return;
	        } else if (_callbackId === fixDomainQueue[fixDomainQueue.length - 1]) {
	          fixDomainQueue = [];
	        }

	        var mpid = "";
	        if (res && res.status && res.status.code === 0) {
	          mpid = res.result && res.result.mpId;
	          // 重置分享 url
	          _this.config.url = res.result && res.result.shareUrl;
	        }
	        SdkLoader()
	          .reset(mpid)
	          .ready(function () {
	            callback.call(_this);
	          });
	      });
	      return;
	    }

	    // if (isRestAndNoUrl || util._isWDHost()) {
	    callback && callback.call(_this);
	    return;
	    // }
	  };

	  /**
	   * 获取多域名最终 url 与 mpid
	   */
	  Share.prototype._getDomianFixedUrl = function (callback) {
	    var shareUrl = this.config.url;

	    var fixUrlThor = "https://thor.weidian.com/skittles/share.getUrlNew/1.0";
	    if (location.host.match(/\.daily\./) !== null) {
	      fixUrlThor =
	        "https://thor.daily.weidian.com/skittles/share.getUrlNew/1.0";
	      // shareUrl = shareUrl.replace(/^https/, "http");
	    }
	    if (location.host.match(/\.pre\./) !== null) {
	      fixUrlThor = "https://thor.pre.weidian.com/skittles/share.getUrlNew/1.0";
	      // shareUrl = shareUrl.replace(/^https/, "http");
	    }

	    util._post({
	      url: fixUrlThor,
	      data: {
	        param: util._JSONStringifySafty({
	          shareUrl: shareUrl,
	          originUrl: location.href
	        })
	      },
	      timeout: 800,
	      success: function (res) {
	        callback && callback(res);
	      },
	      error: function (err) {
	        callback && callback(err);
	      }
	    });
	  };

	  /**
	   * 初始化分享DOM结构
	   * @private
	   */
	  Share.prototype._initShareDOM = function (isReset) {
	    var option = this.option;
	    if (isReset) {
	      if (ua.isQQ || ua.isWx) {
	        option.$dom.innerHTML = this._renderShareTip();
	      } /* istanbul ignore next */ else if (ua.isQQBrowser) {
	        option.$dom.innerHTML = this._renderSharePanel();
	      } else {
	        option.$dom.innerHTML = this._renderCopyPanel();
	      }
	      this._bindEvent();
	      return;
	    }

	    var shareBox = document.createElement("div");
	    shareBox.id = "ui-share-box";
	    shareBox.style.display = "none";
	    shareBox.dataset.spider = "share";
	    this.option.$dom = shareBox;

	    if (ua.isQQ) {
	      //在QQ中
	      shareBox.innerHTML = this._renderShareTip();
	      this._initQQShare();
	    } else if (ua.isWx) {
	      //在微信中
	      shareBox.innerHTML = this._renderShareTip();
	      this._setWXMenuEvent();
	    } /* istanbul ignore next */ else if (ua.isQQBrowser) {
	      //在QQ浏览器中
	      shareBox.innerHTML = this._renderSharePanel();
	    } else if (option.isInApp) {
	      this._showCornerShare();
	    } else {
	      shareBox.innerHTML = this._renderCopyPanel();
	    }

	    document.body.appendChild(shareBox);
	    this._bindEvent();
	  };

	  Share.prototype._initQQShare = function () {
	    var self = this,
	      config = {
	        title: self.config.title,
	        desc: self.config.content,
	        share_url: _coverUrlWfr(self.config.url, "qfriendh5"),
	        image_url: self.config.img
	      };
	    window.mqq.data.setShareInfo(config);
	  };

	  Share.prototype._setWXMenuEvent = function () {
	    if (!window.wx) return;

	    //分享给朋友
	    window.wx.onMenuShareAppMessage(this._setWeixinConfig("chats"));

	    //分享到朋友圈
	    window.wx.onMenuShareTimeline(this._setWeixinConfig("moments"));

	    //分享到QQ
	    window.wx.onMenuShareQQ(this._setWeixinConfig("qq"));

	    //分享到QQ空间
	    window.wx.onMenuShareQZone(this._setWeixinConfig("qzone"));

	    //隐藏部分菜单按钮
	    if (this.option.hideMenuItems.length > 0) {
	      window.wx.hideMenuItems(this._setMenuItem(this.option.hideMenuItems));
	    }

	    if (this.option.showMenuItems.length > 0) {
	      window.wx.showMenuItems(this._setMenuItem(this.option.showMenuItems));
	    }
	  };

	  Share.prototype._setMenuItem = function (menuItems) {
	    var menuList = [];
	    var shareIndex = menuItems.indexOf("share");
	    if (shareIndex > -1) {
	      [].push.apply(menuList, [
	        "menuItem:share:appMessage",
	        "menuItem:share:timeline",
	        "menuItem:share:qq",
	        "menuItem:share:weiboApp",
	        "menuItem:favorite",
	        "menuItem:share:facebook",
	        "menuItem:share:QZone"
	      ]);
	      menuItems.splice(shareIndex, 1);
	    }

	    var protectIndex = menuItems.indexOf("protect");
	    if (protectIndex > -1) {
	      [].push.apply(menuList, [
	        "menuItem:editTag",
	        "menuItem:delete",
	        "menuItem:copyUrl",
	        "menuItem:originPage",
	        "menuItem:readMode",
	        "menuItem:openWithQQBrowser",
	        "menuItem:openWithSafari",
	        "menuItem:share:email"
	      ]);
	      menuItems.splice(protectIndex, 1);
	    }

	    [].push.apply(menuList, menuItems);
	    if (menuList.length > 0) {
	      return { menuList: menuList };
	    }

	    return {};
	  };

	  /**
	   * 微信分享参数设置
	   * @param way
	   * @returns {{title: string, desc: string, link: string, imgUrl: string, trigger: param.trigger, fail: param.fail}}
	   * @private
	   */
	  Share.prototype._setWeixinConfig = function (channel) {
	    var self = this,
	      channels = {
	        chats: {
	          title: "分享给微信好友",
	          scene: 1
	        },
	        moments: {
	          title: "分享到朋友圈",
	          scene: 2
	        },
	        qq: {
	          title: "分享给qq好友",
	          scene: 3
	        },
	        qzone: {
	          title: "分享到qq空间",
	          scene: 4
	        }
	      },
	      wfr = WFR_MAP[channel],
	      link = _coverUrlWfr(self.config.url, wfr),
	      param = {
	        title: self.config.title,
	        desc: self.config.content,
	        link: link,
	        imgUrl: self.config.img,
	        trigger: function (res) {
	          if (window.spider) {
	            window.spider.trackAction({
	              actionName: "_share",
	              actionArgs: {
	                app: "wechat",
	                channel: channels[channel].title.slice(3),
	                shareUrl: link
	              }
	            });
	          }
	        },
	        success: function (res) {
	          var result = {
	            error: false,
	            result: {
	              message: "success",
	              scene: channels[channel].scene
	            }
	          };
	          self.option.wxSuccessCb && self.option.wxSuccessCb(wfr, result);
	        }
	      };

	    if (channel && channel === "moments") {
	      delete param.desc;
	      if (channel === "moments") param.title = self.config.pyq;
	    }

	    return param;
	  };

	  /**
	   * 微信模板
	   * @returns {string}
	   */
	  Share.prototype._renderShareTip = function () {
	    return (
	      '<a href="javascript:;" class="ui-share__placeholder J_closed"></a>' +
	      '<a href="javascript:;" class="ui-share--weixin J_closed">' +
	      '<img src="' +
	      (this.option.wxShareTipImge
	        ? this.option.wxShareTipImge
	        : "https://si.geilicdn.com/110c5d9454010c64fc4366d75230a729.png") +
	      '"></a>'
	    );
	  };

	  /**
	   * 其他模板
	   * @returns {string}
	   */
	  /* istanbul ignore next */
	  Share.prototype._renderSharePanel = function () {
	    var html = "";
	    var scene = this.option.scene;

	    if (scene.indexOf(1) >= 0) {
	      html +=
	        '<a href="javascript:;" class="ui-share--icon J_channel" scene="0" type="weixin" channel="chats" spm-auto data-spider="dsharechats">' +
	        '<img src="https://si.geilicdn.com/hz_img_032100000158d24945100a02685e_48_48_unadjust.png">' +
	        "<p>微信好友</p>" +
	        "</a>";
	    }

	    if (scene.indexOf(2) >= 0) {
	      html +=
	        '<a href="javascript:;" class="ui-share--icon J_channel" scene="1" type="weixin" channel="moments" spm-auto data-spider="dsharemoments">' +
	        '<img src="https://si.geilicdn.com/hz_img_033300000158d26282d20a02685e_48_48_unadjust.png">' +
	        "<p>朋友圈</p>" +
	        "</a>";
	    }

	    if (scene.indexOf(3) >= 0) {
	      html +=
	        '<a href="javascript:;" class="ui-share--icon J_channel" type="qq" scene="0" channel="qq" spm-auto data-spider="dshareqq">' +
	        '<img src="https://si.geilicdn.com/hz_img_136f00000158d26814dc0a026860_48_48_unadjust.png">' +
	        "<p>QQ好友</p>" +
	        "</a>";
	    }

	    if (scene.indexOf(4) >= 0) {
	      html +=
	        '<a href="javascript:;" class="ui-share--icon J_channel" type="qq" scene="1" channel="qzone" spm-auto data-spider="dshareqzone">' +
	        '<img src="https://si.geilicdn.com/hz_img_030900000158d22b05690a02685e_48_48_unadjust.png">' +
	        "<p>QQ空间</p>" +
	        "</a>";
	    }
	    return (
	      '<a href="javascript:;" class="ui-share__placeholder J_closed"></a>' +
	      '<section class="ui-share">' +
	      '<div class="ui-share--panel">' +
	      this.option.prependHtml +
	      html +
	      '</div><a href="javascript:;" class="ui-share--closed J_closed">取消</a>' +
	      "</section>"
	    );
	  };

	  Share.prototype._renderCopyPanel = function () {
	    return (
	      '<a href="javascript:;" class="ui-share__placeholder J_closed"></a>' +
	      '<section class="ui-share">' +
	      '<div class="ui-share--panel">' +
	      '<div class="ui-share-copy">' +
	      "<p>长按复制下方链接，去粘贴给好友吧</p>" +
	      '<input class="copy-href" type="text">' +
	      "</div>" +
	      '</div><a href="javascript:;" class="ui-share--closed J_closed">取消</a>' +
	      "</section>"
	    );
	  };

	  Share.prototype._showCornerShare = function () {
	    var self = this;

	    if (ua.isVbuyer && self.option.vbuyerShare) {
	      self._registerVbuyerShareCallback();
	      self._showVbuyerShare();
	    } else if (ua.isWD && self.option.wdShare) {
	      self._showWDShare();
	    }
	  };

	  var isRegisterConerShareCallback = false;
	  Share.prototype._registerVbuyerShareCallback = function () {
	    var _this = this;
	    !isRegisterConerShareCallback &&
	      window.KDJSBridge2 &&
	      window.KDJSBridge2.FN_registerHandler(
	        "share",
	        "nativeShareResult",
	        function (res) {
	          var standardBridgeRes = {
	            param: res,
	            bridgeParam: {
	              status: {
	                status_code: 0,
	                status_reason: ""
	              }
	            }
	          };
	          var result = _this._logAfterNativeShare(standardBridgeRes);
	          _this.option.appSuccessCb && _this.option.appSuccessCb(res, result);
	        }
	      );
	    isRegisterConerShareCallback = true;
	  };

	  Share.prototype._showVbuyerShare = function () {
	    var config = this.config;
	    var option = this.option;

	    var panelList = this._setNativePanel();
	    var newShare = {
	      panelList: panelList,
	      userInfo: {
	        from: "h5",
	        wdFriendTitle: config.title,
	        wdFriendSubTitle: config.content,
	        utInfo: {}
	      }
	    };
	    if (config.header) {
	      newShare.headerInfo = config.header;
	    }
	    window.KDJSBridge2 &&
	      window.KDJSBridge2.call(
	        "Share",
	        "showOption",
	        {
	          title: config.title,
	          content: config.content,
	          content_ext: config.pyq,
	          url: config.img,
	          cmd: config.url,
	          scene: option.scene,
	          src: location.href,
	          newShare: newShare,
	          h5ShareContext: {}
	        },
	        function (res) {
	          if (res && res.param && res.param.result != 0) {
	            window.vcollect &&
	              window.vcollect.reportError({
	                abstract: "webview 右上角唤起失败",
	                url: location.href
	              });
	          }
	        }
	      );
	  };

	  Share.prototype._showWDShare = function () {
	    var _this = this;
	    var config = this.config;
	    var option = this.option;
	    window.KDJSBridge2 &&
	      window.KDJSBridge2.call(
	        "WDJSBridge",
	        "share",
	        {
	          title: config.title,
	          content: config.content,
	          content_ext: config.pyq,
	          url: config.img,
	          cmd: config.url,
	          mini_path: config.path,
	          mini_id: config.id,
	          mini_withShareTicket: "1",
	          mini_programType: config.miniType,
	          img_urls: config.img_urls,
	          moments_mode: option.momentMode,
	          scene: option.scene,
	          action_immediately: 0,
	          copy_url: config.copyUrl
	        },
	        function (res) {
	          var result = _this._logAfterNativeShare(res);
	          _this.option.appSuccessCb && _this.option.appSuccessCb(res, result);
	        }
	      );
	  };

	  /**
	   * 绑定事件
	   */
	  Share.prototype._bindEvent = function () {
	    var self = this;
	    var closed = document.querySelectorAll(".J_closed");
	    var channel = document.querySelectorAll(".J_channel");
	    var invoking = false;

	    for (var i = 0; i < closed.length; i++) {
	      closed[i].addEventListener("click", function () {
	        invoking = false;
	        self.option.$dom.style.display = "none";
	        document.body.classList.remove("ui-share__hidden");
	      });
	    }
	    /* istanbul ignore next */
	    for (var k = 0; k < channel.length; k++) {
	      channel[k].addEventListener("click", function () {
	        if (invoking == true) return;
	        var channel = this.getAttribute("channel");
	        self._shareInQQBrowser(channel);
	        invoking = true;

	        setTimeout(function () {
	          invoking = false;
	        }, 5000);
	      });
	    }
	  };

	  /**
	   * 调用QQ浏览器分享服务
	   * @private
	   */
	  /* istanbul ignore next */
	  Share.prototype._shareInQQBrowser = function (channel) {
	    var curConfig = this.config,
	      map = { qq: 4, qzone: 3, chats: 1, moments: 8 },
	      toApp = map[channel],
	      wfr = WFR_MAP[channel];

	    var url = _coverUrlWfr(curConfig.url, wfr);
	    var config = {
	      url: url,
	      title: curConfig.title,
	      description: curConfig.content,
	      img_url: curConfig.img,
	      to_app: toApp //微信好友1,腾讯微博2,QQ空间3,QQ好友4,生成二维码7,微信朋友圈8,啾啾分享9,复制网址10,分享到微博11,创意分享13
	    };
	    if (toApp == 8) {
	      config.title = curConfig.pyq;
	    }
	    browser.app.share(config);
	  };

	  /**
	   * 调用native分享
	   * @private
	   */
	  Share.prototype._showNativeShare = function (directScene) {
	    var _this = this;
	    var config = this.config;
	    var option = this.option;
	    if (ua.isVbuyer) {
	      var panelList = this._setNativePanel(directScene);
	      var newShare = {
	        panelList: panelList,
	        userInfo: {
	          from: "h5",
	          wdFriendTitle: config.title,
	          wdFriendSubTitle: config.content,
	          utInfo: {}
	        }
	      };
	      if (config.header) {
	        newShare.headerInfo = config.header;
	      }
	      window.KDJSBridge2 &&
	        window.KDJSBridge2.call(
	          "WDJSBridge",
	          "share",
	          {
	            title: config.title,
	            content: config.content,
	            content_ext: config.pyq,
	            url: config.img,
	            cmd: config.url,
	            mini_path: config.path,
	            mini_id: config.id,
	            mini_withShareTicket: "1",
	            mini_programType: config.miniType,
	            img_urls: config.img_urls,
	            moments_mode: option.momentMode,
	            scene: option.scene,
	            copy_url: config.copyUrl,
	            newShare: newShare
	          },
	          function (res) {
	            var result = _this._logAfterNativeShare(res);
	            option.appSuccessCb && option.appSuccessCb(res, result);
	          }
	        );
	    }
	    if (ua.isWD) {
	      function _generateShareParam(type) {
	        var param = {
	          title: type === "weChatMoment" ? config.pyq : config.title,
	          url: config.url,
	          des: config.content,
	          imageUrl: config.img
	        };

	        //分享出去是小程序特有字段
	        if (type === "weChatMiniProgram") {
	          param.id = config.id;
	          param.environment = 0;
	          param.path = config.path;
	          param.shareTicket = "yes";
	        }
	        return param;
	      }

	      function _assginType(type) {
	        var shareParam = _generateShareParam(type);
	        var param = {};
	        for (var key in shareParam) {
	          param[key] = shareParam[key];
	        }

	        param.type = type;
	        return param;
	      }

	      var items = [
	        {
	          scene: 1,
	          title: "微信好友",
	          iconName: "1",
	          shareParams: _assginType("weChat")
	        },
	        {
	          scene: 2,
	          title: "微信朋友圈",
	          iconName: "3",
	          shareParams: _assginType("weChatMoment")
	        },
	        {
	          scene: 3,
	          title: "QQ好友",
	          iconName: "5",
	          shareParams: _assginType("qq")
	        },
	        {
	          scene: 4,
	          title: "QQ空间",
	          iconName: "6",
	          shareParams: _assginType("qzone")
	        },
	        {
	          scene: 5,
	          title: "微博",
	          iconName: "7",
	          shareParams: _assginType("weibo")
	        },
	        {
	          scene: 6,
	          title: "复制链接",
	          iconName: "15",
	          shareParams: _assginType("copy")
	        },
	        {
	          scene: 15,
	          title: "微店群聊",
	          iconName: "9",
	          shareParams: _assginType("imGroup")
	        },
	        {
	          scene: 99,
	          title: "保存图片",
	          iconName: "12",
	          shareParams: _assginType("saveImage")
	        },
	        {
	          scene: 201,
	          title: "微信好友",
	          iconName: "1",
	          shareParams: _assginType("weChatImage")
	        },
	        {
	          scene: 202,
	          title: "微信朋友圈",
	          iconName: "3",
	          shareParams: _assginType("weChatMomentImage")
	        },
	        {
	          scene: 203,
	          title: "微信小程序",
	          iconName: "1",
	          shareParams: _assginType("weChatMiniProgram")
	        }
	      ];

	      var filterItems = [];
	      option.scene.forEach(function (scene) {
	        items.forEach(function (item) {
	          if (item.scene === scene) {
	            filterItems.push(item);
	          }
	        });
	      });

	      // items = items.filter(function(item) {
	      //   return option.scene.indexOf(item.scene) >= 0;
	      // });

	      window.KDJSBridge2 &&
	        window.KDJSBridge2.call(
	          "service",
	          "SharePopupViewService",
	          {
	            shares: [
	              {
	                items: filterItems
	              }
	            ]
	          },
	          function (res) {
	            var result = _this._logAfterNativeShare(res);
	            option.appSuccessCb && option.appSuccessCb(res, result);
	          }
	        );
	    }
	  };

	  Share.prototype._setNativePanel = function (directScene) {
	    var config = this.config;
	    var option = this.option;
	    var panelList = [
	      {
	        panelType: 1,
	        desc: "链接分享",
	        content: {
	          url: config.url,
	          title: config.title,
	          content: config.content,
	          imageUrl: config.img,
	          scene: option.scene.join("_"),
	          path: config.path || "",
	          userName: config.id || "",
	          videoUrl: ""
	        }
	      },
	      {
	        panelType: 2,
	        desc: "海报分享",
	        content: {
	          postList: [
	            {
	              postType: 0,
	              desc: "纯图片海报",
	              content: {
	                img: config.posterUrl
	              }
	            }
	          ],
	          scene: option.scene.join("_")
	        }
	      },
	      {
	        panelType: 3,
	        desc: "文本分享",
	        content: {
	          text: config.text, //内容
	          scene: option.scene.join("_") //分享渠道列表
	        }
	      }
	    ];

	    var actPanelList = panelList.filter(function (panel) {
	      return option.panel.indexOf(panel.panelType) > -1;
	    });

	    var actPanelListTypes = actPanelList.map(function (panel) {
	      return panel.panelType;
	    });

	    if (actPanelListTypes.length === 0) {
	      actPanelList = panelList[0];
	    }

	    actPanelList.forEach(function (panel) {
	      var otherPanelType = actPanelListTypes.filter(function (type) {
	        return type !== panel.panelType;
	      });
	      var extraScene = otherPanelType.map(function (type) {
	        return "10" + type;
	      });

	      var totalScene = option.scene.concat(extraScene).join("_");
	      panel.content.scene = totalScene;

	      if (directScene) {
	        if (panel.panelType === 1 || panel.panelType === 3) {
	          panel.content.directScene = directScene;
	        }
	      }
	    });

	    return actPanelList;
	  };

	  Share.prototype._logAfterNativeShare = function (res) {
	    var config = this.config;
	    if (
	      res &&
	      res.bridgeParam &&
	      res.bridgeParam.status &&
	      res.bridgeParam.status.status_code != 0
	    ) {
	      window.vcollect &&
	        window.vcollect.reportError({
	          abstract: "jsbridge分享面板唤起失败",
	          app: ua.name,
	          url: location.href
	        });
	      return {
	        error: true,
	        result: {
	          message: "jsbridge分享面板唤起失败"
	        }
	      };
	    } else if (
	      res &&
	      res.param &&
	      (res.param.result == 0 || res.param.code == 0)
	    ) {
	      // 店长版需要上报分享成功信息，买家版由 native 负责
	      var channel = "";
	      if (ua.isWD) {
	        window.pathTracker && window.pathTracker.successTrack();
	        var type = res.param.originParams && res.param.originParams.type;
	        channel = {
	          weChat: 1,
	          weChatMoment: 2,
	          qq: 3,
	          qzone: 4,
	          weibo: 5,
	          saveImage: 99,
	          weChatImage: 201,
	          weChatMomentImage: 202,
	          weChatMiniProgram: 203
	        }[type];
	      }

	      if (ua.isVbuyer) {
	        channel = res.param.type;
	      }

	      window.spider &&
	        window.spider.trackAction({
	          actionName: "_share",
	          actionArgs: {
	            app: ua.name,
	            channel: channel || "unknow",
	            shareUrl: config.url
	          }
	        });

	      return {
	        error: false,
	        result: {
	          message: "success",
	          scene: channel
	        }
	      };
	    } else {
	      return {
	        error: false,
	        result: {
	          message: "用户取消分享",
	          scene: -1
	        }
	      };
	    }
	  };

	  /**
	   * 克隆对象或分配对象
	   * @param obj
	   * @returns {object}
	   * @private
	   */
	  function assgin(target) {
	    var sourceArray = [].slice.call(arguments, 1);
	    sourceArray.forEach(function (source) {
	      for (var key in source) {
	        if (source.hasOwnProperty(key) && !target.hasOwnProperty(key)) {
	          target[key] = source[key];
	        }
	      }
	    });
	    return target;
	  }

	  function _coverUrlWfr(url, wfr) {
	    var parsedUrl = util._urlParse(url);
	    var hash = parsedUrl.hash;

	    var inheritWfr = util._queryStringParse(location.search).wfr;
	    if (!inheritWfr) {
	      inheritWfr = "h5direct";
	    } else {
	      Object.keys(WFR_MAP).forEach(function (channel) {
	        var wfr = WFR_MAP[channel];
	        inheritWfr = inheritWfr.replace("_" + wfr, "");
	      });
	    }

	    var queryParam = util._queryStringParse(parsedUrl.search);
	    queryParam.wfr = inheritWfr + "_" + wfr;

	    var querystring = util._queryStringStringify(queryParam);
	    return url.replace(/(\?|#)[\S]*$/, "") + "?" + querystring + hash;
	  }

	  return Share;
	});


/***/ }),
/* 184 */
/***/ (function(module, exports) {

	module.exports = function() {
	  var dpr = devicePixelRatio;
	  var viewport = document.querySelector('meta[name="viewport"]');

	  var content =
	    viewport &&
	    viewport.getAttribute("content").match(/initial\-scale=([\d\.]+)/);

	  var scale = (content && content[1]) || dpr;
	  var str =
	    "ui-share-box{display:none}#ui-share-box a{text-decoration:none}.ui-share__placeholder{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.8);z-index:10}.ui-share__hidden{overflow:hidden}.ui-share--weixin{position:fixed;top:0;left:0;width:100%;height:100%;z-index:10}.ui-share--weixin>img{width:100%}.ui-share{width:100%;position:fixed;left:0;top:0;background:#ededed;overflow:hidden;z-index:999}.ui-share--panel{background:#fff;font-size:0;text-align:center}.ui-share--icon:nth-of-type(5n){margin-top:0}.ui-share--icon{width:25%;display:inline-block;text-align:center;margin-top:19.2px;margin-bottom:19.2px}.ui-share--icon>img{width:80px}.ui-share--icon>p{font-size:25.6px;color:#222;margin-top:6.4px}" +
	    ".ui-share--closed{background:#fff;font-size:" +
	    20 * scale +
	    "px;text-align:center;padding:" +
	    12 * scale +
	    "px 0;color:#ee3431;display:block;margin-top:12.8px}.ui-share--tips{margin:0;background:#fff;font-size:25.6px;color:#bbb;text-align:center;padding:9.6px 0}" +
	    ".ui-share-copy{padding:" +
	    12 * scale +
	    "px;overflow:hidden;text-align:left}" +
	    ".ui-share-copy>input{font-size:" +
	    16 * scale +
	    "px;padding:" +
	    5 * scale +
	    "px;width:90%;border:1px solid #ccc}" +
	    ".ui-share-copy>p{font-size:" +
	    16 * scale +
	    "px;color:#222;margin:0 0 16px}";
	  var style = document.createElement("style");
	  style.innerHTML = str;
	  document.head.appendChild(style);
	};


/***/ }),
/* 185 */
/***/ (function(module, exports) {

	!(function () {
	    var _window = window,
	        _document = document;
	    // 计数器初始化为0
	    var count = 0;
	    // 登录cookie字段
	    var IS_LOGIN = "is_login",
	        WD_B_ID = "uid",
	        WD_S_ID = "sid",
	        LOGIN_USER_SOURCE = "login_source",
	        LoGIN_TYPE = "login_type";
	    // 错误码
	    var CODE_SUCCESS = 0,
	        CODE_FAILED = 2;
	    // 接口返回信息
	    var MSG_OK = "OK",
	        MSG_LOGIN_ERROR = "LOGIN ERROR";

	    var TYPE_NORMAL = 0,
	        TYPE_LOGIN = 1,
	        TYPE_LOGOFF = 2;

	    /**
	          ## `environment`变量说明

	                0 : 开发
	                1 : 测试、日常
	                2 : 预发
	                3 : 线上
	    */
	    var ENV_MAP = {
	        DEV: 0,
	        DAILY: 1,
	        PRE: 2,
	        PROD: 3
	    }

	    function getHostObject(env) {
	        var bk = (env === ENV_MAP.DEV || env === ENV_MAP.DAILY) ? "-daily.test" : (env === ENV_MAP.PRE ? "-pre.test" : "");
	        var lp = (env === ENV_MAP.DEV || env === ENV_MAP.DAILY) ? ".daily" : (env === ENV_MAP.PRE ? ".pre" : "");
	        var sso = (env === ENV_MAP.DEV || env === ENV_MAP.DAILY) ? "wd.daily" : (env === ENV_MAP.PRE ? "wd.pre" : "sso");
	        return {
	            backendHost: "https://sso" + bk + ".weidian.com",
	            loginPageHost: "https://h5" + lp + ".weidian.com",
	            ssoPageHost: "https://" + sso + ".weidian.com", //新增北京ssohost
	            thorHost: "https://thor" + lp + ".weidian.com"
	        }
	    }

	    function getEnvironmentByUrl() {
	        var hostname = _window.location.hostname,
	            currentItem;
	        // currentItem = (currentItem = hostname.match(/(?:.)dev|daily|pre(?:.)/)) ? currentItem[0] : null;
	        currentItem = (currentItem = hostname.match(/(?=.)\bdev\b|\bdaily\b|\bpre\b(?=.)/)) ? currentItem[0] : null;
	        // hostArray = hostname.split("."),
	        //### ES5的 array.filter方法IE7,8不兼容,故果断抛弃
	        // currentItem = hostArray.filter(function(item) {
	        //     return /dev|daily|pre/.test(item);
	        // })[0];
	        switch (currentItem) {
	            case "dev":
	                return ENV_MAP.DEV;
	            case "daily":
	                return ENV_MAP.DAILY;
	            case "pre":
	                return ENV_MAP.PRE;
	            default:
	                return ENV_MAP.PROD;
	        }
	    }

	    function getHost(environment) {
	        var _env = environment === undefined ? getEnvironmentByUrl() : Number(environment);

	        return getHostObject(_env);
	    }

	    function getHref() {
	        return _window.location.href;
	    }

	    function getUA() {
	        return _window.navigator.userAgent;
	    }

	    function get2ndLevelDomain(hostname) {
	        return hostname
	          .split(".")
	          .slice(-2)
	          .join(".");
	    }

	    function isMobile(type) {
	        // 如果不传，默认为h5
	        return (type === undefined) ? true : type;
	    }

	    function isWDHost(targetHost) {
	        targetHost = targetHost || location.hostname;
	        var writeList = ["koudai.com", "91ruyu.com", "bibikan.cn", "fangxin.com", "xihuan.com.cn", "youshop01.com", "youshop02.com", "youshop03.com", "youshop04.com", "youshop05.com", "youshop06.com", "youshop07.com", "youshop08.com", "youshop09.com", "youshop10.com", "kou6ai.cn", "ynet.com"];
	        var isWDHost = false;
	        writeList.forEach(function(domain) {
	          if (!isWDHost && targetHost.indexOf(domain) > -1) {
	            isWDHost = domain;
	          }
	        });
	        return isWDHost;
	    }

	    function getTargetUrl(url, type) {
	        // return url || getHref();
	        var url = url || getHref();
	        var host, redirectApi, domain;
	        switch(type){
	            case TYPE_LOGIN:
	              if(isWDHost() && !isBuyerApp()){ //买家版中多域名情况login不需要调用synclogin接口
	                host = getHost(),
	                redirectApi = host.backendHost + '/user/synclogin',
	                // domain = get2ndLevelDomain(location.hostname);
	                domain = isWDHost();

	                url =  redirectApi + "?type=" + domain + "&redirect=" + encodeURIComponent(url);
	              }
	              break;
	            case TYPE_LOGOFF:
	                
	            // 多域名退出登录改造
	            // http://wf.vdian.net/browse/WEB-3369

	            if(isWDHost()){
	                host = getHost(),
	                    redirectApi = host.backendHost + '/user/synclogout',
	                    domain = get2ndLevelDomain(location.hostname);
	                url =  redirectApi +
	                    "?type=" +
	                    domain +
	                    "&redirect=" +
	                    encodeURIComponent(url);
	            }

	            break;
	        }

	        //登录&绑定操作 买家版 安卓 < 5.5.2.1版本 需要对url encode两次
	        if(type !== TYPE_LOGOFF && isAndroid() && isBuyerApp() && versionCompare(getAppVersion(),'5.5.2.1') < 0){
	            url = encodeURIComponent(url)
	        }

	        return url;
	    }

	    function getCookie(key) {
	        var result;
	        return (result = new RegExp('(?:^|; )' + key + '=([^;]*)').exec(_document.cookie)) ? result[1] : null;
	    }

	    // 格式化参数对象
	    function formatParams(data) {
	        var arry = [];
	        for (var name in data) {
	            if (typeof data[name] == "object") {
	                arry.push(name + '=' + JSON.stringify(data[name]));
	            }else{
	                arry.push(encodeURIComponent(name) + '=' + encodeURIComponent(data[name]));
	            }

	        }
	        return arry.join("&");
	    }

	    function vap() {
	        return {
	            status: {
	                code: "",
	                message: "",
	                description: ""
	            },
	            result: {}
	        };
	    }

	    function callback(data, success, error) {
	        // 模拟统一的vap接口格式
	        var infoResult = vap();

	        if (data && data.status) {
	            var status = data.status,
	                code = status.status_code,
	                message = status.message;

	            var tempCode, tempMsg;
	            switch (code) {
	                case 0:
	                    // 请求成功
	                    tempCode = CODE_SUCCESS;
	                    tempMsg = MSG_OK;
	                    break;
	                case 420010:
	                    // token校验失败
	                    tempCode = CODE_FAILED;
	                    tempMsg = MSG_LOGIN_ERROR;
	                    break;
	                default:
	                    // 其他类型错误
	                    tempCode = code;
	                    tempMsg = message;
	            }
	            infoResult.status.code = tempCode;
	            infoResult.status.message = tempMsg;
	            infoResult.result = data.result;

	            code === CODE_SUCCESS ? (success && success(infoResult)) : (error && error(infoResult));
	        } else {
	            error && error(new Error("interface isn't legal"));
	        }
	    }

	    function checkParam(param) {
	        return typeof param !== "undefined" ? true : false;
	    }

	    function getCompleteLink(domain, url, params) {
	        var link = "";
	        link = domain + url;
	        if (checkParam(params)) {
	            link += "?" + formatParams(params);
	        }
	        return link;
	    }

	    function jsonp(options) {
	        var options = options || {},
	            data = options.data || {},
	            jsonp = options.jsonp || "callback",
	            success = options.success,
	            error = options.error,
	            url = options.url,
	            responseData;

	        if (!url) {
	            return error && error(new Error("url is not defined!"));
	        }

	        // 动态创建script标签并添加到页面中
	        var callbackName = "jsonp_" + count++,
	            head = document.getElementsByTagName("head")[0],
	            _script = document.createElement("script");
	        // 将随机生成的回调函数存储在对象中
	        data[jsonp] = callbackName;

	        var onLoadCallback = (function () {
	            // 用handled标志位来防止“onreadystatechange”与“onload”两个监听事件重复调用本函数
	            var handled = false;
	            return function () {
	                if (handled) {
	                    return;
	                }
	                handled = true;
	                // 处理回调接口
	                if (!responseData) {
	                    error && error(new Error("callback function error!"));
	                } else {
	                    success && success(responseData);
	                }
	            };
	        }());
	        // 兼容部分IE 不支持onload事件的处理
	        // http://stackoverflow.com/questions/6806584/object-onload-in-internet-explorer-6-7-and-8
	        _script.onreadystatechange = function () {
	            if (this.readyState === "complete" || this.readyState === "loaded") {
	                onLoadCallback();
	            }
	        }
	        // 监听script的src属性请求的资源是否已经加载完成
	        _script.onload = onLoadCallback;
	        // 加载失败
	        _script.onerror = function (e) {
	            head.removeChild(_script);
	            window[callbackName] = null;
	            error && error(e);
	        }

	        // 封装jsonp回调函数
	        window[callbackName] = function (json) {
	            head.removeChild(_script);
	            window[callbackName] = null;
	            // 缓存请求返回的json数据
	            responseData = json;
	        }

	        // 发送请求
	        _script.src = url + (url.indexOf("?") == -1 ? '?' : '&') + formatParams(data);
	        head.appendChild(_script);
	    }
	    // 校验用户是否登录
	    function isLogin() {
	        return (getCookie(IS_LOGIN) || getCookie(WD_B_ID) || getCookie(WD_S_ID)) ? true : false;
	    }
	    // 校验是否纯卖家方式登录
	    function isSellerLogin() {
	        return isLogin() && getCookie(WD_S_ID) ? true : false;
	    }
	    // 校验是否通过微信第三方方式登录
	    function isWechatLogin() {
	        return isLogin() && getCookie(LOGIN_USER_SOURCE) === "LOGIN_USER_SOURCE_WECHAT" ? true : false;
	    }
	    // 校验是否通过通过qq方式登录
	    function isQQLogin() {
	        return isLogin() && getCookie(LOGIN_USER_SOURCE) === "LOGIN_USER_SOURCE_QQ" ? true : false;
	    }
	    // 校验是否为子账号登录
	    function isSubAccount() {
	        return isLogin() && getCookie(LoGIN_TYPE) === "SUB_ACCOUNT" ? true : false;
	    }
	    // 校验是否在微信环境
	    function isWeixin() { //排除企业微信环境的干扰
	        return /MicroMessenger/i.test(getUA()) && !isWXwork();
	    }
	    // 校验是否在qq环境
	    function isQQ() {
	        return /QQ\/([\d\.]+)/i.test(getUA());
	    }
	    //判断是否在企业微信
	    function isWXwork() {
	        return /wxwork/i.test(getUA());
	    }
	    //判断是否在买家版APP环境
	    function isBuyerApp() {
	        return /WDBuyer/i.test(getUA())
	    }
	    //判断是否是安卓环境
	    function isAndroid(){
	        return /android/i.test(getUA())
	    }
	    //获取客户端版本号
	    function getAppVersion() {
	        var UA = getUA();
	        var appName, appVersion, sdkName, sdkVersion;
	        var regApp = /WDAPP\((.*?)\/(.*?)[\s|\)]/i;
	        var app = UA.match(regApp);
	        if (app && app.length == 3) {
	            appName = app[1], appVersion = app[2];
	        }
	        return appVersion;
	    }
	    //比较客户端版本
	    function versionCompare(a, b) {
	        if (a === b) {
	            return 0;
	        }
	        var a_components = a.split(".");
	        var b_components = b.split(".");
	        var len = Math.min(a_components.length, b_components.length);
	        // loop while the components are equal
	        for (var i = 0; i < len; i++) {
	            // A bigger than B
	            if (parseInt(a_components[i]) > parseInt(b_components[i])) {
	                return 1;
	            }
	            // B bigger than A
	            if (parseInt(a_components[i]) < parseInt(b_components[i])) {
	                return -1;
	            }
	        }
	        // If one's a prefix of the other, the longer one is greater.
	        if (a_components.length > b_components.length) {
	            return 1;
	        }
	        if (a_components.length < b_components.length) {
	            return -1;
	        }
	        // Otherwise they are the same.
	        return 0;
	    }


	    // 当前登录用户是否开过店
	    function isOpenShop(opts) {
	        var opts = opts || {},
	            success = opts.success,
	            error = opts.error,
	            host = getHost(opts.environment),
	            CHECK_OPEN_SHOP_URL = host.thorHost + "/wdshop/shop.base.getShopExistInfo/1.0",
	            sellerId = getCookie(WD_S_ID);

	        if (!sellerId) {
	            return error && error(new Error("没获取到当前登录的卖家id"));
	        }

	        jsonp({
	            url: CHECK_OPEN_SHOP_URL,
	            data: {
	                context: {
	                    "shop_id": sellerId
	                }
	            },
	            success: function (data) {
	                success && success(data);
	            },
	            error: function (e) {
	                error && error(e);
	            }
	        });
	    }

	    // 校验第三方登录用户是否绑定了手机号
	    function getBindStatus(opts) {
	        /**
	         * 返回的结果为result=true，未绑定;result=false，已绑定
	         */
	        var opts = opts || {},
	            success = opts.success,
	            error = opts.error,
	            host = getHost(opts.environment),
	            CHECK_BIND_URL = host.backendHost + '/user/oauth/bind/getdemand';

	        jsonp({
	            url: CHECK_BIND_URL,
	            success: function (data) {

	                callback(data, function (result) {
	                    success && success(result);
	                }, function (e) {
	                    error && error(e);
	                });
	            },
	            error: function (e) {
	                error && error(e);
	            }
	        });
	    }

	    //获取登录用户信息
	    function getUserInfo(opts) {
	        /**
	            ###
	            1、校验是否有登录cookie值，因为调取用户信息接口需要cookie参数
	            2、校验当前浏览器是否支持CORS方式跨域；若支持则发起ajax请求(废弃，目前统一采用jsonp的方式处理)
	            3、若不支持，则采取jsonp的方式，动态创建script标签，利用src属性请求接口执行回调函数(因为要兼容IE7,8)

	            ###
	            opts:{
	            environment:环境值,
	            success:function(result){}//执行成功后的回调函数
	            error:function(result){}//执行失败后的回到函数
	        }
	        */
	        var host,
	            opts = opts || {},
	            success = opts.success,
	            error = opts.error,
	            host = getHost(opts.environment),
	            USER_INFO_URL = host.backendHost + "/user/getinfo";

	        // 模拟统一的vap接口格式
	        var infoResult = vap();

	        if (isLogin()) {
	            jsonp({
	                url: USER_INFO_URL,
	                success: function (data) {

	                    callback(data, function (result) {

	                        success && success(result);

	                    }, function (e) {

	                        error && error(e);

	                    });
	                },
	                error: function (e) {
	                    error && error(e);
	                }
	            });
	        } else {
	            infoResult.status.code = CODE_FAILED;
	            infoResult.status.message = MSG_LOGIN_ERROR;
	            infoResult.result = "";

	            error && error(infoResult);
	        }
	    }

	    function qqLogin(options) {
	        var options = options || {},
	            targetUrl = getTargetUrl(options.url, TYPE_LOGIN),
	            host = getHost(options.environment),
	            type = options.device;

	        // _window.location.href = getCompleteLink(host.backendHost, '/user/oauth/qq/login', {
	        //     redirect: targetUrl,
	        //     type: isMobile(type) ? 'mobile' : 'pc'
	        // });

	        return getCompleteLink(host.backendHost, '/user/oauth/qq/login', {
	            redirect: targetUrl,
	            type: isMobile(type) ? 'mobile' : 'pc'
	        });
	    }

	    function wechatSlientLogin(options) {
	        var options = options || {},
	            targetUrl = getTargetUrl(options.url, TYPE_LOGIN),
	            host = getHost(options.environment);

	        // _window.location.href = getCompleteLink(host.backendHost, '/user/oauth/wechat/silentlogin', {
	        //     redirect: targetUrl
	        // });
	        return getCompleteLink(host.backendHost, '/user/oauth/wechat/silentlogin', {
	            redirect: targetUrl
	        });
	    }

	    function wechatForceLogin(options) {
	        var options = options || {},
	            targetUrl = getTargetUrl(options.url, TYPE_LOGIN),
	            host = getHost(options.environment);

	        // _window.location.href = getCompleteLink(host.backendHost, '/user/oauth/wechat/login', {
	        //     redirect: targetUrl
	        // });

	        return getCompleteLink(host.backendHost, '/user/oauth/wechat/login', {
	            redirect: targetUrl
	        });
	    }

	    function login(options) {
	        /**
	         ## 可选参数配置项
	          options:{
	          url: 重定向的url，若不传，则默认获取当前访问页面的url
	          environment:当前环境值，若不传，则默认解析识别当前页面的url的环境值
	          oauth:是否显示第三方登录；oauth=0不显示；不传参，默认显示
	          force:配置微信登录采用静默授权或强制授权；force=1为强制授权，不传，默认静默授权
	          bind: 配置第三方登录成功后是否跳转到绑定页面。bind=1 ：表示第三方登录成功后，如果账号未绑定手机号则跳转到绑定页面，绑定成功后跳转回目标页。默认为不跳转到绑定页面。
	          device:区别h5端或者pc端；h5端：device=1,pc端：device=0
	          }
	        */
	        var options = options || {},
	            host = getHost(options.environment),
	            targetUrl = encodeURIComponent(getTargetUrl(options.url, TYPE_LOGIN));


	        //区分h5端登录和pc端登录
	        // _window.location.href = [host.loginPageHost,
	        //     isMobile(options.device) ? '/m/login/index.html' : '/m/signin/index.html',
	        //     '?redirect=' + targetUrl,
	        //     checkParam(options.oauth) ? '&oauth=0' : '',
	        //     checkParam(options.force) ? '&force=1' : '',
	        //     checkParam(options.bind) ? '&bind=1' : ''
	        // ].join('');

	        return [
	        // host.loginPageHost,
	        // isMobile(options.device) ? '/m/login/index.html' : '/m/signin/index.html',
	        isMobile(options.device) ? (host.ssoPageHost + '/login/index.php') : (host.loginPageHost + '/m/signin/index.html'),
	        '?redirect=' + targetUrl,
	        checkParam(options.oauth) ? '&oauth=0' : '',
	        checkParam(options.force) ? '&force=1' : '',
	        checkParam(options.bind) ? '&bind=1' : '',
	        checkParam(options.nochoice) ? '&nochoice=1' : '',
	        checkParam(options.seller) ? '&seller=1' : ''
	        ].join('');
	    }

	    function register(options) {
	        var options = options || {},
	            targetUrl = getTargetUrl(options.url, TYPE_LOGIN),
	            host = getHost(options.environment);

	        // _window.location.href = getCompleteLink(host.backendHost, '/user/logout', {
	        //     redirect: targetUrl
	        // });

	        return [
	            // host.loginPageHost,
	            // isMobile(options.device) ? '/m/login/index.html' : '/m/signin/index.html',
	            host.ssoPageHost + '/login/index.php',
	            '?redirect=' + targetUrl,
	            '&register=1'
	            ].join('');
	    }

	    function logout(options) {
	        var options = options || {},
	            targetUrl = getTargetUrl(options.url, TYPE_LOGOFF),
	            host = getHost(options.environment);

	        // _window.location.href = getCompleteLink(host.backendHost, '/user/logout', {
	        //     redirect: targetUrl
	        // });

	        return getCompleteLink(host.backendHost, '/user/logout', {
	            redirect: targetUrl
	        });
	    }

	    function bind(options) {
	        var options = options || {},
	            targetUrl = getTargetUrl(options.url, TYPE_NORMAL),
	            host = getHost(options.environment);

	        // _window.location.href = getCompleteLink(host.loginPageHost, '/m/login/bind/index.html', {
	        //     redirect: targetUrl
	        // });

	        // return getCompleteLink(host.loginPageHost, '/m/login/bind/index.html', {
	        //     redirect: targetUrl
	        // });
	        return getCompleteLink(host.ssoPageHost, '/login/index.php', {
	            redirect: targetUrl,
	            bind: 1
	        });
	    }

	    var login = {
	        isLogin: isLogin,
	        isSellerLogin: isSellerLogin,
	        isWechatLogin: isWechatLogin,
	        isQQLogin: isQQLogin,
	        isSubAccount: isSubAccount, 
	        getUserInfo: getUserInfo,
	        qqLogin: qqLogin,
	        wechatSlientLogin: wechatSlientLogin,
	        wechatForceLogin: wechatForceLogin,
	        login: login,
	        register: register,
	        logout: logout,
	        bind: bind,
	        getBindStatus: getBindStatus,
	        isWeixin: isWeixin,
	        isQQ: isQQ,
	        isOpenShop: isOpenShop
	    }

	    if (typeof module !== "undefined" && module.exports) {
	        module.exports = login;
	    } else {
	        _window.login = login;
	    }
	})()


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * see: https://developer.mozilla.org/en-US/docs/Web/API/ErrorEvent
	 * see: https://www.w3.org/TR/html5/webappapis.html#the-errorevent-interface
	 */

	"use strict";

	var util = __webpack_require__(2);
	var undefined = void 0;

	var log = {};
	/* message: 错误关键信息
	* url:     错误文件名，默认当前 url
	* name:    错误大类
	*/
	var necessaryKeys = ["message", "url", "name"];
	var defaultNecessaryValue = {
	  message: "some error happend, but no message",
	  url: location.href,
	  name: "__UNDEF__"
	};
	var supportPerformance =
	  window.performance &&
	  window.performance.getEntries &&
	  typeof window.performance.getEntries === "function" &&
	  window.performance.getEntries() instanceof Array;

	var THOR_HOST_REGEXP = /\/\/thor\.(daily\.|pre\.)?weidian\.com/;

	//提前定义接口函数
	log.error = util._noop;
	log.warn = util._noop;
	log.info = util._noop;
	log.debug = util._noop;
	log.report = util._noop;
	log.setError = util._noop;
	log._erroCode = {
	  ">": null,
	  ">=": null,
	  "<": null,
	  "<=": null,
	  "=": null,
	  "!=": [0]
	};

	var typeUtil = {
	  isObject: function(value) {
	    return (
	      Object.prototype.toString.call(value) !== "[object Array]" &&
	      typeof value === "object"
	    );
	  },
	  isArray: function(value) {
	    return Object.prototype.toString.call(value) === "[object Array]";
	  },
	  isNumber: function(value) {
	    return Object.prototype.toString.call(value) === "[object Number]";
	  },
	  isRegExp: function(value) {
	    return Object.prototype.toString.call(value) === "[object RegExp]";
	  }
	};

	var foreach = function(arr, callback) {
	  for (var i = 0, len = arr.length; i < len; i++) {
	    callback(arr[i], i);
	  }
	};

	function checkStaticPerfect() {
	  var scripts = document.querySelectorAll("script") || [];
	  var links = document.querySelectorAll("link") || [];

	  links = [].filter.call(links, function(link) {
	    return link.rel === "stylesheet" && link.href !== "";
	  });

	  scripts = [].filter.call(scripts, function(script) {
	    return script && script.src !== "";
	  });

	  scripts = [].map.call(scripts, function(script) {
	    return script.src;
	  });

	  links = [].map.call(links, function(link) {
	    return link.href;
	  });

	  var staticAssets = [].concat(scripts, links);
	  var failed = [];
	  staticAssets.forEach(function(name) {
	    if (performance.getEntriesByName(name).length === 0) {
	      failed.push(name);
	    }
	  });

	  return failed;
	}

	//@core install
	log.init = function(core, options) {
	  if (
	    supportPerformance &&
	    typeof performance.getEntriesByName === "function"
	  ) {
	    if (options.auto) {
	      setTimeout(function() {
	        var failed = checkStaticPerfect();
	        failed.forEach(function(name) {
	          logError({
	            name: "__ASSETS_ERROR__",
	            url: name,
	            message: "assets loaded error"
	          });
	        });
	      }, 5000);
	    }
	  }

	  var reportUrl = core.getReportUrl();

	  var logError = function(data) {
	    if (!log.isNotValidConfig) {
	      _log("error", data);
	    }
	  };
	  var logWarn = function(data) {
	    if (!log.isNotValidConfig) {
	      _log("warn", data);
	    }
	  };
	  var logDebug = function(data) {
	    if (!log.isNotValidConfig) {
	      _log("debug", data);
	    }
	  };
	  var logInfo = function(data) {
	    if (!log.isNotValidConfig) {
	      _log("info", data);
	    }
	  };

	  function _log(subtype, data) {
	    data = data || {};

	    if (typeof data.detail === "string") {
	      data.detail = {
	        userReportDetail: data.detail
	      };
	    }

	    util._getNetwork(function(network) {
	      util._extendObj(data.detail, { network: network });
	    });

	    core.report("log", subtype, _normalizeLog(data));
	  }

	  function _normalizeLog(data) {
	    necessaryKeys.forEach(function(key) {
	      if (data[key] === "" || data[key] === undefined) {
	        data[key] = defaultNecessaryValue[key];
	        return;
	      }
	    });

	    var detail = data.detail || {};
	    if (util._isObjectAndNotNull(detail)) {
	      Object.keys(detail).forEach(function(secondKey) {
	        if (detail[secondKey] === "") {
	          detail[secondKey] = null;
	        }
	      });
	    }

	    var originalUrl = data.url || location.href;

	    // url 被转换成 cleanUrl
	    data.url = _cutQuerystringAndHash(originalUrl);

	    // originUrl 为原本 url
	    detail.originalUrl = originalUrl;
	    data.detail = detail;

	    return data;
	  }

	  function _cutQuerystringAndHash(url) {
	    if (/\?\?/.test(url)) {
	      return url.replace(/#\S+,/, ",").replace(/#\S+$/, "");
	    }
	    return url.replace(/[#\?]\S+$/, "");
	  }

	  function _isUploadAPI(url) {
	    return url.indexOf(reportUrl) >= 0;
	  }

	  function _watchXhr() {
	    function _overwriteXhr() {
	      var XhrProto = XMLHttpRequest.prototype;
	      XhrProto._open = XhrProto.open;
	      XhrProto.open = function(method, url) {
	        this._http = this._http || {};
	        this._http.method = method;
	        this._http.url = url;
	        return XhrProto._open.apply(this, [].slice.call(arguments));
	      };
	      XhrProto._send = XhrProto.send;
	      XhrProto.send = function() {
	        var xhr = this;
	        if (!_isUploadAPI(xhr._http.url)) {
	          _listenXhrResponse(xhr);
	        }
	        return XhrProto._send.apply(this, [].slice.call(arguments));
	      };
	    }

	    function _listenXhrResponse(xhr) {
	      var requestUrl = xhr._http.url;

	      var isErrorCode = function(erroCodeMap, statusCode) {
	        // > 的值必须是一个数字
	        if (erroCodeMap[">"] && statusCode > erroCodeMap[">"]) {
	          return true;
	        }

	        // >= 的值必须是一个数字
	        if (erroCodeMap[">="] && statusCode >= erroCodeMap[">="]) {
	          return true;
	        }

	        // < 的值必须是一个数字
	        if (erroCodeMap["<"] && statusCode < erroCodeMap["<"]) {
	          return true;
	        }

	        // <= 的值必须是一个数字
	        if (erroCodeMap["<="] && statusCode <= erroCodeMap["<="]) {
	          return true;
	        }

	        var testEqualArray = function(statusCode) {
	          var isError = false;
	          if (typeUtil.isArray(erroCodeMap["="])) {
	            foreach(erroCodeMap["="], function(item) {
	              if (isError) {
	                return;
	              }
	              if (statusCode === item) {
	                isError = true;
	              }
	            });
	          }
	          return isError;
	        };

	        var testNotEqualArray = function(statusCode) {
	          var isError = false;
	          if (typeUtil.isArray(erroCodeMap["!="])) {
	            foreach(erroCodeMap["!="], function(item) {
	              if (isError) {
	                return;
	              }

	              if (statusCode !== item) {
	                isError = true;
	              }
	            });
	          }

	          return isError;
	        };

	        // = 的值是一个数组
	        if (testEqualArray(statusCode)) {
	          return true;
	        }

	        // = 的值是一个数组
	        if (testNotEqualArray(statusCode)) {
	          return true;
	        }

	        return false;
	      };

	      /* load 事件不一定是 code 200，只要请求返回成功，即执行 load */
	      xhr.addEventListener("load", function() {
	        var res = {};
	        var traceId = "";
	        //只统计thor接口的
	        var requestUrl = xhr._http.url;

	        if (THOR_HOST_REGEXP.test(requestUrl)) {
	          traceId =
	            xhr.getResponseHeader && xhr.getResponseHeader("x-trace-id");
	        }

	        if (xhr.response) {
	          res = util._JSONParseSafty(xhr.response);
	        }

	        if (res) {
	          if (typeof res === "string") {
	            logError({
	              name: "__XHR__",
	              url: requestUrl,
	              message: "status_code_error",
	              detail: {
	                traceId: traceId || "",
	                status: xhr.status,
	                response: res
	              }
	            });
	            return;
	          }

	          var statusCode = res.status && res.status.code;
	          statusCode =
	            statusCode === undefined
	              ? res.status && res.status.status_code
	              : statusCode;
	          if (isErrorCode(log._erroCode, statusCode)) {
	            logError({
	              name: "__XHR__",
	              url: requestUrl,
	              message: "response_code_error",
	              detail: {
	                traceId: traceId || "",
	                status: 200,
	                response: util._JSONStringifySafty(res)
	              }
	            });
	          }
	        }
	      });

	      /* error 事件一般触发在 network error
	      * 1. network error(like cross origin not allow)
	      * 2. methods error or not allow
	      * 3. 302 cause corss origin(Most of the scene),
	      *    the reason is that server invoke uncatch error,
	      *    nginx do this
	      * https://xhr.spec.whatwg.org/#the-open()-method
	      */
	      xhr.addEventListener("error", function() {
	        logError({
	          name: "__XHR__",
	          url: requestUrl,
	          message: "network_error"
	        });
	      });
	      xhr.addEventListener("abort", function() {
	        logWarn({
	          name: "__XHR__",
	          url: requestUrl,
	          message: "abort"
	        });
	      });
	      xhr.addEventListener("timeout", function() {
	        logError({
	          name: "__XHR__",
	          url: requestUrl,
	          message: "timeout"
	        });
	      });
	    }

	    _overwriteXhr();
	  }

	  function _watchPageError() {
	    /* 需要业务方在 script 标签上标记 crossorigin 才能获得详细错误信息
	      *  包括错误文件名等，如果未标记，默认 url 为当前链接
	      */
	    window.addEventListener("error", function(evt) {
	      var error = evt.error;
	      if (!error) {
	        logError({
	          message: "error_in_script",
	          url: location.href,
	          name: "__SCRIPT_ERROR__",
	          detail: {
	            stack:
	              '[vcollect] 浏览器未给出错误详情，请开发者在 <script> 标签上加上 crossorigin="anonymous" 属性以获取错误详情'
	          }
	        });
	      } else {
	        logError({
	          message: error.message,
	          url: evt.filename,
	          name: "__WINDOW_ERROR__",
	          detail: {
	            stack: error.stack,
	            lineno: evt.lineno,
	            colno: evt.colno
	          }
	        });
	      }
	    });

	    /* 需要业务方在 script 标签上标记 crossorigin 才能获捕获 unhandledrejection 事件错误 */
	    window.addEventListener("unhandledrejection", function(evt) {
	      if (evt.reason && typeUtil.isObject(evt.reason)) {
	        logError({
	          message: evt.reason.message,
	          url: "",
	          name: "__UNHANDLEDREJECTION_ERROR__",
	          detail: {
	            stack: evt.reason.stack
	          }
	        });
	      }
	    });
	  }

	  if (options.auto) {
	    _watchXhr();
	    _watchPageError();
	  } else {
	    // _watchPageError();
	  }

	  log.error = logError;
	  log.warn = logWarn;
	  log.info = logInfo;
	  log.debug = logDebug;
	  log.report = function(options) {
	    if (!options || typeof options !== "object") {
	      options = {};
	    }
	    var errorData = {
	      message: options.abstract || "[vcollect] 开发者没有提供错误摘要",
	      url: options.url,
	      name: "__USER_REPORT_ERROR__",
	      detail: options.detail || "[vcollect] 开发者没有提供错误详情"
	    };

	    logError(errorData);
	  };
	  log.isNotValidConfig = false;
	  log.setError = function(options) {
	    // var showErrorMessage = function(msg) {
	    //   console.error(msg);
	    //   log.isNotValidConfig = true;
	    // };
	    // // 检查参数格式是否正确
	    // if (!typeUtil.isObject(options)) {
	    //   showErrorMessage(
	    //     "[vcollect] 设置 errorCode 时，需要传参，参数格式为对象"
	    //   );
	    //   return;
	    // }
	    // if (!typeUtil.isObject(options.errorCode)) {
	    //   showErrorMessage(
	    //     "[vcollect] 设置 errorCode 时，需要传参，参数格式为对象"
	    //   );
	    //   return;
	    // }
	    // for (var key in options.errorCode) {
	    //   var value = options.errorCode[key];
	    //   if (key === ">" || key === ">=" || key === "<" || key === "<=") {
	    //     if (!typeUtil.isNumber(value)) {
	    //       showErrorMessage(
	    //         '[vcollect] 设置 errorCode 时，"' + key + '" 的值必须是数字'
	    //       );
	    //       return;
	    //     }
	    //   } else if (key === "=" || key === "!=") {
	    //     if (!typeUtil.isArray(value)) {
	    //       showErrorMessage(
	    //         '[vcollect] 设置 errorCode 时，"' +
	    //           key +
	    //           '" 的值必须是数字或数组或正则表达式'
	    //       );
	    //       return;
	    //     }
	    //     for (var i = 0, len = value.length; i < len; i++) {
	    //       if (!typeUtil.isNumber(value[i])) {
	    //         showErrorMessage(
	    //           '[vcollect] 设置 errorCode 时，且 "' +
	    //             key +
	    //             '" 的值是数组时，数组项必须是数字'
	    //         );
	    //         return;
	    //       }
	    //     }
	    //   } else {
	    //     showErrorMessage(
	    //       '[vcollect] 设置 errorCode 时，"' +
	    //         key +
	    //         '" 不被支持，支持以下设置 ">"、">=", "<", "<=", "=", "!="'
	    //     );
	    //     return;
	    //   }
	    // }
	    // for (var key in options.errorCode) {
	    //   log._erroCode[key] = options.errorCode[key];
	    // }
	  };
	};

	module.exports = log;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, global) {!function(e,n){ true?n():"function"==typeof define&&define.amd?define(n):n()}(0,function(){"use strict";function e(e){var n=this.constructor;return this.then(function(t){return n.resolve(e()).then(function(){return t})},function(t){return n.resolve(e()).then(function(){return n.reject(t)})})}function n(e){return!(!e||"undefined"==typeof e.length)}function t(){}function o(e){if(!(this instanceof o))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=undefined,this._deferreds=[],c(e,this)}function r(e,n){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,o._immediateFn(function(){var t=1===e._state?n.onFulfilled:n.onRejected;if(null!==t){var o;try{o=t(e._value)}catch(r){return void f(n.promise,r)}i(n.promise,o)}else(1===e._state?i:f)(n.promise,e._value)})):e._deferreds.push(n)}function i(e,n){try{if(n===e)throw new TypeError("A promise cannot be resolved with itself.");if(n&&("object"==typeof n||"function"==typeof n)){var t=n.then;if(n instanceof o)return e._state=3,e._value=n,void u(e);if("function"==typeof t)return void c(function(e,n){return function(){e.apply(n,arguments)}}(t,n),e)}e._state=1,e._value=n,u(e)}catch(r){f(e,r)}}function f(e,n){e._state=2,e._value=n,u(e)}function u(e){2===e._state&&0===e._deferreds.length&&o._immediateFn(function(){e._handled||o._unhandledRejectionFn(e._value)});for(var n=0,t=e._deferreds.length;t>n;n++)r(e,e._deferreds[n]);e._deferreds=null}function c(e,n){var t=!1;try{e(function(e){t||(t=!0,i(n,e))},function(e){t||(t=!0,f(n,e))})}catch(o){if(t)return;t=!0,f(n,o)}}var a=setTimeout;o.prototype["catch"]=function(e){return this.then(null,e)},o.prototype.then=function(e,n){var o=new this.constructor(t);return r(this,new function(e,n,t){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof n?n:null,this.promise=t}(e,n,o)),o},o.prototype["finally"]=e,o.all=function(e){return new o(function(t,o){function r(e,n){try{if(n&&("object"==typeof n||"function"==typeof n)){var u=n.then;if("function"==typeof u)return void u.call(n,function(n){r(e,n)},o)}i[e]=n,0==--f&&t(i)}catch(c){o(c)}}if(!n(e))return o(new TypeError("Promise.all accepts an array"));var i=Array.prototype.slice.call(e);if(0===i.length)return t([]);for(var f=i.length,u=0;i.length>u;u++)r(u,i[u])})},o.resolve=function(e){return e&&"object"==typeof e&&e.constructor===o?e:new o(function(n){n(e)})},o.reject=function(e){return new o(function(n,t){t(e)})},o.race=function(e){return new o(function(t,r){if(!n(e))return r(new TypeError("Promise.race accepts an array"));for(var i=0,f=e.length;f>i;i++)o.resolve(e[i]).then(t,r)})},o._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){a(e,0)},o._unhandledRejectionFn=function(e){void 0!==console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)};var l=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof global)return global;throw Error("unable to locate global object")}();"Promise"in l?l.Promise.prototype["finally"]||(l.Promise.prototype["finally"]=e):l.Promise=o});

	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(45).setImmediate, (function() { return this; }())))

/***/ })
/******/ ]);